var _defs, _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9, _use10, _use11, _use12, _use13, _use14, _use15, _use16, _use17, _use18, _use19, _use20, _use21, _use22, _use23, _use24, _use25, _use26, _use27, _use28, _use29, _use30, _use31, _use32, _use33, _use34, _use35, _use36, _use37, _use38, _use39, _use40, _use41, _use42, _use43, _use44, _use45, _use46, _use47, _use48, _use49, _use50, _use51, _use52, _use53, _use54, _use55, _use56, _use57, _use58, _use59, _use60, _use61, _use62, _use63, _use64, _use65, _use66, _use67, _use68, _use69, _use70, _use71, _use72, _use73, _use74, _use75, _use76, _use77, _use78, _use79, _use80, _use81, _use82, _use83, _use84, _use85, _use86, _use87, _use88, _use89, _use90, _use91, _use92, _use93, _use94, _use95, _use96, _use97, _use98, _use99, _use100, _use101, _use102, _use103, _use104, _use105, _use106, _use107, _use108, _use109, _use110, _use111, _use112, _use113, _use114, _use115, _use116, _use117, _use118, _use119, _use120, _use121, _use122, _use123, _use124, _use125, _use126, _use127, _use128, _use129, _use130, _use131, _use132, _use133, _use134, _use135, _use136, _use137, _use138, _use139, _use140, _use141, _use142, _use143, _use144, _use145, _use146, _use147, _use148, _use149, _use150, _use151, _use152, _use153, _use154, _use155, _use156, _use157, _use158, _use159, _use160, _use161, _use162, _use163, _use164, _use165, _use166, _use167, _use168, _use169, _use170, _use171, _use172, _use173, _use174, _use175, _use176, _use177, _use178, _use179, _use180, _use181, _use182, _use183, _use184, _use185, _use186, _use187, _use188, _use189, _use190, _use191, _use192, _use193, _use194, _use195, _use196, _use197, _use198, _use199, _use200, _use201, _use202, _use203, _use204, _use205, _use206, _use207, _use208, _use209, _use210, _use211, _use212, _use213, _use214, _use215, _use216, _use217, _use218, _use219, _use220, _use221, _use222, _use223, _use224, _use225, _use226, _use227, _use228, _use229, _use230, _use231, _use232, _use233, _use234, _use235, _use236, _use237, _use238, _use239, _use240, _use241, _use242, _use243, _use244, _use245, _use246, _use247, _use248, _use249, _use250, _use251, _use252, _use253, _use254, _use255, _use256, _use257, _use258, _use259, _use260, _use261, _use262, _use263, _use264, _use265, _use266, _use267, _use268, _use269, _use270, _use271, _use272, _use273, _use274, _use275, _use276, _use277, _use278, _use279, _use280, _use281, _use282, _use283, _use284, _use285, _use286, _use287, _use288, _use289, _use290, _use291, _use292, _use293, _use294, _use295, _use296, _use297, _use298, _use299, _use300, _use301, _use302, _use303, _use304, _use305, _use306, _use307, _use308, _use309, _use310, _use311, _use312, _use313, _use314, _use315, _use316, _use317, _use318, _use319, _use320, _use321, _use322, _use323, _use324, _use325, _use326, _use327, _use328, _use329, _use330, _use331, _use332, _use333, _use334, _use335, _use336, _use337, _use338, _use339, _use340, _use341, _use342, _use343, _use344, _use345, _use346, _use347, _use348, _use349, _use350, _use351, _use352, _use353, _use354, _use355, _use356, _use357, _use358, _use359, _use360, _use361, _use362, _use363, _use364, _use365, _use366, _use367, _use368, _use369, _use370, _use371, _use372, _use373, _use374, _use375, _use376, _use377, _use378, _use379, _use380, _use381, _use382, _use383, _use384, _use385, _use386, _use387, _use388, _use389, _use390, _use391, _use392, _use393, _use394, _use395, _use396, _use397, _use398, _use399, _use400, _use401, _use402, _use403, _use404, _use405, _use406, _use407, _use408, _use409, _use410, _use411, _use412, _use413, _use414, _use415, _use416, _use417, _use418, _use419, _use420, _use421, _use422, _use423, _use424, _use425, _use426, _use427, _use428, _use429, _use430, _use431, _use432, _use433, _use434, _use435, _use436, _use437, _use438, _use439, _use440, _use441, _use442, _use443, _use444, _use445, _use446, _use447, _use448, _use449, _use450, _use451, _use452, _use453, _use454, _use455, _use456, _use457, _use458, _use459, _use460, _use461, _use462, _use463, _use464, _use465, _use466, _use467, _use468, _use469, _use470, _use471, _use472, _use473, _use474, _use475, _use476, _use477, _use478, _use479, _use480, _use481, _use482, _use483, _use484, _use485, _use486, _use487, _use488, _use489, _use490, _use491, _use492, _use493, _use494, _use495, _use496, _use497, _use498, _use499, _use500, _use501, _use502, _use503, _use504, _use505, _use506, _use507, _use508, _use509, _use510, _use511, _use512, _use513, _use514, _use515, _use516;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSprite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sprite_svg__bumeran-icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-add-circle"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 13h-2v2c0 .55-.45 1-1 1s-1-.45-1-1v-2H9c-.55 0-1-.45-1-1s.45-1 1-1h2V9c0-.55.45-1 1-1s1 .45 1 1v2h2c.55 0 1 .45 1 1s-.45 1-1 1zM12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-add-square"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 13h-2v2c0 .55-.45 1-1 1s-1-.45-1-1v-2H9c-.55 0-1-.45-1-1s.45-1 1-1h2V9c0-.55.45-1 1-1s1 .45 1 1v2h2c.55 0 1 .45 1 1s-.45 1-1 1zm3-10H6C4.346 3 3 4.346 3 6v12c0 1.654 1.346 3 3 3h12c1.654 0 3-1.346 3-3V6c0-1.654-1.346-3-3-3z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-alert-circle"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 13a1 1 0 01-2 0V8a1 1 0 012 0v5zm-1 4a1 1 0 110-2 1 1 0 010 2zm0-15C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-alert-triangle"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 13a1 1 0 01-2 0V9a1 1 0 012 0v4zm-1 4a1 1 0 110-2 1 1 0 010 2zm10.561-.697L14.89 3.584C14.29 2.592 13.21 2 12 2c-1.21 0-2.29.592-2.889 1.584L1.44 16.303a2.976 2.976 0 00-.045 3.033C1.974 20.363 3.098 21 4.328 21h15.344c1.23 0 2.355-.637 2.934-1.664.54-.956.523-2.09-.045-3.033z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-archive"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 7H6c-.551 0-1-.449-1-1 0-.551.449-1 1-1h12a1.001 1.001 0 010 2zm-3 6.134c0 .476-.39.866-.866.866H9.866A.869.869 0 019 13.134v-.268c0-.476.39-.866.866-.866h4.268c.476 0 .866.39.866.866v.268zM18 3H6C4.346 3 3 4.346 3 6c0 .883.391 1.67 1 2.22V18c0 1.654 1.346 3 3 3h10c1.654 0 3-1.346 3-3V8.22c.609-.55 1-1.337 1-2.22 0-1.654-1.346-3-3-3z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-arrow-circle-down"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.69 13.861l-3 2.862c-.044.043-.1.064-.15.097-.054.036-.102.08-.162.104A1.007 1.007 0 0112 17a1.011 1.011 0 01-.708-.294l-3-2.999a.999.999 0 111.414-1.414L11 13.586V8a1 1 0 112 0v5.663l1.31-1.249a1 1 0 111.38 1.447zM12 2.001C6.486 2 2 6.485 2 12c0 5.513 4.485 10 10 10s10-4.487 10-10c0-5.515-4.485-10-10-10z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-arrow-circle-left"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.139 15.69l-2.862-3c-.043-.044-.064-.1-.097-.15-.036-.054-.08-.102-.104-.162A1.007 1.007 0 017 12a1.011 1.011 0 01.294-.708l2.999-3a.999.999 0 111.414 1.414L10.414 11H16a1 1 0 110 2h-5.663l1.249 1.31a1 1 0 11-1.447 1.38zM21.999 12c0-5.515-4.485-10-10-10C6.487 2 2 6.485 2 12s4.487 10 10 10c5.515 0 10-4.485 10-10z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-arrow-circle-right"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.861 8.31l2.862 3c.043.044.064.1.097.15.036.054.08.102.104.162.05.121.076.25.076.377a1.011 1.011 0 01-.294.708l-2.999 3a.999.999 0 11-1.414-1.415L13.586 13H8a1 1 0 110-2h5.663L12.414 9.69a1 1 0 111.447-1.38zM2.001 12c0 5.515 4.485 10 10 10 5.513 0 10-4.485 10-10 0-5.514-4.487-10-10-10C6.485 2 2 6.486 2 12z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-arrow-circle-up"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.31 10.139l3-2.862c.044-.043.1-.064.15-.097.054-.036.102-.08.162-.104.121-.05.25-.076.377-.076a1.011 1.011 0 01.708.294l3 2.999a.999.999 0 11-1.415 1.414L13 10.414V16a1 1 0 11-2 0v-5.663l-1.308 1.249a1 1 0 11-1.381-1.447zM12 21.999c5.515 0 10-4.485 10-10 0-5.513-4.485-10-10-10C6.485 2 2 6.487 2 12c0 5.515 4.486 10 10 10z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-arrow-triangle-down"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 17c-.506 0-.99-.233-1.326-.642L6.461 11.26a2.085 2.085 0 01-.259-2.211C6.507 8.402 7.114 8 7.787 8h8.426c.673 0 1.28.402 1.585 1.049.346.733.245 1.6-.258 2.21l-4.214 5.099c-.336.409-.82.642-1.326.642z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-arrow-triangle-left"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.544 18.001c-.471 0-.935-.157-1.303-.461l-5.1-4.214A1.722 1.722 0 016.5 12c0-.506.234-.99.64-1.326l5.1-4.213c.609-.504 1.476-.605 2.21-.26.648.306 1.05.913 1.05 1.586v8.426c0 .673-.402 1.28-1.05 1.586a2.127 2.127 0 01-.906.202z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-arrow-triangle-right"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.956 18.003c-.307 0-.617-.066-.906-.202-.648-.306-1.05-.913-1.05-1.586V7.789c0-.673.402-1.28 1.05-1.586a2.086 2.086 0 012.209.259l5.099 4.214c.409.336.642.82.642 1.326 0 .506-.233.99-.642 1.326l-5.099 4.213a2.04 2.04 0 01-1.303.462z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-arrow-triangle-up"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.213 16H7.787c-.673 0-1.28-.402-1.585-1.049a2.087 2.087 0 01.258-2.21l4.214-5.099c.672-.817 1.98-.817 2.652 0l4.213 5.098c.504.611.605 1.478.259 2.211-.305.647-.912 1.049-1.585 1.049z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-at"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.182 15.09A3.095 3.095 0 018.09 12a3.095 3.095 0 013.09-3.091 3.095 3.095 0 013.092 3.09 3.095 3.095 0 01-3.091 3.092zm1.773-13.046a9.988 9.988 0 00-8.05 2.909 10 10 0 00-2.854 8.073c.358 3.572 2.609 6.682 5.876 8.115 1.307.573 2.693.854 4.069.854 2.168 0 4.313-.7 6.084-2.055a1 1 0 10-1.216-1.588c-2.318 1.775-5.434 2.139-8.134.957-2.568-1.126-4.407-3.67-4.69-6.483a8.007 8.007 0 018.73-8.79C16.825 4.413 20 8.01 20 12.225v.675c0 .468-.186.904-.525 1.228-.338.324-.786.49-1.253.47-.894-.04-1.622-.88-1.622-1.874V8.4a1 1 0 00-1-1 .987.987 0 00-.975.875 5.056 5.056 0 00-3.443-1.366 5.098 5.098 0 00-5.091 5.09 5.097 5.097 0 005.09 5.092c1.7 0 3.2-.846 4.125-2.13.645.94 1.668 1.584 2.828 1.635a3.646 3.646 0 002.724-1.023A3.666 3.666 0 0022 12.9v-.675c0-5.237-3.972-9.708-9.045-10.181z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-award"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4c2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.794-4-4 1.794-4 4-4zm6.97 16.751l-2.31-8.979A5.972 5.972 0 0018 8c0-3.309-2.69-6-6-6-3.309 0-6 2.691-6 6 0 1.429.504 2.74 1.34 3.772l-2.309 8.979a1 1 0 001.475 1.111l5.33-3.129 5.68 3.142a.995.995 0 001.096-.084 1 1 0 00.357-1.04z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-backspace"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.707 13.293a.999.999 0 11-1.414 1.414L14 13.414l-1.293 1.293a.997.997 0 01-1.414 0 .999.999 0 010-1.414L12.586 12l-1.293-1.293a.999.999 0 111.414-1.414L14 10.586l1.293-1.293a.999.999 0 111.414 1.414L15.414 12l1.293 1.293zM20.141 4h-9.77a2.99 2.99 0 00-2.019.781.87.87 0 00-.106.113l-6.024 7.479a1 1 0 00.105 1.367l6.025 5.479A2.99 2.99 0 0010.37 20h9.771c1.025 0 1.86-.815 1.86-1.818V5.818C22 4.815 21.165 4 20.14 4z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-battery-charging"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.277 13H7a1.001 1.001 0 01-.868-1.496L9.277 6h-5.11C2.972 6 2 7.089 2 8.429v7.142C2 16.911 2.972 18 4.167 18H8.42l2.857-5zm4.557-7H11.58l-2.858 5H13a.999.999 0 01.868 1.496L10.723 18h5.11C17.03 18 18 16.911 18 15.571V8.429C18 7.089 17.03 6 15.834 6zM20 10a1 1 0 012 0v4a1 1 0 01-2 0v-4z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-battery-full"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.166 6h11.668C17.029 6 18 7.089 18 8.429v7.142C18 16.911 17.03 18 15.834 18H4.166C2.971 18 2 16.911 2 15.571V8.429C2 7.089 2.971 6 4.166 6zM20 10a1 1 0 012 0v4a1 1 0 01-2 0v-4z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-behance"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.405 9.67c.605 0 .96.324.96.852 0 .566-.384.886-1.252.886H8.26V9.67h1.145zm5.36 1.518c-.626 0-1.038.478-1.038 1.096v.01h2.06v-.01c0-.623-.401-1.096-1.022-1.096zm-5.278 1.116H8.26v1.934h.959c1.02 0 1.438-.325 1.438-.944 0-.614-.413-.99-1.17-.99zm7.538.75h-3.298v.132c0 .732.44 1.196 1.09 1.196.51 0 .869-.236.976-.628h1.184c-.121.774-.791 1.543-2.17 1.543-1.41 0-2.332-.828-2.332-2.306v-.442c0-1.415.926-2.252 2.28-2.252 1.402 0 2.27.896 2.27 2.283v.474zM13.25 9.703h3v-.5h-3v.5zm-3.552 5.5H6.975v-6.5h2.728c1.17 0 1.937.606 1.937 1.6 0 .79-.475 1.268-1.122 1.425v.056c.786.077 1.457.61 1.457 1.586 0 1.163-.95 1.833-2.277 1.833zM12 2C6.477 2 2 6.478 2 12c0 5.523 4.477 10 10 10s10-4.477 10-10c0-5.522-4.477-10-10-10z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-book"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 19c-.551 0-1-.449-1-1 0-.551.449-1 1-1h11v2H7zM19 3H7C5.346 3 4 4.346 4 6v12c0 1.654 1.346 3 3 3h12a1 1 0 001-1V4a1 1 0 00-1-1z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-book-open"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.939 4.111a1.242 1.242 0 011.079.225c.307.239.482.599.482.986v11.686c0 .571-.385 1.069-.938 1.211L13 20.16V5.894l6.939-1.783zm-15.881 0L11 5.894V20.16l-7.562-1.942a1.248 1.248 0 01-.938-1.211V5.323A1.247 1.247 0 014.058 4.11z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-bookmark"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 21a1 1 0 01-1-1V5.333C5 4.047 5.987 3 7.2 3h9.6C18.013 3 19 4.047 19 5.333V20a1.001 1.001 0 01-1.492.871l-5.672-3.208-5.321 3.194A1.004 1.004 0 016 21z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-briefcase"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 5.5a.5.5 0 01.5-.5h3a.5.5 0 01.5.5V7h-4V5.5zM7 21h10V7h-1V5.5C16 4.122 14.878 3 13.5 3h-3A2.503 2.503 0 008 5.5V7H7v14zM19 7v14c1.654 0 3-1.346 3-3v-8c0-1.654-1.346-3-3-3zM2 10c0-1.654 1.346-3 3-3v14c-1.654 0-3-1.346-3-3v-8z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-browser"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 18.035c0 .552-.449 1-1 1H6c-.551 0-1-.448-1-1v-7h14v7zm-11-12a1 1 0 110 2 1 1 0 010-2zm4 0a1 1 0 110 2 1 1 0 010-2zm6-3H6c-1.654 0-3 1.346-3 3v12c0 1.654 1.346 3 3 3h12c1.654 0 3-1.346 3-3v-12c0-1.654-1.346-3-3-3z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-brush"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.376 4.668c.777-.777 2.047-.915 2.886-.207.493.417.746 1.002.738 1.596a2.033 2.033 0 01-.602 1.47l-6.485 6.49a.47.47 0 01-.665 0l-2.273-2.274a.472.472 0 010-.667l6.4-6.408zM4.054 16.414c.032-1.836 1.275-3.496 3.07-3.866 2.923-.603 5.338 2.194 4.043 5.19-.584 1.35-1.97 2.177-3.44 2.203h-.002L4.48 20A.471.471 0 014 19.52l.054-3.106z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-bulb"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 5a1 1 0 11-2 0V3a1 1 0 112 0v2zm-6 7c0-2.757 2.243-5 5-5s5 2.243 5 5a5.007 5.007 0 01-2 3.996V20c0 1.103-.897 2-2 2h-2c-1.103 0-2-.897-2-2v-4.004A5.005 5.005 0 017 12zm14-1h-2a1 1 0 100 2h2a1 1 0 100-2zM3 11h2a1 1 0 110 2H3a1 1 0 110-2zm4.66-4.582l-1.44-1.39a1 1 0 00-1.39 1.44l1.44 1.389a.997.997 0 001.414-.025 1 1 0 00-.024-1.414zM17.78 5.03a1 1 0 011.388 1.437l-1.439 1.39a.996.996 0 01-1.413-.025.999.999 0 01.024-1.413l1.44-1.39z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-calendar"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 11H5V7c0-.551.449-1 1-1h1v1c0 .55.45 1 1 1s1-.45 1-1V6h6v1c0 .55.45 1 1 1s1-.45 1-1V6h1c.551 0 1 .449 1 1v4zm-3 6h-4c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1zm-8 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM18 4h-1V3c0-.55-.45-1-1-1s-1 .45-1 1v1H9V3c0-.55-.45-1-1-1s-1 .45-1 1v1H6C4.346 4 3 5.346 3 7v12c0 1.654 1.346 3 3 3h12c1.654 0 3-1.346 3-3V7c0-1.654-1.346-3-3-3z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-camera"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12.5c-.827 0-1.5.673-1.5 1.5s.673 1.5 1.5 1.5 1.5-.673 1.5-1.5-.673-1.5-1.5-1.5zm0 5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5zm-2-12a.5.5 0 01.5-.5h3a.5.5 0 01.5.5V7h-4V5.5zM19 7h-3V5.5C16 4.122 14.879 3 13.5 3h-3A2.503 2.503 0 008 5.5V7H5c-1.654 0-3 1.346-3 3v8c0 1.654 1.346 3 3 3h14c1.654 0 3-1.346 3-3v-8c0-1.654-1.346-3-3-3z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-car"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.98 18a1 1 0 11-2.001 0 1 1 0 012 0zm-12 0a1 1 0 11-2.001 0 1 1 0 012 0zm13-5.52V15h-3v-4.919l3 2.4zm1.624-1.261l-4.625-3.7V5c0-1.103-.813-2-1.813-2H3.791c-.999 0-1.812.897-1.812 2v10c0 .873.513 1.609 1.221 1.882-.14.346-.22.722-.22 1.118 0 1.654 1.345 3 3 3 1.653 0 3-1.346 3-3 0-.353-.073-.686-.186-1h6.37a2.938 2.938 0 00-.185 1c0 1.654 1.346 3 3 3s3-1.346 3-3c0-.353-.072-.686-.185-1h.185a1 1 0 001-1v-4a1 1 0 00-.375-.781z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-chat-bouble-circle"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 13a1 1 0 110-2.001 1 1 0 010 2zm-4 0a1 1 0 110-2.001 1 1 0 010 2zm-4 0a1 1 0 110-2.001 1 1 0 010 2zm11.07-8.072c-2.283-2.284-5.444-3.303-8.673-2.804-4.077.636-7.457 3.92-8.22 7.987a10.016 10.016 0 00.61 5.765c.099.23.129.446.09.64l-.857 4.287a.999.999 0 001.176 1.176l4.283-.856c.246-.047.485.022.644.088 1.814.767 3.808.977 5.765.611 4.067-.763 7.35-4.143 7.987-8.22.503-3.228-.52-6.389-2.804-8.674z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-chat-bouble-square"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 12a1 1 0 110-2 1 1 0 010 2zm-4 0a1 1 0 110-2 1 1 0 010 2zm-4 0a1 1 0 110-2 1 1 0 010 2zm11-9H5C3.346 3 2 4.346 2 6v15a1 1 0 001.515.857l4.524-2.714A.997.997 0 018.554 19H19c1.654 0 3-1.346 3-3V6c0-1.654-1.346-3-3-3z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-checkmark-active"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.295 9.605l-4.568 6a1 1 0 01-.789.395h-.007c-.307 0-.597-.142-.787-.384L7.712 12.51a1 1 0 111.575-1.232l1.633 2.086 3.784-4.969a1 1 0 011.591 1.211zM18 3H6C4.345 3 3 4.345 3 6v12c0 1.654 1.345 3 3 3h12c1.654 0 3-1.346 3-3V6c0-1.655-1.346-3-3-3z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-checkmark-circle"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.296 9.605l-4.569 6a1 1 0 01-.789.395h-.007c-.306 0-.596-.142-.786-.384L7.712 12.51a1 1 0 111.575-1.232l1.633 2.086 3.784-4.969a1 1 0 011.591 1.211zM12 2C6.477 2 2 6.477 2 12s4.476 10 10 10c5.522 0 10-4.477 10-10S17.523 2 12 2z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-checkmark-circle-1"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.258 8.976c.07-.08.135-.163.195-.248A9.985 9.985 0 0122 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2c2.323 0 4.46.792 6.158 2.12a2.986 2.986 0 00-1.416.905l-4.888 5.586-.733-.732A3 3 0 106.88 14.12l2.992 2.993a3.01 3.01 0 004.394-.146l6.993-7.992zM8.293 11.293a.999.999 0 011.414 0l2.244 2.244 6.297-7.196a1 1 0 011.504 1.318l-7 8a1.002 1.002 0 01-.719.34H12a1 1 0 01-.707-.292l-3-3a.999.999 0 010-1.414z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-clipboard"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 8h8a1 1 0 001-1V3a1 1 0 00-1-1H8a1 1 0 00-1 1v4a1 1 0 001 1zm10-1V4c1.654 0 3 1.346 3 3v12c0 1.654-1.346 3-3 3H6c-1.654 0-3-1.346-3-3V7c0-1.654 1.346-3 3-3v3c0 1.103.897 2 2 2h8c1.103 0 2-.897 2-2z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-clock"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 13h-4a1 1 0 01-1-1V8a1 1 0 112 0v3h3a1 1 0 110 2zM12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-close-circle"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.707 13.293a.999.999 0 11-1.414 1.414L12 13.414l-1.293 1.293a.997.997 0 01-1.414 0 .999.999 0 010-1.414L10.586 12l-1.293-1.293a.999.999 0 111.414-1.414L12 10.586l1.293-1.293a.999.999 0 111.414 1.414L13.414 12l1.293 1.293zM12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-close-square"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.707 13.293a.999.999 0 11-1.414 1.414L12 13.414l-1.293 1.293a.997.997 0 01-1.414 0 .999.999 0 010-1.414L10.586 12l-1.293-1.293a.999.999 0 111.414-1.414L12 10.586l1.293-1.293a.999.999 0 111.414 1.414L13.414 12l1.293 1.293zM18 3H6C4.346 3 3 4.346 3 6v12c0 1.654 1.346 3 3 3h12c1.654 0 3-1.346 3-3V6c0-1.654-1.346-3-3-3z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-color-palette"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.75 7.799a1.5 1.5 0 11-1.5-2.6 1.5 1.5 0 011.5 2.6zm-5.75-.8A1.5 1.5 0 1111 4a1.5 1.5 0 01-.001 3zM8.299 9.25a1.5 1.5 0 11-2.598-1.5 1.5 1.5 0 012.598 1.5zm-1.46 5.494a1.498 1.498 0 11-1.678-2.486 1.5 1.5 0 111.678 2.486zM19.54 5.085C17.617 3.1 14.814 1.993 11.906 2h-.001c-4.944.042-9.164 3.752-9.813 8.63-.382 2.86.47 5.742 2.338 7.904A10.006 10.006 0 0011.861 22h.037c1.201 0 2.259-.787 2.528-1.886a2.514 2.514 0 00-.568-2.288.497.497 0 01-.128-.325c0-.275.225-.5.5-.5h1.651c3.192 0 5.991-2.598 6.112-5.672.092-2.3-.779-4.517-2.453-6.244z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-color-picker"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.366 14.94l5.58-5.58 2.695 2.696-2.79 2.796m7.551-7.515l-2.739-2.74c-.768-.767-1.986-.795-2.715-.067l-2.003 2.002-1.238-1.238a.999.999 0 10-1.414 1.414l1.238 1.238-5.579 5.58a1.977 1.977 0 00-.569 1.213l-.379 4.17a1 1 0 001.087 1.088l4.17-.38a1.97 1.97 0 001.213-.57l5.58-5.579 1.24 1.24a.997.997 0 001.413 0 1 1 0 000-1.415l-1.238-1.238 2.001-2.003c.73-.73.7-1.947-.068-2.715z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-compass"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.797 13.213l1.692-.684.714-1.742-1.692.684-.714 1.742zm5.128-3.793l-1.746 4.258c-.102.25-.3.447-.55.549l-4.213 1.701a1.01 1.01 0 01-.374.072.998.998 0 01-.713-.31c-.018-.017-.037-.031-.054-.048-.009-.011-.015-.024-.023-.035a.991.991 0 01-.178-1.027l1.746-4.258a.998.998 0 01.551-.548l4.213-1.702a1.003 1.003 0 011.1.246.996.996 0 01.241 1.102zM12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-copy"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 12v1H5.667A.667.667 0 015 12.333V5.667C5 5.299 5.299 5 5.667 5h6.666c.368 0 .667.299.667.667V9h-1c-1.654 0-3 1.346-3 3zm9-3h-3V5.667A2.67 2.67 0 0012.333 3H5.667A2.67 2.67 0 003 5.667v6.666A2.67 2.67 0 005.667 15H9v3c0 1.654 1.346 3 3 3h6c1.654 0 3-1.346 3-3v-6c0-1.654-1.346-3-3-3z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-credit-card"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 9H4V8c0-.551.448-1 1-1h14c.552 0 1 .449 1 1v1zm-3 6h-2c-.55 0-1-.45-1-1s.45-1 1-1h2c.55 0 1 .45 1 1s-.45 1-1 1zm-6 0H7c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1zm8-10H5C3.346 5 2 6.346 2 8v8c0 1.654 1.346 3 3 3h14c1.654 0 3-1.346 3-3V8c0-1.654-1.346-3-3-3z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-cube"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 10.503l8.512-3.578a1.751 1.751 0 00-.511-.375l-7.2-3.374a1.908 1.908 0 00-1.602 0l-7.2 3.374c-.2.093-.365.226-.511.375L12 10.503zm-.75 1.324L3 8.36v7.73c-.005.64.379 1.228.99 1.517l7.2 3.373c.01.005.02.008.03.01l.03.011v-9.173zm1.5 9.17v-9.17L21 8.36v7.738c0 .64-.387 1.224-.999 1.51l-7.2 3.372a.167.167 0 01-.028.01l-.023.008z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-download"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.846 10.827c.021.068.043.136.057.207.062.313.097.635.097.966 0 .308-.036.611-.092.91-.013.068-.03.134-.046.2l-.022.088a5.145 5.145 0 01-.303.877c-.087.19-.188.372-.3.551l-.05.084a2.036 2.036 0 01-.085.14c-.01.012-.017.026-.025.039a.473.473 0 01-.026.042.1.1 0 01-.03.025.114.114 0 00-.023.02C20.086 16.196 18.642 17 17 17h-.012A1.98 1.98 0 0015 15.103c-.356 0-.7.093-1 .268v-3.37c0-1.104-.897-2-2-2-1.102 0-2 .896-2 2v3.265a2 2 0 00-2.414.32C7.196 15.976 7 16.488 7 17H7c-1.642 0-3.086-.803-3.997-2.025-.007-.007-.016-.013-.024-.018-.011-.007-.022-.014-.03-.026a.444.444 0 01-.028-.045l-.022-.037a2.197 2.197 0 01-.089-.142l-.048-.08a5.15 5.15 0 01-.3-.552 5.567 5.567 0 01-.116-.282l-.004-.01a5.14 5.14 0 01-.2-.66 2.89 2.89 0 01-.05-.213A5.023 5.023 0 012 12c0-.33.036-.653.097-.966a2.01 2.01 0 01.059-.213l.037-.122.012-.046c.048-.176.096-.351.163-.518.036-.09.08-.175.125-.26a6.38 6.38 0 00.058-.112l.019-.038c.07-.14.14-.278.224-.409.064-.1.136-.194.208-.287l.052-.067.003-.004c.097-.125.193-.248.3-.364.097-.104.2-.197.306-.292l.018-.016a4.509 4.509 0 01.734-.546 4.72 4.72 0 01.43-.234 4.632 4.632 0 01.896-.326 4.22 4.22 0 01.407-.094c.026-.005.052-.012.077-.019a.747.747 0 01.1-.022A6.02 6.02 0 0112 3a6.018 6.018 0 015.675 4.045c.034.005.067.014.1.022a.97.97 0 00.078.02 4.2 4.2 0 01.406.093 4.656 4.656 0 011.326.56c.127.076.25.156.369.244.127.094.247.196.365.302.112.1.22.198.324.308a5.058 5.058 0 01.34.417c.078.1.155.198.224.305.083.13.152.268.222.407l.02.04.057.112c.045.085.09.17.126.26.068.167.116.344.164.52l.012.044c.011.043.025.086.038.128zM13 17.644l1.305-1.26a1 1 0 011.39 1.439l-3 2.897a1.005 1.005 0 01-1.402-.013l-3-3a.999.999 0 111.414-1.414L11 17.586V12a1 1 0 112 0v5.644z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-droplet-off"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.969 16.14c1.033-2.709.499-5.905-1.627-8.107l-4.56-4.727a1.006 1.006 0 00-.71-.306 1.004 1.004 0 00-.717.295l-2.611 2.62 10.225 10.226zM5.988 8.816c-2.176 2.961-1.974 7.185.647 9.9A7.393 7.393 0 0011.925 21h.002a7.36 7.36 0 004.646-1.599L5.988 8.816zM4.707 3.293l16 16a.999.999 0 11-1.414 1.414l-16-16a.999.999 0 111.414-1.414z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-droplet-on"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1 20.4a6.826 6.826 0 01-4.883-2.108c-2.667-2.762-2.631-7.221.08-9.942l4.278-4.293a.92.92 0 011.318.01L17.1 8.43c2.667 2.763 2.63 7.223-.081 9.941a6.82 6.82 0 01-4.918 2.03H12.1z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-edit"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.019 10.679l-2.695-2.695 1.948-1.95 2.694 2.695-1.947 1.95zm3.385-3.341l-.001-.001-2.738-2.738c-.741-.74-2.014-.774-2.716-.07l-8.996 8.997a1.973 1.973 0 00-.57 1.214l-.38 4.17a1.002 1.002 0 001.088 1.086l4.17-.38a1.974 1.974 0 001.214-.567l8.997-8.997c.728-.73.697-1.948-.068-2.714z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-edit-2"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.965 6.729l-2.694-2.694-1.948 1.949 2.695 2.695 1.947-1.95zM5.09 17.996a1 1 0 01-1.087-1.086l.38-4.17c.042-.457.244-.89.57-1.214l8.995-8.996c.702-.705 1.976-.67 2.716.069l2.738 2.738h.002c.765.767.796 1.985.067 2.715l-8.996 8.997a1.975 1.975 0 01-1.214.569l-4.17.378zM5 20h14c.55 0 1 .45 1 1s-.45 1-1 1H5c-.55 0-1-.45-1-1s.45-1 1-1z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-eye"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 10.5c-.827 0-1.5.673-1.5 1.5s.673 1.5 1.5 1.5 1.5-.673 1.5-1.5-.673-1.5-1.5-1.5zm0 5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5zm9.868-3.998c-.639-1.112-4.162-6.686-10.139-6.5-5.527.142-8.743 5.012-9.597 6.5a1.005 1.005 0 000 .996C2.762 13.595 6.162 19 12.025 19l.246-.003c5.527-.141 8.743-5.011 9.597-6.5a1.005 1.005 0 000-.995z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-eye-off"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.407 17.993l1.3 1.3a.999.999 0 11-1.414 1.414L16.586 18 16 17.414l-1.345-1.345-.069-.069-2.502-2.502a1.502 1.502 0 01-1.581-1.581l-3.22-3.22-1.751-1.751-2.239-2.239a.999.999 0 111.414-1.414L6.42 5.006l1.465 1.465 4.031 4.031L12 10.5a1.502 1.502 0 011.498 1.584L17.414 16l1.993 1.993zM8.593 5.764l2.797 2.797c.199-.035.4-.06.61-.06 1.93 0 3.5 1.57 3.5 3.5 0 .208-.026.41-.061.61l2.682 2.682.834.834a15.623 15.623 0 002.913-3.63 1.004 1.004 0 000-.995c-.638-1.112-4.162-6.686-10.138-6.499a9.361 9.361 0 00-3.228.671l.09.09zm5.355 11.013l1.345 1.344.205.205a9.332 9.332 0 01-3.473.674c-5.863 0-9.263-5.405-9.893-6.503a1.004 1.004 0 010-.995 15.644 15.644 0 012.913-3.629l1.531 1.532 1.986 1.985A3.41 3.41 0 008.5 12c0 1.93 1.57 3.5 3.5 3.5.209 0 .411-.026.61-.062l1.269 1.269.069.07z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-facebook"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 3.5a.5.5 0 00-.5-.5H14c-2.762 0-5 2.015-5 4.5v2.7H6.5a.5.5 0 00-.5.5v2.6a.5.5 0 00.5.5H9v6.7a.5.5 0 00.5.5h3a.5.5 0 00.5-.5v-6.7h2.619c.225 0 .422-.15.483-.366l.721-2.6a.5.5 0 00-.481-.634H13V7.5c0-.497.447-.9 1-.9h2.5a.5.5 0 00.5-.5V3.5z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-fast-forward"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.858 10.674L15.76 6.46a2.091 2.091 0 00-2.21-.26c-.646.307-1.048.914-1.048 1.587v2.59L7.759 6.46a2.091 2.091 0 00-2.21-.26c-.647.307-1.049.914-1.049 1.587v8.426c0 .673.402 1.28 1.05 1.586.288.136.6.202.905.202.471 0 .935-.157 1.304-.462l4.742-3.916v2.59c0 .673.402 1.28 1.049 1.586.288.136.6.202.905.202.472 0 .935-.157 1.304-.462l5.1-4.213c.407-.336.641-.82.641-1.326 0-.506-.233-.99-.642-1.326z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-file"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 3.978L17.742 8h-3.028C14.32 8 14 7.619 14 7.15V3.978zm5.741 3.35l-4.445-5a.998.998 0 00-.74-.328h-8C5.146 2 4 3.122 4 4.5v15C4 20.878 5.146 22 6.556 22h10.888C18.854 22 20 20.878 20 19.5V8a.998.998 0 00-.259-.672z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-file-2"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.714 8C14.32 8 14 7.619 14 7.15V3.978L17.742 8h-3.028zM15 18H9a1 1 0 010-2h6a1 1 0 110 2zm-6-6h3a1 1 0 010 2H9a1 1 0 010-2zm10.74-4.672l-4.444-5a.998.998 0 00-.74-.328h-8C5.146 2 4 3.122 4 4.5v15C4 20.878 5.147 22 6.556 22h10.888C18.854 22 20 20.878 20 19.5V8a1 1 0 00-.26-.672z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-file-add"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.714 8C14.32 8 14 7.619 14 7.15V3.978L17.742 8h-3.028zM14 15h-1v1a1 1 0 11-2 0v-1h-1a1 1 0 110-2h1v-1a1 1 0 112 0v1h1a1 1 0 110 2zm5.74-7.672l-4.444-5a.998.998 0 00-.74-.328h-8C5.146 2 4 3.122 4 4.5v15C4 20.878 5.147 22 6.556 22h10.888C18.854 22 20 20.878 20 19.5V8a1 1 0 00-.26-.672z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-file-remove"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.714 8C14.32 8 14 7.619 14 7.15V3.978L17.742 8h-3.028zM14 15h-4a1 1 0 110-2h4a1 1 0 110 2zm5.74-7.672l-4.444-5a.998.998 0 00-.74-.328h-8C5.146 2 4 3.122 4 4.5v15C4 20.878 5.147 22 6.556 22h10.888C18.854 22 20 20.878 20 19.5V8a1 1 0 00-.26-.672z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-film"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 18.256c0 .41-.334.744-.744.744H17v-2h2v1.256zm-14 0V17h2v2H5.744A.745.745 0 015 18.256zM5.744 5H7v2H5V5.744c0-.41.334-.744.744-.744zM19 5.744V7h-2V5h1.256c.41 0 .744.334.744.744zM17 15h2v-2h-2v2zm0-4h2V9h-2v2zM5 15h2v-2H5v2zm0-4h2V9H5v2zm13.256-8H5.744A2.748 2.748 0 003 5.744v12.512A2.747 2.747 0 005.744 21h12.512A2.747 2.747 0 0021 18.256V5.744A2.748 2.748 0 0018.256 3z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-fire"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.959 18.023a3.545 3.545 0 01-2.488.977h-.001A3.538 3.538 0 019 17.985a3.316 3.316 0 01.041-4.787l2.163-2.068a.478.478 0 01.335-.13.478.478 0 01.332.136l2.129 2.1a3.318 3.318 0 01-.041 4.787zm2.847-10.037l-4.593-4.69a1.014 1.014 0 00-1.415-.016 1.002 1.002 0 00-.309.788c.009.14.009.278.009.426 0 2.557-.643 4.07-.998 4.443-.151-.166-.425-.602-.656-1.493a1 1 0 00-1.679-.453l-.984.993c-2.911 2.967-2.907 7.801.008 10.772A7.372 7.372 0 0011.492 21h.008a7.393 7.393 0 005.315-2.243c2.917-2.972 2.912-7.806-.009-10.77z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-flag"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.268 4.68a1.79 1.79 0 00-1.6-.253c-.575.188-1.325.287-2.168.287-1.124 0-2.1-.383-3.134-.788C11.204 3.47 10 3 8.5 3c-2.886 0-4.004.952-4.2 1.144a1 1 0 00-.3.714V20a1 1 0 102 0v-4.298c.395-.175 1.173-.416 2.5-.416 1.124 0 2.1.383 3.135.789 1.162.455 2.364.925 3.865.925 1.809 0 2.923-.378 3.54-.695.593-.307.96-.902.96-1.556V6.106c0-.56-.273-1.093-.732-1.426z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-flash"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.111 23a1 1 0 01-.994-1.107l.768-7.093H5a1 1 0 01-.83-1.556l7.887-11.8c.256-.383.74-.542 1.173-.383a.997.997 0 01.652 1.046L13.114 9.2H19a1 1 0 01.831 1.556l-7.889 11.8a.998.998 0 01-.83.444z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-flash-off"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.328 14.5l2.503-3.744a1 1 0 00-.83-1.556h-5.887l.77-7.093a1 1 0 00-1.827-.663L8.938 6.11l8.39 8.39zm-10.656-5l-2.503 3.744a1 1 0 00.83 1.556h5.887l-.77 7.093a1 1 0 001.827.663l3.119-4.666-8.39-8.39zM4.707 3.293l16 16a.999.999 0 11-1.414 1.414l-16-16a.999.999 0 111.414-1.414z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-folder"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 20.5h-15c-1.378 0-2.5-1.091-2.5-2.432V5.932C2 4.591 3.122 3.5 4.5 3.5h4.601c.299 0 .584.135.774.367l2.599 3.179H19.5c1.378 0 2.5 1.091 2.5 2.432v8.59c0 1.341-1.122 2.432-2.5 2.432z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-folder-add"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 15h-1v1c0 .55-.45 1-1 1s-1-.45-1-1v-1h-1c-.55 0-1-.45-1-1s.45-1 1-1h1v-1c0-.55.45-1 1-1s1 .45 1 1v1h1c.55 0 1 .45 1 1s-.45 1-1 1zm5.5-7.954h-7.026L9.875 3.867a1.002 1.002 0 00-.774-.367H4.5C3.122 3.5 2 4.591 2 5.932v12.136C2 19.409 3.122 20.5 4.5 20.5h15c1.378 0 2.5-1.091 2.5-2.432v-8.59c0-1.341-1.122-2.432-2.5-2.432z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-folder-minus"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 15h-4c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1zm5.5-7.954h-7.026L9.875 3.867a1.002 1.002 0 00-.774-.367H4.5C3.122 3.5 2 4.591 2 5.932v12.136C2 19.409 3.122 20.5 4.5 20.5h15c1.378 0 2.5-1.091 2.5-2.432v-8.59c0-1.341-1.122-2.432-2.5-2.432z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-funnel"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.903 22a.992.992 0 01-.603-.203l-4.026-3.045a1 1 0 01-.397-.797v-3.274L4.111 5.459A.999.999 0 015.001 4h14a1 1 0 01.88 1.475l-4.978 9.215V21a1.003 1.003 0 01-1 1z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-gift"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.443 21h-5.625v-5.728h6.545v4.819a.915.915 0 01-.92.909zm-13.806-.91v-4.817h6.545V21H5.557a.915.915 0 01-.92-.91zm15.463-13h-1.842c.179-.372.288-.785.288-1.227A2.867 2.867 0 0015.682 3C13.8 3 12.66 4.32 12 5.569c-.661-1.25-1.8-2.57-3.681-2.57a2.868 2.868 0 00-2.865 2.864c0 .442.11.855.289 1.228H3.9C3.404 7.09 3 7.677 3 8.4v3.926c0 .723.404 1.31.9 1.31h7.282V7.09h1.637v6.546H20.1c.497 0 .9-.587.9-1.31V8.4c0-.724-.403-1.31-.9-1.31zm-4.418 0H13.1c.386-1.015 1.18-2.453 2.58-2.453.678 0 1.229.55 1.229 1.226a1.23 1.23 0 01-1.228 1.228zm-7.363 0A1.23 1.23 0 017.09 5.864c0-.676.55-1.226 1.228-1.226 1.4 0 2.195 1.438 2.58 2.454H8.32z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-github"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1C5.925 1 1 5.82 1 11.767c0 4.755 3.152 8.791 7.523 10.214.55.099.75-.233.75-.519 0-.255-.008-.933-.013-1.83-3.06.65-3.705-1.444-3.705-1.444-.501-1.244-1.222-1.575-1.222-1.575-1-.668.076-.654.076-.654 1.104.076 1.684 1.109 1.684 1.109.98 1.646 2.574 1.17 3.202.895.1-.695.383-1.17.698-1.44-2.443-.271-5.011-1.195-5.011-5.32 0-1.175.429-2.136 1.133-2.889-.114-.272-.491-1.367.107-2.849 0 0 .924-.289 3.026 1.103A10.772 10.772 0 0112 6.206c.934.005 1.875.123 2.754.362 2.1-1.392 3.021-1.103 3.021-1.103.6 1.482.224 2.577.11 2.849.704.753 1.13 1.714 1.13 2.889 0 4.136-2.571 5.046-5.021 5.313.395.332.746.989.746 1.993 0 1.439-.014 2.6-.014 2.953 0 .288.198.623.756.518C19.85 20.554 23 16.521 23 11.767 23 5.82 18.075 1 12 1z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-globe-1"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.889 18.319c-.172-.433-.416-.811-.63-1.134-.108-.162-.22-.327-.316-.497-.39-.676-.255-.95.376-2.007l.102-.173c.51-.861.539-1.687.565-2.415.012-.358.024-.695.093-1.012.16-.732 1.708-.927 2.667-1.042.16.629.254 1.284.254 1.962a7.982 7.982 0 01-3.111 6.318zM11.999 4c.617 0 1.212.076 1.788.208-.17.372-.43.711-.774.98-.218.172-.463.315-.706.46-.651.388-1.388.828-1.85 1.674-.616 1.13-.616 2.284-.616 3.302 0 1.355-.044 2.156-.948 2.864-1.37 1.072-3.464.473-4.76-.072A8.071 8.071 0 014 12.002c0-4.412 3.589-8 8-8zm0-2C6.487 2 2 6.486 2 12s4.487 10 10 10c5.515 0 10-4.486 10-10S17.515 2 12 2z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-globe-2"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.962 15.8a8.31 8.31 0 002.026.273c1.08 0 2.183-.263 3.137-1.01 1.716-1.342 1.716-3.059 1.716-4.439 0-.891 0-1.661.372-2.344.2-.366.626-.62 1.119-.915.302-.18.614-.367.915-.602a4.598 4.598 0 001.417-1.866 8.028 8.028 0 013.325 3.222c-1.427.199-3.455.666-3.863 2.534-.108.494-.125.959-.14 1.37-.02.583-.036 1.044-.286 1.465l-.1.168c-.646 1.083-1.378 2.312-.391 4.029.119.208.252.408.383.606.344.517.513.802.514 1.081A7.94 7.94 0 0112 20a8.006 8.006 0 01-7.038-4.2zM12 2C6.486 2 2 6.487 2 12c0 5.514 4.486 10 10 10s10-4.486 10-10c0-5.513-4.486-10-10-10z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-google"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.495 13.98c-.666 2.142-2.326 3.625-4.535 3.953-3.37.498-6.68-2.057-6.943-5.457a6.001 6.001 0 018.253-6.032.503.503 0 00.642-.216l1.435-2.647a.504.504 0 00-.224-.697A9.976 9.976 0 0012.004 2c-5.622 0-10.16 4.636-10 10.293.147 5.162 4.407 9.48 9.564 9.698 5.546.235 10.146-4.046 10.425-9.468a84.47 84.47 0 00.003-2.027.497.497 0 00-.5-.495h-8.999a.5.5 0 00-.5.5v2.98a.5.5 0 00.5.5h4.998z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-graph"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.647 19.974h16.34a1.013 1.013 0 110 2.026H4.647A2.647 2.647 0 012 19.353V3.013a1.013 1.013 0 112.026 0v16.34a.62.62 0 00.621.62z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.45 18.732a1.013 1.013 0 001.014-1.013v-5.72a1.013 1.013 0 10-2.027 0v5.72a1.013 1.013 0 001.014 1.013z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.915 18.732a1.013 1.013 0 001.013-1.013v-5.72a1.013 1.013 0 00-2.026 0v5.72a1.013 1.013 0 001.013 1.013zM17.72 18.732a1.013 1.013 0 001.012-1.013V7.915a1.013 1.013 0 10-2.026 0v9.804a1.013 1.013 0 001.013 1.013zM11.183 18.732a1.013 1.013 0 001.013-1.013V7.915a1.013 1.013 0 00-2.026 0v9.804a1.013 1.013 0 001.013 1.013z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-grid"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3h4c1.103 0 2 .897 2 2v4c0 1.103-.897 2-2 2H5c-1.103 0-2-.897-2-2V5c0-1.103.897-2 2-2zm10 0h4c1.103 0 2 .897 2 2v4c0 1.103-.897 2-2 2h-4c-1.103 0-2-.897-2-2V5c0-1.103.897-2 2-2zM9 13H5c-1.103 0-2 .897-2 2v4c0 1.103.897 2 2 2h4c1.103 0 2-.897 2-2v-4c0-1.103-.897-2-2-2zm6 0h4c1.103 0 2 .897 2 2v4c0 1.103-.897 2-2 2h-4c-1.103 0-2-.897-2-2v-4c0-1.103.897-2 2-2z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-hard-drive"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.618 11l2.724-5.447A.994.994 0 019.236 5h5.528c.381 0 .724.212.894.553L18.382 11H5.618zM16 17h-4c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1zm-8 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm12.79-5.658l-3.343-6.684A2.985 2.985 0 0014.764 3H9.236a2.984 2.984 0 00-2.683 1.658l-3.342 6.684a2.012 2.012 0 00-.21.894V18c0 1.654 1.345 3 3 3h12c1.653 0 3-1.346 3-3v-5.764c0-.308-.074-.618-.212-.894z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-headphones"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.486 2 2 6.65 2 12.366V17c0 2.206 1.794 4 4 4s4-1.794 4-4-1.794-4-4-4a3.95 3.95 0 00-2 .557v-1.191C4 7.753 7.589 4 12 4s8 3.753 8 8.366v1.191A3.95 3.95 0 0018 13c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4v-4.634C22 6.65 17.514 2 12 2z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-heart"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21a.996.996 0 01-.708-.294l-7.767-7.78a5.245 5.245 0 010-7.399A5.188 5.188 0 017.22 4c1.399 0 2.712.543 3.695 1.527L12 6.614l1.084-1.086A5.189 5.189 0 0116.78 4c1.399 0 2.712.543 3.695 1.527a5.246 5.246 0 01.001 7.399l-7.768 7.781A1 1 0 0112 21z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-home"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.715 2.3l7.709 7.885c.366.376.576.9.576 1.439V20c0 1.103-.847 2-1.888 2H16v-9a1 1 0 00-1-1H9a1 1 0 00-1 1v9H4.889c-1.041 0-1.89-.897-1.89-2v-8.376c0-.54.21-1.063.576-1.438l7.71-7.885c.377-.385 1.053-.385 1.43 0zM14 21h-4v-7h4v7z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-ia-stars"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 11l.784-1.569c.266-.53.399-.796.576-1.026a3 3 0 01.545-.545c.23-.177.495-.31 1.026-.575L11 6.5l-1.569-.785c-.53-.265-.796-.398-1.026-.575a3 3 0 01-.545-.545c-.177-.23-.31-.495-.576-1.026L6.5 2l-.784 1.569c-.266.53-.399.796-.576 1.026a3 3 0 01-.545.545c-.23.177-.495.31-1.026.575L2 6.5l1.569.785c.53.265.796.398 1.026.575a3 3 0 01.545.545c.177.23.31.495.576 1.026L6.5 11zM15 22l1.179-3.064c.282-.734.423-1.1.642-1.409a3 3 0 01.706-.706c.309-.22.675-.36 1.409-.642L22 15l-3.064-1.179c-.734-.282-1.1-.423-1.409-.642a3 3 0 01-.706-.706c-.22-.309-.36-.675-.642-1.409L15 8l-1.179 3.064c-.282.734-.423 1.1-.642 1.409a3 3 0 01-.706.706c-.309.22-.675.36-1.409.642L8 15l3.064 1.179c.734.282 1.1.423 1.409.642a3 3 0 01.706.706c.22.309.36.675.642 1.409L15 22z",
    fill: "#000018"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 11l.784-1.569c.266-.53.399-.796.576-1.026a3 3 0 01.545-.545c.23-.177.495-.31 1.026-.575L11 6.5l-1.569-.785c-.53-.265-.796-.398-1.026-.575a3 3 0 01-.545-.545c-.177-.23-.31-.495-.576-1.026L6.5 2l-.784 1.569c-.266.53-.399.796-.576 1.026a3 3 0 01-.545.545c-.23.177-.495.31-1.026.575L2 6.5l1.569.785c.53.265.796.398 1.026.575a3 3 0 01.545.545c.177.23.31.495.576 1.026L6.5 11zM15 22l1.179-3.064c.282-.734.423-1.1.642-1.409a3 3 0 01.706-.706c.309-.22.675-.36 1.409-.642L22 15l-3.064-1.179c-.734-.282-1.1-.423-1.409-.642a3 3 0 01-.706-.706c-.22-.309-.36-.675-.642-1.409L15 8l-1.179 3.064c-.282.734-.423 1.1-.642 1.409a3 3 0 01-.706.706c-.309.22-.675.36-1.409.642L8 15l3.064 1.179c.734.282 1.1.423 1.409.642a3 3 0 01.706.706c.22.309.36.675.642 1.409L15 22z",
    stroke: "#29293D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-image"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 10a1.5 1.5 0 10-.001-3.001A1.5 1.5 0 008 10zM6 5h12a1 1 0 011 1v8.364l-3.203-2.732c-.99-.842-2.539-.842-3.52-.006L5 17.698V6a1 1 0 011-1zm12-2H6C4.346 3 3 4.346 3 6v12c0 1.654 1.346 3 3 3h12c1.654 0 3-1.346 3-3V6c0-1.654-1.346-3-3-3z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-image-2"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 17.834c0 .644-.448 1.166-1 1.166H6l7.566-6.817c.246-.245.692-.244.933-.001L19 16.66v1.174zM8 7a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 018 7zm10-4H6C4.346 3 3 4.346 3 6v12c0 1.654 1.346 3 3 3h12c1.654 0 3-1.346 3-3V6c0-1.654-1.346-3-3-3z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-inbox"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.342 5.553A1 1 0 019.237 5h5.527c.379 0 .725.214.894.553L18.382 11H16a1 1 0 00-1 1v2a1 1 0 01-1 1h-4a1 1 0 01-1-1v-2a1 1 0 00-1-1H5.618l2.724-5.447zm12.447 5.789l-3.342-6.684A2.984 2.984 0 0014.764 3H9.236a2.985 2.985 0 00-2.683 1.658L3.21 11.342a2.013 2.013 0 00-.211.895V18c0 1.655 1.346 3 3 3h12c1.655 0 3-1.345 3-3v-5.763c0-.31-.073-.62-.211-.895z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-info"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 9a1 1 0 110-2 1 1 0 010 2zm1 7a1 1 0 01-2 0v-5a1 1 0 012 0v5zM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10c5.522 0 10-4.477 10-10S17.522 2 12 2z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-keyboard"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 2C3.346 2 2 3.346 2 5s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3zm7 0c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3zm10 3c0 1.654-1.346 3-3 3s-3-1.346-3-3 1.346-3 3-3 3 1.346 3 3zM5 9c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3zm4 3c0-1.654 1.346-3 3-3s3 1.346 3 3-1.346 3-3 3-3-1.346-3-3zm10-3c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3zM2 19c0-1.654 1.346-3 3-3s3 1.346 3 3-1.346 3-3 3-3-1.346-3-3zm10-3c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3zm4 3c0-1.654 1.346-3 3-3s3 1.346 3 3-1.346 3-3 3-3-1.346-3-3z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-layers"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.24 7.287l8.522 4.636c.147.08.329.08.477 0l8.52-4.636a.444.444 0 00-.051-.812l-8.52-3.439a.509.509 0 00-.376 0l-8.52 3.439a.444.444 0 00-.051.812zm17.468 3.37l-1.83-.78-6.639 3.611a.506.506 0 01-.478 0L5.122 9.876l-1.83.78a.48.48 0 00-.051.858l8.52 4.897a.48.48 0 00.478 0l8.52-4.897a.48.48 0 00-.051-.858zm-1.557 3.766l1.557.674a.49.49 0 01.051.87l-8.52 4.969a.475.475 0 01-.478 0l-8.52-4.968a.49.49 0 01.051-.871l1.557-.674 6.912 3.76c.148.08.33.08.478 0l6.912-3.76z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-layout"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 8V6c0-1.654-1.346-3-3-3H6C4.346 3 3 4.346 3 6v2h18zM3 10v8c0 1.654 1.346 3 3 3h5V10H3zm10 11V10h8v8c0 1.654-1.346 3-3 3h-5z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-linkedin"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 5.25a2.25 2.25 0 114.502.002A2.25 2.25 0 013 5.25zM15.15 8.4c-3.23 0-5.85 2.604-5.85 5.814V20.1c0 .497.403.901.9.901h2.1a.902.902 0 00.9-.9v-5.886c0-1.136.984-2.044 2.152-1.927 1.014.101 1.747 1.028 1.747 2.047V20.1c0 .497.404.901.901.901h2.1a.902.902 0 00.9-.9v-5.886c0-3.21-2.62-5.814-5.85-5.814zm-8.55.9H3.9a.9.9 0 00-.9.9v9.9a.9.9 0 00.9.9h2.7a.9.9 0 00.9-.9v-9.9a.9.9 0 00-.9-.9z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-location-pin"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 8c-.827 0-1.5.673-1.5 1.5S11.173 11 12 11s1.5-.673 1.5-1.5S12.827 8 12 8zm0 5c-1.93 0-3.5-1.57-3.5-3.5S10.07 6 12 6s3.5 1.57 3.5 3.5S13.93 13 12 13zm0-11C7.589 2 4 5.554 4 9.923c0 5.474 7.049 11.579 7.349 11.836a.997.997 0 001.302 0c.3-.257 7.349-6.362 7.349-11.836C20 5.554 16.411 2 12 2z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-lock"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 14a1 1 0 100 2 1 1 0 000-2zm0 4c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zM10 6.111C10 4.947 10.897 4 12 4s2 .947 2 2.111V8h-4V6.111zM17 8h-1V6.111C16 3.845 14.206 2 12 2S8 3.845 8 6.111V8H7c-1.654 0-3 1.346-3 3v8c0 1.654 1.346 3 3 3h10c1.654 0 3-1.346 3-3v-8c0-1.654-1.346-3-3-3z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-lock-open"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 14a1 1 0 100 2 1 1 0 000-2zm0 4c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zm5-10h-7V6c0-1.103.897-2 2-2s2 .897 2 2a1 1 0 102 0c0-2.206-1.794-4-4-4S8 3.794 8 6v2H7c-1.654 0-3 1.346-3 3v8c0 1.654 1.346 3 3 3h10c1.654 0 3-1.346 3-3v-8c0-1.654-1.346-3-3-3z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-mail"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.006 6l-6.505 4.468a1 1 0 01-.99 0L5.006 6h14zm0-2h-14c-1.654 0-3 1.346-3 3v10c0 1.654 1.346 3 3 3h14c1.654 0 3-1.346 3-3V7c0-1.654-1.346-3-3-3z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-map"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 17.454l-2-.898V6.546l2 .898v10.01zM9 6.546l2 .898v10.01l-2-.898V6.546zm11.41-.66l-4-1.798c-.015-.007-.031-.008-.046-.014a1.106 1.106 0 00-.36-.067c-.044 0-.087.001-.131.006-.037.004-.072.013-.108.022a1.21 1.21 0 00-.13.04c-.014.005-.031.006-.045.013L12 5.701 8.41 4.088c-.015-.007-.031-.008-.046-.014a1.106 1.106 0 00-.36-.067c-.044 0-.087.001-.131.006-.037.004-.072.013-.108.022a1.21 1.21 0 00-.13.04c-.014.005-.031.006-.045.013l-4 1.798a1 1 0 00-.59.912V19a1.002 1.002 0 001.41.912L8 18.3l3.59 1.613c.015.007.031.004.047.01A.974.974 0 0012 20a.974.974 0 00.363-.078c.015-.006.033-.003.047-.01L16 18.3l3.59 1.613A.998.998 0 0021 19V6.798a1 1 0 00-.59-.912z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-mark-blue"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "#4CA5D1"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-mark-green"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "#71C087"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-mark-red"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "#F64A3F"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-mark-star"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.562 21c-.158 0-.317-.036-.463-.112l-5.1-2.664-5.097 2.664a1.002 1.002 0 01-1.448-1.057l.97-5.628-4.12-3.985a1.002 1.002 0 01.553-1.708l5.7-.828 2.548-5.126c.338-.68 1.453-.68 1.79 0l2.549 5.126 5.7.828a.998.998 0 01.552 1.708l-4.12 3.985.97 5.628a1 1 0 01-.984 1.17z",
    fill: "#FAB306"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-megaphone"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.323 4c-.25 0-.498.035-.738.104L6.82 7.192c-.09.026-.183.039-.276.039H5a3 3 0 00-3 3v3.538a3 3 0 003 3h1V19a1 1 0 102 0v-1.853l9.585 2.75A2.677 2.677 0 0021 17.323v-2.658c.598-.433 1-1.24 1-2.166 0-.925-.402-1.733-1-2.165V6.677A2.677 2.677 0 0018.323 4zM5.5 9A1.5 1.5 0 004 10.5v3A1.5 1.5 0 005.5 15H6V9h-.5z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-message-square"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 9a1 1 0 100 2 1 1 0 000-2zm4 0a1 1 0 100 2 1 1 0 000-2zM8 9a1 1 0 100 2 1 1 0 000-2zm11-7H5C3.346 2 2 3.346 2 5v15a1 1 0 001.515.857l4.524-2.714A.997.997 0 018.554 18H19c1.654 0 3-1.346 3-3V5c0-1.654-1.346-3-3-3z",
    fill: "#7000C8"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-mic"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 11c0 2.206-1.794 4-4 4s-4-1.794-4-4V6c0-2.206 1.794-4 4-4s4 1.794 4 4v5zm2-1a1 1 0 011 1c0 3.52-2.613 6.432-6 6.92V20h2.105c.493 0 .895.402.895.895v.21a.897.897 0 01-.895.895h-6.21A.897.897 0 018 21.105v-.21c0-.493.402-.895.895-.895H11v-2.08c-3.387-.488-6-3.4-6-6.92a1 1 0 112 0c0 2.757 2.243 5 5 5s5-2.243 5-5a1 1 0 011-1z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-mic-off"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.58 12.751c.26-.531.42-1.12.42-1.751V6c0-2.206-1.794-4-4-4a4.003 4.003 0 00-3.924 3.248l7.503 7.503zM19 11a1 1 0 10-2 0c0 .909-.262 1.75-.688 2.484l1.463 1.463A6.948 6.948 0 0019 11zm-6.915 3.992A.581.581 0 0112 15c-2.206 0-4-1.794-4-4v-.172l4.156 4.156a.648.648 0 00-.07.008zm8.622 4.301l-16-16a.999.999 0 10-1.414 1.414l16 16a.997.997 0 001.414 0 .999.999 0 000-1.414zM13 20h2c.55 0 1 .45 1 1s-.45 1-1 1H9c-.55 0-1-.45-1-1s.45-1 1-1h2v-2.08c-3.387-.488-6-3.4-6-6.92a1 1 0 112 0c0 2.757 2.243 5 5 5 .362 0 .714-.043 1.055-.117l1.593 1.593a6.96 6.96 0 01-1.648.443V20z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-moon"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.296 22H12.2a10.266 10.266 0 01-7.344-3.154C1.179 15.041 1.064 8.744 4.599 4.81a10.23 10.23 0 013.993-2.743.994.994 0 011.059.222c.28.275.373.688.238 1.056a8.397 8.397 0 001.94 8.804c2.298 2.293 5.764 3.054 8.829 1.938a.998.998 0 011.276 1.298 10.225 10.225 0 01-2.336 3.596A10.261 10.261 0 0112.296 22z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-music"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.947 14.992V4a1 1 0 00-1.217-.976L8.76 5.017a1.001 1.001 0 00-.785.976v8.341c-.44-.2-.924-.319-1.439-.319a3.496 3.496 0 00-3.492 3.493A3.496 3.496 0 006.536 21a3.496 3.496 0 003.492-3.492c0-.179-.026-.35-.053-.522V6.796l6.972-1.55v7.095a3.45 3.45 0 00-1.439-.319 3.496 3.496 0 00-3.493 3.492 3.496 3.496 0 003.493 3.492A3.496 3.496 0 0019 15.514c0-.179-.027-.35-.053-.522z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-navigation"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.667 22l-.061-.002a.999.999 0 01-.919-.8l-1.538-7.566a.999.999 0 00-.781-.781l-7.567-1.54a.998.998 0 01-.117-1.927l16-5.332a1.001 1.001 0 011.265 1.264l-5.334 16a.998.998 0 01-.948.684z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-navigation-up"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 21a1 1 0 01-.552-.166l-6.896-4.567a.998.998 0 00-1.104 0l-6.896 4.567a1.002 1.002 0 01-1.447-1.281l8-16a1 1 0 011.79 0l8 16A1.001 1.001 0 0120 21z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-notification"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 18.341c0 .9-.916 1.66-2 1.66s-2-.76-2-1.66v-.34h4v.34zm6.521-3.134l-1.8-1.803V8.936c0-3.48-2.503-6.437-5.822-6.877a6.724 6.724 0 00-5.316 1.607A6.731 6.731 0 005.28 8.727v4.677l-1.8 1.804a1.63 1.63 0 00-.355 1.782c.255.613.848 1.01 1.512 1.01H8v.341c0 2.018 1.794 3.66 4 3.66s4-1.642 4-3.66v-.34h3.362a1.63 1.63 0 001.511-1.01 1.632 1.632 0 00-.352-1.784z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-notifiction-off"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.707 20.706a.997.997 0 01-1.414 0l-2.707-2.707-.586-.586-1.345-1.345-.069-.069-7.303-7.303-1.752-1.751-2.238-2.239a.999.999 0 111.414-1.414L6.42 5.005 7.886 6.47l9.528 9.529 1.993 1.993 1.3 1.3a.999.999 0 010 1.414zM7.035 4.206A6.724 6.724 0 0112.9 2.06c3.32.44 5.821 3.396 5.821 6.876v4.468l1.8 1.803c.47.47.608 1.17.353 1.784a1.62 1.62 0 01-.453.6l-.306-.305-1.993-1.993-9.528-9.529-1.466-1.465-.092-.092zM14 18.34c0 .899-.916 1.659-2 1.659s-2-.76-2-1.659v-.341h4v.341zm1.88.366l-.587-.586-1.345-1.344-.069-.07-7.303-7.302L5.311 8.14c-.016.195-.03.39-.03.587l-.002 4.677-1.8 1.804a1.633 1.633 0 00-.354 1.782c.255.613.848 1.01 1.512 1.01H8v.341C8 20.358 9.794 22 12 22c2.042 0 3.712-1.412 3.951-3.22l-.072-.074z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-npm"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 3H6C4.346 3 3 4.346 3 6v12c0 1.654 1.346 3 3 3h7V11h4v10h1c1.654 0 3-1.346 3-3V6c0-1.654-1.346-3-3-3z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-office"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 5a3 3 0 013-3h10a3 3 0 013 3v15H4V5zM2 21a1 1 0 011-1h18a1 1 0 110 2H3a1 1 0 01-1-1z",
    fill: "#29293D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 7a1 1 0 011-1h1a1 1 0 110 2H9a1 1 0 01-1-1zM8 11a1 1 0 011-1h1a1 1 0 110 2H9a1 1 0 01-1-1zM13 7a1 1 0 011-1h1a1 1 0 110 2h-1a1 1 0 01-1-1zM13 11a1 1 0 011-1h1a1 1 0 110 2h-1a1 1 0 01-1-1zM9 16a2 2 0 012-2h2a2 2 0 012 2v4h-2v-4h-2v4H9v-4z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-options"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 14.184V3a1 1 0 10-2 0v11.184A2.996 2.996 0 003 17c0 1.302.839 2.401 2 2.816V21a1 1 0 102 0v-1.184A2.996 2.996 0 009 17a2.996 2.996 0 00-2-2.816zM21 13a2.995 2.995 0 00-2-2.815V3a1 1 0 10-2 0v7.185A2.995 2.995 0 0015 13c0 1.302.839 2.401 2 2.815V21a1 1 0 102 0v-5.185A2.995 2.995 0 0021 13zM12 2c1.654 0 3 1.346 3 3a2.995 2.995 0 01-2 2.815V21a1 1 0 11-2 0V7.815A2.995 2.995 0 019 5c0-1.654 1.346-3 3-3z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-options-2"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 7h1.185A2.995 2.995 0 007 9a2.995 2.995 0 002.815-2H21a1 1 0 100-2H9.815A2.995 2.995 0 007 3a2.995 2.995 0 00-2.815 2H3a1 1 0 100 2zm16 2a2.995 2.995 0 00-2.815 2H3a1 1 0 100 2h13.185A2.995 2.995 0 0019 15c1.654 0 3-1.346 3-3s-1.346-3-3-3zm-5.185 8H21a1 1 0 110 2h-7.185A2.995 2.995 0 0111 21a2.995 2.995 0 01-2.815-2H3a1 1 0 110-2h5.185A2.995 2.995 0 0111 15c1.302 0 2.401.839 2.815 2z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-pantone"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 8h3.818V5H5v3zm0 5h3.818v-3H5v3zm3.818 2H5v2.091A1.91 1.91 0 006.909 19a1.91 1.91 0 001.909-1.909V15zm2 2.091A3.914 3.914 0 016.909 21 3.914 3.914 0 013 17.091V4a1 1 0 011-1h5.818a1 1 0 011 1v13.091zm7.371-7.79l-4.135-3.858a.937.937 0 00-.717-.267.996.996 0 00-.696.317l-.823.882v10.716c0 .195-.035.382-.057.571l6.478-6.949a.998.998 0 00-.05-1.413zM21 14.18V20a1 1 0 01-1 1h-9.983l.449-.482L11.881 19l3.559-3.818 1.865-2H20a1 1 0 011 1z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-paper-plane"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.937 2.678a.951.951 0 01.056.3c.002.013.004.026.003.04a1 1 0 01-.048.299l-6 18a.998.998 0 01-1.896 0l-2.843-8.526-8.525-2.842a1 1 0 010-1.898l18-6c.098-.032.199-.046.299-.048.013 0 .025.001.037.003l.028.003a.987.987 0 01.364.089.96.96 0 01.295.195.967.967 0 01.23.385z",
    fill: "#7000C8"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-pause"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 5,
    width: 3,
    height: 14,
    rx: 1.5,
    fill: "#000018",
    fillOpacity: 0.84
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 5,
    width: 3,
    height: 14,
    rx: 1.5,
    fill: "#000018",
    fillOpacity: 0.84
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-pause-circle"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 15c0 .55-.45 1-1 1s-1-.45-1-1V9c0-.55.45-1 1-1s1 .45 1 1v6zm-4 0c0 .55-.45 1-1 1s-1-.45-1-1V9c0-.55.45-1 1-1s1 .45 1 1v6zm1-13C6.485 2 2 6.486 2 12s4.486 10 10 10c5.515 0 10-4.486 10-10S17.515 2 12 2z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-people"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 11c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4zm8 2c1.654 0 3-1.346 3-3s-1.346-3-3-3-3 1.346-3 3 1.346 3 3 3zm5 6a1 1 0 01-1 1h-5a1 1 0 01-1 1H3a1 1 0 01-1-1c0-3.86 3.141-7 7-7 1.927 0 3.673.783 4.94 2.046A4.994 4.994 0 0117 14c2.757 0 5 2.243 5 5z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-phone"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4 22C8.908 22 2 15.092 2 6.6a4.605 4.605 0 016.09-4.352 1 1 0 01.648.722l1.37 5.964c.075.328-.02.672-.253.916-.137.142-.14.145-1.38.794a9.947 9.947 0 004.88 4.883c.649-1.241.653-1.245.795-1.381.245-.234.59-.325.917-.253l5.964 1.369a1 1 0 01.72.646c.083.236.144.48.185.731A4.605 4.605 0 0117.4 22z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-phone-call"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 4c3.859 0 7 3.141 7 7a1 1 0 102 0c0-4.963-4.037-9-9-9a1 1 0 100 2zm0 4c1.654 0 3 1.346 3 3a1 1 0 102 0c0-2.757-2.243-5-5-5a1 1 0 100 2zm8.03 7.262a.997.997 0 01.721.646A4.574 4.574 0 0122 17.4c0 2.536-2.063 4.6-4.6 4.6C8.909 22 2 15.092 2 6.6a4.605 4.605 0 016.091-4.352 1 1 0 01.647.722l1.369 5.963a.998.998 0 01-.252.916c-.137.143-.14.146-1.38.794a9.949 9.949 0 004.88 4.884c.65-1.24.653-1.245.795-1.382.244-.233.587-.326.916-.253l5.964 1.37z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-phone-missed"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.75 15.909A4.565 4.565 0 0122 17.4 4.604 4.604 0 0117.402 22C8.909 22 2 15.092 2 6.6 2 4.064 4.064 2 6.6 2a4.5 4.5 0 01.766.066c.243.039.489.1.726.183a1 1 0 01.647.72l1.368 5.965c.075.328-.02.673-.252.916-.137.143-.141.145-1.375.792l-.005.003a9.927 9.927 0 004.88 4.883c.649-1.242.652-1.245.795-1.382.243-.234.588-.326.916-.253l5.964 1.369a.995.995 0 01.72.647zm-4.482-7.21a1.042 1.042 0 01-1.466 0 1.042 1.042 0 010-1.467l.733-.732-.733-.733a1.04 1.04 0 010-1.465 1.04 1.04 0 011.466 0l.732.733.733-.733a1.039 1.039 0 011.465 0 1.039 1.039 0 010 1.465l-.733.733.733.732a1.04 1.04 0 010 1.466 1.04 1.04 0 01-1.465 0L18 7.965l-.732.733z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-phone-off"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.273 12.055a9.863 9.863 0 01-.799-1.41c1.24-.65 1.243-.653 1.38-.795.233-.243.328-.588.253-.916L8.738 2.97a.999.999 0 00-.647-.721 4.242 4.242 0 00-.726-.183A4.5 4.5 0 006.6 2 4.605 4.605 0 002 6.6c0 3.566 1.23 6.844 3.271 9.457l4.002-4.002zm12.663 4.584a4.266 4.266 0 00-.186-.73.995.995 0 00-.72-.647l-5.964-1.37a1.004 1.004 0 00-.916.254c-.143.137-.146.14-.796 1.382a9.564 9.564 0 01-1.411-.8l-4 4A15.306 15.306 0 0017.4 22a4.604 4.604 0 004.536-5.361zM18.482 4.26a.887.887 0 011.257 0 .887.887 0 010 1.257L5.517 19.74a.889.889 0 01-1.257-1.257L18.482 4.26z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-pie"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.273 8.667a5.844 5.844 0 00-4.94-4.94v4.94h4.94zm.893 1.665H14.5a.833.833 0 01-.834-.832V2.833c0-.46.374-.833.834-.833C18.636 2 22 5.365 22 9.5a.833.833 0 01-.834.832zm-8.232 1.645h8.15a.92.92 0 01.911 1.011 10.027 10.027 0 01-11.114 8.948c-4.585-.506-8.312-4.233-8.819-8.818a10.027 10.027 0 018.95-11.113.918.918 0 011.01.91v8.152c0 .502.408.91.912.91z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-pie-2"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.934 11.978h8.15a.92.92 0 01.911 1.01 10.027 10.027 0 01-11.114 8.949c-4.585-.506-8.312-4.233-8.819-8.818a10.027 10.027 0 018.95-11.114.918.918 0 011.01.91v8.152c0 .503.408.91.912.91zm8.233-1.645H14.5a.832.832 0 01-.833-.833V2.833c0-.46.373-.833.833-.833C18.635 2 22 5.364 22 9.5a.833.833 0 01-.833.833z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-play"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.25 11.278a.833.833 0 010 1.444l-12.5 7.217a.833.833 0 01-1.25-.722V4.783a.833.833 0 011.25-.722l12.5 7.217z",
    fill: "#000018",
    fillOpacity: 0.84
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-play-circle"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 14.6l2.809-2.6L11.5 9.4v5.2zm4.48-1.421l-3.642 3.37a1.698 1.698 0 01-1.157.45 1.74 1.74 0 01-.693-.144A1.607 1.607 0 019.5 15.37V8.63c0-.65.378-1.22.988-1.484a1.71 1.71 0 011.851.306l3.641 3.37c.331.305.52.735.52 1.178 0 .444-.189.873-.52 1.179zM12 1.999C6.486 2 2 6.488 2 12c0 5.515 4.486 10 10 10s10-4.485 10-10c0-5.512-4.486-10-10-10z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-price-tag"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.56 11.56a1.5 1.5 0 11-2.12-2.119 1.5 1.5 0 012.12 2.12zm9.907.021L15.05 5.165a.995.995 0 00-.614-.288l-9.344-.872a1.002 1.002 0 00-1.089 1.088l.872 9.345c.023.232.124.45.29.614l6.416 6.417a1.817 1.817 0 002.57 0l7.316-7.316c.343-.342.532-.8.532-1.285 0-.487-.189-.943-.532-1.286z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-printer"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 19v-4h9l.002 4H7.5zm.514-14H16v2H8.007l.007-2zm11.349 2H18V5c0-1.103-.822-2-1.833-2H7.833C6.822 3 6 3.897 6 5v2H4.637C3.183 7 2 8.196 2 9.667v6.666C2 17.804 3.183 19 4.637 19H5.5c0 1.103.897 2 2 2h9c1.103 0 2-.897 2-2h.863C20.817 19 22 17.804 22 16.333V9.667C22 8.196 20.817 7 19.363 7z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-question-mark-circle"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 12.837V14a1 1 0 11-2 0v-2a1 1 0 011-1c.827 0 1.5-.673 1.5-1.5S12.827 8 12 8s-1.5.673-1.5 1.5a1 1 0 11-2 0C8.5 7.57 10.07 6 12 6s3.5 1.57 3.5 3.5c0 1.58-1.06 2.903-2.5 3.337zM12 18a1 1 0 110-2 1 1 0 110 2zm0-16C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-quotes"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.478 4.279a.49.49 0 00-.579-.124C4.572 6.21 2 9.89 2 13.944 2 16.865 3.882 19 6.47 19c2.236 0 4-1.573 4-3.652 0-1.573-1.058-2.865-2.646-3.258C6 11.697 5.94 11.64 5.94 10.742c0-1.84 1.34-3.582 3.922-5.087a.514.514 0 00.136-.78l-.52-.596zm11.53 0a.49.49 0 00-.58-.124C16.102 6.21 13.53 9.89 13.53 13.944 13.53 16.865 15.412 19 18 19c2.235 0 4-1.573 4-3.652 0-1.573-1.059-2.865-2.647-3.258-1.824-.393-1.882-.45-1.882-1.348 0-1.84 1.339-3.582 3.921-5.087a.514.514 0 00.136-.78l-.52-.596z",
    fill: "#000018",
    fillOpacity: 0.84
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-radio"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.644 16.234c.422.357.477.988.122 1.41a1.002 1.002 0 01-1.41.122C3.192 15.944 2 13.541 2 11c0-2.54 1.192-4.944 3.356-6.766a1.002 1.002 0 011.41.122c.355.422.3 1.053-.122 1.41C4.938 7.2 4 9.06 4 11c0 1.941.938 3.8 2.644 5.234zM22 11c0 2.541-1.192 4.944-3.356 6.766a1 1 0 01-1.288-1.532C19.062 14.8 20 12.941 20 11c0-1.94-.938-3.8-2.644-5.234a1.002 1.002 0 01-.122-1.41 1.004 1.004 0 011.41-.122C20.808 6.056 22 8.46 22 11zM9.144 7.765C8.084 8.657 7.5 9.807 7.5 11s.584 2.343 1.644 3.235a1 1 0 01-1.288 1.53C6.337 14.486 5.5 12.795 5.5 11c0-1.794.837-3.486 2.356-4.765a1 1 0 011.288 1.53zm7 8C17.663 14.486 18.5 12.795 18.5 11c0-1.794-.837-3.486-2.356-4.765a1 1 0 00-1.288 1.53C15.916 8.657 16.5 9.807 16.5 11s-.584 2.343-1.644 3.235a1 1 0 001.288 1.53zM9 11c0-1.654 1.346-3 3-3s3 1.346 3 3a2.993 2.993 0 01-2.035 2.826c.004.021.01.041.015.061.01.037.02.073.02.113v6a1 1 0 11-2 0v-6c0-.04.01-.076.02-.113.005-.02.011-.04.015-.061A2.993 2.993 0 019 11z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-radio-button"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5zm0 13c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8zm0-18C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-rewind"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.45 6.201a2.085 2.085 0 00-2.209.26l-4.74 3.916v-2.59c0-.673-.404-1.28-1.05-1.586a2.085 2.085 0 00-2.21.26l-5.1 4.213c-.407.336-.64.82-.64 1.326 0 .506.233.99.64 1.326l5.1 4.214c.368.304.832.461 1.303.461.307 0 .617-.067.906-.202.647-.306 1.05-.913 1.05-1.586v-2.59l4.741 3.917c.368.304.832.461 1.303.461.307 0 .617-.067.906-.202.647-.306 1.05-.913 1.05-1.586V7.787c0-.673-.403-1.28-1.05-1.586z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-save"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.292 3.878l4.83 4.829c.561.562.878 1.326.878 2.122V18a3 3 0 01-3 3h-2v-4c0-1.103-.898-2-2-2h-4c-1.103 0-2 .897-2 2v4H6a3 3 0 01-3-3V6a3 3 0 013-3h2v7a1 1 0 001 1h6a1 1 0 100-2h-5V3h3.172c.795 0 1.558.316 2.12.878zM10 17h4l.001 4H10v-4z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-screen"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3h14c1.654 0 3 1.346 3 3v5H2V6c0-1.654 1.346-3 3-3zm0 14c-1.654 0-3-1.346-3-3v-1h20v1c0 1.654-1.346 3-3 3h-6v2h4c.55 0 1 .45 1 1s-.45 1-1 1H7c-.55 0-1-.45-1-1s.45-1 1-1h4v-2H5z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-search"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.656 14.875a8.25 8.25 0 10-1.78 1.78l5.226 5.226s0 0 0 0a1.258 1.258 0 101.78-1.779h0l-5.226-5.227zm-2.59-.81a5.75 5.75 0 11-8.131-8.131 5.75 5.75 0 018.132 8.132z",
    fill: "#29293D",
    stroke: "#29293D",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-settings"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 10.5c-.827 0-1.5.673-1.5 1.5s.673 1.5 1.5 1.5 1.5-.673 1.5-1.5-.673-1.5-1.5-1.5zm0 5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5zm8.317-6.125h-1.084c-.147 0-.247-.117-.308-.264-.046-.111-.058-.265.047-.37l.77-.766c.318-.317.494-.74.494-1.188 0-.45-.174-.872-.492-1.189l-1.341-1.341a1.683 1.683 0 00-2.377 0l-.77.771c-.104.105-.258.092-.403.032-.11-.045-.228-.146-.228-.293V3.676c0-.924-.751-1.676-1.676-1.676h-1.892c-.928 0-1.682.755-1.682 1.683v1.084c0 .147-.117.247-.264.308-.111.047-.266.059-.37-.047l-.765-.769a1.667 1.667 0 00-1.189-.494h-.002c-.449 0-.871.174-1.188.492l-1.34 1.34a1.683 1.683 0 000 2.377l.771.77c.104.104.092.259.032.403-.045.11-.146.228-.293.228H3.676c-.924 0-1.676.751-1.676 1.676v1.892c0 .928.755 1.682 1.683 1.682h1.084c.147 0 .247.117.308.264.046.111.058.265-.047.37l-.769.765c-.319.318-.494.74-.494 1.189-.001.45.174.872.492 1.19l1.34 1.34a1.683 1.683 0 002.377 0l.77-.771c.105-.103.259-.091.403-.032.11.045.228.146.228.293v1.091c0 .924.751 1.676 1.676 1.676h1.892c.928 0 1.682-.755 1.682-1.683v-1.084c0-.147.117-.247.264-.308.11-.046.265-.058.37.047l.765.769c.318.319.74.494 1.189.494h.002c.449 0 .871-.174 1.188-.492l1.34-1.34a1.683 1.683 0 000-2.377l-.771-.77c-.104-.104-.092-.259-.045-.37l.013-.033c.045-.11.146-.228.293-.228h1.091c.924 0 1.676-.751 1.676-1.676v-1.892c0-.928-.755-1.682-1.683-1.682z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-settings-1"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 10.5c-.827 0-1.5.673-1.5 1.5s.673 1.5 1.5 1.5 1.5-.673 1.5-1.5-.673-1.5-1.5-1.5zm0 5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5zm9.892-5.181l-.787-2.521a2.299 2.299 0 00-1.153-1.378 2.227 2.227 0 00-1.732-.132l-.34.113a1.735 1.735 0 01-1.593-.264l-.107-.081a1.78 1.78 0 01-.694-1.429l.002-.279a2.345 2.345 0 00-.683-1.675 2.246 2.246 0 00-1.598-.67L10.66 2h-.004C9.402 2 8.378 3.042 8.373 4.326l-.001.241a1.911 1.911 0 01-.733 1.51l-.129.098a1.916 1.916 0 01-1.777.297 2.157 2.157 0 00-1.683.116 2.23 2.23 0 00-1.124 1.334l-.816 2.595a2.346 2.346 0 001.48 2.941l.164.056c.518.177.935.629 1.119 1.211l.055.168c.219.646.143 1.327-.231 1.857-.72 1.023-.501 2.466.489 3.216l2.072 1.574a2.231 2.231 0 001.703.434 2.268 2.268 0 001.511-.944l.231-.328a1.772 1.772 0 011.428-.767c.587-.033 1.147.273 1.497.777l.118.172c.359.518.895.858 1.509.957a2.23 2.23 0 001.711-.428l2.061-1.556c.994-.749 1.222-2.197.508-3.229l-.261-.375a1.952 1.952 0 01-.258-1.652 1.915 1.915 0 011.21-1.286l.201-.067c1.187-.397 1.844-1.711 1.465-2.929z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-share"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 15c-.817 0-1.557.33-2.099.861l-7.935-3.526c.013-.11.034-.22.034-.335 0-.114-.021-.223-.034-.335l7.935-3.526A2.991 2.991 0 0018 9c1.654 0 3-1.346 3-3s-1.346-3-3-3-3 1.346-3 3c0 .114.021.224.034.335L7.099 9.861A2.991 2.991 0 005 9.001c-1.654 0-3 1.346-3 3s1.346 3 3 3c.817 0 1.557-.33 2.099-.861l7.935 3.526c-.013.11-.034.22-.034.334 0 1.654 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-shield"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21.85c-.339 0-.678-.083-.979-.253l-.303-.171A15.159 15.159 0 013 8.23v-.145c0-.72.39-1.387 1.018-1.742l7.002-3.938a2.009 2.009 0 011.959-.001l7.001 3.938A2.006 2.006 0 0121 8.085v.145a15.159 15.159 0 01-7.718 13.196l-.302.17c-.302.17-.641.255-.98.255z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-shield-off"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.839 16.011a15.132 15.132 0 002.16-7.78v-.146c0-.72-.39-1.387-1.018-1.743L12.98 2.404a2.01 2.01 0 00-1.96.001L7.316 4.488l11.523 11.523zM3.73 6.561a1.99 1.99 0 00-.73 1.524v.145a15.16 15.16 0 007.716 13.196l.303.171a2.004 2.004 0 001.96-.001l.302-.17a15.112 15.112 0 003.047-2.268L3.731 6.56zm-.438-3.268a.999.999 0 011.414 0l16 16a.999.999 0 11-1.414 1.414l-16-16a.999.999 0 010-1.414z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-shopping-bag"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.414 7l1.707-1.707A1.01 1.01 0 018.828 5h6.344c.263 0 .52.107.707.293L17.586 7H6.414zM12 16c-2.206 0-4-1.794-4-4a1 1 0 112 0c0 1.103.897 2 2 2 1.102 0 2-.897 2-2a1 1 0 112 0c0 2.206-1.794 4-4 4zm8.121-9.293l-2.828-2.828A2.978 2.978 0 0015.173 3H8.827c-.8 0-1.555.312-2.12.879L3.878 6.707A2.978 2.978 0 003 8.829V18c0 1.654 1.346 3 3 3h12c1.654 0 3-1.346 3-3V8.829c0-.802-.313-1.556-.879-2.122z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-shopping-cart"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.083 6.948A1.986 1.986 0 0019.382 6h-12.8l-.617-2.263A1 1 0 005 3H3a1 1 0 100 2h1.236l2.799 10.263A1 1 0 008 16h9c.379 0 .725-.214.895-.553l3.276-6.553a1.988 1.988 0 00-.088-1.946zM7.5 18a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm8.5 1.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-skip-forward"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 6a1 1 0 00-1 1v3.818c-.047-.048-.088-.1-.142-.144L9.759 6.46a2.088 2.088 0 00-2.209-.259c-.648.306-1.05.913-1.05 1.586v8.426c0 .673.402 1.28 1.05 1.586.289.136.599.202.906.202a2.04 2.04 0 001.303-.462l5.1-4.213c.053-.044.094-.096.141-.144V17a1 1 0 102 0V7a1 1 0 00-1-1z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-skip-to-start"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.45 6.201c-.734-.345-1.602-.243-2.209.26l-5.1 4.213c-.053.044-.094.095-.14.144V7a1 1 0 10-2 0v10a1 1 0 102 0v-3.819c.046.05.087.101.14.145l5.1 4.214c.368.304.832.461 1.303.461.307 0 .617-.067.906-.202.647-.306 1.05-.913 1.05-1.586V7.787c0-.673-.403-1.28-1.05-1.586z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-smartphone"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 8h-5a1 1 0 110-2h5a1 1 0 110 2zM12 18a1.5 1.5 0 11.001-3A1.5 1.5 0 0112 18zm5-16H7C5.346 2 4 3.348 4 5v14c0 1.655 1.346 3 3 3h10c1.654 0 3-1.345 3-3V5c0-1.653-1.346-3-3-3z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-speaker"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 8a1 1 0 11-2 0 1 1 0 012 0zm-2.5 7.5c0-.826.673-1.5 1.5-1.5s1.5.674 1.5 1.5c0 .828-.673 1.5-1.5 1.5s-1.5-.672-1.5-1.5zM12 19c-1.93 0-3.5-1.57-3.5-3.5S10.07 12 12 12s3.5 1.57 3.5 3.5S13.93 19 12 19zm0-14c1.654 0 3 1.347 3 3 0 1.655-1.346 3-3 3S9 9.656 9 8c0-1.653 1.346-3 3-3zm5-3H7C5.346 2 4 3.348 4 5v14c0 1.655 1.346 3 3 3h10c1.654 0 3-1.345 3-3V5c0-1.653-1.346-3-3-3z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-star"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.562 21c-.158 0-.317-.036-.463-.112l-5.1-2.664-5.097 2.664a1.002 1.002 0 01-1.448-1.057l.97-5.628-4.12-3.985a1.002 1.002 0 01.553-1.708l5.7-.828 2.548-5.126c.338-.68 1.453-.68 1.79 0l2.549 5.126 5.7.828a.998.998 0 01.552 1.708l-4.12 3.985.97 5.628a1 1 0 01-.984 1.17z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-stop-circle"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 14h4v-4h-4v4zm6 .75c0 .689-.561 1.25-1.25 1.25h-5.5C8.561 16 8 15.439 8 14.75v-5.5C8 8.561 8.561 8 9.25 8h5.5c.689 0 1.25.561 1.25 1.25v5.5zM12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-substract-circle"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 13H9c-.55 0-1-.45-1-1s.45-1 1-1h6c.55 0 1 .45 1 1s-.45 1-1 1zM12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-substract-square"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 13H9c-.55 0-1-.45-1-1s.45-1 1-1h6c.55 0 1 .45 1 1s-.45 1-1 1zm3-10H6C4.346 3 3 4.346 3 6v12c0 1.654 1.346 3 3 3h12c1.654 0 3-1.346 3-3V6c0-1.654-1.346-3-3-3z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 17 16",
    fill: "none",
    id: "sprite_svg__icon-bold-suitcase"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.527 5.556a1.779 1.779 0 00-1.78-1.778h-1.334v-.445A1.334 1.334 0 0011.08 2H6.63a1.336 1.336 0 00-1.334 1.333v.445H3.96a1.782 1.782 0 00-1.779 1.778v1.333h13.345V5.556zm-4.003-1.778H6.186v-.445a.444.444 0 01.444-.444h4.449a.445.445 0 01.444.444v.445zM11.079 8.222a.667.667 0 01-.668.667H7.299a.668.668 0 01-.668-.667v-.11A.111.111 0 006.52 8H2.181v4a1.777 1.777 0 001.78 1.778h9.786A1.78 1.78 0 0015.527 12V8H11.19a.111.111 0 00-.111.111v.111z",
    fill: "#222B45"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-sun"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6a1 1 0 001-1V3a1 1 0 10-2 0v2a1 1 0 001 1zm9 5h-2a1 1 0 100 2h2a1 1 0 100-2zM5 11a1 1 0 110 2H3a1 1 0 110-2h2zm1.22-5.972a1 1 0 00-1.39 1.439l1.44 1.39c.195.188.445.28.695.28a1 1 0 00.695-1.719l-1.44-1.39zm11.51 2.83a1 1 0 01-1.39-1.44l1.44-1.39a1 1 0 011.39 1.439l-1.44 1.39zM12 18a1 1 0 00-1 1v2a1 1 0 102 0v-2a1 1 0 00-1-1zm4.316-1.832a1.002 1.002 0 011.414-.025l1.44 1.39a1 1 0 01-1.39 1.439l-1.44-1.39a1 1 0 01-.024-1.414zM6.27 16.143l-1.439 1.39a1 1 0 001.39 1.439l1.439-1.39a1 1 0 00-1.39-1.44zM8 12c0-2.206 1.794-4 4-4s4 1.794 4 4-1.794 4-4 4-4-1.794-4-4z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-termometer"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 9.54V5a.965.965 0 00-.287-.694A.976.976 0 0012 4c-.552 0-1 .449-1 1v4.54h2zM12 22c-2.757 0-5-2.243-5-5 0-1.58.754-3.063 2-3.997V5c0-1.654 1.346-3 3-3 .812 0 1.566.317 2.127.892C14.684 3.434 15 4.189 15 5v8.003c1.246.934 2 2.417 2 3.997 0 2.757-2.243 5-5 5z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-termometer-menus"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 5v4.54h-2V5c0-.551.448-1 1-1 .267 0 .514.102.713.306A.965.965 0 0115 5zM9 17c0 2.757 2.243 5 5 5s5-2.243 5-5c0-1.58-.754-3.063-2-3.997V5c0-.811-.316-1.566-.873-2.108A2.944 2.944 0 0014 2c-1.654 0-3 1.346-3 3v8.003A5.008 5.008 0 009 17zM3 7h4c.55 0 1-.45 1-1s-.45-1-1-1H3c-.55 0-1 .45-1 1s.45 1 1 1z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-termometer-plus"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 9.54V5a.965.965 0 00-.287-.694A.976.976 0 0014 4c-.552 0-1 .449-1 1v4.54h2zM14 22c-2.757 0-5-2.243-5-5 0-1.58.754-3.063 2-3.997V5c0-1.654 1.346-3 3-3 .812 0 1.566.317 2.127.892C16.684 3.434 17 4.189 17 5v8.003c1.246.934 2 2.417 2 3.997 0 2.757-2.243 5-5 5zM4 7H3c-.55 0-1-.45-1-1s.45-1 1-1h1V4c0-.55.45-1 1-1s1 .45 1 1v1h1c.55 0 1 .45 1 1s-.45 1-1 1H6v1c0 .55-.45 1-1 1s-1-.45-1-1V7z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-thrash"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16c0 .55-.45 1-1 1s-1-.45-1-1v-4c0-.55.45-1 1-1s1 .45 1 1v4zM10 4.328c0-.155.214-.328.5-.328h3c.286 0 .5.173.5.328V6h-4V4.328zM10 16c0 .55-.45 1-1 1s-1-.45-1-1v-4c0-.55.45-1 1-1s1 .45 1 1v4zM21 6h-5V4.328C16 3.044 14.879 2 13.5 2h-3C9.121 2 8 3.044 8 4.328V6H3c-.55 0-1 .45-1 1s.45 1 1 1h1v11c0 1.654 1.346 3 3 3h10c1.654 0 3-1.346 3-3V8h1c.55 0 1-.45 1-1s-.45-1-1-1z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-thrash-full"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 4.328c0-.155.214-.328.5-.328h3c.286 0 .5.173.5.328V6h-4V4.328zM21 6h-5V4.328C16 3.044 14.879 2 13.5 2h-3C9.121 2 8 3.044 8 4.328V6H3c-.55 0-1 .45-1 1s.45 1 1 1h1v11c0 1.654 1.346 3 3 3h10c1.654 0 3-1.346 3-3V8h1c.55 0 1-.45 1-1s-.45-1-1-1z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-timer"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 14h-3a1 1 0 01-1-1v-3a1 1 0 112 0v2h2a1 1 0 110 2zm-2.012-9.942C12.99 4.037 13 4.021 13 4V3h1a1 1 0 100-2h-4a1 1 0 100 2h1v1c0 .021.01.037.012.058C6.513 4.552 3 8.372 3 13c0 4.963 4.038 9 9 9s9-4.037 9-9c0-4.628-3.513-8.448-8.012-8.942z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-toggle-left"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.003 11.006a.998.998 0 10.002 1.998.998.998 0 00-.002-1.998zM9.008 15a3 3 0 01-3-2.992 2.999 2.999 0 012.992-3A2.999 2.999 0 0112 12a3 3 0 01-2.992 3zm5.979-9.994l-5.993.008c-3.853.005-6.986 3.145-6.98 7 .005 3.853 3.145 6.986 7 6.98l5.992-.008c3.854-.005 6.986-3.145 6.98-7-.004-3.853-3.145-6.986-7-6.98z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-toggle-right"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 11a1 1 0 100 2 1 1 0 000-2zm0 4c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zm0-10H9c-3.859 0-7 3.141-7 7s3.141 7 7 7h6c3.859 0 7-3.141 7-7s-3.141-7-7-7z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-tv"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 19a1 1 0 01-1 1H6a1 1 0 01-1-1v-7a1 1 0 011-1h12a1 1 0 011 1v7zM18 6h-3.586l2.293-2.293a.999.999 0 10-1.414-1.414L12 5.586 8.707 2.293a.999.999 0 10-1.414 1.414L9.586 6H6C4.346 6 3 7.346 3 9v10c0 1.654 1.346 3 3 3h12c1.654 0 3-1.346 3-3V9c0-1.654-1.346-3-3-3z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-twitter"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.077 20c7.246 0 11.438-5.626 11.438-10.965 0-.147 1.03-1.03 1.47-2.874a.441.441 0 00-.616-.512c-.88.404-1.773.084-2.161-.376a3.874 3.874 0 00-5.574-.175 4.112 4.112 0 00-1.14 3.86c-3.351.24-5.652-1.349-7.544-3.526-.244-.283-.697-.134-.748.24-.28 2.082-.368 7.144 4.648 10.051-.871 1.252-2.576 1.991-4.474 2.308-.42.071-.52.653-.136.841a10.923 10.923 0 004.837 1.125",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-umbrella"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.486 2 2 6.486 2 12a1 1 0 001 1h8v6c0 1.654 1.346 3 3 3s3-1.346 3-3a1 1 0 10-2 0 1 1 0 01-2 0v-6h8a1 1 0 001-1c0-5.514-4.486-10-10-10z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-undo"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.22 21c-.46 0-.861-.315-.971-.763-.89-3.649-4.02-6.285-7.795-6.684v1.121c0 .706-.42 1.335-1.092 1.64a2.032 2.032 0 01-2.177-.304l-5.067-4.424A1.785 1.785 0 012.5 10.25c0-.505.226-.992.618-1.336L8.185 4.49a2.032 2.032 0 012.177-.304c.673.305 1.092.934 1.092 1.64v1.218C17.078 7.537 21.5 12.15 21.5 17.75c0 .81-.103 1.646-.307 2.486a1 1 0 01-.972.764z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-upload"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.846 11.827c.021.068.043.136.057.207.062.313.097.635.097.966 0 .308-.036.611-.092.91-.013.068-.03.134-.046.2l-.022.088a5.145 5.145 0 01-.303.877c-.087.19-.188.372-.3.551l-.05.084a2.036 2.036 0 01-.085.14c-.01.012-.017.026-.025.039a.473.473 0 01-.026.042.1.1 0 01-.03.025.114.114 0 00-.023.02C20.086 17.196 18.642 18 17 18h-3v-1.267A1.99 1.99 0 0015 17a2.001 2.001 0 001.414-3.414l-3-3a2 2 0 00-2.8-.029l-3.003 2.9A2.003 2.003 0 009 16.897c.356 0 .698-.093.999-.267V18H7c-1.642 0-3.086-.803-3.997-2.025-.007-.007-.016-.013-.024-.018-.011-.007-.022-.014-.03-.026a.444.444 0 01-.028-.045l-.022-.037a2.197 2.197 0 01-.089-.142l-.048-.08a5.15 5.15 0 01-.3-.552 5.567 5.567 0 01-.116-.282l-.004-.01a5.14 5.14 0 01-.2-.66 2.89 2.89 0 01-.05-.213A5.023 5.023 0 012 13c0-.33.036-.653.097-.966a2.01 2.01 0 01.059-.213l.037-.122.012-.046c.048-.176.096-.351.163-.518.036-.09.08-.175.125-.26l.058-.112.019-.038c.07-.14.14-.278.224-.409.064-.1.136-.194.208-.287l.052-.067.003-.004c.097-.125.193-.248.3-.364.097-.104.2-.197.306-.292l.018-.016a4.509 4.509 0 01.734-.546 4.72 4.72 0 01.43-.234 4.632 4.632 0 01.896-.326 4.22 4.22 0 01.407-.094c.026-.005.052-.012.077-.019a.747.747 0 01.1-.022A6.02 6.02 0 0112 4a6.018 6.018 0 015.675 4.045c.034.005.067.014.1.023a.97.97 0 00.078.018 4.2 4.2 0 01.406.094 4.656 4.656 0 011.326.56c.127.076.25.156.369.244.127.094.247.196.365.302.112.1.22.198.324.308.109.117.206.242.303.368l.038.05c.077.098.154.197.223.304.083.13.152.268.222.407a7.376 7.376 0 00.078.152c.044.085.088.17.125.26.068.167.116.344.164.52l.012.044c.011.043.025.086.038.128zm-10.541-.547a1.003 1.003 0 011.402.013l3 3a.999.999 0 11-1.414 1.414L13 14.414V20a1 1 0 11-2 0v-5.644l-1.305 1.26a1 1 0 01-1.39-1.439l3-2.897z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-user"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 7c0 2.206-1.794 4-4 4S8 9.206 8 7s1.794-4 4-4 4 1.794 4 4zm3 13a1 1 0 01-1 1H6a1 1 0 01-1-1c0-3.86 3.141-7 7-7s7 3.14 7 7z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-user-add"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 11c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4zm11-5h-1V5c0-.55-.45-1-1-1s-1 .45-1 1v1h-1c-.55 0-1 .45-1 1s.45 1 1 1h1v1c0 .55.45 1 1 1s1-.45 1-1V8h1c.55 0 1-.45 1-1s-.45-1-1-1zm-4 14a1 1 0 01-1 1H4a1 1 0 01-1-1c0-3.86 3.141-7 7-7s7 3.14 7 7z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-user-ok"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 11c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4zm11.656-6.754a1 1 0 00-1.41.098l-1.867 2.145-.634-.71a.999.999 0 10-1.49 1.335l1.39 1.553a1 1 0 00.744.333h.007c.287-.002.56-.127.748-.343l2.611-3a1 1 0 00-.099-1.411zM17 20a1 1 0 01-1 1H4a1 1 0 01-1-1c0-3.86 3.141-7 7-7s7 3.14 7 7z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-user-remove"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 11c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4zm11-5h-4c-.55 0-1 .45-1 1s.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1zm-4 14a1 1 0 01-1 1H4a1 1 0 01-1-1c0-3.86 3.141-7 7-7s7 3.14 7 7z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-user-remove-1"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 11c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4zm10.465-3.5l.733-.732a1.04 1.04 0 000-1.466 1.039 1.039 0 00-1.465 0L19 6.035l-.732-.733a1.04 1.04 0 00-1.466 0 1.042 1.042 0 000 1.466l.733.732-.733.732a1.042 1.042 0 000 1.466 1.04 1.04 0 001.466 0L19 8.965l.733.733a1.039 1.039 0 001.465 0 1.04 1.04 0 000-1.466l-.733-.732zM17 20a1 1 0 01-1 1H4a1 1 0 01-1-1c0-3.859 3.141-7 7-7s7 3.141 7 7z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-verified"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.875 11.667a.506.506 0 010 .667l-2.042 2.329a.505.505 0 00-.123.38l.284 3.079a.506.506 0 01-.393.54l-3.018.684a.507.507 0 00-.324.236l-1.58 2.66a.508.508 0 01-.637.208l-2.84-1.217a.51.51 0 00-.402 0l-2.84 1.225a.508.508 0 01-.639-.206l-1.58-2.66a.507.507 0 00-.324-.236L3.4 18.672a.507.507 0 01-.393-.54l.285-3.09a.506.506 0 00-.124-.38l-2.042-2.329a.506.506 0 010-.666l2.043-2.34a.506.506 0 00.123-.378L3.006 5.86a.507.507 0 01.395-.54l3.015-.676a.507.507 0 00.326-.236l1.58-2.66a.508.508 0 01.636-.207L11.8 2.76a.509.509 0 00.4 0l2.841-1.218a.508.508 0 01.638.208l1.58 2.67c.071.12.189.205.325.236l3.017.684a.506.506 0 01.393.54l-.284 3.08a.506.506 0 00.123.38l2.042 2.328zm-12.092 1.715l4.268-5.033c.376-.445 1.082-.532 1.58-.193.496.34.592.974.214 1.42l-5.153 6.077c-.211.25-.54.398-.889.399h-.008a1.18 1.18 0 01-.888-.388l-2.742-3.147c-.385-.44-.298-1.077.193-1.421.49-.346 1.2-.269 1.583.173l1.842 2.113z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-video"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.012 7.146a1.719 1.719 0 00-1.851.306l-2.161 2V8c0-1.654-1.345-3-3-3H5C3.346 5 2 6.346 2 8v8c0 1.654 1.346 3 3 3h9c1.655 0 3-1.346 3-3v-1.451l2.16 1.998c.322.297.737.453 1.16.453.233 0 .468-.047.692-.145.609-.267.988-.835.988-1.485V8.63c0-.65-.38-1.218-.988-1.484z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-video-off"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 13.586l2 2 3.707 3.707a.999.999 0 11-1.414 1.414L16.386 17.8l-1.455-1.455L5.586 7l-1.76-1.76-.533-.533a.999.999 0 111.414-1.414L6.414 5l2 2L15 13.586zm6.012-6.44a1.719 1.719 0 00-1.851.306l-2.161 2V8c0-1.654-1.345-3-3-3H7.828L9.12 6.293l6.586 6.586 2 2 2.01 2.01a1.716 1.716 0 001.295-.034c.609-.267.988-.835.988-1.485V8.63c0-.65-.38-1.218-.988-1.484zm-6.788 9.906L4.879 7.707l-1.76-1.76-.145-.145A2.982 2.982 0 002 8v8c0 1.655 1.346 3 3 3h9c.617 0 1.189-.187 1.665-.507l-1.441-1.441z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-voice-message"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 8c-2.206 0-4 1.794-4 4 0 .731.212 1.409.557 2H9.443A3.953 3.953 0 0010 12c0-2.206-1.794-4-4-4s-4 1.794-4 4 1.794 4 4 4h12c2.206 0 4-1.794 4-4s-1.794-4-4-4z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-volume"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 21a1 1 0 01-.565-.175l-6.412-4.396H5a1 1 0 01-1-1V8.571a1 1 0 011-1h5.023l6.412-4.396A1.001 1.001 0 0118 4v16a1.001 1.001 0 01-1 1z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-volume-down"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.434 3.175A.998.998 0 0117 4v16a1.001 1.001 0 01-1.566.825l-6.41-4.397H4a1 1 0 01-1-1V8.571a1 1 0 011-1h5.023l6.411-4.396zm3.94 5.046a1.001 1.001 0 011.405.152c1.636 2.034 1.636 5.22 0 7.254a1.001 1.001 0 01-1.559-1.254c1.036-1.286 1.036-3.46 0-4.746a1 1 0 01.153-1.406z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-volume-off"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 4v8.172L9.026 6.198l4.409-3.023A.998.998 0 0115 4zm6 8c0 1.599-.63 3.12-1.778 4.394l1.415 1.415C22.163 16.155 23 14.137 23 11.999c0-2.568-1.194-4.974-3.362-6.77a1.001 1.001 0 00-1.276 1.542C20.063 8.18 21 10.036 21 12zm-4.09 2.082l1.439 1.44c1.558-2.039 1.54-5.148-.07-7.149a1 1 0 00-1.559 1.254c.964 1.196 1.019 3.151.19 4.455zM4.744 7.572H2a1 1 0 00-1 1v6.856a1 1 0 001 1h5.023l6.411 4.397a1.005 1.005 0 001.032.06A.999.999 0 0015 20v-2.172L4.743 7.571zm-1.45-4.28a.999.999 0 011.414 0l16 16a.999.999 0 11-1.414 1.415l-16-16a.999.999 0 010-1.414z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-volume-up"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.434 3.175A.998.998 0 0115 4v16a1.001 1.001 0 01-1.566.825l-6.41-4.397H2a1 1 0 01-1-1V8.571a1 1 0 011-1h5.023l6.411-4.396zm6.204 2.054a1 1 0 10-1.275 1.541C20.063 8.18 21 10.036 21 12c0 1.963-.937 3.82-2.637 5.23a1 1 0 101.275 1.54C21.806 16.974 23 14.57 23 12c0-2.57-1.194-4.975-3.362-6.77zm-1.359 3.144a1.001 1.001 0 00-1.559 1.254c1.036 1.286 1.036 3.46 0 4.746a1 1 0 001.56 1.254c1.635-2.034 1.635-5.22 0-7.254z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-weight"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 4.172V6a1 1 0 102 0V4.172a3 3 0 011.907 2.1c.063.22.093.46.093.728 0 1.654-1.346 3-3 3S9 8.654 9 7c0-.262.031-.495.091-.712l.007-.035.004-.015A2.975 2.975 0 0111 4.172zM18 5h-1.422A4.983 4.983 0 0012 2a4.984 4.984 0 00-4.58 3H6C4.346 5 3 6.346 3 8v11c0 1.654 1.346 3 3 3h12c1.654 0 3-1.346 3-3V8c0-1.654-1.346-3-3-3z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    fill: "none",
    id: "sprite_svg__icon-bold-whatsapp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24z",
    fill: "#25D366"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.791 37.352h-.006c-2.388 0-4.735-.6-6.82-1.737L10.4 37.6l2.024-7.395a14.245 14.245 0 01-1.904-7.135c.003-7.868 6.405-14.27 14.27-14.27a14.18 14.18 0 0110.096 4.185 14.184 14.184 0 014.176 10.096c-.003 7.867-6.403 14.268-14.271 14.271zm-6.475-4.32l.433.257a11.843 11.843 0 006.037 1.653h.005c6.538 0 11.859-5.32 11.861-11.861a11.79 11.79 0 00-3.47-8.392 11.78 11.78 0 00-8.386-3.479c-6.543 0-11.864 5.321-11.867 11.861 0 2.241.626 4.424 1.814 6.313l.282.448-1.199 4.377 4.49-1.177zm13.176-6.878c.249.12.417.201.489.321.089.149.089.863-.208 1.696s-1.722 1.593-2.407 1.695c-.614.092-1.392.13-2.246-.141a20.476 20.476 0 01-2.033-.751c-3.343-1.444-5.602-4.684-6.029-5.296-.03-.043-.05-.073-.063-.088l-.002-.004c-.19-.252-1.454-1.94-1.454-3.685 0-1.643.807-2.504 1.179-2.9l.07-.075a1.31 1.31 0 01.95-.446c.238 0 .476.002.684.012.025.002.052.002.08.001.207 0 .466-.002.722.612l.394.955c.307.747.646 1.573.706 1.692.089.179.148.387.03.625-.019.036-.035.07-.05.102-.09.182-.156.316-.307.493-.06.07-.122.144-.183.22-.123.149-.245.298-.352.404-.179.178-.365.371-.157.728s.924 1.525 1.984 2.47a9.21 9.21 0 002.632 1.664c.098.043.178.077.236.106.356.179.564.149.772-.089.208-.238.892-1.041 1.13-1.398.237-.357.475-.298.802-.179.327.12 2.08.982 2.436 1.16l.195.096z",
    fill: "#FDFDFD"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-zoom-in"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 12h-1v1c0 .55-.45 1-1 1s-1-.45-1-1v-1H9c-.55 0-1-.45-1-1s.45-1 1-1h1V9c0-.55.45-1 1-1s1 .45 1 1v1h1c.55 0 1 .45 1 1s-.45 1-1 1zm7.707 7.293l-3.395-3.396A7.952 7.952 0 0019 11c0-4.411-3.589-8-8-8s-8 3.589-8 8 3.589 8 8 8a7.952 7.952 0 004.897-1.688l3.396 3.395a.997.997 0 001.414 0 .999.999 0 000-1.414z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-bold-zoom-out"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 12H9c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1zm7.707 7.293l-3.395-3.396A7.952 7.952 0 0019 11c0-4.411-3.589-8-8-8s-8 3.589-8 8 3.589 8 8 8a7.952 7.952 0 004.897-1.688l3.396 3.395a.997.997 0 001.414 0 .999.999 0 000-1.414z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-activity"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.33 20c-.068 0-.137-.003-.206-.01-.88-.086-1.57-.707-1.76-1.582L9.681 6.014l-2.763 6.383C6.76 12.764 6.398 13 6 13H3a1 1 0 110-2h2.344L7.85 5.21c.355-.816 1.137-1.29 2.026-1.202.88.087 1.57.708 1.76 1.583l2.683 12.393 2.763-6.383a1 1 0 01.918-.601h3a1 1 0 110 2h-2.344l-2.506 5.787A1.968 1.968 0 0114.33 20z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-add"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 11h-6V5a1 1 0 10-2 0v6H5a1 1 0 100 2h6v6a1 1 0 102 0v-6h6a1 1 0 100-2z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-add-circle"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 11h-2V9c0-.55-.45-1-1-1s-1 .45-1 1v2H9c-.55 0-1 .45-1 1s.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1v-2h2c.55 0 1-.45 1-1s-.45-1-1-1zm-3 9c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8zm0-18C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-add-comment"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 15c0 .551-.449 1-1 1H8.554c-.543 0-1.077.148-1.544.428L4 18.234V5c0-.551.449-1 1-1h14c.551 0 1 .449 1 1v10zM19 2H5C3.346 2 2 3.346 2 5v15a1 1 0 001.515.857l4.524-2.714A.997.997 0 018.554 18H19c1.654 0 3-1.346 3-3V5c0-1.654-1.346-3-3-3z",
    fill: "#29293D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 9h-2V7c0-.55-.45-1-1-1s-1 .45-1 1v2H9c-.55 0-1 .45-1 1s.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1v-2h2c.55 0 1-.45 1-1s-.45-1-1-1z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-alert-circle"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 8a1 1 0 012 0v5a1 1 0 01-2 0V8zm0 8a1 1 0 112 0 1 1 0 01-2 0zm1 4c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8zm0-18C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-alert-triangle"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 9a1 1 0 012 0v4a1 1 0 01-2 0V9zm0 7a1 1 0 112 0 1 1 0 01-2 0zm9.865 2.353c-.23.405-.675.647-1.193.647H4.328c-.518 0-.964-.242-1.192-.647a.971.971 0 01.017-1.017l7.67-12.718c.468-.774 1.886-.774 2.353 0l7.672 12.718c.266.44.125.827.017 1.017zm1.696-2.05L14.889 3.584c-.6-.992-1.68-1.584-2.89-1.584-1.21 0-2.29.592-2.887 1.584L1.44 16.303a2.973 2.973 0 00-.046 3.033C1.973 20.363 3.098 21 4.328 21h15.344c1.23 0 2.355-.637 2.935-1.664.54-.956.523-2.09-.046-3.033z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-antenna"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 5.55a1.563 1.563 0 11-3.125 0 1.563 1.563 0 013.125 0zm2 0a3.563 3.563 0 01-5.274 3.125l-.698.698 5.025 5.024c.748.75.853 2.12-.17 2.868-1.233.904-3.07 1.73-5.244 1.694a8.28 8.28 0 01-.42-.017c.378.73.516 1.476.516 2.045a1 1 0 01-2 0c0-.399-.149-1.05-.597-1.583-.415-.494-1.162-.98-2.559-.98-1.397 0-2.144.486-2.56.98a2.599 2.599 0 00-.596 1.583 1 1 0 01-2 0c0-.788.266-1.918 1.065-2.87.678-.806 1.687-1.422 3.08-1.623-.319-.267-.638-.56-.957-.878-2.39-2.39-3.307-4.825-3.343-7.027-.035-2.175.79-4.012 1.694-5.245.75-1.022 2.12-.918 2.868-.17l4.784 4.785.698-.698A3.563 3.563 0 1121 5.55zM7.483 4.656L18.57 15.745c-.957.666-2.324 1.24-3.9 1.214-1.621-.026-3.576-.688-5.645-2.757-2.07-2.07-2.732-4.024-2.758-5.646-.025-1.576.549-2.943 1.215-3.9z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-archivar"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.535 3a2 2 0 00-1.664.89L2.465 6l-.13.194A2 2 0 002 7.303V19a3 3 0 003 3h14a3 3 0 003-3V7.303a2 2 0 00-.336-1.11L21.535 6 20.13 3.89A2 2 0 0018.465 3H5.535zm12.662 3a.5.5 0 100-1H5.803a.5.5 0 000 1h12.394zM20 8.5a.5.5 0 00-.5-.5h-15a.5.5 0 00-.5.5V19a1 1 0 001 1h14a1 1 0 001-1V8.5z",
    fill: "#29293D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 14.603a.2.2 0 01-.341.141L9.414 13.5A1 1 0 008 14.914l3.646 3.647a.5.5 0 00.708 0L16 14.914a1 1 0 00-1.414-1.414l-1.245 1.244a.2.2 0 01-.34-.141V10.5a1 1 0 10-2 0v4.103z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-archive"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.866 14h4.268c.476 0 .866-.39.866-.866v-.268a.869.869 0 00-.866-.866H9.866a.868.868 0 00-.866.866v.268c0 .476.39.866.866.866zM18 18c0 .551-.448 1-1 1H7c-.551 0-1-.449-1-1V9h12v9zM6 5h12a1.001 1.001 0 010 2H6c-.551 0-1-.449-1-1 0-.551.449-1 1-1zm15 1c0-1.654-1.346-3-3-3H6C4.346 3 3 4.346 3 6c0 .883.391 1.67 1 2.22V18c0 1.654 1.346 3 3 3h10c1.654 0 3-1.346 3-3V8.22c.609-.55 1-1.337 1-2.22z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-arrow-circle-down"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.31 12.414L13 13.664V8a1 1 0 10-2 0v5.586l-1.293-1.293a.999.999 0 10-1.414 1.414l3 3a.996.996 0 001.084.217c.06-.025.109-.068.162-.104.05-.033.107-.053.152-.096l3-2.863a1 1 0 00-1.381-1.447zM12 20c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8zm0-18C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-arrow-circle-left"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 11h-5.664l1.25-1.31a1.001 1.001 0 00-1.447-1.38l-2.863 3c-.038.04-.055.09-.086.135-.041.059-.087.113-.114.181a.944.944 0 00-.057.283C7.016 11.94 7 11.968 7 12l.001.005a1.005 1.005 0 00.292.703l3 2.999a.997.997 0 001.414 0 .999.999 0 000-1.414L10.414 13H16a1 1 0 000-2zm-4 9c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8zm0-18C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-arrow-circle-right"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.999 12.005L17 12c0-.033-.016-.06-.019-.092a.937.937 0 00-.057-.282c-.027-.068-.073-.122-.114-.182-.031-.044-.048-.095-.086-.135l-2.863-3a1 1 0 10-1.447 1.381l1.25 1.31H8a1 1 0 100 2h5.586l-1.293 1.293a.999.999 0 101.414 1.414l3-3a.994.994 0 00.292-.702zM12 20c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8zm0-18C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-arrow-circle-up"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.707 7.293a.978.978 0 00-.322-.215.978.978 0 00-.38-.077H12c-.036 0-.066.015-.101.02-.092.01-.184.02-.271.054-.07.029-.126.075-.187.117-.042.03-.091.047-.13.085l-3 2.862a1.001 1.001 0 001.38 1.447l1.31-1.25V16a1 1 0 002 0v-5.585l1.293 1.293a1 1 0 001.415-1.415l-3-3zM12 20c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8zm0-18C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-arrow-corner-down-left"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.97 5.996a1 1 0 00-1-.996h-.003a1 1 0 00-.996 1.004l.02 5a.997.997 0 01-.995 1.004l-8.92.037 2.686-3.386a1 1 0 00-1.566-1.243l-3.98 5.016c-.29.367-.287.885.006 1.25l4.02 4.983a.998.998 0 001.406.15 1 1 0 00.15-1.406l-2.713-3.364 8.918-.037a2.981 2.981 0 002.119-.887 2.984 2.984 0 00.87-2.125l-.021-5z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-arrow-corner-down-right"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.78 12.376l-4-5a.999.999 0 10-1.561 1.248l2.7 3.377H8c-.55 0-1-.45-1-1V6a1 1 0 10-2 0v5c0 1.654 1.347 3 3 3h8.92l-2.7 3.374a.999.999 0 00.78 1.625.997.997 0 00.782-.375l4-5a1 1 0 000-1.25z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-arrow-corner-left-down"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 5h-5c-1.654 0-3 1.346-3 3v8.919l-3.375-2.7a1 1 0 00-1.25 1.562l5 4a1 1 0 001.25 0l5-4a1 1 0 00-1.25-1.562L12 16.919V8c0-.551.45-1 1-1h5a1 1 0 000-2z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-arrow-corner-left-up"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 17h-5c-.551 0-1-.449-1-1V7.081l3.375 2.7a1 1 0 001.25-1.562l-5-4a1.001 1.001 0 00-1.25 0l-5 4a1 1 0 001.25 1.562L10 7.081V16c0 1.654 1.346 3 3 3h5a1 1 0 000-2z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-arrow-corner-right-down"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.78 14.376a.999.999 0 00-1.404-.156L14 16.92V8c0-1.655-1.345-3-3-3H6a1 1 0 100 2h5a1 1 0 011 1v8.92l-3.375-2.7a1 1 0 10-1.25 1.56l5 4a.997.997 0 001.25 0l5-4a1 1 0 00.156-1.404z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-arrow-corner-right-up"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.625 8.22l-5-4a1 1 0 00-1.25 0l-5 4a1 1 0 001.249 1.562L12 7.08V16c0 .551-.447 1-1 1H6a1 1 0 000 2h5c1.655 0 3-1.346 3-3V7.08l3.376 2.701a.998.998 0 001.405-.157.999.999 0 00-.155-1.405z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-arrow-corner-up-left"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 10H7.081l2.7-3.375a1 1 0 00-1.562-1.25l-4 5a1.001 1.001 0 000 1.25l4 5a.998.998 0 001.406.156 1 1 0 00.156-1.406L7.081 12H16c.551 0 1 .449 1 1v5a1 1 0 002 0v-5c0-1.654-1.346-3-3-3z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-arrow-corner-up-right"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.781 10.375l-4-5a1 1 0 00-1.562 1.25L16.92 10H8c-1.655 0-3 1.345-3 3v5a1 1 0 002 0v-5a1 1 0 011-1h8.92l-2.7 3.375a1 1 0 101.561 1.25l4-5a1 1 0 000-1.25z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-arrow-down"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.768 13.36a1 1 0 00-1.408-.128L13 16.865V5a1 1 0 00-2 0v11.865l-4.36-3.633a1 1 0 10-1.28 1.536l6 5c.047.04.103.059.155.089.041.024.077.052.122.07A.992.992 0 0012 20a.992.992 0 00.363-.073c.045-.018.081-.046.122-.07.052-.03.108-.049.155-.089l6-5a1 1 0 00.128-1.408z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-arrow-ios-down"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 16a.993.993 0 01-.64-.232l-6-5a1 1 0 111.28-1.536l5.371 4.476 5.362-4.315a1 1 0 011.254 1.558l-6 4.828A1 1 0 0112 16z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-arrow-ios-left"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.829 19a.998.998 0 01-.78-.373l-4.828-6a1 1 0 01.01-1.267l5-6a1 1 0 111.536 1.28l-4.474 5.371 4.315 5.362a1 1 0 01-.78 1.627z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-arrow-ios-right"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 19a1 1 0 01-.768-1.64l4.476-5.371-4.316-5.362a1 1 0 011.56-1.254l4.828 6a1 1 0 01-.011 1.267l-5 6a1 1 0 01-.77.36z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-arrow-ios-up"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 15a.995.995 0 01-.64-.232l-5.371-4.476-5.362 4.315a.999.999 0 11-1.253-1.558l6-4.828a.998.998 0 011.266.011l6 5A1 1 0 0118 15z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-arrow-left"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 11H7.135l3.633-4.36a1 1 0 10-1.536-1.28l-5 6c-.039.047-.059.102-.088.154-.024.042-.053.078-.071.124a.985.985 0 00-.072.358L4 12l.001.004c0 .122.027.243.072.358.018.046.047.082.071.124.029.052.049.107.088.154l5 6a.999.999 0 101.536-1.28L7.135 13H19a1 1 0 000-2z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-arrow-left-down"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.293 6.293a.999.999 0 011.414 0L16 14.586V9a1 1 0 112 0v8a1 1 0 01-1 1H9a1 1 0 110-2h5.586L6.293 7.707a.999.999 0 010-1.414z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-arrow-left-up"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.707 16.293L9.418 8.004 15.001 8A1 1 0 0015 6h-.001l-7.95.006A1 1 0 006.05 7L6 14.994A1 1 0 006.994 16H7a1 1 0 001-.994l.035-5.557 8.258 8.258a.997.997 0 001.414 0 .999.999 0 000-1.414z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-arrow-right"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 13h11.865l-3.633 4.36a1 1 0 101.537 1.28l5-6c.039-.047.058-.102.087-.154.024-.042.053-.078.071-.124a.985.985 0 00.072-.358L20 12l-.001-.004a.985.985 0 00-.072-.358c-.018-.046-.047-.082-.071-.124-.029-.052-.048-.107-.087-.154l-5-6a1.002 1.002 0 00-1.409-.128 1 1 0 00-.128 1.408L16.865 11H5a1 1 0 000 2z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-arrow-right-down"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 8a1 1 0 00-1 1v5.586L7.707 6.293a.999.999 0 10-1.414 1.414L14.586 16H9a1 1 0 100 2h8a1 1 0 001-1V9a1 1 0 00-1-1z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-arrow-right-up"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.993 7.049a1 1 0 00-.994-1L9.006 6H9a1 1 0 00-.006 2l5.558.036-8.259 8.258a.999.999 0 101.414 1.414l8.288-8.288L16 15A1 1 0 0017 16h.001a1 1 0 001-1.001l-.008-7.95z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-arrow-triangle-down"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.092 10l3.91 4.822L15.987 10H8.092zM12 17c-.506 0-.99-.233-1.326-.642L6.46 11.26a2.087 2.087 0 01-.26-2.211C6.508 8.402 7.115 8 7.788 8h8.426c.673 0 1.28.402 1.585 1.049.346.733.245 1.6-.258 2.21l-4.214 5.099c-.336.409-.82.642-1.326.642z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-arrow-triangle-left"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.678 12.002l4.822 3.983V8.092l-4.822 3.91zm4.866 5.999c-.47 0-.935-.157-1.303-.461l-5.1-4.214A1.724 1.724 0 016.501 12c0-.506.233-.99.64-1.326l5.1-4.213c.608-.504 1.475-.605 2.21-.26.646.306 1.05.913 1.05 1.586v8.426c0 .673-.404 1.28-1.05 1.586a2.127 2.127 0 01-.907.202z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-arrow-triangle-right"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 8.015v7.894l4.821-3.911L10.5 8.015zM10.456 18c-.307 0-.617-.066-.906-.202-.648-.305-1.05-.913-1.05-1.586V7.787c0-.672.402-1.28 1.05-1.585a2.085 2.085 0 012.209.258l5.099 4.214c.409.336.642.82.642 1.326 0 .506-.233.99-.642 1.327l-5.099 4.212a2.04 2.04 0 01-1.303.462z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-arrow-triangle-up"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.014 14h7.895l-3.911-4.822L8.014 14zm8.199 2H7.787c-.672 0-1.28-.402-1.585-1.049a2.087 2.087 0 01.258-2.21l4.214-5.099c.672-.817 1.98-.817 2.652 0l4.213 5.098c.504.611.605 1.478.259 2.211-.305.647-.912 1.049-1.585 1.049z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-arrow-up"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.232 10.64a1 1 0 001.408.128L11 7.135V19a1 1 0 002 0V7.135l4.36 3.633a1 1 0 101.28-1.536l-6-5c-.047-.04-.103-.059-.155-.089-.041-.024-.077-.052-.122-.07A.992.992 0 0012 4a.992.992 0 00-.363.073c-.045.018-.081.046-.122.07-.052.03-.108.049-.155.089l-6 5a1 1 0 00-.128 1.408z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-arrowhead-down"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12a.995.995 0 01-.64-.232l-6-5a1 1 0 011.28-1.536l5.37 4.475 5.363-4.314a1 1 0 011.254 1.558l-6 4.828A1 1 0 0112 12zm.011 4.708l5.362-4.315a1.002 1.002 0 011.406.152c.346.43.278 1.06-.152 1.407l-6 4.828a.999.999 0 01-1.267-.012l-6-5a1 1 0 111.28-1.536l5.371 4.476z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-arrowhead-left"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.768 6.64l-4.476 5.371 4.315 5.362a1 1 0 01-1.559 1.254l-4.828-6a1 1 0 01.011-1.267l5-6a1 1 0 011.537 1.28zm-8.536-1.28a1 1 0 011.536 1.28l-4.476 5.37 4.315 5.363a1 1 0 01-1.558 1.254l-4.828-6a1 1 0 01.011-1.267l5-6z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-arrowhead-right"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.951 5.373l4.828 6a1 1 0 01-.01 1.267l-5 6a1 1 0 11-1.537-1.28l4.476-5.371-4.316-5.362a1 1 0 111.56-1.254zm-8.406-.152a1 1 0 011.406.152l4.828 6a1 1 0 01-.01 1.267l-5 6a1 1 0 11-1.537-1.28l4.475-5.371-4.315-5.362a1 1 0 01.153-1.406z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-arrowhead-up"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.989 7.292l-5.362 4.315a1 1 0 01-1.254-1.559l6-4.828a.998.998 0 011.267.012l6 5A.998.998 0 0118 12c-.226 0-.453-.077-.64-.232l-5.371-4.476zm-.616 4.929a.998.998 0 011.267.01l6 5a1 1 0 01-1.28 1.537l-5.371-4.475-5.362 4.314a.999.999 0 11-1.254-1.558l6-4.828z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-at"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.182 15.09A3.095 3.095 0 018.09 12a3.095 3.095 0 013.09-3.091 3.095 3.095 0 013.092 3.09 3.095 3.095 0 01-3.091 3.092zm1.773-13.046a9.988 9.988 0 00-8.05 2.909 10 10 0 00-2.854 8.073c.358 3.572 2.609 6.682 5.876 8.115 1.307.573 2.693.854 4.069.854 2.168 0 4.313-.7 6.084-2.055a1 1 0 10-1.216-1.588c-2.318 1.775-5.434 2.139-8.134.957-2.568-1.126-4.407-3.67-4.69-6.483a8.007 8.007 0 018.73-8.79C16.825 4.413 20 8.01 20 12.225v.675c0 .468-.186.904-.525 1.228-.338.324-.786.49-1.253.47-.894-.04-1.622-.88-1.622-1.874V8.4a1 1 0 00-1-1 .987.987 0 00-.975.875 5.056 5.056 0 00-3.443-1.366 5.098 5.098 0 00-5.091 5.09 5.097 5.097 0 005.09 5.092c1.7 0 3.2-.846 4.125-2.13.645.94 1.668 1.584 2.828 1.635a3.646 3.646 0 002.724-1.023A3.666 3.666 0 0022 12.9v-.675c0-5.237-3.972-9.708-9.045-10.181z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-attach"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22c-3.309 0-6-2.557-6-5.698V6.132C6 3.854 7.944 2 10.333 2c2.39 0 4.334 1.854 4.334 4.132l-.006 10.177c0 1.414-1.197 2.565-2.667 2.565-1.47 0-2.666-1.151-2.666-2.566l.005-9.391a1 1 0 011-.999h.001a1 1 0 01.999 1.001l-.005 9.39c0 .311.298.565.666.565.368 0 .667-.254.667-.566l.006-10.177C12.667 4.956 11.62 4 10.333 4 9.047 4 8 4.956 8 6.132v10.17C8 18.341 9.794 20 12 20s4-1.659 4-3.698V6.132a1 1 0 112 0v10.17C18 19.443 15.309 22 12 22z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-attach-2"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.294 21c-1.656 0-3.23-.666-4.432-1.875-2.388-2.403-2.486-6.213-.22-8.494l7.386-7.43A4.085 4.085 0 0114.95 2c1.194 0 2.328.479 3.192 1.349 1.721 1.731 1.788 4.482.146 6.132l-7.395 7.429a2.535 2.535 0 01-1.815.748 2.738 2.738 0 01-1.95-.821c-1.053-1.061-1.086-2.752-.073-3.772L13.88 6.21a.999.999 0 111.416 1.41l-6.823 6.856c-.24.242-.207.669.074.951a.76.76 0 00.53.231.55.55 0 00.399-.158l7.394-7.429c.867-.873.802-2.358-.146-3.312-.906-.912-2.446-.984-3.277-.148l-7.386 7.43c-1.494 1.503-1.396 4.049.22 5.674C7.104 18.544 8.174 19 9.294 19a3.648 3.648 0 002.61-1.064l7.387-7.43a1 1 0 111.418 1.41l-7.386 7.43C12.262 20.412 10.83 21 9.293 21z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-award"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.306 16.707a.994.994 0 00-.99.013l-3.748 2.2 1.468-5.71a5.957 5.957 0 005.929 0l1.489 5.792-4.148-2.295zM12 4c2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.794-4-4 1.794-4 4-4zm6.969 16.751l-2.31-8.979A5.972 5.972 0 0018 8c0-3.309-2.69-6-6-6-3.307 0-6 2.691-6 6 0 1.429.505 2.74 1.34 3.772l-2.307 8.979a.999.999 0 001.474 1.111l5.33-3.129 5.68 3.142a1.001 1.001 0 001.453-1.124z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-back-to-search-result-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 3,
    width: 12,
    height: 4,
    rx: 1,
    stroke: "#29293D",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 10,
    width: 12,
    height: 4,
    rx: 1,
    stroke: "#29293D",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 16H5l1.768-2.36a1 1 0 10-1.536-1.28l-3 4c-.039.047-.059.102-.088.154-.024.042-.053.078-.071.124a.986.986 0 00-.072.358L2 17l.001.004c0 .122.027.243.072.358.018.046.047.082.071.124.029.052.049.107.088.154l3 4a.999.999 0 101.536-1.28L5 18h8a1 1 0 000-2z",
    fill: "#29293D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 19.5v.5a1 1 0 001 1h10a1 1 0 001-1v-2a1 1 0 00-1-1h-4.5",
    stroke: "#29293D",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-background"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.25 3H6.75C4.68 3 3 4.68 3 6.75v10.5C3 19.32 4.68 21 6.75 21h10.5c2.07 0 3.75-1.68 3.75-3.75V6.75C21 4.68 19.32 3 17.25 3zm2.25 10.943L13.943 19.5h-3.128l8.693-8.693v3.128l-.008.008zm-1.282-9.218l-13.5 13.493a2.205 2.205 0 01-.218-.968v-1.943L15.307 4.5h1.943c.345 0 .675.082.968.218v.007zM4.5 10.057L10.057 4.5h3.128L4.5 13.193v-3.136zM6.75 4.5h1.192L4.5 7.942V6.75A2.257 2.257 0 016.75 4.5zm-.968 14.782l13.5-13.5c.143.293.218.623.218.968v1.943L8.693 19.5H6.75c-.345 0-.675-.082-.968-.218zm11.468.218h-1.192l3.442-3.442v1.192a2.257 2.257 0 01-2.25 2.25z",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-backspace"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.293 14.707a.997.997 0 001.414 0L14 13.414l1.293 1.293a.997.997 0 001.414 0 .999.999 0 000-1.414L15.414 12l1.293-1.293a.999.999 0 10-1.414-1.414L14 10.586l-1.293-1.293a.999.999 0 10-1.414 1.414L12.586 12l-1.293 1.293a.999.999 0 000 1.414zM20 18h-9.63a1 1 0 01-.673-.261L4.37 11.894l5.377-5.675A.997.997 0 0110.37 6H20v12zm.141-14h-9.77a2.99 2.99 0 00-2.019.781.87.87 0 00-.106.113l-6.024 6.479a1 1 0 00.105 1.367l6.025 6.479A2.99 2.99 0 0010.37 20h9.771c1.025 0 1.86-.815 1.86-1.818V5.818C22 4.815 21.165 4 20.14 4z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-bar-chart-1"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4c-.55 0-1 .45-1 1v15c0 .55.45 1 1 1s1-.45 1-1V5c0-.55-.45-1-1-1zm7 8c-.55 0-1 .45-1 1v7c0 .55.45 1 1 1s1-.45 1-1v-7c0-.55-.45-1-1-1zM4 9c0-.55.45-1 1-1s1 .45 1 1v11c0 .55-.45 1-1 1s-1-.45-1-1V9z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-bar-chart-2"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 4c-.55 0-1 .45-1 1v15c0 .55.45 1 1 1s1-.45 1-1V5c0-.55-.45-1-1-1zm-7 4c-.55 0-1 .45-1 1v11c0 .55.45 1 1 1s1-.45 1-1V9c0-.55-.45-1-1-1zm-8 5c0-.55.45-1 1-1s1 .45 1 1v7c0 .55-.45 1-1 1s-1-.45-1-1v-7z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-battery"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 10v4a1 1 0 01-2 0v-4a1 1 0 012 0zm-6 5.571c0 .253-.121.406-.172.429l-11.652.001c-.05-.018-.176-.171-.176-.43V8.429c0-.259.126-.412.167-.429l11.657-.001c.05.018.176.171.176.43v7.142zM15.833 6H4.167C2.972 6 2 7.089 2 8.429v7.142C2 16.911 2.972 18 4.167 18h11.666C17.028 18 18 16.911 18 15.571V8.429C18 7.089 17.028 6 15.833 6z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-battery-charging"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.504 19.868a.999.999 0 001.364-.372l4-7A1 1 0 0013 11H8.723l3.145-5.504a1 1 0 10-1.736-.992l-4 7A1 1 0 007 13h4.277l-3.145 5.504a1 1 0 00.372 1.364zM12.732 6h3.102C17.029 6 18 7.089 18 8.429v7.142C18 16.911 17.03 18 15.834 18h-3.958l1.142-2h2.81c.052-.023.172-.176.172-.429V8.429c0-.259-.126-.412-.175-.43h-4.236L12.732 6zM20 10a1 1 0 012 0v4a1 1 0 01-2 0v-4zM4 15.571V8.428c0-.258.126-.412.167-.428h2.815l1.143-2H4.167C2.972 6 2 7.09 2 8.428v7.143c0 1.34.972 2.43 2.167 2.43h3.101l1.142-2H4.176c-.05-.018-.176-.172-.176-.43z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-behance"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.25 9.703h3v-.5h-3v.5zm2.538 2.591h-2.061v-.01c0-.618.412-1.096 1.038-1.096.62 0 1.023.473 1.023 1.096v.01zm-1.033-1.997c-1.354 0-2.28.837-2.28 2.252v.441c0 1.48.921 2.307 2.333 2.307 1.378 0 2.047-.77 2.169-1.543h-1.184c-.107.392-.466.628-.975.628-.65 0-1.091-.464-1.091-1.196v-.132h3.298v-.474c0-1.388-.868-2.283-2.27-2.283zm-5.536 3.94H8.26v-1.933h1.227c.757 0 1.17.376 1.17.99 0 .619-.417.943-1.438.943zM8.26 9.67h1.145c.605 0 .959.324.959.852 0 .567-.383.886-1.251.886H8.26V9.67zm2.258 2.114v-.056c.647-.158 1.122-.634 1.122-1.424 0-.995-.767-1.601-1.937-1.601H6.975v6.5h2.723c1.328 0 2.277-.671 2.277-1.833 0-.975-.671-1.51-1.457-1.586zM12 20c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8zm0-18C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 80 62",
    fill: "none",
    id: "sprite_svg__icon-light-blog"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sprite_svg__icon-light-blog_clip0_2626_244281)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.787 58.853h.5V8.036c0-2.395-1.93-4.342-4.316-4.342H8.03c-2.386 0-4.316 1.947-4.316 4.342v50.817h72.074z",
    stroke: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.462 62H4.538a4.316 4.316 0 01-4.321-4.31v-1.002c0-.39.316-.706.707-.706h78.152c.39 0 .708.316.708.706v1.001c0 2.381-1.935 4.311-4.322 4.311z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.563 5.522v48.505H17V5.522C17 4.68 17.681 4 18.522 4H62.04c.84 0 1.522.681 1.522 1.522z",
    stroke: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.548 26.182h-2.742a1.374 1.374 0 01-1.371-1.377c0-.759.615-1.376 1.37-1.376h2.743c.759 0 1.371.617 1.371 1.376 0 .759-.612 1.377-1.37 1.377zM57.102 26.182H31.036a1.374 1.374 0 01-1.371-1.377c0-.759.615-1.376 1.37-1.376h26.067c.758 0 1.37.617 1.37 1.376 0 .759-.614 1.377-1.37 1.377zM28.293 37.896h-5.487a1.374 1.374 0 01-1.371-1.376c0-.759.615-1.376 1.37-1.376h5.488c.759 0 1.371.617 1.371 1.376 0 .759-.615 1.376-1.37 1.376zM57.102 37.896H33.78a1.374 1.374 0 01-1.371-1.376c0-.759.615-1.376 1.37-1.376h23.322a1.376 1.376 0 010 2.753zM33.78 32.039H22.807a1.374 1.374 0 01-1.371-1.376c0-.76.615-1.377 1.37-1.377h10.976c.758 0 1.37.618 1.37 1.377 0 .758-.614 1.376-1.37 1.376zM46.127 32.039h-6.859a1.374 1.374 0 01-1.371-1.376c0-.76.615-1.377 1.371-1.377h6.859c.758 0 1.371.618 1.371 1.377 0 .758-.615 1.376-1.371 1.376zM57.001 9.318h-12.52c-.865 0-1.564-.598-1.564-1.332 0-.733.702-1.33 1.565-1.33h12.52c.865 0 1.564.597 1.564 1.33 0 .734-.702 1.332-1.565 1.332zM57.001 14.91h-12.52c-.865 0-1.564-.598-1.564-1.332 0-.734.702-1.33 1.565-1.33h12.52c.865 0 1.564.596 1.564 1.33 0 .734-.702 1.331-1.565 1.331zM57.001 20.5h-12.52c-.865 0-1.564-.597-1.564-1.33 0-.735.702-1.332 1.565-1.332h12.52c.865 0 1.564.597 1.564 1.331S57.864 20.5 57 20.5zM57.102 32.039h-5.488a1.374 1.374 0 01-1.37-1.376c0-.76.614-1.377 1.37-1.377h5.488c.758 0 1.371.618 1.371 1.377 0 .758-.615 1.376-1.371 1.376zM28.293 48.577h-5.487a1.374 1.374 0 01-1.371-1.376c0-.76.615-1.377 1.37-1.377h5.488c.759 0 1.371.618 1.371 1.377 0 .758-.615 1.376-1.37 1.376zM57.102 48.577H33.78a1.374 1.374 0 01-1.371-1.376c0-.76.615-1.377 1.37-1.377h23.322c.758 0 1.371.618 1.371 1.377 0 .758-.615 1.376-1.371 1.376zM33.78 43.753H22.807a1.374 1.374 0 01-1.371-1.377c0-.758.615-1.376 1.37-1.376h10.976c.758 0 1.37.618 1.37 1.376 0 .76-.614 1.377-1.37 1.377zM46.127 43.753h-6.859a1.374 1.374 0 01-1.371-1.377c0-.758.615-1.376 1.371-1.376h6.859a1.376 1.376 0 010 2.753zM57.102 43.753h-5.488a1.374 1.374 0 01-1.37-1.377c0-.758.614-1.376 1.37-1.376h5.488a1.376 1.376 0 010 2.753z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5 20.647V6.375a.019.019 0 00-.006-.014.015.015 0 00-.01-.005H21.95a.015.015 0 00-.011.005.02.02 0 00-.006.014v14.272c0 .005.002.01.006.013a.016.016 0 00.01.005s0 0 0 0h17.534a.015.015 0 00.01-.005.02.02 0 00.006-.013z",
    stroke: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.718 17.653h-8.952c-.011 0-.022 0-.033-.003l4.233-7.361a.297.297 0 01.516 0l2.842 4.94.136.236 1.258 2.188z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M32.718 17.652h-3.056l1.5-2.187.108-.158.054-.079.136.237 1.258 2.188z",
    fill: "#C3C2C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.702 17.652h-7.743l1.5-2.187.108-.158 1.956-2.85c.128-.188.436-.2.587-.036.01.011.02.023.028.035l3.564 5.196zM31.866 12.033A1.329 1.329 0 0130.54 10.7c0-.735.594-1.33 1.326-1.33.733 0 1.327.595 1.327 1.33 0 .736-.594 1.332-1.327 1.332z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-bluetooth"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 18.25v-4.072l2.467 2.38L13 18.25zm0-12.49l2.497 1.734L13 9.85V5.76zm.629 6.247l4.015-3.79a1.133 1.133 0 00-.137-1.762L12.833 3.21a1.169 1.169 0 00-1.215-.077A1.141 1.141 0 0011 4.146v6.205L7.807 6.375a.999.999 0 10-1.56 1.25l3.474 4.328-3.505 4.427a1 1 0 101.568 1.24L11 13.56v6.293c0 .424.235.811.613 1.011a1.184 1.184 0 001.214-.07l4.642-3.186a1.135 1.135 0 00.147-1.757l-3.987-3.845z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-bold"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.25 11.8A3.68 3.68 0 0017 9a3.93 3.93 0 00-3.86-4H6.65v14h7a3.739 3.739 0 003.7-3.78v-.12a3.64 3.64 0 00-2.1-3.3zM8.65 7h4.2a2.09 2.09 0 012 1.3 2.09 2.09 0 01-1.37 2.61c-.205.06-.417.09-.63.09h-4.2V7zm4.6 10h-4.6v-4h4.6a2.09 2.09 0 012 1.3 2.09 2.09 0 01-1.37 2.61c-.205.06-.417.09-.63.09z",
    fill: "#000018"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-book"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 19c-.551 0-1-.449-1-1 0-.551.449-1 1-1h11v2H7zM7 5h11v10H7c-.353 0-.686.072-1 .184V6c0-.551.449-1 1-1zm12-2H7C5.346 3 4 4.346 4 6v12c0 1.654 1.346 3 3 3h12a1 1 0 001-1V4a1 1 0 00-1-1z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-book-open"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 16.402l-6 1.348V7.597l6-1.347v10.152zM5 6.25l6 1.347V17.75l-6-1.348V6.25zm15.625-2.032a1.003 1.003 0 00-.845-.194L12 5.772 4.22 4.024A.999.999 0 003 5v12.202c0 .468.324.873.78.975l8 1.798a.977.977 0 00.44 0l8-1.798a.998.998 0 00.78-.975V5c0-.304-.138-.59-.375-.782z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-bookmark"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.821 15.506c.17 0 .34.043.492.129L17 18.285V5.335c0-.201-.12-.334-.2-.334H7.2c-.08 0-.2.133-.2.334v12.9l4.306-2.585c.16-.095.337-.143.515-.143zM6.001 21a1 1 0 01-1-1V5.334C5 4.047 5.986 3 7.2 3h9.6C18.012 3 19 4.047 19 5.334V20a1 1 0 01-1.493.87l-5.672-3.207-5.322 3.195A1.006 1.006 0 016 21z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-briefcase"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 5.5a.5.5 0 01.5-.5h3a.5.5 0 01.5.5V7h-4V5.5zM9 19h6V9H9v10zm11-1c0 .551-.449 1-1 1h-2V9h2c.551 0 1 .449 1 1v8zM4 10v8c0 .551.449 1 1 1h2V9H5c-.551 0-1 .449-1 1zm15-3h-3V5.5C16 4.122 14.878 3 13.5 3h-3A2.503 2.503 0 008 5.5V7H5c-1.654 0-3 1.346-3 3v8c0 1.654 1.346 3 3 3h14c1.654 0 3-1.346 3-3v-8c0-1.654-1.346-3-3-3z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 77 62",
    fill: "none",
    id: "sprite_svg__icon-light-briefcase-2"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sprite_svg__icon-light-briefcase-2_clip0_2636_244442)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.13 9.39H49.74V4.36a4.362 4.362 0 00-1.28-3.09c-.41-.41-.89-.73-1.43-.95-.53-.21-1.1-.33-1.67-.32H30.69c-1.16 0-2.28.46-3.1 1.27-.82.82-1.28 1.93-1.28 3.09v5.03H4.93C2.21 9.39 0 11.6 0 14.31v14.12c0 1.8.97 3.38 2.43 4.24v23.95c0 2.97 2.41 5.38 5.38 5.38h60.44c2.97 0 5.38-2.41 5.38-5.38V32.67a4.915 4.915 0 002.43-4.24V14.31c0-2.71-2.21-4.92-4.93-4.92zm-16.66 2v19.96H21.48V11.39h32.99zM30.81 7.03c0-.29.06-.59.17-.86.12-.27.28-.52.49-.73.21-.21.46-.38.74-.49.27-.11.57-.17.86-.17h9.91c.3 0 .59.06.87.17.27.11.52.28.73.49.21.21.38.46.49.73.12.27.18.57.18.86v2.36H30.81V7.03zM2 28.43V14.31c0-1.61 1.31-2.92 2.93-2.92h9.17v19.96H4.93c-.17 0-.34-.01-.5-.05-.85-.14-1.57-.64-2-1.35-.27-.44-.43-.97-.43-1.52zm69.63 28.19c0 1.86-1.51 3.38-3.38 3.38H7.81c-1.87 0-3.38-1.52-3.38-3.38v-23.3c.16.02.33.03.5.03h9.17v4.68h-1.68a.68.68 0 00-.68.68v5.83c0 .37.3.67.68.67h1.68v5.87c-.02.49.07.98.25 1.44a3.707 3.707 0 002 2.06c.46.19.95.29 1.44.29s.98-.1 1.44-.29a3.684 3.684 0 002-2.06c.18-.46.26-.95.25-1.44v-5.87h1.68c.38 0 .68-.3.68-.67v-5.83c0-.37-.3-.68-.68-.68h-1.68v-4.68h32.99v4.68h-1.68a.68.68 0 00-.68.68v5.83c0 .37.3.67.68.67h1.68v5.87c-.02.49.07.98.25 1.44a3.707 3.707 0 002 2.06 3.704 3.704 0 004.09-.83c.34-.35.61-.77.79-1.23.18-.46.26-.95.25-1.44v-5.87h1.68c.37 0 .68-.3.68-.67v-5.83c0-.37-.31-.68-.68-.68h-1.68v-4.68h9.28c.17 0 .34-.01.5-.03v23.3zm2.43-28.19c0 .55-.16 1.08-.43 1.52-.43.71-1.15 1.21-2 1.35-.16.04-.33.05-.5.05h-9.28V11.39h9.28c1.62 0 2.93 1.31 2.93 2.92v14.12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.03 16.56c-2.66 0-4.81 2.16-4.81 4.81 0 .44.06.87.18 1.28.21.76.6 1.44 1.13 2 .87.94 2.12 1.52 3.5 1.52s2.63-.58 3.5-1.52c.53-.56.92-1.24 1.13-2 .12-.41.18-.84.18-1.28 0-2.65-2.15-4.81-4.81-4.81z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-browser"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 7a1 1 0 112 0 1 1 0 01-2 0zm4 0a1 1 0 112 0 1 1 0 01-2 0zM5 9V6c0-.552.449-1 1-1h12c.551 0 1 .448 1 1v3H5zm14 9c0 .552-.449 1-1 1H6c-.551 0-1-.448-1-1v-7h14v7zM18 3H6C4.346 3 3 4.346 3 6v12c0 1.654 1.346 3 3 3h12c1.654 0 3-1.346 3-3V6c0-1.654-1.346-3-3-3z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-brush"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.766 7.393l-5.867 5.865a4.137 4.137 0 00-.521-.636 3.994 3.994 0 00-.637-.517l5.869-5.867a.84.84 0 011.157 0 .794.794 0 01.233.59.782.782 0 01-.234.565zM8.246 17.94l-2.228.041.039-2.23a2.4 2.4 0 012.339-2.339h.04c.584 0 1.125.22 1.528.623.413.412.634.968.624 1.566a2.4 2.4 0 01-2.342 2.34zM20 6.827a2.76 2.76 0 00-.82-2.004c-1.061-1.06-2.924-1.064-3.984 0l-6.613 6.61c-.075-.003-.147-.02-.222-.02-2.334.041-4.265 1.973-4.304 4.303L4 18.983A1 1 0 005 20h.019l3.266-.06c2.332-.04 4.262-1.972 4.303-4.305 0-.075-.015-.146-.017-.221l6.609-6.608c.538-.538.83-1.25.82-1.979z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-bulb"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.168 6.467l-1.438 1.39a1 1 0 11-1.389-1.438l1.438-1.39a1 1 0 011.389 1.438zM7.684 7.832a.997.997 0 01-1.414.026l-1.439-1.39a1 1 0 011.39-1.44l1.439 1.39a1 1 0 01.024 1.414zM6 12a1 1 0 01-1 1H3a1 1 0 110-2h2a1 1 0 011 1zm16 0a1 1 0 01-1 1h-2a1 1 0 110-2h2a1 1 0 011 1zM11 5V3a1 1 0 112 0v2a1 1 0 11-2 0zm2.501 9.593c-.31.179-.501.51-.501.867V20h-2v-4.54c0-.357-.191-.688-.501-.867A2.996 2.996 0 0112 9a2.996 2.996 0 011.501 5.593zM12 7c-2.757 0-5 2.243-5 5 0 1.579.753 3.062 2 3.996V20c0 1.103.897 2 2 2h2c1.103 0 2-.897 2-2v-4.004A5.007 5.007 0 0017 12c0-2.757-2.243-5-5-5z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-bulleted-list"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 10.5c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5 1.5-.7 1.5-1.5-.7-1.5-1.5-1.5zm0-5c-.8 0-1.5.7-1.5 1.5S3.2 8.5 4 8.5 5.5 7.8 5.5 7 4.8 5.5 4 5.5zm0 10c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5 1.5-.7 1.5-1.5-.7-1.5-1.5-1.5zM7.5 6v2h14V6h-14zm0 12h14v-2h-14v2zm0-5h14v-2h-14v2z",
    fill: "#000018"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-bumi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.586 12.386a2.627 2.627 0 00-.049-.543 2.193 2.193 0 00-.618-1.096 1.531 1.531 0 01-.155-.17c-.002 0-.002-.003-.002-.005a.7.7 0 00-.413-.217.16.16 0 01-.044-.011h-.003l-.003-.002a2.377 2.377 0 00-.719-.187l-.12.004-.041.002c-.043-.002-.06-.046-.076-.082-.054-.125-.107-.25-.17-.37-.142-.27-.332-.512-.468-.786-.005-.003-.011-.011-.018-.025a6.277 6.277 0 00-1.15-1.565 8.355 8.355 0 00-2.162-1.561 10.541 10.541 0 00-1.957-.75 2.527 2.527 0 01-.29-.098.018.018 0 01-.01-.023.962.962 0 00-.051-.75.782.782 0 00-.16-.218.589.589 0 00-.238-.14 9.254 9.254 0 00-4.885-.106c-.243.06-.402.11-.476.152a.727.727 0 00-.333.408c-.071.2-.076.412-.015.64a.02.02 0 01-.012.023c-.104.046-.24.09-.406.131-.518.13-1.051.316-1.6.558a7.851 7.851 0 00-3.281 2.67 5.933 5.933 0 00-.27.415c-.257.433-.518.865-.737 1.319l-.028.058c-.014.03-.023.073-.054.091a.102.102 0 01-.053.012c-.072 0-.144-.007-.217-.002a2.525 2.525 0 00-.826.215 1.112 1.112 0 00-.24.134c-.078.061-.14.14-.214.206-.081.077-.143.144-.186.201-.273.36-.413.772-.42 1.237a90.248 90.248 0 00.005 2.87c.017.28.066.54.147.777a2.39 2.39 0 001.167 1.36c.459.226.957.27 1.495.13a.028.028 0 01.03.01c.197.294.423.57.661.831.227.247.462.483.728.688.26.2.54.374.822.54.128.074.256.148.384.22a8.077 8.077 0 001.438.647 12.822 12.822 0 001.672.444 16.63 16.63 0 002.461.29c.53.023 1.06.015 1.59-.023.225-.017.45-.036.675-.058a13.483 13.483 0 003.444-.798c.236-.088.444-.177.626-.266a8.97 8.97 0 001.722-1.117l.008-.006a6.299 6.299 0 001.241-1.406.024.024 0 01.026-.01c.56.154 1.085.1 1.572-.164.657-.356 1.069-1.02 1.216-1.742.03-.15.046-.36.047-.629 0-.786-.002-1.572-.007-2.357zm-3.3 4.668a10.41 10.41 0 01-.256.351c-.092.12-.184.232-.278.333a7.174 7.174 0 01-2.867 1.89c-.35.127-.63.22-.841.279a14.454 14.454 0 01-3.336.516c-.217.008-.443.013-.68.015a14.4 14.4 0 01-3.707-.435 10.23 10.23 0 01-2.513-1 6.579 6.579 0 01-2.018-1.78c-.82-1.11-1.219-2.375-1.195-3.795a9.983 9.983 0 01.07-1.487c.115-.89.394-1.74.838-2.547A7.516 7.516 0 015.042 7.43 7.86 7.86 0 017.404 5.95a10.557 10.557 0 012.31-.634 15.297 15.297 0 011.515-.166 13.048 13.048 0 013.71.277c.819.181 1.61.472 2.374.872a7.37 7.37 0 013.928 5.539c.108.732.133 1.468.075 2.206a5.681 5.681 0 01-1.03 3.011zm2.805-2.03c-.029.618-.262 1.102-.698 1.455a1.607 1.607 0 01-.597.313 1.602 1.602 0 01-.768.013h-.004a.013.013 0 01-.005-.019 6.58 6.58 0 00.62-1.556c.125-.56.19-1.128.193-1.7 0-.216-.003-.444-.011-.683a8.467 8.467 0 00-.345-2.127.03.03 0 01.032-.028c.283.014.54.08.768.197.208.105.38.25.516.434.2.27.3.587.298.951-.003.524 0 1.048.007 1.572.001.074 0 .17-.004.29a5.521 5.521 0 00-.003.29c.012.162.012.362.001.599z",
    fill: "#29293D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.022 21.384c-.205 0-.41-.004-.613-.013a17.125 17.125 0 01-2.52-.297 13.319 13.319 0 01-1.728-.459 8.448 8.448 0 01-1.506-.678c-.118-.066-.255-.144-.389-.223a8.492 8.492 0 01-.863-.567 6.16 6.16 0 01-.782-.737 7.845 7.845 0 01-.55-.667 2.442 2.442 0 01-1.515-.213 2.807 2.807 0 01-1.374-1.596 3.439 3.439 0 01-.167-.884 90.82 90.82 0 01-.005-2.902c.008-.553.177-1.05.502-1.48.057-.074.132-.156.23-.249l.01-.01c.019-.017.042-.04.066-.066.048-.048.1-.104.169-.157.112-.086.228-.143.327-.186l.072-.03a2.927 2.927 0 01.937-.22c.208-.42.446-.82.677-1.21l.04-.067a8.29 8.29 0 013.737-3.25 10.445 10.445 0 011.734-.598 1.41 1.41 0 01.08-.516c.098-.279.272-.49.517-.628.076-.042.21-.103.58-.193a9.696 9.696 0 015.095.11.993.993 0 01.402.234c.097.09.179.202.245.331.109.217.158.444.147.677.681.19 1.346.446 1.98.764.839.422 1.602.973 2.268 1.638a6.72 6.72 0 011.178 1.58l.012.006.055.111c.061.125.14.248.224.378.08.126.164.256.24.4.04.078.076.155.11.231.265.028.53.097.789.205a1.1 1.1 0 01.62.332l.056.057.009.023c.019.02.046.05.084.086.37.362.616.799.732 1.298.038.167.057.374.059.633.005.783.008 1.577.007 2.36 0 .302-.019.534-.055.711-.183.894-.701 1.63-1.423 2.021-.5.27-1.037.358-1.6.26a6.814 6.814 0 01-1.175 1.277l-.01.008h-.001a9.38 9.38 0 01-1.798 1.166 7.508 7.508 0 01-.662.281c-1.14.428-2.333.704-3.546.823-.228.022-.46.041-.687.058-.338.024-.68.037-1.023.037h.002zM12.12 5.53c-.287 0-.575.01-.863.029a15.18 15.18 0 00-1.48.162c-.773.122-1.52.327-2.222.61a7.493 7.493 0 00-2.24 1.405 7.135 7.135 0 00-1.456 1.857 6.78 6.78 0 00-.79 2.402 9.616 9.616 0 00-.066 1.425v.015c-.022 1.321.353 2.513 1.114 3.544a6.206 6.206 0 001.89 1.668c.73.413 1.543.736 2.415.96 1.131.29 2.343.432 3.603.422.235-.002.46-.007.668-.014 1.094-.04 2.185-.21 3.242-.503.2-.055.474-.146.812-.268a6.803 6.803 0 002.707-1.784c.084-.092.17-.194.252-.303.085-.111.168-.225.246-.337a5.3 5.3 0 00.956-2.798l.001-.011a9.424 9.424 0 00-.07-2.113 7.34 7.34 0 00-.511-1.815 7.003 7.003 0 00-3.203-3.42 9.17 9.17 0 00-2.274-.836 12.641 12.641 0 00-2.731-.297zm8.531 12.144l.003.001h-.003zM1.298 11.018a1.309 1.309 0 00-.138.148c-.22.291-.33.616-.336.994A90.959 90.959 0 00.828 15c.015.242.058.467.126.67.104.308.271.57.511.802.14.136.292.244.449.32.362.18.746.215 1.175.112-.618-1.041-.921-2.207-.901-3.476-.012-.56.013-1.079.073-1.54.058-.447.156-.886.292-1.316l-.026.001c-.042 0-.078 0-.11-.002-.033-.001-.065-.002-.086 0a2.115 2.115 0 00-.69.181.769.769 0 00-.156.084.974.974 0 00-.083.08c-.03.03-.064.066-.104.102zm20.727.204c.116.526.184 1.066.203 1.61.009.247.012.482.011.7a8.416 8.416 0 01-.203 1.788l-.003.012a6.997 6.997 0 01-.37 1.07 1.209 1.209 0 00.474-.244c.345-.278.524-.655.547-1.153.01-.22.01-.405 0-.548l-.001-.024c-.002-.101-.001-.206.003-.312.003-.114.005-.205.004-.27-.008-.518-.01-1.05-.007-1.58a1.128 1.128 0 00-.217-.704 1.044 1.044 0 00-.44-.345zm1.124-.776zm-2.102-1.74l.002.003-.002-.002zm-5.54-3.682v0zm-3.387-.315c.873 0 1.741.084 2.593.251a.428.428 0 01.017-.184.551.551 0 00-.027-.44.384.384 0 00-.074-.104.185.185 0 00-.074-.046 8.896 8.896 0 00-4.675-.1c-.292.07-.367.108-.374.112a.32.32 0 00-.147.186.655.655 0 00-.006.396l.002.007a.44.44 0 01.008.172l.287-.05A15.454 15.454 0 0111.2 4.74c.307-.02.613-.03.918-.03zm-3.335-.175h-.001z",
    fill: "#29293D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.091 15.025c-.029.617-.262 1.101-.698 1.454a1.607 1.607 0 01-.597.313 1.602 1.602 0 01-.768.013h-.004a.013.013 0 01-.005-.019 6.58 6.58 0 00.62-1.556c.125-.56.19-1.128.193-1.7 0-.216-.003-.444-.011-.683a8.469 8.469 0 00-.345-2.127.03.03 0 01.032-.028c.283.014.54.08.768.197.208.105.38.25.516.434.2.27.3.587.298.951-.003.524 0 1.048.007 1.572.001.074 0 .17-.004.29a5.519 5.519 0 00-.003.29c.012.162.012.362.001.599z",
    fill: "#29293D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.39 17.255c-.133 0-.268-.013-.404-.04h-.036l-.091-.034-.033-.018a.427.427 0 01-.167-.567l.004-.009c.253-.457.448-.946.579-1.453a7.6 7.6 0 00.182-1.606c.001-.207-.003-.43-.01-.667a8.086 8.086 0 00-.326-2.011.447.447 0 01-.02-.13l.002-.026a.441.441 0 01.455-.412h.003c.34.018.654.098.933.241.264.134.485.321.658.555.253.341.38.745.378 1.199-.002.524 0 1.05.008 1.563 0 .08 0 .18-.005.31a5.095 5.095 0 00-.003.258c.013.177.013.385.001.636-.035.737-.32 1.327-.85 1.755a2.019 2.019 0 01-.747.389 1.97 1.97 0 01-.511.067zm-.514-.07l.002.002-.002-.001zm1.15-5.963c.115.527.183 1.066.202 1.61.008.247.012.482.011.7a8.415 8.415 0 01-.203 1.788l-.003.012a7.024 7.024 0 01-.37 1.07 1.209 1.209 0 00.474-.244c.345-.278.524-.655.547-1.153.01-.22.01-.405 0-.548l-.002-.024a6.05 6.05 0 01.003-.312c.004-.114.006-.205.005-.27a78.06 78.06 0 01-.008-1.58 1.128 1.128 0 00-.216-.704 1.043 1.043 0 00-.44-.345zM8.47 17.532c-.17 0-.351-.016-.54-.048a5.845 5.845 0 01-1.624-.532 3.787 3.787 0 01-.646-.408 4.19 4.19 0 01-.462-.418 2.881 2.881 0 01-.755-1.518 4.717 4.717 0 01-.05-1.012c.078-1.648.8-2.945 2.144-3.855a7.463 7.463 0 011.79-.882 9.394 9.394 0 011.33-.35 13.814 13.814 0 012.715-.21c.726.013 1.43.087 2.092.22.976.195 1.871.533 2.66 1.003.838.501 1.489 1.18 1.935 2.018.19.358.326.754.402 1.177.032.179.058.383.078.609.04.475.027.938-.043 1.376-.022.145-.066.3-.127.46-.054.14-.125.28-.21.419-.305.489-.711.889-1.208 1.19-.58.353-1.213.591-1.88.71a3.309 3.309 0 01-1.041.011c-.428-.06-.72-.104-.87-.13-.37-.065-.746-.117-1.118-.156a9.903 9.903 0 00-2.316.031c-.369.049-.946.135-1.717.255-.17.027-.351.04-.54.04zm3.628-8.82c-.811 0-1.606.07-2.367.208a8.973 8.973 0 00-1.271.334 7.064 7.064 0 00-1.692.833c-.616.417-1.094.925-1.418 1.508-.325.585-.508 1.265-.545 2.022a4.27 4.27 0 00.046.92c.086.5.304.938.647 1.303.121.128.261.254.416.375.179.14.373.263.577.364.478.239.986.405 1.509.494a2.793 2.793 0 00.945.008c.774-.121 1.355-.207 1.727-.257.8-.105 1.611-.116 2.412-.032.382.04.768.093 1.147.16.142.025.438.07.856.128a2.9 2.9 0 00.911-.009 5.027 5.027 0 001.739-.655 3.206 3.206 0 001.07-1.055c.072-.116.131-.234.176-.35.051-.131.086-.257.104-.374.065-.404.078-.833.039-1.274a6.454 6.454 0 00-.073-.57 3.593 3.593 0 00-.36-1.056 4.732 4.732 0 00-1.78-1.856 7.954 7.954 0 00-2.53-.953 11.396 11.396 0 00-2.285-.215z",
    fill: "#29293D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.47 17.772a3.45 3.45 0 01-.58-.052 6.08 6.08 0 01-1.689-.553 4.05 4.05 0 01-.686-.434 4.41 4.41 0 01-.49-.442 3.114 3.114 0 01-.815-1.642 4.938 4.938 0 01-.055-1.064c.083-1.728.84-3.088 2.25-4.042a7.713 7.713 0 011.847-.91c.469-.159.928-.28 1.364-.358.886-.16 1.815-.233 2.761-.215.74.013 1.458.089 2.134.225 1.002.2 1.922.548 2.734 1.032a5.375 5.375 0 012.023 2.11c.203.38.346.8.426 1.248.033.186.06.398.08.63.044.495.03.977-.043 1.435a2.5 2.5 0 01-.141.51c-.06.153-.137.307-.23.458a3.854 3.854 0 01-1.287 1.27 5.67 5.67 0 01-1.962.74 3.545 3.545 0 01-1.115.012c-.43-.06-.726-.105-.877-.131a15.74 15.74 0 00-1.102-.154 9.67 9.67 0 00-2.26.03c-.367.048-.943.134-1.712.254a3.79 3.79 0 01-.575.043zm3.628-8.82c-.797 0-1.58.068-2.325.203-.393.071-.81.181-1.238.326-.59.2-1.14.47-1.634.805-.585.396-1.037.876-1.344 1.426-.306.552-.48 1.197-.514 1.916a4.05 4.05 0 00.043.869c.077.452.274.849.585 1.178.113.119.244.237.39.352.166.13.346.244.535.338a5.2 5.2 0 001.443.473 2.583 2.583 0 00.87.006 84.441 84.441 0 011.732-.257 10.528 10.528 0 012.468-.033c.387.04.778.095 1.163.163.14.024.432.068.847.126.295.042.577.04.838-.007a4.79 4.79 0 001.656-.625c.41-.248.743-.577.992-.977.064-.104.117-.207.156-.309a1.6 1.6 0 00.091-.325l.002-.013c.06-.381.071-.786.035-1.203a6.246 6.246 0 00-.07-.55 3.35 3.35 0 00-.335-.984 4.497 4.497 0 00-1.694-1.763 7.718 7.718 0 00-2.453-.925 11.183 11.183 0 00-2.24-.21h.001z",
    fill: "#29293D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.835 14.982c.463 0 .837-.842.837-1.88 0-1.037-.374-1.879-.837-1.879-.463 0-.837.841-.837 1.88 0 1.037.375 1.879.837 1.879z",
    fill: "#29293D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.835 11.343c.397 0 .719.788.719 1.76 0 .971-.322 1.759-.719 1.759-.397 0-.718-.788-.718-1.76 0-.971.321-1.76.718-1.76zm0-.24c-.398 0-.627.416-.728.664-.147.36-.228.835-.228 1.335s.081.975.228 1.336c.101.247.33.663.728.663.398 0 .627-.416.728-.663.148-.36.229-.835.229-1.336 0-.5-.082-.974-.229-1.335-.1-.248-.33-.663-.728-.663zM8.27 14.982c.463 0 .838-.842.838-1.88 0-1.037-.375-1.879-.837-1.879-.463 0-.838.841-.838 1.88 0 1.037.375 1.879.838 1.879z",
    fill: "#29293D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.27 11.343c.397 0 .719.788.719 1.76 0 .971-.322 1.759-.719 1.759-.397 0-.718-.788-.718-1.76 0-.971.321-1.76.718-1.76zm0-.24c-.398 0-.627.416-.728.664-.147.36-.228.835-.228 1.335s.08.975.228 1.336c.101.247.33.663.728.663.398 0 .627-.416.728-.663.148-.36.228-.835.228-1.336 0-.5-.08-.974-.228-1.335-.101-.248-.33-.663-.728-.663z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-calendar"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 16c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1-1-.45-1-1zm5-1h4c.55 0 1 .45 1 1s-.45 1-1 1h-4c-.55 0-1-.45-1-1s.45-1 1-1zm6 5H6c-.551 0-1-.449-1-1v-6h14v6c0 .551-.449 1-1 1zM6 6h1v1c0 .55.45 1 1 1s1-.45 1-1V6h6v1c0 .55.45 1 1 1s1-.45 1-1V6h1c.551 0 1 .449 1 1v4H5V7c0-.551.449-1 1-1zm12-2h-1V3c0-.55-.45-1-1-1s-1 .45-1 1v1H9V3c0-.55-.45-1-1-1s-1 .45-1 1v1H6C4.346 4 3 5.346 3 7v12c0 1.654 1.346 3 3 3h12c1.654 0 3-1.346 3-3V7c0-1.654-1.346-3-3-3z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-camera"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 15.5c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5zm0-5c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5zm8 7.5c0 .551-.448 1-1 1H5c-.552 0-1-.449-1-1v-8c0-.551.448-1 1-1h14c.552 0 1 .449 1 1v8zM10 5.5a.5.5 0 01.5-.5h3a.5.5 0 01.5.5V7h-4V5.5zM16 7V5.5C16 4.122 14.879 3 13.5 3h-3A2.503 2.503 0 008 5.5V7H5c-1.654 0-3 1.346-3 3v8c0 1.654 1.346 3 3 3h14c1.654 0 3-1.346 3-3v-8c0-1.654-1.346-3-3-3h-3z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-car"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.283 10.927L15.7 5.784A4.166 4.166 0 0012.28 4H9.083a4.187 4.187 0 00-3.896 2.69l-1.726 4.553A3.334 3.334 0 002 14v1.25a2.087 2.087 0 001.667 2.042v.458a2.917 2.917 0 005.833 0v-.417h5v.417a2.917 2.917 0 005.833 0v-.458A2.088 2.088 0 0022 15.25v-.417a4.176 4.176 0 00-2.717-3.906zm-4.95-4.19l2.737 3.93h-5.903v-5h1.113a2.5 2.5 0 012.053 1.07zM6.75 7.28a2.512 2.512 0 012.333-1.614H9.5v5H5.462L6.75 7.28zM7.833 17.75a1.25 1.25 0 11-2.5 0v-.417h2.5v.417zM17.417 19a1.25 1.25 0 01-1.25-1.25v-.417h2.5v.417a1.25 1.25 0 01-1.25 1.25zm2.916-3.75a.417.417 0 01-.416.417H4.083a.416.416 0 01-.416-.417V14a1.667 1.667 0 011.666-1.667h12.5a2.5 2.5 0 012.5 2.5v.417z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-caret-down"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 15.5a.997.997 0 01-.707-.293l-4-4a.999.999 0 111.414-1.414l3.305 3.305 3.293-3.18a1 1 0 011.39 1.439l-4 3.862A.997.997 0 0112 15.5z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-caret-left"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.362 17a.996.996 0 01-.719-.305l-3.863-4a1 1 0 01.013-1.402l4-4a.999.999 0 111.414 1.414l-3.305 3.305 3.18 3.293a1 1 0 01-.72 1.695z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-caret-right"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 17a.999.999 0 01-.707-1.707l3.305-3.305-3.18-3.293a1 1 0 011.439-1.39l3.862 4a1 1 0 01-.012 1.402l-4 4A.997.997 0 0110.5 17z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-caret-up"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 14.5a.997.997 0 01-.707-.293l-3.305-3.305-3.293 3.18a1 1 0 01-1.39-1.439l4-3.862a1 1 0 011.402.012l4 4A.999.999 0 0116 14.5z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-cast"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.6 3h12.8C19.835 3 21 4.246 21 5.777v12.446C21 19.754 19.834 21 18.4 21H17a1 1 0 110-2h1.4c.326 0 .6-.356.6-.777V5.777c0-.421-.274-.777-.6-.777H5.6c-.326 0-.6.356-.6.777V7a1 1 0 11-2 0V5.777C3 4.246 4.166 3 5.6 3zM3.01 15.17a1 1 0 01.853-1.127 4.486 4.486 0 013.814 1.278 4.533 4.533 0 01.901 5.102 1.001 1.001 0 01-1.813-.846 2.521 2.521 0 00-.502-2.841 2.514 2.514 0 00-2.127-.713.993.993 0 01-1.127-.853zm.852-5.093a1 1 0 10.275 1.98 6 6 0 015.097 1.708 6.038 6.038 0 011.525 5.956 1 1 0 001.92.558 8.038 8.038 0 00-2.03-7.928 7.96 7.96 0 00-6.787-2.274zM3 19a1 1 0 112 0 1 1 0 11-2 0z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-chair"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.15 13.004a2 2 0 00-1.73 1.253l-.8 2A2 2 0 005.477 19H11v1.073c-1.648.256-2.454 1.142-2.793 1.955-.212.51.24.972.793.972h6c.552 0 1.005-.462.793-.972-.339-.813-1.145-1.699-2.793-1.955V19h5.523a2 2 0 001.857-2.743l-.8-2a2 2 0 00-1.73-1.253c.038-.177.059-.366.059-.568 0-1.24-.365-5.855-.546-7.998-.012-.549-.226-1.248-.705-1.83-.526-.638-1.352-1.109-2.476-1.109H9.818c-1.125 0-1.95.471-2.476 1.11-.48.581-.693 1.28-.705 1.83-.18 2.142-.546 6.758-.546 7.997 0 .202.02.392.058.568zm2.486-8.518c0-.106.06-.377.25-.606.155-.19.42-.381.932-.381h4.364c.511 0 .776.192.932.38.19.23.25.5.25.607v.043l.003.042c.184 2.18.542 6.727.542 7.865 0 .14-.03.21-.05.243a.333.333 0 01-.112.114.963.963 0 01-.474.134H8.727a.963.963 0 01-.474-.134.333.333 0 01-.113-.114.48.48 0 01-.05-.243c0-1.138.359-5.686.543-7.865l.003-.042v-.043zM17.384 15a.5.5 0 01.465.314l.4 1a.5.5 0 01-.465.686H6.216a.5.5 0 01-.465-.686l.4-1A.5.5 0 016.616 15h10.768z",
    fill: "#29293D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 9a1 1 0 011 1v2a1 1 0 11-2 0v-2a1 1 0 011-1zM21 10a1 1 0 10-2 0v2a1 1 0 102 0v-2z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-checkbox-checked"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.705 8.394l-3.784 4.97-1.633-2.087a.999.999 0 10-1.575 1.232l2.43 3.107a1 1 0 00.789.383h.007a.994.994 0 00.788-.394l4.569-6a.999.999 0 10-1.591-1.21zM19 18c0 .552-.449 1-1 1H6c-.551 0-1-.448-1-1V6c0-.552.449-1 1-1h12c.551 0 1 .448 1 1v12zM18 3H6C4.346 3 3 4.346 3 6v12c0 1.654 1.346 3 3 3h12c1.654 0 3-1.346 3-3V6c0-1.654-1.346-3-3-3z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-checkmark"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.863 18a1 1 0 01-.729-.315l-4.863-5.179a1 1 0 111.457-1.369l4.125 4.391 8.408-9.202a1 1 0 011.477 1.348l-9.137 10a.998.998 0 01-.73.326h-.008z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-checkmark-circle"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.997 10.974H21a1 1 0 011 .997 9.932 9.932 0 01-2.909 7.08 9.935 9.935 0 01-7.062 2.95H12a9.932 9.932 0 01-7.051-2.91A9.935 9.935 0 012 12.03a9.93 9.93 0 012.909-7.08A9.934 9.934 0 0111.971 2c.795.012 1.605.092 2.381.278a1 1 0 01-.469 1.945A8.817 8.817 0 0011.977 4a7.946 7.946 0 00-5.65 2.36A7.947 7.947 0 004 12.022a7.948 7.948 0 002.359 5.65A7.949 7.949 0 0012 20h.023a7.946 7.946 0 005.65-2.359A7.949 7.949 0 0020 11.977a1 1 0 01.997-1.003zm-12.704.319a.999.999 0 011.414 0l2.244 2.244 6.297-7.196a1 1 0 011.504 1.318l-7 8a1.002 1.002 0 01-.719.341H12a1 1 0 01-.707-.293l-3-3a.999.999 0 010-1.414z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-checkmark-circle-1"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.705 8.394l-3.784 4.97-1.633-2.087a.999.999 0 10-1.575 1.232l2.43 3.107a1 1 0 00.789.383h.007a.994.994 0 00.788-.394l4.569-6a.999.999 0 10-1.591-1.21zM12 20c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8zm0-18C6.477 2 2 6.478 2 12s4.477 10 10 10 10-4.478 10-10S17.523 2 12 2z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-checkmark-double"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.616 6.213a.998.998 0 00-1.403.17l-7.055 9.009-3.379-4.197a1 1 0 00-1.559 1.254l4.17 5.178c.19.236.476.373.78.373h.006a.998.998 0 00.78-.384l7.831-10a.998.998 0 00-.17-1.403zm5 0a.998.998 0 00-1.403.17l-7.055 9.009-.604-.75-1.265 1.618 1.1 1.367c.191.236.477.373.78.373h.007a.998.998 0 00.78-.384l7.831-10a.998.998 0 00-.17-1.403zM9.98 11.444L8.713 13.06l-.492-.61a1 1 0 011.558-1.255l.2.25z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-checkmark-square"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 12.834a1 1 0 012 0V18.4a2.604 2.604 0 01-2.6 2.6H5.6A2.604 2.604 0 013 18.4V5.6C3 4.166 4.167 3 5.6 3h9.567a1 1 0 110 2H5.6a.6.6 0 00-.6.6v12.8c0 .33.269.6.6.6h12.8c.331 0 .6-.27.6-.6v-5.566zm-9.69-1.887a1 1 0 011.414.033l1.505 1.577 6.053-6.253a1 1 0 111.437 1.391l-6.777 7a.997.997 0 01-.718.306h-.004a1 1 0 01-.72-.31l-2.223-2.33a1 1 0 01.033-1.415z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 12 13",
    fill: "none",
    id: "sprite_svg__icon-light-classic-zonajobs"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.852 12.164c-1.11 0-2.073-.23-2.891-.687a4.798 4.798 0 01-1.89-1.961C.627 8.666.405 7.664.405 6.508v-.383c0-1.104.214-2.08.64-2.93a4.89 4.89 0 011.837-2.007C3.68.703 4.63.46 5.734.46c.766 0 1.487.11 2.164.328a5.32 5.32 0 011.813 1v2.75H8.016L7.78 2.813a3.235 3.235 0 00-.883-.43 3.498 3.498 0 00-1.109-.164c-.963 0-1.721.351-2.273 1.054-.552.698-.829 1.644-.829 2.836v.399c0 1.198.287 2.148.86 2.851.573.704 1.354 1.055 2.344 1.055.328 0 .656-.036.984-.11.333-.077.635-.176.906-.296l.235-1.602H9.71v2.719c-.443.292-.995.54-1.656.742-.662.198-1.396.297-2.203.297z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-clipboard"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 19c0 .552-.449 1-1 1H6c-.551 0-1-.448-1-1V8c0-.552.449-1 1-1v1c0 1.103.897 2 2 2h8c1.103 0 2-.897 2-2V7c.551 0 1 .448 1 1v11zM8 4l8 .003V8H8V4zm10 1V4c0-1.103-.897-2-2-2H8c-1.103 0-2 .897-2 2v1C4.346 5 3 6.346 3 8v11c0 1.654 1.346 3 3 3h12c1.654 0 3-1.346 3-3V8c0-1.654-1.346-3-3-3z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-clock"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 11h-3V8a1 1 0 10-2 0v4a1 1 0 001 1h4a1 1 0 100-2zm-4 9c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8zm0-18C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-close"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.414 12l4.293-4.293a.999.999 0 10-1.414-1.414L12 10.586 7.707 6.293a.999.999 0 10-1.414 1.414L10.586 12l-4.293 4.293a.999.999 0 101.414 1.414L12 13.414l4.293 4.293a.997.997 0 001.414 0 .999.999 0 000-1.414L13.414 12z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-close-circle"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.707 9.293a.999.999 0 00-1.414 0L12 10.586l-1.293-1.293a.999.999 0 10-1.414 1.414L10.586 12l-1.293 1.293a.999.999 0 101.414 1.414L12 13.414l1.293 1.293a.997.997 0 001.414 0 .999.999 0 000-1.414L13.414 12l1.293-1.293a.999.999 0 000-1.414zM12 20c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8zm0-18C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-close-square"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.707 9.293a.999.999 0 00-1.414 0L12 10.586l-1.293-1.293a.999.999 0 10-1.414 1.414L10.586 12l-1.293 1.293a.999.999 0 101.414 1.414L12 13.414l1.293 1.293a.997.997 0 001.414 0 .999.999 0 000-1.414L13.414 12l1.293-1.293a.999.999 0 000-1.414zM19 18a1 1 0 01-1 1H6a1 1 0 01-1-1V6a1 1 0 011-1h12a1 1 0 011 1v12zM18 3H6C4.346 3 3 4.346 3 6v12c0 1.654 1.346 3 3 3h12c1.654 0 3-1.346 3-3V6c0-1.654-1.346-3-3-3z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-cloud-download"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3a6.018 6.018 0 015.675 4.045A5.008 5.008 0 0122 12a4.995 4.995 0 01-1.25 3.309 1 1 0 11-1.5-1.325A2.993 2.993 0 0020 12c0-1.654-1.346-3-3-3h-.1a1 1 0 01-.98-.803A4.006 4.006 0 0012 5a4.005 4.005 0 00-3.92 3.197A1.001 1.001 0 017.1 9H7c-1.654 0-3 1.346-3 3 0 .732.266 1.438.75 1.984a1 1 0 11-1.499 1.325A4.991 4.991 0 012 12a5.008 5.008 0 014.325-4.955A6.02 6.02 0 0112 3zm1 14.644l1.305-1.26a1 1 0 011.39 1.439l-3 2.897a1.005 1.005 0 01-1.402-.013l-3-3a.999.999 0 111.414-1.414L11 17.586V12a1 1 0 112 0v5.644z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-cloud-upload"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3a6.018 6.018 0 015.675 4.045A5.008 5.008 0 0122 12a4.995 4.995 0 01-1.25 3.309 1 1 0 11-1.5-1.325A2.993 2.993 0 0020 12c0-1.654-1.346-3-3-3h-.1a1 1 0 01-.98-.803A4.006 4.006 0 0012 5a4.005 4.005 0 00-3.92 3.197A1.001 1.001 0 017.1 9H7c-1.654 0-3 1.346-3 3 0 .732.266 1.438.75 1.984a1 1 0 11-1.499 1.325A4.991 4.991 0 012 12a5.008 5.008 0 014.325-4.955A6.02 6.02 0 0112 3zm-.695 8.28a1.003 1.003 0 011.402.013l3 3a.999.999 0 11-1.414 1.414L13 14.414V20a1 1 0 11-2 0v-5.644l-1.305 1.26a1 1 0 01-1.39-1.439l3-2.897z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-code"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.951 5.373l4.828 6a1 1 0 01-.01 1.268l-5 6a.998.998 0 01-1.41.128 1.003 1.003 0 01-.128-1.41l4.477-5.37-4.316-5.362a1 1 0 011.56-1.254zm-9.72-.014A1.001 1.001 0 018.77 6.64l-4.477 5.37 4.316 5.363a1 1 0 01-1.56 1.254l-4.827-6a1 1 0 01.01-1.268l5-6z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-code-download"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.78 11.373l-4.829-6a1 1 0 00-1.559 1.254l4.316 5.362-4.477 5.37a1.003 1.003 0 00.768 1.64.998.998 0 00.77-.358l5-6a1 1 0 00.01-1.268zm-17.488.638l4.477-5.37a1.002 1.002 0 00-.128-1.41 1.003 1.003 0 00-1.41.129l-5 6a1 1 0 00-.01 1.267l4.828 6a1 1 0 101.558-1.254L4.292 12.01zm10.014-.627a1 1 0 011.389 1.44l-3 2.896a1.003 1.003 0 01-1.402-.013l-3-3a1 1 0 011.414-1.414L11 12.585V8a1 1 0 112 0v4.644l1.306-1.26z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-collapse"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.416 8.999L19 9a1 1 0 010 2l-4.976-.003a1 1 0 01-1-.995l-.023-4.997A1 1 0 0113.995 4H14a1 1 0 011 .995l.011 2.578 3.28-3.28a1 1 0 111.415 1.414l-3.291 3.292zM5.004 13.001l4.998.024a1 1 0 01.994 1L11.002 19a1.001 1.001 0 01-2 .002l-.003-2.585-3.29 3.29a1 1 0 01-1.415-1.413l3.28-3.28L4.994 15A1 1 0 015 13h.004z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-collapse---horizontal"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.287 12.592l1.846 1.847a1.01 1.01 0 01-1.429 1.428l-3.552-3.556a1.01 1.01 0 01-.003-1.425L16.7 7.3a1.01 1.01 0 011.428-.008l.004.004a1.01 1.01 0 01.003 1.425l-1.832 1.85h4.685a1.01 1.01 0 11.001 2.02h-4.703zM7.299 7.3l3.551 3.586a1.01 1.01 0 01-.003 1.425l-3.55 3.556a1.011 1.011 0 01-1.43-1.427l1.844-1.848H3.01a1.011 1.011 0 010-2.02h4.685l-1.831-1.85a1.01 1.01 0 011.432-1.426l.003.003z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-color-palette"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 6.5a1.5 1.5 0 113.001.001A1.5 1.5 0 0110.5 6.5zm4.201 2.75a1.5 1.5 0 112.6-1.5 1.5 1.5 0 01-2.6 1.5zM8.75 7.201a1.5 1.5 0 10-1.5 2.6 1.5 1.5 0 001.5-2.6zM5.757 13.34a1.499 1.499 0 112.486-1.678 1.5 1.5 0 11-2.486 1.678zM15.881 15h-1.65a2.502 2.502 0 00-2.5 2.5c0 .606.224 1.193.63 1.653.125.14.166.305.122.488-.05.205-.285.338-.594.358a8.01 8.01 0 01-5.946-2.773c-1.515-1.755-2.18-4.004-1.87-6.332.512-3.833 3.959-6.862 7.85-6.895h.075c2.357 0 4.578.9 6.107 2.478 1.288 1.329 1.96 3.024 1.89 4.772-.08 1.998-2.002 3.751-4.114 3.751zm3.659-9.916C17.617 3.101 14.815 1.993 11.906 2h-.001c-4.944.042-9.164 3.752-9.813 8.631a10.057 10.057 0 002.338 7.903A10.006 10.006 0 0011.86 22h.039c1.2 0 2.258-.787 2.527-1.886a2.517 2.517 0 00-.567-2.288.494.494 0 01-.128-.325.5.5 0 01.5-.5h1.65c3.192 0 5.99-2.598 6.112-5.672.092-2.3-.78-4.517-2.453-6.244z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-color-picker"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.056 10.641L13.36 7.945l1.912-1.91 2.694 2.693-1.91 1.913zm-6.977 6.984l-2.976.27.264-2.955 5.579-5.58 2.696 2.696-5.563 5.569zm7.584-13.027c-.767-.768-1.986-.796-2.714-.068l-2.003 2.002-1.24-1.24a1 1 0 00-1.413 1.415l1.239 1.239-5.58 5.58a1.977 1.977 0 00-.57 1.213l-.378 4.17a1.002 1.002 0 001.087 1.087l4.17-.378a1.979 1.979 0 001.214-.57l5.58-5.58 1.238 1.239a.995.995 0 00.707.292.999.999 0 00.707-1.707l-1.238-1.237 2.002-2.003c.73-.73.699-1.947-.068-2.715l-2.74-2.74z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-compass"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.797 13.213l.714-1.742 1.692-.684-.714 1.742-1.692.684zm4.886-4.895a1.002 1.002 0 00-1.1-.246l-4.212 1.702a.998.998 0 00-.551.548L8.075 14.58a.991.991 0 00.178 1.028c.008.01.014.023.023.034.016.017.035.031.053.048a1 1 0 00.713.31c.125 0 .252-.023.374-.072l4.213-1.701c.25-.102.449-.299.55-.549l1.746-4.258a.993.993 0 00-.242-1.102zM12 20c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8zm0-18C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-conecta"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.237 18.497c-.245 0-.484.074-.687.211a1.265 1.265 0 00-.187 1.925 1.232 1.232 0 001.347.272 1.24 1.24 0 00.555-.461 1.262 1.262 0 00-.155-1.579 1.233 1.233 0 00-.873-.368zM12.191 8.862a2.656 2.656 0 011.496.401c.358.223.658.528.877.888a.563.563 0 00.472.284h1.205c.33 0 .57-.315.448-.622-.72-1.799-2.278-2.939-4.498-2.939-2.708 0-4.736 1.697-5.133 4.22-.045.286.186.53.475.53H8.77c.265 0 .48-.21.537-.47a2.93 2.93 0 01.858-1.515 2.867 2.867 0 012.026-.777zM12.191 15.142a2.867 2.867 0 01-2.02-.77 2.93 2.93 0 01-.862-1.507c-.058-.258-.272-.466-.536-.466h-1.24c-.288 0-.52.245-.473.53.402 2.512 2.445 4.224 5.128 4.224 2.225 0 3.775-1.152 4.493-2.946.122-.307-.118-.622-.448-.622h-1.207a.563.563 0 00-.47.28c-.22.357-.52.66-.876.88a2.656 2.656 0 01-1.489.397zM12.237 3c-.245 0-.484.073-.687.21a1.265 1.265 0 00-.187 1.925 1.232 1.232 0 001.347.273 1.24 1.24 0 00.555-.461 1.263 1.263 0 00-.155-1.58A1.233 1.233 0 0012.237 3z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-copy"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 13v-1c0-1.654 1.346-3 3-3h1V5.667A.667.667 0 0012.333 5H5.667A.667.667 0 005 5.667v6.666c0 .368.299.667.667.667H9zm0 2H5.667A2.67 2.67 0 013 12.333V5.667A2.67 2.67 0 015.667 3h6.666A2.67 2.67 0 0115 5.667V9h3c1.654 0 3 1.346 3 3v6c0 1.654-1.346 3-3 3h-6c-1.654 0-3-1.346-3-3v-3zm2-3c0-.551.449-1 1-1h6c.552 0 1 .449 1 1v6c0 .551-.448 1-1 1h-6c-.551 0-1-.449-1-1v-6z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-credit-card"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 15H7c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1zm6 0h-2c-.55 0-1-.45-1-1s.45-1 1-1h2c.55 0 1 .45 1 1s-.45 1-1 1zm3 1c0 .551-.448 1-1 1H5c-.552 0-1-.449-1-1v-5h16v5zM4 8c0-.551.448-1 1-1h14c.552 0 1 .449 1 1v1H4V8zm15-3H5C3.346 5 2 6.346 2 8v8c0 1.654 1.346 3 3 3h14c1.654 0 3-1.346 3-3V8c0-1.654-1.346-3-3-3z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-crop"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.556 16A.557.557 0 018 15.444V8h7.445c.306 0 .555.249.555.556V16H8.556zM21 16h-3V8.556A2.558 2.558 0 0015.445 6H8V3a1 1 0 10-2 0v3H3a1 1 0 100 2h3v7.444A2.559 2.559 0 008.556 18H16v3a1 1 0 102 0v-3h3a1 1 0 100-2z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-crown"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.291 4a1 1 0 01.71.33l2.06 2.281a1 1 0 001.513-.033l.884-1.07C18.652 4.062 21 4.906 21 6.78V16a3 3 0 01-3 3H6a3 3 0 01-3-3V6.781c0-1.875 2.348-2.719 3.542-1.273l.98 1.186a1 1 0 001.466.081l2.574-2.493a1 1 0 01.73-.281zm-.08 2.439L10.38 8.212a3 3 0 01-4.4-.245L5 6.781V13h14V6.781l-.884 1.07a3 3 0 01-4.54.101L12.21 6.439zM19 15H5v1a1 1 0 001 1h12a1 1 0 001-1v-1z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-cube"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.69 15.963L13 18.607V11.89l6-2.787v6.435c0 .174-.118.336-.31.424zm-13.387 0c-.189-.087-.305-.25-.303-.431V9.104l6 2.787v6.718l-5.697-2.645zm6.404-10.9a.687.687 0 01.585 0l5.33 2.475L12 10.15 6.378 7.538l5.33-2.474zm8.95 2.196c-.004-.008-.003-.017-.007-.025-.003-.008-.01-.013-.016-.021-.046-.076-.102-.143-.155-.213-.03-.034-.056-.072-.09-.101a2.523 2.523 0 00-.856-.678l-6.4-2.973-.002-.001a2.7 2.7 0 00-2.265 0L4.47 6.22a2.524 2.524 0 00-.857.677c-.037.03-.064.073-.097.11-.052.067-.105.132-.149.204-.005.009-.013.015-.017.023-.004.009-.003.018-.007.027A2.379 2.379 0 003 8.458v7.067c-.008.95.564 1.834 1.458 2.252l6.4 2.972a2.688 2.688 0 002.275 0l6.397-2.971c.892-.412 1.47-1.29 1.47-2.238V8.457a2.387 2.387 0 00-.344-1.198z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 80 61",
    fill: "none",
    id: "sprite_svg__icon-light-cvs"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sprite_svg__icon-light-cvs_clip0_2637_244462)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.94 20.56c.47.34.97.61 1.51.79l.36.12c.38.12.77.2 1.17.24.03.01.07.01.12.01.5.05 1 .03 1.51-.05.16-.03.33-.06.49-.1.15-.03.29-.07.43-.12.16-.05.31-.1.46-.16.52-.21 1-.49 1.43-.81.18-.13.35-.28.5-.43.18-.16.34-.34.49-.53.11-.12.21-.24.3-.36a6.226 6.226 0 001.19-3.66c0-.34-.02-.67-.08-1.01a6.27 6.27 0 00-7.19-5.2 6.201 6.201 0 00-4.09 2.51 6.276 6.276 0 00-1.12 4.67 6.252 6.252 0 002.52 4.09zm-.59-8.17a5.294 5.294 0 013.44-2.12c.28-.04.56-.06.84-.06 1.27 0 2.47.46 3.4 1.25.93.78 1.6 1.9 1.8 3.19.17 1 .04 2-.36 2.91-1.15-1.01-2.67-1.59-4.29-1.46.9-.35 1.48-1.3 1.32-2.3a2.117 2.117 0 00-2.43-1.75 2.102 2.102 0 00-1.75 2.42c.15 1 1 1.72 1.97 1.77a5.732 5.732 0 00-3.63 2.71 5.193 5.193 0 01-1.25-2.64 5.22 5.22 0 01.94-3.92zM27.84 47.98l-15.97 2.55c-.4.07-.75.47-.68.94.08.47.47.75.94.68l16.03-2.57c.41-.06.69-.45.62-.92-.08-.47-.47-.76-.94-.68zM43.98 12.81l-.02-.07.01.07h.01z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.39 20.52L69.36 5.47 42.76.06c-.72-.15-1.42-.03-2 .29-.73.39-1.28 1.1-1.46 1.99l-1.25 6.14-8.76-6.3L2.48 6.47C.88 6.73-.18 8.15.03 9.74v.09l7.71 48.13c.12.75.53 1.41 1.16 1.86.5.35 1.09.54 1.7.54.08 0 .16 0 .25-.01.08-.01.16-.01.24-.03l30.41-4.86h.01l26.74 5.44c.2.04.41.06.61.06 1.15 0 2.17-.66 2.64-1.7.09-.2.16-.42.21-.65l7.73-38.01-.05-.08zM10.77 58.35a.981.981 0 01-.71-.16.867.867 0 01-.35-.55L2.02 9.51c-.09-.52.25-.98.77-1.07l26-4.15.97.7 1.28 7.68a2.146 2.146 0 002.5 1.81l3.39-.54-2.1 10.34-26.48 4.24c-.47.07-.75.47-.68.94.08.47.47.75.94.67L34.48 26l-1.24 6.06-23.72 3.8c-.47.07-.75.46-.67.93.07.47.46.76.93.68l23.11-3.69-1.23 6.06-20.96 3.35c-.47.08-.76.47-.68.94.07.47.46.75.94.68l20.35-3.26-1.74 8.55v.03c-.15.74.02 1.49.44 2.12a2.92 2.92 0 001.77 1.23c.03.01.07.01.1.02l4.06.83-25.17 4.02zm58.98-.14a.93.93 0 01-1.11.73l-21.52-4.38-5.56-1.13-9.28-1.89a.976.976 0 01-.61-.4.872.872 0 01-.14-.64l1.89-9.28.35-1.71 1.24-6.07.34-1.71 1.24-6.07.35-1.71 2.11-10.35.34-1.68.43-2.12v-.04l1.44-7.02a.9.9 0 01.9-.74c.03 0 .06 0 .09.01.03-.01.07 0 .11.01l25.8 5.25.65.98-1.5 7.66c-.24 1.2.5 2.33 1.7 2.57l7.66 1.56.65.98-7.57 37.19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.85 15.52c.21.31.44.6.7.87.03.03.06.07.09.1.43.43.91.79 1.44 1.07.19.1.37.19.56.27.17.07.36.14.54.2.22.07.44.13.66.17a6.117 6.117 0 001.87.1c.17-.01.34-.03.5-.07.16-.03.32-.07.48-.11.08-.02.17-.04.25-.07.14-.04.28-.09.42-.15.12-.04.23-.09.34-.15.12-.05.24-.11.36-.18.13-.06.26-.14.38-.22a6.24 6.24 0 002.8-4.04c.33-1.64.01-3.32-.92-4.71a6.243 6.243 0 00-3.98-2.69 6.25 6.25 0 00-4.72.92c-.97.64-1.72 1.51-2.2 2.53-.22.45-.38.94-.48 1.45-.08.36-.12.74-.12 1.1-.01.02-.01.04 0 .06-.02.34.01.69.06 1.02.13.89.46 1.75.97 2.53zm0-2.87c-.03-.26-.04-.52-.03-.79a5.259 5.259 0 012.35-4.2 5.25 5.25 0 012.9-.88c.36 0 .71.04 1.07.11 1.38.28 2.57 1.09 3.35 2.26.77 1.17 1.05 2.58.77 3.96a5.2 5.2 0 01-1.37 2.6c-.72-1.35-1.93-2.42-3.49-2.87.97 0 1.83-.71 2.03-1.7.23-1.14-.51-2.26-1.65-2.49-1.14-.23-2.26.51-2.49 1.65-.21 1.01.34 2 1.27 2.37-1.6-.22-3.16.25-4.34 1.19-.02.02-.04.03-.06.06v-.02c-.14-.34-.23-.7-.28-1.07-.01-.04-.01-.07-.01-.11-.01-.02-.01-.05-.01-.07h-.01zM72.26 29.23l-26.45-5.39h-.07l-2.02-.42-3.22-.66c-.47-.09-.87.17-.96.64v.13c-.04.41.22.75.65.84l1.03.21 2.78.57 2.03.41h.07l25.84 5.27c.47.1.87-.17.97-.64a.794.794 0 00-.64-.96h-.01zM70.77 36.51l-23.7-4.83-.08-.02-2.02-.41-5.95-1.21c-.47-.09-.87.17-.97.64-.04.22-.01.43.09.6.11.18.3.32.55.37l3.26.66 3.3.67 2.02.42h.07l23.11 4.71c.47.1.87-.17.96-.64.1-.46-.17-.87-.64-.96zM69.29 43.79l-20.97-4.27h-.07l-2.02-.42-2.65-.54-1.7-.35h-.01l-4.33-.88c-.47-.1-.87.17-.97.63-.09.47.17.87.64.97h.1l4.52.94 4.67.95 2.02.41.08.02 20.37 4.14c.46.1.87-.17.96-.64.1-.46-.17-.86-.64-.96zM51.9 47.83l-2.33-.47-.07-.02-2.02-.41-11.43-2.32c-.4-.09-.87.17-.96.63-.1.47.17.87.64.97l12.03 2.45 2.02.41.07.02 1.79.36c.4.08.8-.19.9-.65.09-.47-.17-.87-.64-.97z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-desarchivar"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.535 3a2 2 0 00-1.664.89L2.465 6l-.13.194A2 2 0 002 7.303V19a3 3 0 003 3h14a3 3 0 003-3V7.303a2 2 0 00-.336-1.11L21.535 6 20.13 3.89A2 2 0 0018.465 3H5.535zm12.662 3a.5.5 0 100-1H5.803a.5.5 0 000 1h12.394zM20 8.5a.5.5 0 00-.5-.5h-15a.5.5 0 00-.5.5V19a1 1 0 001 1h14a1 1 0 001-1V8.5z",
    fill: "#29293D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 13.811a.2.2 0 01.341-.141l1.245 1.244A1 1 0 0016 13.5l-3.646-3.646a.5.5 0 00-.707 0L8 13.5a1 1 0 101.414 1.414l1.245-1.244a.2.2 0 01.341.141v4.103a1 1 0 002 0v-4.103z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-discapacity"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 4a2 2 0 11-4 0 2 2 0 014 0zm-1.007 3.883A1 1 0 0010 8v5l.007.117A1 1 0 0011 14h4.713l2.575 4.608.063.098a1 1 0 001.292.29l1.83-.92.1-.061a1 1 0 00.295-1.296l-.062-.1a1 1 0 00-1.252-.318l-.3.139h-.001l-.704.325-2.377-4.253-.064-.1A1 1 0 0016.3 12H12v-1h2l.117-.007A1 1 0 0014 9h-2V8l-.007-.117zM2 16a6 6 0 0012 0h-2l-.005.2A4 4 0 118 12v-2l-.225.004A6 6 0 002 16z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-download"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.003 12.076A1.06 1.06 0 0111 12V4a1 1 0 112 0v8l2.4-1.8a1 1 0 111.2 1.6l-4 3a1 1 0 01-1.175.018l-4-2.814a1 1 0 111.15-1.636l2.428 1.708zM6 17v1h12v-1c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1H5c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1s1 .45 1 1z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-drag"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 7,
    width: 20,
    height: 2,
    rx: 1,
    fill: "#29293D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 11,
    width: 20,
    height: 2,
    rx: 1,
    fill: "#29293D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 15,
    width: 20,
    height: 2,
    rx: 1,
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-drop"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.559 5.429l-3.91 3.926c-2.176 2.183-2.205 5.759-.068 7.972A5.4 5.4 0 0012.448 19h.002a5.405 5.405 0 003.895-1.61c2.174-2.179 2.203-5.754.065-7.969l-3.851-3.992zM12.431 21a7.388 7.388 0 01-5.29-2.284c-2.89-2.992-2.85-7.823.087-10.77l4.632-4.651c.19-.19.448-.297.717-.295.27.003.526.114.712.306l4.56 4.727c2.887 2.993 2.848 7.825-.088 10.769A7.387 7.387 0 0112.433 21h-.002z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-drop-off"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.997 5.429l3.884 3.959c1.372 1.397 1.864 3.352 1.49 5.155l1.609 1.609c1.047-2.733.49-5.961-1.671-8.164l-4.6-4.688a1.002 1.002 0 00-.712-.3h-.001a1 1 0 00-.714.3l-2.55 2.604 1.414 1.415 1.85-1.89zM12.002 19H12a5.403 5.403 0 01-3.882-1.64c-1.89-1.926-2.122-4.915-.693-7.106L5.993 8.822c-2.186 2.982-1.959 7.233.698 9.939A7.387 7.387 0 0012.001 21h.001a7.355 7.355 0 004.576-1.594l-1.43-1.43A5.372 5.372 0 0112.001 19zM4.707 3.293l16 16a.999.999 0 11-1.414 1.414l-16-16a.999.999 0 111.414-1.414z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-edit-1"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.019 10.679l-2.695-2.695 1.948-1.95 2.694 2.695-1.947 1.95zm-6.94 6.946l-2.976.27.264-2.955 5.617-5.617 2.696 2.696-5.6 5.606zM19.405 7.338l-.001-.001-2.738-2.738c-.741-.74-2.014-.774-2.716-.07l-8.996 8.997a1.973 1.973 0 00-.57 1.214l-.38 4.17a1.002 1.002 0 001.088 1.086l4.17-.38a1.974 1.974 0 001.214-.567l8.997-8.997c.728-.73.697-1.948-.068-2.714z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-edit-2"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.103 15.873l2.977-.27 5.6-5.606L11.983 7.3l-5.616 5.618-.264 2.956zm7.22-9.912l2.695 2.695 1.947-1.95-2.694-2.694-1.948 1.95zm-9.03 11.725a1.003 1.003 0 01-.29-.799l.38-4.17c.042-.457.244-.888.57-1.213l8.995-8.997c.702-.705 1.976-.67 2.716.07l2.738 2.737.002.001c.765.766.796 1.984.067 2.714l-8.996 8.997a1.975 1.975 0 01-1.214.57l-4.17.378a1.003 1.003 0 01-.798-.289zM20 20.977c0 .55-.45 1-1 1H5c-.55 0-1-.45-1-1 0-.549.45-1 1-1h14c.55 0 1 .451 1 1z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-email"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 18H5c-.551 0-1-.448-1-1V7.25l7.4 5.55a.995.995 0 001.2 0L20 7.25V17c0 .552-.449 1-1 1zm-.667-12L12 10.75 5.667 6h12.666zM19 4H5C3.346 4 2 5.346 2 7v10c0 1.654 1.346 3 3 3h14c1.654 0 3-1.346 3-3V7c0-1.654-1.346-3-3-3z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-emoji"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.991 3a9 9 0 10.018 18 9 9 0 00-.018-18zM12 19a7 7 0 110-14 7 7 0 010 14zm3.105-5.2h1.503a4.946 4.946 0 01-9.216 0h1.503a3.578 3.578 0 006.21 0zM7.5 9.75a1.35 1.35 0 112.7 0 1.35 1.35 0 01-2.7 0zm6.3 0a1.35 1.35 0 112.7 0 1.35 1.35 0 01-2.7 0z",
    fill: "#000018"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-envelope-calado"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.062 18H5c-.551 0-1-.448-1-1V7.25l7.4 5.55a.995.995 0 001.2 0L20 7.25v3.812c.699.087 1.37.264 2 .52V7c0-1.654-1.346-3-3-3H5C3.346 4 2 5.346 2 7v10c0 1.654 1.346 3 3 3h6.062a8.069 8.069 0 010-2zM12 10.75L18.333 6H5.667L12 10.75z",
    fill: "#222B45"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-exit"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 2h9c.55 0 1 .45 1 1v18c0 .55-.45 1-1 1h-9a1 1 0 01-1-1v-2a1 1 0 112 0v1h7V4h-7v1a1 1 0 11-2 0V3.006 3c0-.018 0-.036.002-.055A1 1 0 0111 2z",
    fill: "#29293D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.6 16.8a1 1 0 01-1.4-.2l-3-4a.998.998 0 01-.018-1.174l2.814-4a.999.999 0 011.393-.243 1 1 0 01.243 1.394l-1.718 2.442c.014-.002.026-.005.04-.01.014-.004.03-.008.046-.008h9.895a1 1 0 010 2H4.999L6.8 15.4a1 1 0 01-.2 1.4z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-expand"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.002 4.025a1 1 0 01.995 1L20 9.998a1 1 0 01-1 1.002 1 1 0 01-1-1l-.002-2.585-3.291 3.291a.997.997 0 01-1.414 0 1 1 0 010-1.414l3.28-3.28L13.996 6A1.001 1.001 0 0114 4h.005l4.997.025zm-9.709 9.268a.999.999 0 111.414 1.414l-3.292 3.292L10 18a1 1 0 110 2h-.001l-4.975-.003a1 1 0 01-.999-.995L4 14.005A1 1 0 014.995 13H5a1 1 0 011 .995l.013 2.578 3.28-3.28z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-expand---horizontal"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.71 10.847a.997.997 0 01-.003 1.41l-3.528 3.52a1.006 1.006 0 01-1.42.002 1 1 0 010-1.414l1.832-1.83h-4.67a1.002 1.002 0 01-1.003-1c0-.552.45-1 1.003-1h4.655l-1.82-1.83a.999.999 0 01.007-1.416 1.006 1.006 0 011.415.004l.004.003 3.527 3.551zM10.079 10.536a1 1 0 110 2H5.407l1.834 1.828a.998.998 0 010 1.415c-.393.39-1.028.39-1.42-.001l-3.528-3.52a.997.997 0 01-.003-1.41l3.528-3.552a1.006 1.006 0 011.42-.007l.003.004a.998.998 0 01.003 1.41l-1.82 1.833h4.655z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-export"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.781 7.376l-3-4a1 1 0 00-1.562 1.249L17.92 7H13c-1.655 0-3 1.345-3 3v4a1 1 0 002 0v-4a1 1 0 011-1h4.92l-1.701 2.375a1 1 0 101.562 1.249l3-4a1 1 0 000-1.25z",
    fill: "#29293D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 7a3 3 0 013-3h1.5a1 1 0 010 2H6a1 1 0 00-1 1v11a1 1 0 001 1h11a1 1 0 001-1v-1.5a1 1 0 112 0V18a3 3 0 01-3 3H6a3 3 0 01-3-3V7z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-external-link"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 18v-6a1 1 0 112 0v6c0 1.654-1.346 3-3 3H6c-1.654 0-3-1.346-3-3V6c0-1.654 1.346-3 3-3h6a1 1 0 110 2H6c-.552 0-1 .449-1 1v12c0 .551.448 1 1 1h12c.552 0 1-.449 1-1zM17.578 5.008L15.995 5A1 1 0 0116 3h.005l3.997.02a1 1 0 01.995.999L21 7.999a1 1 0 11-2 .002V6.415l-6.293 6.292a.997.997 0 01-1.414 0 .999.999 0 010-1.414l6.285-6.285z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-eye-closed"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.81 13.395a8.947 8.947 0 003.182-5.771 1 1 0 00-1.984-.249C18.57 10.867 15.556 13.5 12 13.5s-6.569-2.633-7.008-6.125a1 1 0 10-1.984.249 8.947 8.947 0 003.183 5.771L3.88 15.707a1.003 1.003 0 000 1.414 1.003 1.003 0 001.414 0l2.603-2.603c.954.482 2.001.8 3.104.921V19c0 .55.45 1 1 1s1-.45 1-1v-3.561a9.062 9.062 0 003.103-.921l2.604 2.603a1.003 1.003 0 001.414 0 1.003 1.003 0 000-1.414l-2.312-2.312z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-eye-off"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.868 12.498a15.623 15.623 0 01-2.913 3.629l-1.411-1.411a13.398 13.398 0 002.283-2.711c-.932-1.42-3.755-5.111-8.046-5.002-.6.015-1.163.109-1.7.25l-1.58-1.58a9.356 9.356 0 013.229-.67c5.975-.186 9.5 5.388 10.138 6.5.176.308.176.687 0 .995zm-7.95 4.249l1.58 1.58a9.35 9.35 0 01-3.473.673c-5.863 0-9.263-5.405-9.892-6.502a.999.999 0 010-.995 15.605 15.605 0 012.912-3.63l1.41 1.412a13.433 13.433 0 00-2.282 2.71c.932 1.42 3.742 5.103 8.047 5.003a7.29 7.29 0 001.698-.251zM12 13.499c-.827 0-1.5-.671-1.5-1.5 0-.024.01-.048.012-.074l1.563 1.563c-.026.002-.05.011-.075.011zM4.707 3.292a1 1 0 00-1.414 1.415l5.63 5.63A3.454 3.454 0 008.5 12c0 1.93 1.57 3.5 3.5 3.5.59 0 1.155-.147 1.663-.423l5.63 5.63A.995.995 0 0020 21a.999.999 0 00.707-1.707l-16-16z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-eye-open"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 13.5c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5zm0-5c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5zm.22 8.498c-4.306.1-7.115-3.583-8.047-5.002 1.026-1.605 3.61-4.891 7.608-4.993 4.289-.11 7.114 3.583 8.046 5.002-1.025 1.605-3.61 4.89-7.607 4.993zm9.648-5.495c-.638-1.112-4.162-6.686-10.138-6.5-5.528.14-8.743 5.01-9.597 6.5a.999.999 0 000 .995C2.762 13.595 6.162 19 12.025 19l.246-.003c5.527-.141 8.743-5.01 9.597-6.5a1.004 1.004 0 000-.994z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-facebook"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20h2v-6.2a1 1 0 011-1h2.24l.445-1.6H13a1 1 0 01-1-1V7.5c0-1.048.897-1.9 2-1.9h2V4h-2c-2.206 0-4 1.57-4 3.5v2.7a1 1 0 01-1 1H7v1.6h2a1 1 0 011 1V20zm3 2H9a1 1 0 01-1-1v-6.2H6a1 1 0 01-1-1v-3.6a1 1 0 011-1h2V7.5C8 4.468 10.691 2 14 2h3a1 1 0 011 1v3.6a1 1 0 01-1 1h-3v1.6h3a1.003 1.003 0 01.964 1.268l-1 3.599A1 1 0 0116 14.8h-2V21a1 1 0 01-1 1z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-file"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.444 20H6.555C6.25 20 6 19.776 6 19.5v-15c0-.276.25-.5.555-.5H11v4.15C11 9.722 12.217 11 13.714 11H18v8.5c0 .276-.25.5-.556.5zm.205-11h-3.935C13.32 9 13 8.619 13 8.15V4h.112l4.537 5zm2.091-.672l-5.444-6a.998.998 0 00-.74-.328h-7C5.145 2 4 3.122 4 4.5v15C4 20.878 5.146 22 6.555 22h10.89C18.852 22 20 20.878 20 19.5V9a1 1 0 00-.26-.672z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-file-add"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 13h-1v-1a1 1 0 10-2 0v1h-1a1 1 0 100 2h1v1a1 1 0 102 0v-1h1a1 1 0 100-2zm3.444 7H6.555C6.25 20 6 19.776 6 19.5v-15c0-.276.25-.5.555-.5H12v3.15C12 8.722 13.217 10 14.714 10H18v9.5c0 .276-.249.5-.556.5zM14 4.978L16.742 8h-2.028C14.32 8 14 7.619 14 7.15V4.978zm5.74 3.35l-5.444-6a1 1 0 00-.74-.328h-7C5.145 2 4 3.122 4 4.5v15C4 20.878 5.146 22 6.555 22h10.89C18.852 22 20 20.878 20 19.5V9a1 1 0 00-.26-.672z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-file-remove"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 13h-4a1 1 0 100 2h4a1 1 0 100-2zm3.444 7H6.555C6.25 20 6 19.776 6 19.5v-15c0-.276.25-.5.555-.5H12v3.15C12 8.722 13.217 10 14.714 10H18v9.5c0 .276-.249.5-.556.5zM14 4.978L16.742 8h-2.028C14.32 8 14 7.619 14 7.15V4.978zm5.74 3.35l-5.444-6a1 1 0 00-.74-.328h-7C5.145 2 4 3.122 4 4.5v15C4 20.878 5.146 22 6.555 22h10.89C18.852 22 20 20.878 20 19.5V9a1 1 0 00-.26-.672z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-file-text"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 14H9a1 1 0 010-2h3a1 1 0 010 2zm-4 3a1 1 0 011-1h6a1 1 0 110 2H9a1 1 0 01-1-1zm9.444 3H6.555C6.25 20 6 19.776 6 19.5v-15c0-.276.25-.5.555-.5H12v3.15C12 8.722 13.217 10 14.714 10H18v9.5c0 .276-.249.5-.556.5zM14 4.978L16.742 8h-2.028C14.32 8 14 7.619 14 7.15V4.978zm5.74 3.35l-5.444-6a1 1 0 00-.74-.328h-7C5.145 2 4 3.122 4 4.5v15C4 20.878 5.146 22 6.555 22h10.89C18.852 22 20 20.878 20 19.5V9a1 1 0 00-.26-.672z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-film"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 18.256c0 .41-.334.744-.744.744H17v-2h2v1.256zm-14 0V17h2v2H5.744A.745.745 0 015 18.256zM5.744 5H7v2H5V5.744c0-.41.334-.744.744-.744zM19 5.744V7h-2V5h1.256c.41 0 .744.334.744.744zM17 15h2v-2h-2v2zm0-4h2V9h-2v2zm-8 8h6V5H9v14zm-4-4h2v-2H5v2zm0-4h2V9H5v2zm13.256-8H5.744A2.748 2.748 0 003 5.744v12.512A2.747 2.747 0 005.744 21h12.512A2.747 2.747 0 0021 18.256V5.744A2.748 2.748 0 0018.256 3z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-fire"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.495 9.517c-2.032 2.199-1.989 5.685.13 7.844A5.384 5.384 0 0011.495 19h.005a5.41 5.41 0 003.885-1.64c2.156-2.198 2.152-5.773-.009-7.968l-2.986-3.051c-.302 2.482-1.233 4.66-2.89 4.66-.509 0-1.337-.226-2.006-1.485zm4.006 11.485h-.007a7.363 7.363 0 01-5.299-2.242c-2.914-2.97-2.918-7.804-.009-10.769l.983-.994a1 1 0 011.679.454c.23.89.504 1.326.655 1.492.355-.374.997-1.885.997-4.442 0-.147 0-.286-.008-.425a1.01 1.01 0 011.722-.773l4.59 4.69c2.92 2.963 2.925 7.796.01 10.767a7.392 7.392 0 01-5.313 2.241z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-flag"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 14.586c-.396.177-1.175.414-2.5.414-1.124 0-2.101-.383-3.135-.788-1.162-.455-2.364-.926-3.865-.926-1.057 0-1.876.127-2.5.298V5.416C6.396 5.239 7.177 5 8.5 5c1.124 0 2.101.383 3.135.788 1.162.455 2.364.926 3.865.926.938 0 1.776-.101 2.5-.3v8.172zm1.268-9.906a1.79 1.79 0 00-1.599-.253c-.576.187-1.326.287-2.169.287-1.124 0-2.101-.383-3.135-.788C11.203 3.471 10.001 3 8.5 3c-2.887 0-4.005.952-4.2 1.144a.996.996 0 00-.3.713V20a1 1 0 102 0v-4.298c.395-.176 1.173-.416 2.5-.416 1.124 0 2.101.383 3.135.788 1.162.455 2.364.926 3.865.926 1.809 0 2.923-.378 3.541-.695.592-.307.959-.903.959-1.556V6.106c0-.56-.273-1.093-.732-1.426z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-flash-off"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.193 8.364l.262-2.42L10.38 7.55l-1.442-1.44 3.12-4.667a1 1 0 011.825.663L13.114 9.2H19a1 1 0 01.831 1.556L17.328 14.5l-1.44-1.442 1.241-1.858h-3.1l-2.836-2.837zm9.514 10.929l-16-16a.999.999 0 10-1.414 1.414l16 16a.997.997 0 001.414 0 .999.999 0 000-1.414zm-8.162-1.236l.262-2.421L9.972 12.8H6.87l1.242-1.858L6.672 9.5l-2.503 3.745a1 1 0 00.83 1.555h5.887l-.77 7.093a1 1 0 001.826.663l3.12-4.666-1.442-1.441-1.075 1.608z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-flash-on"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.871 12.8h5.13a1 1 0 01.993 1.107l-.449 4.15L17.13 11.2H12a1 1 0 01-.994-1.107l.45-4.15L6.87 12.8zm4.24 10.2a.998.998 0 01-.994-1.107l.77-7.093H5a1 1 0 01-.83-1.556l7.888-11.8a1 1 0 011.825.663L13.114 9.2H19a1.001 1.001 0 01.831 1.556l-7.889 11.8a.998.998 0 01-.83.444z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-flip"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.293 7.207a.999.999 0 010-1.414l3-3a.999.999 0 011.414 0l3 3a.997.997 0 010 1.414.999.999 0 01-1.414 0L19 5.914V17.91c0 1.98-1.583 3.59-3.529 3.59H13a1 1 0 110-2h2.471c.843 0 1.529-.713 1.529-1.59V5.914l-1.293 1.293a.999.999 0 01-1.414 0zM5 18.086V6.09C5 4.11 6.583 2.5 8.529 2.5H11a1 1 0 110 2H8.529C7.687 4.5 7 5.213 7 6.09v11.996l1.293-1.293a1 1 0 011.414 1.414l-3 3a.999.999 0 01-1.414 0l-3-3a.999.999 0 111.414-1.414L5 18.086z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-flip-1"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.207 9.707a.999.999 0 01-1.414 0l-3-3a.999.999 0 010-1.414l3-3a.997.997 0 011.414 0 .999.999 0 010 1.414L5.914 5H17.91c1.98 0 3.59 1.583 3.59 3.529V11a1 1 0 11-2 0V8.529C19.5 7.686 18.787 7 17.91 7H5.914l1.293 1.293a.999.999 0 010 1.414zM18.086 19H6.09c-1.98 0-3.59-1.583-3.59-3.529V13a1 1 0 112 0v2.471c0 .842.713 1.529 1.59 1.529h11.996l-1.293-1.293a1 1 0 011.414-1.414l3 3a.999.999 0 010 1.414l-3 3a.999.999 0 11-1.414-1.414L18.086 19z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-folder"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 13.755v4.313c0 .238.224.432.5.432h15c.276 0 .5-.194.5-.431v-8.59c0-.24-.224-.433-.5-.433H12a.999.999 0 01-.774-.368L8.626 5.5H4.5c-.276 0-.5.193-.5.431v7.824zM19.5 20.5h-15C3.122 20.5 2 19.41 2 18.07V5.93c0-1.34 1.122-2.43 2.5-2.43h4.601a1 1 0 01.774.366l2.599 3.18H19.5c1.378 0 2.5 1.09 2.5 2.431v8.59c0 1.341-1.122 2.432-2.5 2.432z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-folder-add"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 13h-1v-1c0-.55-.45-1-1-1s-1 .45-1 1v1h-1c-.55 0-1 .45-1 1s.45 1 1 1h1v1c0 .55.45 1 1 1s1-.45 1-1v-1h1c.55 0 1-.45 1-1s-.45-1-1-1zm6 5.069c0 .238-.224.431-.5.431h-15c-.276 0-.5-.194-.5-.431V5.93c0-.238.224-.43.5-.43h4.126l2.6 3.177c.19.233.474.368.774.368h7.5c.276 0 .5.193.5.432v8.59zm-.5-11.023h-7.026L9.875 3.867a1 1 0 00-.774-.367H4.5C3.122 3.5 2 4.59 2 5.931v12.137C2 19.41 3.122 20.5 4.5 20.5h15c1.378 0 2.5-1.09 2.5-2.431v-8.59c0-1.343-1.122-2.433-2.5-2.433z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-folder-remove"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 13h-4c-.55 0-1 .45-1 1s.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1zm6 5.069c0 .238-.224.431-.5.431h-15c-.276 0-.5-.194-.5-.431V5.93c0-.238.224-.43.5-.43h4.126l2.6 3.177c.19.233.474.368.774.368h7.5c.276 0 .5.193.5.432v8.59zm-.5-11.023h-7.026L9.875 3.867a1 1 0 00-.774-.367H4.5C3.122 3.5 2 4.59 2 5.931v12.137C2 19.41 3.122 20.5 4.5 20.5h15c1.378 0 2.5-1.09 2.5-2.431v-8.59c0-1.343-1.122-2.433-2.5-2.433z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-food"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.96 7.4C8.986 7.272 9 4.138 9 4a1 1 0 112 0c0 .144-.008 3.285-.022 3.425A4.01 4.01 0 018 10.874v9.073C8 20.527 7.55 21 7 21s-1-.474-1-1.053v-9.073a4.009 4.009 0 01-2.984-3.516C3.006 7.24 3 4.12 3 4a1 1 0 112 0c0 .11.009 3.217.026 3.322.098.602.465 1.115.974 1.41v-4.68C6 3.475 6.45 3 7 3s1 .474 1 1.053v4.679c.486-.282.844-.763.96-1.331zM17 14.987v4.961c0 .58-.45 1.053-1 1.053s-1-.474-1-1.053V4.053C15 3.473 15.45 3 16 3c.069 0 .136.007.2.021 2.459.364 4.535 4.413 4.564 7.418l.063 3.566a1.002 1.002 0 01-1.01 1.01L17 14.985zm0-2l1.817.018-.053-2.546C18.75 8.937 18.063 6.762 17 5.781v7.204z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-foward"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 15.908V8.014l4.822 3.984-4.822 3.91zm-8 0V8.014l4.822 3.984-4.822 3.91zm14.358-5.234L15.759 6.46a2.088 2.088 0 00-2.209-.259c-.648.306-1.05.913-1.05 1.586v2.591L7.759 6.46a2.088 2.088 0 00-2.209-.259c-.648.306-1.05.913-1.05 1.586v8.426c0 .673.402 1.28 1.05 1.586.289.135.599.202.906.202a2.04 2.04 0 001.303-.462l4.741-3.916v2.59c0 .673.402 1.28 1.05 1.586.289.135.599.202.906.202a2.04 2.04 0 001.303-.462l5.1-4.213c.407-.336.641-.82.641-1.326 0-.506-.234-.99-.642-1.326z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-funnel"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.877 17.457l2.026 1.533v-4.553c0-.166.042-.329.12-.475L17.323 6H6.643l4.122 7.978c.074.142.112.3.112.459v3.02zM13.903 22a.994.994 0 01-.603-.203l-4.026-3.045a1 1 0 01-.397-.797v-3.274L4.112 5.459A1 1 0 015 4h14a1 1 0 01.88 1.475l-4.977 9.215V21a1 1 0 01-1 1z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-gift"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 19h4.5v-4H13v4zm-6.5 0H11v-4H6.5v4zM5 9.2c0-.083.013-.15.026-.2H11v4H5.026A.784.784 0 015 12.8V9.2zM7 6c0-.552.513-1 1.143-1C9.4 5 10.17 6.09 10.594 7H8.143C7.513 7 7 6.552 7 6zm8.857-1C16.487 5 17 5.448 17 6s-.513 1-1.143 1H13.4c.42-.91 1.188-2 2.457-2zM19 9.2v3.6c0 .083-.013.15-.026.2H13V9h5.974c.013.05.026.117.026.2zm.2-2.2h-.393c.118-.314.193-.647.193-1 0-1.654-1.41-3-3.143-3C13.935 3 12.729 4.199 12 5.397 11.271 4.199 10.065 3 8.143 3 6.41 3 5 4.346 5 6c0 .353.076.686.193 1H4.8C3.791 7 3 7.967 3 9.2v3.6c0 1.107.64 1.993 1.5 2.164v4.369c0 .919.813 1.667 1.812 1.667h11.375c1 0 1.813-.748 1.813-1.667v-4.369c.86-.171 1.5-1.057 1.5-2.164V9.2c0-1.233-.791-2.2-1.8-2.2z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-github"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.24 22a1 1 0 01-1-1v-2.599c.047-.663-.152-1.24-.543-1.659a.999.999 0 01.615-1.677C17.746 14.783 20 13.947 20 9.775c0-.8-.232-1.572-.67-2.228a2.762 2.762 0 01-.414-2.053 3.701 3.701 0 00-.012-1.419c-.404.12-1.096.405-2.093 1.1-.245.17-.556.22-.842.14a10.192 10.192 0 00-5.516 0c-.287.08-.596.03-.84-.14-.988-.688-1.676-.974-2.096-1.092a3.684 3.684 0 00-.01 1.408 2.823 2.823 0 01-.427 2.077 4 4 0 00-.657 2.23c0 3.893 1.88 4.932 4.7 5.295a1 1 0 01.604 1.674 2.095 2.095 0 00-.547 1.567l.001.788a1.2 1.2 0 010 .12L11.182 21a1 1 0 11-2 0v-.57c-2.685.35-4.215-1.09-5.276-2.09-.44-.413-.854-.804-1.157-.883a1 1 0 11.502-1.936c.8.208 1.395.77 2.026 1.363 1.022.963 1.992 1.875 3.905 1.52v-.003a3.918 3.918 0 01.225-1.584c-2.054-.512-4.984-2.005-4.984-7.015a5.993 5.993 0 01.987-3.335.833.833 0 00.13-.613 5.688 5.688 0 01.334-3.21c.114-.277.345-.488.63-.576.331-.102 1.551-.297 3.862 1.203a12.186 12.186 0 015.69 0c2.312-1.5 3.531-1.306 3.862-1.203.285.088.516.3.63.575a5.684 5.684 0 01.335 3.215.78.78 0 00.108.577 5.984 5.984 0 011.01 3.34c0 5.063-2.924 6.538-4.98 7.032.183.53.26 1.098.216 1.671L17.24 21a1 1 0 01-1 1z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-globe"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.617 19.552A13.123 13.123 0 0016.975 13h2.955a8.012 8.012 0 01-5.313 6.552zM4.069 13h2.992a12.902 12.902 0 002.346 6.561A8.015 8.015 0 014.069 13zm5.369-8.571A13.144 13.144 0 007.065 11H4.069a8.013 8.013 0 015.369-6.571zM9.079 11c.306-3.272 1.98-5.55 2.947-6.603 1 1.071 2.648 3.328 2.933 6.603h-5.88zm.001 2h5.882c-.306 3.277-1.984 5.555-2.95 6.608A11.018 11.018 0 019.08 13zm10.85-2h-2.952a12.892 12.892 0 00-2.328-6.539A8.009 8.009 0 0119.93 11zM22 12c0-5.504-4.471-9.982-9.972-9.998l-.013-.001L12 2C6.486 2 2 6.487 2 12c0 5.514 4.486 10 10 10l.015-.001.005.001.008-.002C17.529 21.983 22 17.504 22 12z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 12 13",
    fill: "none",
    id: "sprite_svg__icon-light-gold-zonajobs"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.727 12.164c-1.13 0-2.094-.234-2.891-.703A4.71 4.71 0 011 9.508c-.422-.834-.633-1.8-.633-2.899v-.39c0-1.136.211-2.136.633-3 .422-.865 1.018-1.54 1.79-2.024.775-.49 1.692-.734 2.75-.734a7.68 7.68 0 012.296.336c.724.224 1.351.56 1.883 1.008v2.523H8.03l-.32-1.523c-.208-.177-.484-.318-.828-.422a3.813 3.813 0 00-1.172-.164c-.64 0-1.19.166-1.649.5-.458.333-.81.8-1.054 1.398-.245.6-.367 1.294-.367 2.086v.406c0 1.157.27 2.081.812 2.774.542.687 1.323 1.031 2.344 1.031.4 0 .768-.039 1.101-.117.339-.078.618-.17.836-.274v-1.93L6.11 7.97V6.367h3.914v4.602c-.505.36-1.114.648-1.828.867-.713.219-1.536.328-2.468.328z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-google"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.003 4c-2.182 0-4.22.861-5.74 2.426a7.936 7.936 0 00-2.26 5.809c.118 4.104 3.55 7.583 7.65 7.757 4.382.173 8.119-3.212 8.342-7.573.007-.128.006-.693.004-1.219h-7.002v1.582h5.309L17.9 14.08c-.721 2.314-2.55 3.902-4.89 4.248-1.746.253-3.565-.246-4.988-1.383-1.397-1.113-2.273-2.731-2.405-4.44a6.347 6.347 0 011.685-4.852c1.666-1.8 4.359-2.493 6.667-1.744l.773-1.429a7.962 7.962 0 00-2.74-.48zm-.007 17.999c-.141 0-.284-.003-.427-.009-5.128-.217-9.418-4.567-9.565-9.698a9.93 9.93 0 012.824-7.26A9.927 9.927 0 0112.003 2c1.434 0 2.82.298 4.119.885.36.163.642.473.769.851.129.383.093.807-.1 1.162L15.5 7.282a1.447 1.447 0 01-1.835.643c-1.653-.673-3.673-.233-4.895 1.087a4.37 4.37 0 00-1.158 3.339c.09 1.158.694 2.262 1.658 3.031.994.793 2.256 1.146 3.448.968 1.1-.163 2.012-.715 2.632-1.568h-2.903c-.8 0-1.45-.65-1.45-1.45V10.65c0-.799.65-1.45 1.45-1.45h8.1c.793 0 1.444.645 1.45 1.438a88.28 88.28 0 01-.004 1.882c-.273 5.312-4.716 9.479-9.997 9.479z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-graduation-cap"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.49 10.19l-1-.55-9-5h-.11a1.058 1.058 0 00-.19-.06h-.37a1.17 1.17 0 00-.2.06h-.11l-9 5a1 1 0 000 1.74L4 12.76v4.74a3 3 0 003 3h8a3 3 0 003-3v-4.74l2-1.12v2.86a1 1 0 002 0v-3.44a1 1 0 00-.51-.87zM16 17.5a1 1 0 01-1 1H7a1 1 0 01-1-1v-3.63l4.51 2.5.15.06h.09c.083.01.167.01.25 0 .083.01.167.01.25 0h.09a.47.47 0 00.15-.06l4.51-2.5v3.63zm-5-3.14L4.06 10.5 11 6.64l6.94 3.86L11 14.36z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-graph"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.647 19.974h16.34a1.013 1.013 0 110 2.026H4.647A2.647 2.647 0 012 19.353V3.013a1.013 1.013 0 112.026 0v16.34a.62.62 0 00.621.62z",
    fill: "#29293D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 13a1 1 0 112 0v4a1 1 0 11-2 0v-4zM10 10a1 1 0 112 0v7a1 1 0 11-2 0v-7zM14 12a1 1 0 112 0v5a1 1 0 11-2 0v-5zM18 6a1 1 0 112 0v11a1 1 0 11-2 0V6z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 74 62",
    fill: "none",
    id: "sprite_svg__icon-light-graph-up"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sprite_svg__icon-light-graph-up_clip0_2332_255103)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.779 58.522V40.018a1.31 1.31 0 00-1.313-1.309h-8.42a1.31 1.31 0 00-1.314 1.31v18.503a1.31 1.31 0 001.313 1.309h8.42a1.309 1.309 0 001.314-1.309z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.466 38.71h-6.634a1.31 1.31 0 011.313 1.308v18.504a1.31 1.31 0 01-1.313 1.309h6.634a1.31 1.31 0 001.313-1.309V40.018a1.31 1.31 0 00-1.313-1.309zM41.816 58.522v-27.23a1.31 1.31 0 00-1.313-1.31h-8.42a1.31 1.31 0 00-1.313 1.31v27.23a1.31 1.31 0 001.313 1.309h8.42a1.31 1.31 0 001.313-1.309z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5 29.983h-6.667a1.31 1.31 0 011.313 1.308v27.231a1.31 1.31 0 01-1.313 1.309h6.67a1.31 1.31 0 001.313-1.309v-27.23c0-.724-.59-1.31-1.315-1.31zM61.85 58.522V21.666a1.31 1.31 0 00-1.312-1.31h-8.42a1.31 1.31 0 00-1.313 1.31v36.856a1.31 1.31 0 001.312 1.309h8.421a1.309 1.309 0 001.313-1.31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.538 20.357H53.8a1.31 1.31 0 011.313 1.309v36.856A1.31 1.31 0 0153.8 59.83h6.738a1.31 1.31 0 001.312-1.31V21.667a1.31 1.31 0 00-1.312-1.31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.365 58.28H5.119a.9.9 0 01-.9-.896V2.663a.9.9 0 00-.899-.897H1.635a.9.9 0 00-.9.897v58.44a.9.9 0 00.9.897h70.73a.9.9 0 00.9-.897v-1.926a.9.9 0 00-.9-.896z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.361 6.495L59.578.913a1.065 1.065 0 00-1.214-.901l-6.167.942a1.06 1.06 0 10.324 2.097l3.595-.55C51.31 8.425 46.141 13.47 40.728 17.513c-4.712 3.519-9.617 6.29-14.58 8.24-8.448 3.321-14.219 3.102-14.274 3.1a1.06 1.06 0 10-.102 2.118c.034.002.179.007.428.007 1.533 0 6.99-.234 14.593-3.2 5.157-2.013 10.246-4.873 15.127-8.508 5.609-4.176 10.954-9.39 15.913-15.513l.425 3.027a1.062 1.062 0 002.103-.29z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 16 13",
    fill: "none",
    id: "sprite_svg__icon-light-gratis-zonajobs"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.617 12.164c-1.187 0-2.127-.388-2.82-1.164-.693-.781-1.04-1.924-1.04-3.43V5.062c0-1.5.345-2.64 1.032-3.421C9.482.854 10.42.46 11.602.46c1.177 0 2.111.393 2.804 1.18.698.78 1.047 1.921 1.047 3.421V7.57c0 1.506-.346 2.649-1.039 3.43-.687.776-1.62 1.164-2.797 1.164zm0-1.75c.51 0 .899-.208 1.164-.625.266-.417.399-1.083.399-2V4.83c0-.902-.136-1.56-.407-1.977-.27-.422-.661-.633-1.171-.633-.516 0-.907.208-1.172.625-.266.416-.399 1.078-.399 1.984V7.79c0 .917.133 1.583.399 2 .27.417.666.625 1.187.625zM2.836 12.254V11.1a3.4 3.4 0 01-1.3-.393 2.25 2.25 0 01-.897-.896C.424 9.424.322 8.943.334 8.369l.012-.03H2.01c0 .524.12.9.363 1.126.242.226.547.34.914.34.356 0 .627-.094.815-.282.191-.191.287-.447.287-.767 0-.317-.092-.574-.276-.774-.18-.199-.49-.384-.931-.556a7.905 7.905 0 01-1.436-.668C1.371 6.52 1.09 6.24.902 5.92.72 5.596.627 5.197.627 4.725c0-.657.209-1.194.627-1.612.422-.422.988-.67 1.7-.744V1.11h.93v1.278c.684.101 1.221.388 1.612.861.395.469.588 1.08.58 1.834l-.017.03H4.395c0-.462-.096-.817-.288-1.067a.924.924 0 00-.773-.375c-.336 0-.588.098-.756.293-.164.191-.246.447-.246.767 0 .305.086.553.258.745.176.187.496.373.96.556.575.227 1.05.461 1.425.703.379.239.66.518.843.838.188.32.282.711.282 1.172 0 .676-.211 1.219-.633 1.629-.418.406-.985.647-1.7.72v1.16h-.931z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-grid"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 19v-4h4l.001 4H15zm4-6h-4c-1.103 0-2 .897-2 2v4c0 1.103.897 2 2 2h4c1.103 0 2-.897 2-2v-4c0-1.103-.897-2-2-2zM5 19v-4h4l.001 4H5zm4-6H5c-1.103 0-2 .897-2 2v4c0 1.103.897 2 2 2h4c1.103 0 2-.897 2-2v-4c0-1.103-.897-2-2-2zm6-4V5h4l.001 4H15zm4-6h-4c-1.103 0-2 .897-2 2v4c0 1.103.897 2 2 2h4c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM5 9V5h4l.001 4H5zm4-6H5c-1.103 0-2 .897-2 2v4c0 1.103.897 2 2 2h4c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-gym"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.025 2.404l-2.121 2.121a2 2 0 000 2.829l1.72 1.72a.998.998 0 00-.33.219l-4 4c-.06.06-.11.124-.152.193L7.707 12.05a2 2 0 00-2.828 0l-2.122 2.122a2 2 0 000 2.828L7 21.243a2 2 0 002.828 0l2.122-2.121a2 2 0 000-2.829l-1.436-1.435c.07-.042.134-.092.193-.151l4-4a.999.999 0 00.22-.33l1.22 1.22a2 2 0 002.828 0l2.121-2.122a2 2 0 000-2.828l-4.242-4.243a2 2 0 00-2.829 0zm-.707 3.535l2.121-2.12 4.243 4.242-2.121 2.121-4.243-4.243zm-7.025 7.526l-2.121 2.12 4.242 4.244 2.122-2.122-4.243-4.242z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-hard-drive"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 16c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1-1-.45-1-1zm5-1h4c.55 0 1 .45 1 1s-.45 1-1 1h-4c-.55 0-1-.45-1-1s.45-1 1-1zm6 4H6c-.551 0-1-.448-1-1v-5h14v5c0 .552-.449 1-1 1zM8.342 5.553A.994.994 0 019.236 5h5.528c.381 0 .724.212.894.553L18.382 11H5.618l2.724-5.447zm12.447 5.789l-3.342-6.684A2.984 2.984 0 0014.764 3H9.236a2.984 2.984 0 00-2.683 1.658l-3.342 6.684a2.012 2.012 0 00-.211.894V18c0 1.654 1.346 3 3 3h12c1.654 0 3-1.346 3-3v-5.764c0-.308-.073-.618-.211-.894z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-hashtag"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.698 14l.73-4h3.874l-.729 4H9.698zM20 14h-4.302l.73-4H20c.55 0 1-.45 1-1s-.45-1-1-1h-3.21l.694-3.811c.1-.548-.282-1.077-.849-1.173-.567-.097-1.112.273-1.212.822L14.665 8H10.79l.694-3.811c.1-.548-.282-1.077-.849-1.173-.567-.097-1.112.273-1.212.822L8.665 8H4c-.55 0-1 .45-1 1s.45 1 1 1h4.302l-.729 4H4c-.55 0-1 .45-1 1s.45 1 1 1h3.21l-.695 3.81c-.099.549.283 1.078.85 1.174.566.097 1.112-.273 1.211-.822L9.334 16h3.875l-.694 3.81c-.099.549.283 1.078.85 1.174.566.097 1.112-.273 1.211-.822L15.334 16H20c.55 0 1-.45 1-1s-.45-1-1-1z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-headphones"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 19c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zM6 15c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2zm6-13C6.486 2 2 6.65 2 12.366V17c0 2.206 1.794 4 4 4s4-1.794 4-4-1.794-4-4-4a3.95 3.95 0 00-2 .557v-1.191C4 7.753 7.589 4 12 4s8 3.753 8 8.366v1.191A3.95 3.95 0 0018 13c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4v-4.634C22 6.65 17.514 2 12 2z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-health"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 21c1.654 0 3-1.346 3-3v-2h2c1.654 0 3-1.346 3-3v-2c0-1.654-1.346-3-3-3h-2V6c0-1.654-1.346-3-3-3h-2C9.346 3 8 4.346 8 6v2H6c-1.654 0-3 1.346-3 3v2c0 1.654 1.346 3 3 3h2v2c0 1.654 1.346 3 3 3h2zm-2-2c-.551 0-1-.449-1-1v-4H6c-.551 0-1-.449-1-1v-2c0-.551.449-1 1-1h4V6c0-.551.449-1 1-1h2c.551 0 1 .449 1 1v4h4c.551 0 1 .449 1 1v2c0 .551-.449 1-1 1h-4v4c0 .551-.449 1-1 1h-2z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-heart"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.22 6c-.864 0-1.674.334-2.28.941a3.241 3.241 0 000 4.573L12 18.585l7.06-7.071a3.24 3.24 0 000-4.573c-1.212-1.215-3.348-1.213-4.56 0l-1.792 1.795a1.028 1.028 0 01-1.416 0L9.5 6.94A3.2 3.2 0 007.22 6zM12 21a.994.994 0 01-.707-.294l-7.768-7.78a5.245 5.245 0 010-7.399A5.19 5.19 0 017.22 4c1.399 0 2.712.543 3.695 1.527L12 6.614l1.085-1.086A5.187 5.187 0 0116.78 4c1.398 0 2.71.543 3.694 1.527a5.244 5.244 0 010 7.399l-7.767 7.781A1 1 0 0112 21z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-height"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 4h7c.55 0 1 .45 1 1s-.45 1-1 1H3c-.55 0-1-.45-1-1s.45-1 1-1zm3 7h4c.55 0 1 .45 1 1s-.45 1-1 1H6c-.55 0-1-.45-1-1s.45-1 1-1zm4 7H8c-.55 0-1 .45-1 1s.45 1 1 1h2c.55 0 1-.45 1-1s-.45-1-1-1zm9-1.356l1.305-1.26a1 1 0 011.39 1.439l-3 2.897a1.005 1.005 0 01-1.402-.013l-3-3a.999.999 0 111.414-1.414L17 16.586v-9.23l-1.305 1.26a1 1 0 01-1.39-1.44l3-2.896a1.002 1.002 0 011.402.013l3 3a1 1 0 01-1.414 1.414L19 7.414v9.23z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-hiring-room"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 4v15.684h10.643V4H7zm8.268 14.217l-7.62.94V4.578l7.62.941v12.698z",
    fill: "#222B45"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-home"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 19.988h2.99l.01-8.376-7.002-7.192-6.992 7.15L5 19.989h3v-7a1 1 0 011-1h6a1 1 0 011 1v7zm-2 0h-4v-6h4v6zm6.424-9.815l-7.709-7.884c-.377-.385-1.053-.385-1.43 0l-7.71 7.885c-.365.375-.575.899-.575 1.438v8.376c0 1.103.847 2 1.888 2H19.111c1.041 0 1.89-.897 1.89-2v-8.376c0-.54-.21-1.063-.577-1.44z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 20 20",
    fill: "none",
    id: "sprite_svg__icon-light-hr"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 2v15.684h10.643V2H5zm8.268 14.217l-7.62.94V2.578l7.62.941v12.698z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-ia-stars"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 11l.784-1.569c.266-.53.399-.796.576-1.026a3 3 0 01.545-.545c.23-.177.495-.31 1.026-.575L11 6.5l-1.569-.785c-.53-.265-.796-.398-1.026-.575a3 3 0 01-.545-.545c-.177-.23-.31-.495-.576-1.026L6.5 2l-.784 1.569c-.266.53-.399.796-.576 1.026a3 3 0 01-.545.545c-.23.177-.495.31-1.026.575L2 6.5l1.569.785c.53.265.796.398 1.026.575a3 3 0 01.545.545c.177.23.31.495.576 1.026L6.5 11zM15 22l1.179-3.064c.282-.734.423-1.1.642-1.409a3 3 0 01.706-.706c.309-.22.675-.36 1.409-.642L22 15l-3.064-1.179c-.734-.282-1.1-.423-1.409-.642a3 3 0 01-.706-.706c-.22-.309-.36-.675-.642-1.409L15 8l-1.179 3.064c-.282.734-.423 1.1-.642 1.409a3 3 0 01-.706.706c-.309.22-.675.36-1.409.642L8 15l3.064 1.179c.734.282 1.1.423 1.409.642a3 3 0 01.706.706c.22.309.36.675.642 1.409L15 22z",
    stroke: "#29293D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-image"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 10a1.5 1.5 0 10-.001-3.001A1.5 1.5 0 008 10zm10 9H6.561l7.005-5.845c.246-.209.692-.208.933-.001L19 16.994V18a1 1 0 01-1 1zM6 5h12a1 1 0 011 1v8.364l-3.203-2.732c-.99-.842-2.539-.842-3.52-.006L5 17.698V6a1 1 0 011-1zm12-2H6C4.346 3 3 4.346 3 6v12c0 1.654 1.346 3 3 3h12c1.654 0 3-1.346 3-3V6c0-1.654-1.346-3-3-3z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-inbox"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 19H6c-.551 0-1-.448-1-1v-5h2v3a1 1 0 001 1h8a1 1 0 001-1v-3h2v5c0 .552-.449 1-1 1zM8.342 5.553A.994.994 0 019.236 5h5.528c.381 0 .724.212.894.553L18.382 11H16a1 1 0 00-1 1v3H9v-3a1 1 0 00-1-1H5.618l2.724-5.447zm12.447 5.789l-3.342-6.684A2.984 2.984 0 0014.764 3H9.236a2.984 2.984 0 00-2.683 1.658l-3.342 6.684a2.012 2.012 0 00-.211.894V18c0 1.654 1.346 3 3 3h12c1.654 0 3-1.346 3-3v-5.764c0-.308-.073-.618-.211-.894z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-info"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 8a1 1 0 112 0 1 1 0 01-2 0zm0 3a1 1 0 012 0v5a1 1 0 01-2 0v-5zm1 9c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8zm0-18C6.477 2 2 6.477 2 12s4.477 10 10 10c5.522 0 10-4.477 10-10S17.522 2 12 2z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-instagram"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.801 1.8c-2.716 0-3.057.012-4.123.06-1.065.05-1.792.218-2.428.465A4.897 4.897 0 003.48 3.478 4.91 4.91 0 002.325 5.25c-.248.636-.417 1.363-.465 2.428-.047 1.066-.06 1.407-.06 4.123s.012 3.056.06 4.122c.05 1.065.218 1.792.465 2.427a4.9 4.9 0 001.153 1.772 4.897 4.897 0 001.771 1.154c.637.247 1.363.416 2.428.465 1.066.048 1.407.06 4.123.06s3.056-.012 4.122-.06c1.065-.05 1.792-.218 2.429-.465a4.894 4.894 0 001.77-1.154 4.91 4.91 0 001.154-1.771c.246-.636.415-1.363.465-2.428.048-1.066.06-1.406.06-4.122s-.012-3.057-.06-4.123c-.05-1.065-.22-1.792-.465-2.427a4.908 4.908 0 00-1.154-1.772 4.887 4.887 0 00-1.771-1.153c-.638-.247-1.365-.416-2.43-.465-1.066-.048-1.405-.06-4.122-.06h.003zm-.897 1.802h.897c2.67 0 2.986.01 4.04.058.976.044 1.505.207 1.858.344.466.181.799.398 1.149.748s.566.683.748 1.15c.137.352.3.881.345 1.856.047 1.054.058 1.371.058 4.04 0 2.668-.01 2.985-.058 4.04-.045.974-.208 1.504-.345 1.856a3.093 3.093 0 01-.748 1.148c-.35.35-.683.567-1.15.748-.352.138-.881.3-1.856.345-1.054.048-1.371.058-4.041.058-2.67 0-2.987-.01-4.04-.058-.976-.045-1.505-.208-1.858-.345a3.097 3.097 0 01-1.15-.748 3.1 3.1 0 01-.748-1.15c-.137-.351-.3-.88-.345-1.856-.047-1.054-.057-1.37-.057-4.04 0-2.671.01-2.986.057-4.04.045-.975.208-1.505.345-1.857.181-.467.398-.8.748-1.15.35-.35.684-.567 1.15-.748.353-.138.882-.3 1.857-.345.923-.042 1.28-.054 3.144-.056v.002zm5.035 2.86a1.2 1.2 0 112.4 0 1.2 1.2 0 01-2.4 0zm-4.138.203a5.136 5.136 0 100 10.271 5.136 5.136 0 000-10.271zm3.333 5.135a3.333 3.333 0 10-6.666 0 3.333 3.333 0 006.666 0z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-italic"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.76 9h2l-2.2 10h-2l2.2-10zm1.68-4a1 1 0 100 2 1 1 0 000-2z",
    fill: "#000018"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-key"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.254 22A6.25 6.25 0 016.558 9.736a6.14 6.14 0 013.234-.04l6.59-6.588A3.749 3.749 0 0119.053 2 2.949 2.949 0 0122 4.947a3.756 3.756 0 01-1.107 2.672l-.56.56a1.679 1.679 0 01-1.178.488h-1.322V9.5a1.666 1.666 0 01-1.666 1.667h-.834v1.321a1.658 1.658 0 01-.488 1.179l-.542.541a6.113 6.113 0 01-.039 3.234 6.274 6.274 0 01-5.356 4.524 6.365 6.365 0 01-.654.034zm0-10.833a4.584 4.584 0 104.408 5.825 4.5 4.5 0 00-.084-2.75.833.833 0 01.199-.863l.89-.89v-1.322A1.667 1.667 0 0115.333 9.5h.834v-.833A1.667 1.667 0 0117.833 7h1.322l.56-.56a2.1 2.1 0 00.618-1.493 1.281 1.281 0 00-1.279-1.28 2.1 2.1 0 00-1.494.619l-6.942 6.941a.832.832 0 01-.864.198 4.552 4.552 0 00-1.504-.258h.004zM6.167 17a.833.833 0 101.666 0 .833.833 0 00-1.666 0z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-keypad"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 20a1 1 0 110-2 1 1 0 110 2zm0-4c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3zm-7 4a1 1 0 110-2 1 1 0 110 2zm0-4c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3zm-7 4a1 1 0 110-2 1 1 0 110 2zm0-4c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3zm14-3a1 1 0 110-2 1 1 0 110 2zm0-4c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3zm-7 4a1 1 0 110-2 1 1 0 110 2zm0-4c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3zm-7 4a1 1 0 110-2 1 1 0 110 2zm0-4c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3zm14-5a1 1 0 110 2 1 1 0 110-2zm0 4c1.654 0 3-1.346 3-3s-1.346-3-3-3-3 1.346-3 3 1.346 3 3 3zm-7-2a1 1 0 110-2 1 1 0 010 2zm0-4c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3zM5 6a1 1 0 110-2 1 1 0 110 2zm0-4C3.346 2 2 3.346 2 5s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-lamp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.037 4.3a.905.905 0 00.066 1.278l-1.34 1.486a2.907 2.907 0 01-.21-4.104 2.904 2.904 0 014.101-.212l-1.34 1.486a.904.904 0 00-1.277.066z",
    fill: "#29293D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.103 5.578L11.19 7.46l1.212-1.344-2.086-1.882 1.34-1.486 2.878 2.597a6.365 6.365 0 014.83.138c1.009.45 1.07 1.752.33 2.573l-5.825 6.461c-.74.821-2.042.895-2.592-.063a6.373 6.373 0 01-.634-4.793L9.422 8.56l-4.038 4.406 7.03 7.033H20A1 1 0 0120 22H4a1 1 0 010-2h5.586L3.97 14.38a2.002 2.002 0 01-.06-2.766l4.026-4.395-.172-.155 1.34-1.486zm8.78 1.499l-5.175 5.74a4.353 4.353 0 015.175-5.74z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-layers"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.76 15.54L12 18.847 6.24 15.54l1.694-.72 3.568 2.047a.994.994 0 00.996 0l3.568-2.049 1.694.722zm-6.258-2.673a.994.994 0 00.996 0l3.568-2.049 1.694.722L12 14.847 6.24 11.54l1.694-.722 3.568 2.05zM12 5.087l5.76 2.453L12 10.847 6.24 7.54 12 5.087zm8.998 6.261a1.002 1.002 0 00-.607-.861l-2.152-.916 2.26-1.297a.999.999 0 00-.108-1.787l-8-3.407a.995.995 0 00-.783 0l-8 3.407a1 1 0 00-.106 1.787L5.76 9.571l-2.152.916a1 1 0 00-.106 1.787l2.258 1.297-2.152.916a1 1 0 00-.106 1.787l8 4.593a.994.994 0 00.996 0l8-4.593a.999.999 0 00-.106-1.787l-2.152-.917 2.258-1.296a.999.999 0 00.5-.926z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-layout"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 19h-5v-9h6v8c0 .552-.449 1-1 1zM5 18v-8h6v9H6c-.551 0-1-.448-1-1zM6 5h12c.551 0 1 .448 1 1v2H5V6c0-.552.449-1 1-1zm12-2H6C4.346 3 3 4.346 3 6v12c0 1.654 1.346 3 3 3h12c1.654 0 3-1.346 3-3V6c0-1.654-1.346-3-3-3z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-lifeguard"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 12a9.967 9.967 0 01-3.1 7.239A9.966 9.966 0 0112 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10zm-1.5 0c0 2.296-.91 4.379-2.389 5.908l-2.516-2.433A4.984 4.984 0 0017 12h3.5zm-4.855-3.423l2.551-2.396a8.477 8.477 0 00-6.348-2.68l.063 3.5L12 7c1.437 0 2.733.606 3.645 1.577zm-7.132-.16L6.072 5.909A8.475 8.475 0 003.5 12H7c0-1.405.58-2.675 1.513-3.583zm3.729 8.577a4.986 4.986 0 01-3.886-1.572L5.803 17.82a8.476 8.476 0 006.607 2.671l-.17-3.496zM15.5 12a3.5 3.5 0 11-7 0 3.5 3.5 0 017 0z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-link-1"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 16H7.21c-2.106 0-4.006-1.535-4.193-3.634A4.003 4.003 0 017 8h2a1 1 0 100-2H7.209c-3.049 0-5.77 2.187-6.158 5.211A6.007 6.007 0 007 18h2a1 1 0 100-2zm-1-4a1 1 0 001 1h6a1 1 0 100-2H9a1 1 0 00-1 1zm8.76-6c3.066 0 5.818 2.197 6.193 5.242A6.007 6.007 0 0117 18h-2a1 1 0 110-2h2a4.003 4.003 0 003.983-4.366C20.796 9.535 18.896 8 16.79 8H15a1 1 0 01-1-1c0-.553.443-1 1.25-1h1.51z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-link-2"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.527 3.9c2.182-2.187 5.703-2.582 8.135-.68 2.913 2.278 3.104 6.523.573 9.06l-1.423 1.425a1.003 1.003 0 01-1.422 0 1.009 1.009 0 010-1.425l1.422-1.426a4.04 4.04 0 00-.272-5.95c-1.627-1.363-4.069-1.103-5.568.399L11.7 6.578a1.003 1.003 0 01-1.422 0c-.393-.393-.397-1.028.177-1.603L11.527 3.9zm1.766 5.393l-4 4a.999.999 0 101.414 1.414l4-4a.999.999 0 10-1.414-1.414zm-1.013 8.104l-1.274 1.27c-1.5 1.497-3.948 1.755-5.576.398a4.015 4.015 0 01-.273-5.93l1.425-1.42a1.004 1.004 0 000-1.421 1.012 1.012 0 00-1.425 0l-1.275 1.272c-2.172 2.166-2.553 5.65-.675 8.074 2.271 2.933 6.531 3.131 9.073.598l1.425-1.42a1.004 1.004 0 000-1.422 1.009 1.009 0 00-1.425 0z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-linkedin"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 10h-.002L4 20h2V10H4zm2 12H4c-1.103 0-2-.897-2-2V10c0-1.103.897-2 2-2h2c1.103 0 2 .897 2 2v10c0 1.103-.897 2-2 2zm9.505-10.308c.153 0 .308.013.46.037 1.35.221 2.368 1.467 2.368 2.9V20H20v-5.462C20 12.036 17.982 10 15.5 10c-2.481 0-4.5 2.036-4.5 4.538V20h1.667v-5.462c0-.839.365-1.63 1.003-2.173a2.83 2.83 0 011.835-.673zM20 22h-1.667c-1.102 0-2-.898-2-2v-5.37c0-.458-.303-.864-.688-.926a.82.82 0 00-.68.184.853.853 0 00-.298.65V20c0 1.102-.897 2-2 2H11c-1.102 0-2-.898-2-2v-5.462C9 10.932 11.916 8 15.5 8s6.5 2.932 6.5 6.538V20c0 1.102-.897 2-2 2zM5 3a1 1 0 100 2 1 1 0 000-2zm0 4C3.346 7 2 5.654 2 4s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-list"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 7a1 1 0 112 0 1 1 0 01-2 0zm0 5a1 1 0 112 0 1 1 0 01-2 0zm1 4a1 1 0 100 2 1 1 0 000-2zm3.936-5h12.128c.515 0 .936.421.936.936v.128a.938.938 0 01-.936.936H7.936A.938.938 0 017 12.064v-.128c0-.515.42-.936.936-.936zm12.128 5H7.936a.938.938 0 00-.936.936v.128c0 .515.42.936.936.936h12.128a.938.938 0 00.936-.936v-.128a.938.938 0 00-.936-.936zM7.936 6h12.128c.515 0 .936.421.936.936v.128a.938.938 0 01-.936.936H7.936A.938.938 0 017 7.064v-.128C7 6.421 7.42 6 7.936 6z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-list-cards"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 13a2 2 0 00-2 2v3a2 2 0 002 2h12a2 2 0 002-2v-3a2 2 0 00-2-2H6zm12 2H6v3h12v-3zM6 4a2 2 0 00-2 2v3a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2H6zm12 2H6v3h12V6z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-loader"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 3a1 1 0 112 0v2a1 1 0 11-2 0V3zm8 8h2a1 1 0 110 2h-2a1 1 0 110-2zM6 12a1 1 0 00-1-1H3a1 1 0 100 2h2a1 1 0 001-1zM4.807 5.053a1 1 0 011.414-.025l1.439 1.39a1 1 0 01-1.39 1.44l-1.44-1.39a1 1 0 01-.023-1.415zm12.228 3.085a1 1 0 00.695-.28l1.44-1.39a1 1 0 00-1.39-1.44l-1.44 1.39a1 1 0 00.695 1.72zM11 19a1 1 0 112 0v2a1 1 0 11-2 0v-2zm6.73-2.857a1 1 0 00-1.39 1.439l1.439 1.39c.195.188.445.28.695.28a1 1 0 00.695-1.719l-1.439-1.39zm-12.899 1.39l1.439-1.39a1 1 0 011.39 1.439l-1.439 1.39a.996.996 0 01-.695.28 1 1 0 01-.695-1.719z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-location-pin"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11c-.827 0-1.5-.674-1.5-1.5 0-.828.673-1.5 1.5-1.5s1.5.672 1.5 1.5c0 .826-.673 1.5-1.5 1.5zm0-5c-1.93 0-3.5 1.57-3.5 3.5S10.07 13 12 13s3.5-1.57 3.5-3.5S13.93 6 12 6zm0 13.646c-1.675-1.584-6-6.031-6-9.724C6 6.657 8.691 4 12 4s6 2.657 6 5.922c0 3.693-4.325 8.14-6 9.724zM12 2C7.589 2 4 5.553 4 9.922c0 5.475 7.049 11.579 7.349 11.836a.998.998 0 001.302 0c.3-.257 7.349-6.361 7.349-11.836C20 5.553 16.411 2 12 2z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-lock"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 16a1 1 0 110-2 1 1 0 010 2zm0-4c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3zm6 7a1 1 0 01-1 1H7a1 1 0 01-1-1v-8a1 1 0 011-1h10a1 1 0 011 1v8zM10 6.111C10 4.947 10.897 4 12 4s2 .947 2 2.111V8h-4V6.111zM17 8h-1V6.111C16 3.845 14.206 2 12 2S8 3.845 8 6.111V8H7c-1.654 0-3 1.346-3 3v8c0 1.654 1.346 3 3 3h10c1.654 0 3-1.346 3-3v-8c0-1.654-1.346-3-3-3z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-lock-open"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 16a1 1 0 110-2 1 1 0 010 2zm0-4c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3zm6 7a1 1 0 01-1 1H7a1 1 0 01-1-1v-8a1 1 0 011-1h10a1 1 0 011 1v8zM17 8h-7V6c0-1.103.897-2 2-2s2 .897 2 2a1 1 0 102 0c0-2.206-1.794-4-4-4S8 3.794 8 6v2H7c-1.654 0-3 1.346-3 3v8c0 1.654 1.346 3 3 3h10c1.654 0 3-1.346 3-3v-8c0-1.654-1.346-3-3-3z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-log-in"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 4h2c.55 0 1 .45 1 1v14c0 .55-.45 1-1 1h-2c-.55 0-1-.45-1-1s.45-1 1-1h1V6h-1c-.55 0-1-.45-1-1s.45-1 1-1zm-6.6 3.2a1 1 0 011.4.2l3 4c.26.346.268.82.018 1.175l-2.814 4a.999.999 0 01-1.393.243 1 1 0 01-.243-1.394l1.718-2.442c-.014.002-.026.006-.039.01-.015.004-.03.008-.047.008H4a1 1 0 010-2h8l-1.8-2.4a.999.999 0 01.2-1.4z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-log-out"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 5c0 .55-.45 1-1 1H6v12h1c.55 0 1 .45 1 1s-.45 1-1 1H5c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h2c.55 0 1 .45 1 1zm10.004 2.425l2.814 4A.998.998 0 0120.8 12.6l-3 4a.998.998 0 01-1.4.2.999.999 0 01-.2-1.4L18 13h-8a1 1 0 110-2h8c.016 0 .032.005.047.01.013.003.025.007.039.008l-1.718-2.443a1 1 0 111.636-1.15z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-map"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 17.454l-2-.898V6.546l2 .898v10.01zm-6-10.01l2-.898v10.01l-2 .898V7.444zm-4-.898l2 .898v10.01l-2-.898V6.546zm-4 .898l2-.898v10.01l-2 .898V7.444zm15.41-1.558l-4-1.798c-.015-.007-.031-.008-.046-.014a1.106 1.106 0 00-.36-.067c-.044 0-.087.001-.131.006-.037.004-.072.013-.108.022a1.21 1.21 0 00-.13.04c-.014.005-.031.006-.045.013L12 5.701 8.41 4.088c-.015-.007-.031-.008-.046-.014a1.106 1.106 0 00-.36-.067c-.044 0-.087.001-.131.006-.037.004-.072.013-.108.022a1.21 1.21 0 00-.13.04c-.014.005-.031.006-.045.013l-4 1.798a1 1 0 00-.59.912V19a1.002 1.002 0 001.41.912L8 18.3l3.59 1.613c.015.007.031.004.047.01A.974.974 0 0012 20a.974.974 0 00.363-.078c.015-.006.033-.003.047-.01L16 18.3l3.59 1.613A.998.998 0 0021 19V6.798a1 1 0 00-.59-.912z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-mapa-del-empleo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.388 8.778a2.388 2.388 0 10-.002-4.777 2.388 2.388 0 00.002 4.777zM11.996 8.778a2.389 2.389 0 100-4.777 2.389 2.389 0 000 4.777zM17.612 8.778a2.388 2.388 0 10-.001-4.777 2.388 2.388 0 00.001 4.777zM11.996 14.39a2.388 2.388 0 100-4.778 2.388 2.388 0 000 4.777zM11.996 20a2.388 2.388 0 100-4.777 2.388 2.388 0 000 4.777z",
    fill: "#019DF4"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-megaphone"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.323 4c-.25 0-.498.035-.738.104L6.82 7.192a1 1 0 01-.276.039H5a3 3 0 00-3 3v3.538a3 3 0 003 3h1V19a1 1 0 102 0v-1.853l9.585 2.75A2.677 2.677 0 0021 17.323v-2.658c.598-.433 1-1.24 1-2.166 0-.925-.402-1.733-1-2.165V6.677A2.677 2.677 0 0018.323 4zm-.186 2.026a.677.677 0 01.863.65v10.647a.677.677 0 01-.863.65L8 15.067V8.934l10.137-2.908zM6 9.231v5.538H5a1 1 0 01-1-1v-3.538a1 1 0 011-1h1z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-menu"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.948 6h16.103c.522 0 .95.427.95.949v.102a.952.952 0 01-.95.949H3.948A.95.95 0 013 7.051v-.102A.95.95 0 013.948 6zm16.103 5H3.948a.95.95 0 00-.948.949v.102a.95.95 0 00.948.949h16.103a.952.952 0 00.95-.949v-.102a.952.952 0 00-.95-.949zm0 5H3.948a.95.95 0 00-.948.949v.102a.95.95 0 00.948.949h16.103a.952.952 0 00.95-.949v-.102a.952.952 0 00-.95-.949z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-menu-2"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.936 6h16.128c.515 0 .936.421.936.936v.128a.938.938 0 01-.936.936H3.936A.938.938 0 013 7.064v-.128C3 6.421 3.42 6 3.936 6zM5 12a1 1 0 11-2 0 1 1 0 012 0zm2.936-1h12.128c.515 0 .936.421.936.936v.128a.938.938 0 01-.936.936H7.936A.938.938 0 017 12.064v-.128c0-.515.42-.936.936-.936zm12.128 5H3.936a.938.938 0 00-.935.936v.128c0 .515.42.936.935.936h16.128a.938.938 0 00.936-.936v-.128a.938.938 0 00-.936-.936z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-menu-back"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.948 5h16.104c.52 0 .948.427.948.948v.104a.951.951 0 01-.948.948H3.948A.951.951 0 013 6.052v-.104C3 5.427 3.427 5 3.948 5zm16.104 6H5.914l1.293-1.293a.999.999 0 10-1.414-1.414l-3 3a1 1 0 000 1.414l3 3a.999.999 0 101.414-1.414L5.914 13h14.138a.951.951 0 00.948-.948v-.104a.951.951 0 00-.948-.948zm0 6H3.948a.951.951 0 00-.948.948v.104c0 .521.427.948.948.948h16.104a.951.951 0 00.948-.948v-.104a.951.951 0 00-.948-.948z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-message-circle"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 11a1 1 0 112.001 0 1 1 0 01-2 0zm5-1a1 1 0 10.001 2 1 1 0 000-2zm4 0a1 1 0 10.001 2 1 1 0 000-2zm3.899 2.294c-.507 3.254-3.13 5.953-6.38 6.562a8.003 8.003 0 01-4.616-.487 3.215 3.215 0 00-1.253-.262c-.19 0-.378.018-.563.055l-2.812.562.563-2.817c.118-.585.046-1.21-.207-1.81a8.01 8.01 0 01-.487-4.617c.609-3.249 3.307-5.872 6.562-6.379 2.59-.403 5.123.413 6.95 2.241 1.83 1.83 2.647 4.363 2.243 6.952zm-.827-8.366c-2.285-2.284-5.445-3.303-8.674-2.804-4.077.636-7.457 3.92-8.22 7.987a10.008 10.008 0 00.61 5.765c.098.231.128.446.09.64l-.858 4.287a.997.997 0 00.274.903.996.996 0 00.903.274l4.283-.857a1.15 1.15 0 01.643.088 10.02 10.02 0 005.765.611c4.068-.763 7.352-4.143 7.988-8.22.502-3.227-.52-6.389-2.804-8.674z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-message-square"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 9a1 1 0 100 2 1 1 0 000-2zm4 0a1 1 0 100 2 1 1 0 000-2zM8 9a1 1 0 100 2 1 1 0 000-2zm12 6c0 .551-.449 1-1 1H8.554c-.543 0-1.077.148-1.544.428L4 18.234V5c0-.551.449-1 1-1h14c.551 0 1 .449 1 1v10zM19 2H5C3.346 2 2 3.346 2 5v15a1 1 0 001.515.857l4.524-2.714A.997.997 0 018.554 18H19c1.654 0 3-1.346 3-3V5c0-1.654-1.346-3-3-3z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-mic-off"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 6c0-1.103.897-2 2-2s2 .897 2 2v5c0 .033-.004.064-.009.095a.961.961 0 00-.007.061l1.595 1.595C15.84 12.22 16 11.631 16 11V6c0-2.206-1.794-4-4-4a4.003 4.003 0 00-3.924 3.248L10 7.172V6zm9 5a1 1 0 10-2 0c0 .909-.262 1.75-.688 2.484l1.463 1.463A6.948 6.948 0 0019 11zm-6.915 3.992A.581.581 0 0112 15c-2.206 0-4-1.794-4-4v-.172l4.156 4.156a.648.648 0 00-.07.008zm8.622 4.301l-16-16a.999.999 0 10-1.414 1.414l16 16a.997.997 0 001.414 0 .999.999 0 000-1.414zM13 20h2c.55 0 1 .45 1 1s-.45 1-1 1H9c-.55 0-1-.45-1-1s.45-1 1-1h2v-2.08c-3.387-.488-6-3.4-6-6.92a1 1 0 112 0c0 2.757 2.243 5 5 5 .362 0 .714-.043 1.055-.117l1.593 1.593a6.96 6.96 0 01-1.648.443V20z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-mic-on"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 17.92V20h2.105c.493 0 .895.402.895.895v.211a.896.896 0 01-.895.894h-6.21A.896.896 0 018 21.106v-.211c0-.493.402-.895.895-.895H11v-2.08c-3.387-.488-6-3.4-6-6.92a1 1 0 112 0c0 2.757 2.243 5 5 5s5-2.243 5-5a1 1 0 112 0c0 3.52-2.613 6.432-6 6.92zM10 6c0-1.103.897-2 2-2s2 .897 2 2v5c0 1.103-.897 2-2 2s-2-.897-2-2V6zm2 9c2.206 0 4-1.794 4-4V6c0-2.205-1.794-4-4-4S8 3.795 8 6v5c0 2.206 1.794 4 4 4z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-money"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 4c-4.411 0-8 3.589-8 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8zm0 18C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10zM11 9h4a1 1 0 100-2h-2V6a1 1 0 10-2 0v1a3 3 0 000 6h2a1 1 0 110 2H9a1 1 0 100 2h2v1a1 1 0 102 0v-1a3 3 0 100-6h-2a1 1 0 110-2z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-money-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.286 7.714H16a1.429 1.429 0 100-2.857h-2.857V3.43a1.429 1.429 0 00-2.857 0v1.428a4.286 4.286 0 000 8.572h2.857a1.429 1.429 0 010 2.857H7.429a1.429 1.429 0 000 2.857h2.857v1.428a1.429 1.429 0 102.857 0v-1.428a4.286 4.286 0 000-8.572h-2.857a1.429 1.429 0 110-2.857z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-money-panama"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 4c-4.411 0-8 3.589-8 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8zm0 18C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10z",
    fill: "#000018",
    fillOpacity: 0.84
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.282 15.698a.27.27 0 01-.199-.084.27.27 0 01-.083-.198V8.68a.27.27 0 01.083-.199.27.27 0 01.199-.083h3.076c.445 0 .817.07 1.116.209.3.132.54.302.72.51.18.202.31.425.386.668.083.236.125.46.125.668 0 .208-.028.396-.083.563-.056.16-.126.299-.209.417a1.646 1.646 0 01-.24.282.999.999 0 01-.188.156c.216.146.414.355.595.626.18.264.271.601.271 1.012 0 .264-.049.528-.146.792a2.16 2.16 0 01-1.137 1.21 2.344 2.344 0 01-.97.188H6.282zm4.015-5.194c0-.264-.083-.463-.25-.595-.167-.139-.431-.208-.793-.208H7.408v1.606h1.846c.362 0 .626-.066.793-.198.167-.14.25-.341.25-.605zm-2.889 3.89h1.93c.382 0 .66-.08.834-.24a.84.84 0 00.271-.646.826.826 0 00-.281-.647c-.181-.167-.456-.25-.824-.25h-1.93v1.783zM17.934 14.539a1.159 1.159 0 11-2.318 0 1.159 1.159 0 012.318 0z",
    fill: "#000018",
    fillOpacity: 0.84
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.2,
    height: 8.284,
    rx: 0.6,
    transform: "scale(-1 1) rotate(-19.088 16.438 52.301)",
    fill: "#000018",
    fillOpacity: 0.84
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-money-peru"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 4c-4.411 0-8 3.589-8 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8zm0 18C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10z",
    fill: "#000018",
    fillOpacity: 0.84
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.934 14.539a1.159 1.159 0 11-2.318 0 1.159 1.159 0 012.318 0zM16.004 8.818a.6.6 0 00-1.134-.392l-2.317 6.694a.6.6 0 101.134.393l2.317-6.695zM8.973 8.295c.469 0 .882.063 1.239.189.357.126.654.283.892.472.238.19.417.4.536.63.126.224.196.438.21.641a.24.24 0 01-.084.21.293.293 0 01-.2.074h-.735a.492.492 0 01-.273-.063.868.868 0 01-.157-.19 1.315 1.315 0 00-.483-.451c-.21-.133-.525-.2-.945-.2-.182 0-.357.021-.525.063a1.382 1.382 0 00-.43.168.854.854 0 00-.284.263.629.629 0 00-.105.357c0 .161.031.294.094.399.07.098.182.186.336.263.161.07.371.136.63.199.26.063.581.136.966.22.42.091.78.2 1.082.326.308.119.556.266.745.441.196.168.34.364.43.588.099.224.148.48.148.767 0 .315-.07.609-.21.882-.14.266-.34.497-.599.693-.259.188-.577.339-.955.451a4.467 4.467 0 01-1.27.168c-.393 0-.767-.046-1.124-.136a3.579 3.579 0 01-.956-.41 2.346 2.346 0 01-.661-.651 1.696 1.696 0 01-.284-.84.225.225 0 01.074-.2.309.309 0 01.21-.084h.735c.119 0 .21.021.273.063a.476.476 0 01.157.19c.05.09.109.181.179.272.07.091.164.172.283.242.12.07.266.13.441.178.182.043.406.064.672.064.21 0 .413-.014.61-.042.195-.035.367-.088.514-.158.147-.077.266-.168.357-.273a.628.628 0 00.136-.41.512.512 0 00-.147-.377c-.098-.098-.248-.182-.451-.252a5.921 5.921 0 00-.735-.2 27.832 27.832 0 01-1.019-.242 6.001 6.001 0 01-.924-.293 2.34 2.34 0 01-.65-.431 1.632 1.632 0 01-.379-.588 2.398 2.398 0 01-.126-.819c0-.315.07-.606.21-.872.14-.266.333-.493.578-.682a2.76 2.76 0 01.871-.441 3.53 3.53 0 011.103-.168z",
    fill: "#000018",
    fillOpacity: 0.84
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-money-venezuela"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 4c-4.411 0-8 3.589-8 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8zm0 18C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10z",
    fill: "#000018",
    fillOpacity: 0.84
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.284 15.35a.273.273 0 01-.2-.084.273.273 0 01-.084-.2V8.284c0-.076.028-.143.084-.199a.273.273 0 01.2-.084H9.38c.448 0 .822.07 1.123.21.302.133.543.304.725.514.182.204.312.428.389.672.083.238.125.462.125.672 0 .21-.027.4-.084.568a1.683 1.683 0 01-.21.42 1.652 1.652 0 01-.241.283 1 1 0 01-.189.157c.217.147.416.357.598.63.182.267.273.606.273 1.019 0 .266-.049.532-.147.798a2.176 2.176 0 01-1.144 1.218 2.36 2.36 0 01-.976.189h-3.34zm4.042-5.229c0-.266-.084-.466-.252-.598-.168-.14-.434-.21-.798-.21H7.418v1.617h1.858c.364 0 .63-.067.798-.2.168-.14.252-.343.252-.609zm-2.909 3.916H9.36c.385 0 .665-.08.84-.241a.846.846 0 00.273-.651.83.83 0 00-.284-.651c-.181-.168-.458-.252-.829-.252H7.418v1.795zM15.55 13.786a.256.256 0 00-.073-.19.688.688 0 00-.263-.136 3.863 3.863 0 00-.483-.126 56.284 56.284 0 01-.777-.168 3.25 3.25 0 01-.766-.263 1.714 1.714 0 01-.494-.367 1.236 1.236 0 01-.252-.473 2.255 2.255 0 01-.073-.588c0-.21.049-.416.147-.619a1.62 1.62 0 01.42-.536 2.23 2.23 0 01.682-.388c.266-.098.57-.147.914-.147.343 0 .647.038.913.115.273.077.504.179.693.305.19.126.336.273.441.441.105.161.165.325.179.493a.228.228 0 01-.084.2.273.273 0 01-.2.084h-.808a.458.458 0 01-.242-.053 4.588 4.588 0 00-.168-.136.845.845 0 00-.252-.126c-.105-.042-.262-.063-.472-.063-.21 0-.396.031-.557.095-.16.063-.241.175-.241.335 0 .078.017.144.052.2a.569.569 0 00.22.136c.113.043.263.088.452.137.196.042.448.095.756.157.623.133 1.06.343 1.313.63.259.28.388.63.388 1.05 0 .21-.052.417-.157.62a1.733 1.733 0 01-.462.536c-.196.153-.441.28-.735.377a3.227 3.227 0 01-.977.137c-.37 0-.7-.042-.987-.126a2.608 2.608 0 01-.714-.347 1.596 1.596 0 01-.451-.472 1.087 1.087 0 01-.168-.514.24.24 0 01.073-.2.309.309 0 01.21-.084h.809c.105 0 .182.024.23.074.057.049.116.104.18.168.07.063.164.118.283.167.119.05.297.074.535.074.105 0 .214-.007.326-.021.112-.014.213-.035.304-.063a.866.866 0 00.242-.126.259.259 0 00.094-.2zM18.7 14.65a.75.75 0 11-1.5 0 .75.75 0 011.5 0z",
    fill: "#000018",
    fillOpacity: 0.84
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-moon"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.44 4.918c-.5.354-.958.764-1.374 1.228-2.85 3.171-2.756 8.245.207 11.31A8.274 8.274 0 0012.197 20l.077.001a8.277 8.277 0 005.89-2.436c.328-.327.626-.678.893-1.052-3.146.392-6.371-.662-8.662-2.948A10.402 10.402 0 017.44 4.918zm4.834 17.083L12.179 22a10.26 10.26 0 01-7.344-3.153C1.158 15.042 1.043 8.745 4.577 4.81A10.227 10.227 0 018.57 2.067a1 1 0 011.296 1.278 8.399 8.399 0 001.94 8.804c2.299 2.293 5.764 3.054 8.829 1.938a1 1 0 011.276 1.298 10.225 10.225 0 01-2.336 3.596 10.26 10.26 0 01-7.302 3.02z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-more-horizontal"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 12a2 2 0 114.001.001A2 2 0 013 12zm9-2a2 2 0 10.001 4.001A2 2 0 0012 10zm7 0a2 2 0 10.001 4.001A2 2 0 0019 10z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-more-vertical"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7a2 2 0 10-.001-4.001A2 2 0 0012 7zm0 3a2 2 0 10.001 4.001A2 2 0 0012 10zm-2 9a2 2 0 114.001.001A2 2 0 0110 19z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-move"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.709 11.308l-3-3.013a.999.999 0 00-1.414-.003.999.999 0 00-.004 1.414L18.58 11H13V5.409l1.291 1.297a.999.999 0 101.418-1.411l-2.987-3a.998.998 0 00-1.415-.003l-3.013 3a1 1 0 101.412 1.417L11 5.419V11H5.408l1.297-1.29a.999.999 0 10-1.41-1.417l-3 2.987a.997.997 0 00-.004 1.414l3 3.013a.997.997 0 001.414.003.999.999 0 00.004-1.414L5.42 13H11v5.592l-1.291-1.297a1 1 0 10-1.418 1.41l2.987 3a1 1 0 00.707.295h.002c.265 0 .519-.105.706-.291l3.013-3a1 1 0 10-1.412-1.417L13 18.58V13h5.592l-1.297 1.292a.999.999 0 101.41 1.417l3-2.987a.997.997 0 00.004-1.414z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-music"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.508 17.006a1.493 1.493 0 01-1.492-1.492 1.493 1.493 0 012.954-.3 1.493 1.493 0 01-1.462 1.792zM6.536 19c-.823 0-1.492-.67-1.492-1.493 0-.822.669-1.492 1.492-1.492.72 0 1.322.512 1.462 1.191v.003A1.494 1.494 0 016.536 19zm12.41-4.008V4a1 1 0 00-1.215-.976L8.759 5.017a1 1 0 00-.783.976v8.341a3.471 3.471 0 00-1.44-.319 3.497 3.497 0 00-3.492 3.492A3.497 3.497 0 006.536 21a3.497 3.497 0 003.493-3.493c0-.178-.027-.35-.053-.522V6.796l6.97-1.55v7.094c-.44-.2-.923-.318-1.438-.318a3.495 3.495 0 00-3.492 3.492 3.495 3.495 0 003.492 3.492A3.495 3.495 0 0019 15.514c0-.179-.026-.35-.053-.522z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-navigation"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.866 9.099l5.198 1.057a.996.996 0 01.781.78l1.056 5.198L18.42 5.58 7.866 9.099zm6.801 11.9c-.02 0-.04 0-.06-.002a1 1 0 01-.92-.797l-1.67-8.217-8.216-1.67a.999.999 0 01-.118-1.929l16-5.333a1.002 1.002 0 011.266 1.265l-5.334 16a1 1 0 01-.948.684z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-navigation-up"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 13.702c.192 0 .385.056.552.166l4.88 3.231L12 6.236 6.568 17.1l4.88-3.23c.167-.11.36-.167.552-.167zM20 21a1 1 0 01-.552-.166L12 15.901l-7.448 4.933a1.002 1.002 0 01-1.447-1.28l8-16c.339-.679 1.451-.679 1.79 0l8 16A1.001 1.001 0 0120 21z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-new-notifications-bell"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.45 2.156a6.722 6.722 0 00-5.866 1.51 6.728 6.728 0 00-2.303 5.06v4.677l-1.802 1.804a1.631 1.631 0 00-.354 1.782c.255.614.848 1.01 1.512 1.01H8v.34C8 20.359 9.794 22 12 22s4-1.641 4-3.66V18h3.363c.664 0 1.256-.396 1.51-1.01a1.63 1.63 0 00-.352-1.782l-1.8-1.804V8.936c0-.434-.04-.86-.114-1.273a3.986 3.986 0 01-1.975.32c.058.308.088.627.088.953v4.467c0 .534.208 1.036.585 1.413l1.181 1.183H5.516l1.18-1.182c.377-.378.585-.88.585-1.414V8.726c0-1.357.59-2.654 1.62-3.556a4.66 4.66 0 014.101-1.065l-.001-.106c0-.665.162-1.292.449-1.843zM12 19.999c1.084 0 2-.76 2-1.66V18h-4v.34c0 .9.916 1.66 2 1.66z",
    fill: "#0A26EE"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-new-notifications-ellipse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 4,
    r: 3.5,
    fill: "#F13D89"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 20 20",
    fill: "none",
    id: "sprite_svg__icon-light-notes"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 11.667H7.5A.834.834 0 017.5 10H10a.834.834 0 010 1.667zm-3.333 2.5c0-.46.373-.834.833-.834h5a.833.833 0 110 1.667h-5a.834.834 0 01-.833-.833zm7.87 2.5H5.463c-.255 0-.463-.187-.463-.417V3.75c0-.23.208-.417.463-.417H10v2.625c0 1.31 1.014 2.375 2.262 2.375H15v7.917c0 .23-.207.417-.463.417zm-2.87-12.519l2.285 2.519h-1.69c-.328 0-.595-.318-.595-.709v-1.81zM16.45 6.94l-4.536-5a.833.833 0 00-.618-.273H5.463c-1.174 0-2.13.935-2.13 2.083v12.5c0 1.148.956 2.083 2.13 2.083h9.074c1.174 0 2.13-.935 2.13-2.083V7.5a.833.833 0 00-.217-.56z",
    fill: "#000018",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-notification-off"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.707 19.292l-1.3-1.3L17.414 16 7.886 6.47 6.42 5.005 4.707 3.292a.999.999 0 10-1.414 1.414l2.238 2.24 1.752 1.75L14.586 16l.07.07L16 17.412l.586.586 2.707 2.707a.997.997 0 001.414 0 .999.999 0 000-1.414zM14 18.34V18h-4v.34c0 .9.916 1.66 2 1.66s2-.76 2-1.66zm1.172-.34l.78.78C15.711 20.587 14.041 22 12 22c-2.206 0-4-1.642-4-3.66V18H4.637a1.632 1.632 0 01-1.512-1.01 1.633 1.633 0 01.353-1.783l1.801-1.804.001-4.677c0-.197.015-.392.031-.587l1.97 1.968v3.296c0 .534-.209 1.036-.587 1.414L5.515 16h7.657l.857.857L15.172 18zM8.468 5.64L7.035 4.205A6.72 6.72 0 0112.9 2.06c3.32.44 5.821 3.396 5.821 6.877v4.467l1.8 1.804a1.63 1.63 0 01.353 1.783 1.62 1.62 0 01-.453.6l-3.605-3.604a2.027 2.027 0 01-.095-.583V8.936c0-2.482-1.755-4.586-4.082-4.895A4.664 4.664 0 008.9 5.171c-.162.141-.293.308-.432.468z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-notification-on"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.515 16l1.18-1.182c.378-.378.586-.88.586-1.414V8.727c0-1.357.59-2.654 1.62-3.556a4.66 4.66 0 013.737-1.129c2.327.309 4.082 2.413 4.082 4.895v4.467c0 .534.208 1.036.585 1.413L18.485 16H5.516zM14 18.341C14 19.24 13.084 20 12 20s-2-.76-2-1.659V18h4v.341zm6.52-3.133l-1.8-1.804V8.937c0-3.481-2.502-6.438-5.82-6.877a6.722 6.722 0 00-5.317 1.607 6.728 6.728 0 00-2.302 5.06l-.001 4.677-1.801 1.804a1.631 1.631 0 00-.354 1.782c.255.614.848 1.01 1.512 1.01H8v.341C8 20.359 9.794 22 12 22s4-1.641 4-3.659V18h3.363c.664 0 1.256-.396 1.51-1.009a1.63 1.63 0 00-.352-1.783z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-npm"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 19h4V9h-4v10zM6 5c-.551 0-1 .449-1 1v12c0 .551.449 1 1 1h12c.551 0 1-.449 1-1V6c0-.551-.449-1-1-1H6zm12 16H6c-1.654 0-3-1.346-3-3V6c0-1.654 1.346-3 3-3h12c1.654 0 3 1.346 3 3v12c0 1.654-1.346 3-3 3z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-numbered-list"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 16h2v.5h-1v1h1v.5h-2v1h3v-4h-3v1zm1-7h1V5h-2v1h1v3zm-1 2h1.8l-1.8 2.1v.9h3v-1H3.7l1.8-2.1V10h-3v1zm5-5v2h14V6h-14zm0 12h14v-2h-14v2zm0-5h14v-2h-14v2z",
    fill: "#000018"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-office"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 5a3 3 0 013-3h10a3 3 0 013 3v15h-2V5a1 1 0 00-1-1H7a1 1 0 00-1 1v15H4V5zM2 21a1 1 0 011-1h18a1 1 0 110 2H3a1 1 0 01-1-1z",
    fill: "#29293D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 7a1 1 0 011-1h1a1 1 0 110 2H9a1 1 0 01-1-1zM8 11a1 1 0 011-1h1a1 1 0 110 2H9a1 1 0 01-1-1zM13 7a1 1 0 011-1h1a1 1 0 110 2h-1a1 1 0 01-1-1zM13 11a1 1 0 011-1h1a1 1 0 110 2h-1a1 1 0 01-1-1zM9 16a2 2 0 012-2h2a2 2 0 012 2v4h-2v-4h-2v4H9v-4z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-options"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6a1 1 0 110-2 1 1 0 010 2zm3-1c0-1.654-1.346-3-3-3S9 3.346 9 5c0 1.302.839 2.401 2 2.815V21a1 1 0 102 0V7.815A2.995 2.995 0 0015 5zM6 18a1 1 0 110-2 1 1 0 010 2zm1-3.815V3a1 1 0 10-2 0v11.185A2.995 2.995 0 003 17c0 1.302.839 2.401 2 2.815V21a1 1 0 102 0v-1.185A2.995 2.995 0 009 17a2.995 2.995 0 00-2-2.815zM18 14a1 1 0 110-2 1 1 0 010 2zm3-1a2.995 2.995 0 00-2-2.815V3a1 1 0 10-2 0v7.185A2.995 2.995 0 0015 13c0 1.302.839 2.401 2 2.815V21a1 1 0 102 0v-5.185A2.995 2.995 0 0021 13z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-options-2"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 19a1 1 0 110-2 1 1 0 010 2zm10-2h-7.185A2.995 2.995 0 0011 15a2.995 2.995 0 00-2.815 2H3a1 1 0 100 2h5.185A2.995 2.995 0 0011 21a2.995 2.995 0 002.815-2H21a1 1 0 100-2zm-2-4a1 1 0 110-2 1 1 0 010 2zm0-4a2.995 2.995 0 00-2.815 2H3a1 1 0 100 2h13.185A2.995 2.995 0 0019 15c1.654 0 3-1.346 3-3s-1.346-3-3-3zM7 5a1 1 0 110 2 1 1 0 010-2zM3 7h1.185A2.995 2.995 0 007 9a2.995 2.995 0 002.815-2H21a1 1 0 100-2H9.815A2.995 2.995 0 007 3a2.995 2.995 0 00-2.815 2H3a1 1 0 100 2z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-order"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 4a2 2 0 114 0 2 2 0 01-4 0zM14 4a2 2 0 114 0 2 2 0 01-4 0zM6 12a2 2 0 114 0 2 2 0 01-4 0zM14 12a2 2 0 114 0 2 2 0 01-4 0zM6 20a2 2 0 114 0 2 2 0 01-4 0zM14 20a2 2 0 114 0 2 2 0 01-4 0z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-order-1"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 19a.997.997 0 01-.707-.293l-4-4a.999.999 0 111.414-1.414l3.305 3.305 3.293-3.18a1 1 0 011.39 1.439l-4 3.862A.997.997 0 0112 19zM16 11a.997.997 0 01-.707-.293l-3.305-3.305-3.293 3.18a1 1 0 01-1.39-1.439l4-3.862a1 1 0 011.402.012l4 4A.999.999 0 0116 11z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-pantone"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 19h-8.486l3.559-3.818H19V19zM5 17.09V15h3.818v2.091A1.91 1.91 0 016.909 19 1.91 1.91 0 015 17.091zM5 8h3.818V5H5v3zm0 5h3.818v-3H5v3zm8.422-5.412l2.673 2.493-5.277 5.659v-5.36l2.604-2.792zM20 13.182h-4.063l2.302-2.469a.998.998 0 00-.05-1.413l-4.135-3.857a.96.96 0 00-.717-.267.996.996 0 00-.696.317l-1.823 1.955V4a1 1 0 00-1-1H4a1 1 0 00-1 1v13.091A3.914 3.914 0 006.909 21H20a1 1 0 001-1v-5.818a1 1 0 00-1-1z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-paper-plane"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 17.838l-1.856-5.567 5.568-5.57L15 17.839zm2.298-12.55l-5.568 5.568L6.162 9l11.136-3.712zm4.692-2.34a.951.951 0 00-.088-.361.967.967 0 00-.195-.294.96.96 0 00-.384-.23.987.987 0 00-.275-.054c-.022-.001-.042-.006-.065-.006-.1.002-.201.016-.299.048l-18 6a1 1 0 000 1.898l8.525 2.842 2.843 8.526a.998.998 0 001.896 0l6-18a1 1 0 00.048-.3c.001-.023-.005-.045-.006-.07z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-pause"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 5,
    width: 3,
    height: 14,
    rx: 1.5,
    fill: "#29293D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 5,
    width: 3,
    height: 14,
    rx: 1.5,
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-pause-circle"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 9c0-.55.45-1 1-1s1 .45 1 1v6c0 .55-.45 1-1 1s-1-.45-1-1V9zm4 0c0-.55.45-1 1-1s1 .45 1 1v6c0 .55-.45 1-1 1s-1-.45-1-1V9zm-1 11c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8zm0-18C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-pause-simple"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 5,
    width: 3,
    height: 14,
    rx: 1.5,
    fill: "#000018",
    fillOpacity: 0.84
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 5,
    width: 3,
    height: 14,
    rx: 1.5,
    fill: "#000018",
    fillOpacity: 0.84
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-people"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 19a1 1 0 11-2 0c0-1.654-1.346-3-3-3-.683 0-1.332.234-1.856.649.544.996.856 2.138.856 3.351a1 1 0 11-2 0c0-2.757-2.243-5-5-5s-5 2.243-5 5a1 1 0 11-2 0c0-3.86 3.141-7 7-7 1.927 0 3.673.783 4.94 2.046A4.994 4.994 0 0117 14c2.757 0 5 2.243 5 5zM17 9a1.001 1.001 0 010 2 1.001 1.001 0 010-2zm0 4c1.654 0 3-1.346 3-3s-1.346-3-3-3-3 1.346-3 3 1.346 3 3 3zM9 5c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2zm0 6c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-percent"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.74 4.26a.887.887 0 00-1.257 0L4.26 18.484a.886.886 0 000 1.257.889.889 0 001.257 0L19.74 5.518a.889.889 0 000-1.257zM16 19c-.827 0-1.5-.673-1.5-1.5S15.173 16 16 16s1.5.673 1.5 1.5S16.827 19 16 19zm0-5c-1.93 0-3.5 1.57-3.5 3.5S14.07 21 16 21s3.5-1.57 3.5-3.5S17.93 14 16 14zM8 6c.827 0 1.5.673 1.5 1.5S8.827 9 8 9s-1.5-.673-1.5-1.5S7.173 6 8 6zm0 5c1.93 0 3.5-1.57 3.5-3.5S9.93 4 8 4 4.5 5.57 4.5 7.5 6.07 11 8 11z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-person"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 20a1 1 0 11-2 0c0-2.757-2.243-5-5-5s-5 2.243-5 5a1 1 0 11-2 0c0-3.86 3.141-7 7-7s7 3.14 7 7zM12 5c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2zm0 6c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-person-add"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 13c-3.859 0-7 3.14-7 7a1 1 0 102 0c0-2.757 2.243-5 5-5s5 2.243 5 5a1 1 0 102 0c0-3.86-3.141-7-7-7zM8 7c0 1.103.897 2 2 2s2-.897 2-2-.897-2-2-2-2 .897-2 2zM6 7c0-2.206 1.794-4 4-4s4 1.794 4 4-1.794 4-4 4-4-1.794-4-4zm16 0c0 .55-.45 1-1 1h-1v1c0 .55-.45 1-1 1s-1-.45-1-1V8h-1c-.55 0-1-.45-1-1s.45-1 1-1h1V5c0-.55.45-1 1-1s1 .45 1 1v1h1c.55 0 1 .45 1 1z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-person-checked"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 13c-3.859 0-7 3.14-7 7a1 1 0 102 0c0-2.757 2.243-5 5-5s5 2.243 5 5a1 1 0 102 0c0-3.86-3.141-7-7-7zM8 7c0 1.103.897 2 2 2s2-.897 2-2-.897-2-2-2-2 .897-2 2zM6 7c0-2.206 1.794-4 4-4s4 1.794 4 4-1.794 4-4 4-4-1.794-4-4zm15.755-1.344l-2.61 3a1.001 1.001 0 01-.749.344h-.006a.997.997 0 01-.745-.333l-1.39-1.553a1 1 0 011.49-1.334l.634.709 1.866-2.145a1 1 0 111.51 1.312z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-person-delete"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 13c-3.859 0-7 3.141-7 7a1 1 0 102 0c0-2.757 2.243-5 5-5s5 2.243 5 5a1 1 0 102 0c0-3.859-3.141-7-7-7zM8 7c0 1.103.897 2 2 2s2-.897 2-2-.897-2-2-2-2 .897-2 2zM6 7c0-2.206 1.794-4 4-4s4 1.794 4 4-1.794 4-4 4-4-1.794-4-4zm15.198 1.232a1.04 1.04 0 010 1.466 1.04 1.04 0 01-1.466 0L19 8.965l-.732.733a1.04 1.04 0 01-1.466 0 1.04 1.04 0 010-1.466l.733-.732-.733-.732a1.04 1.04 0 010-1.466 1.04 1.04 0 011.466 0l.732.733.732-.733a1.04 1.04 0 011.466 0 1.04 1.04 0 010 1.466l-.733.732.733.732z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-person-remove"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 13c-3.859 0-7 3.14-7 7a1 1 0 102 0c0-2.757 2.243-5 5-5s5 2.243 5 5a1 1 0 102 0c0-3.86-3.141-7-7-7zM8 7c0 1.103.897 2 2 2s2-.897 2-2-.897-2-2-2-2 .897-2 2zM6 7c0-2.206 1.794-4 4-4s4 1.794 4 4-1.794 4-4 4-4-1.794-4-4zm16 0c0 .55-.45 1-1 1h-4c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-phone"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.6 4A2.602 2.602 0 004 6.6C4 13.988 10.011 20 17.4 20a2.603 2.603 0 002.58-2.928l-4.62-1.06c-.093.176-.194.367-.286.545-.456.87-.786 1.502-1.628 1.163-3.306-1.16-6.005-3.86-7.18-7.206-.357-.785.323-1.141 1.185-1.591l.537-.281-1.06-4.621A2.604 2.604 0 006.6 4zm10.8 18C8.908 22 2 15.092 2 6.6a4.605 4.605 0 016.091-4.352c.325.113.57.386.647.722l1.37 5.964a.998.998 0 01-.254.916c-.136.142-.139.145-1.379.794a9.949 9.949 0 004.88 4.883c.65-1.241.653-1.245.795-1.381a1.01 1.01 0 01.916-.253l5.965 1.369a.998.998 0 01.72.646A4.553 4.553 0 0122 17.4c0 2.537-2.064 4.6-4.6 4.6z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-phone-call"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 17.4c0-.11-.007-.22-.021-.327l-4.621-1.061a57.44 57.44 0 01-.285.544c-.455.87-.781 1.502-1.627 1.163-3.306-1.16-6.005-3.859-7.18-7.206-.357-.784.323-1.14 1.185-1.59.175-.092.364-.19.537-.282l-1.06-4.62A2.603 2.603 0 004 6.6C4 13.99 10.011 20 17.4 20c1.434 0 2.6-1.166 2.6-2.6zm1.936-.761A4.605 4.605 0 0117.4 22C8.909 22 2 15.09 2 6.598a4.604 4.604 0 016.091-4.35c.326.112.57.384.647.72l1.369 5.964a.997.997 0 01-.253.916c-.136.143-.139.146-1.379.794a9.95 9.95 0 004.879 4.884c.651-1.24.654-1.244.796-1.381.244-.234.587-.327.916-.254l5.964 1.37a.999.999 0 01.721.646c.082.236.145.48.185.73zM13 4c3.859 0 7 3.14 7 7a1 1 0 102 0c0-4.963-4.037-9-9-9a1 1 0 100 2zm-1 3a1 1 0 011-1c2.757 0 5 2.243 5 5a1 1 0 11-2 0c0-1.655-1.346-3-3-3a1 1 0 01-1-1z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-phone-missed"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.802 7.232l.733-.732-.733-.732a1.042 1.042 0 010-1.466 1.042 1.042 0 011.466 0l.732.734.733-.734a1.04 1.04 0 011.465 0 1.04 1.04 0 010 1.466l-.733.732.733.732a1.04 1.04 0 010 1.466 1.04 1.04 0 01-1.465 0L18 7.964l-.732.734a1.042 1.042 0 01-1.466 0 1.042 1.042 0 010-1.466zM17.4 20C10.01 20 4 13.99 4 6.6A2.602 2.602 0 016.928 4.02l1.06 4.62-.544.285c-.871.455-1.5.785-1.178 1.588 1.175 3.347 3.874 6.046 7.18 7.206.848.338 1.172-.293 1.627-1.163l.286-.545 4.62 1.06A2.602 2.602 0 0117.4 20zm4.535-3.361a4.266 4.266 0 00-.185-.73.999.999 0 00-.72-.648l-5.964-1.368a1.007 1.007 0 00-.916.252c-.143.138-.146.14-.796 1.383a9.927 9.927 0 01-4.88-4.883c1.239-.65 1.243-.653 1.38-.796.233-.243.328-.588.253-.916L8.738 2.97a1 1 0 00-.646-.72 4.233 4.233 0 00-.727-.184A4.605 4.605 0 002 6.6C2 15.091 8.908 22 17.4 22a4.605 4.605 0 004.536-5.361z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-phone-off"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.698 14.63A13.313 13.313 0 014 6.6a2.602 2.602 0 012.927-2.578l1.061 4.62-.17.089-.375.196c-.87.455-1.5.784-1.178 1.587.376 1.07.921 2.062 1.58 2.97l1.428-1.429a9.863 9.863 0 01-.799-1.41c1.24-.65 1.244-.653 1.38-.795a1 1 0 00.253-.916L8.738 2.97a.997.997 0 00-.646-.721 4.277 4.277 0 00-.727-.183A4.5 4.5 0 006.6 2 4.605 4.605 0 002 6.6a15.31 15.31 0 003.271 9.457l1.427-1.427zM19.74 4.26a.887.887 0 00-1.257 0L4.26 18.484a.889.889 0 001.257 1.257L19.74 5.518a.887.887 0 000-1.257zM21.75 15.91A4.565 4.565 0 0122 17.4 4.604 4.604 0 0117.402 22a15.306 15.306 0 01-9.457-3.271l1.427-1.427A13.311 13.311 0 0017.4 20a2.602 2.602 0 002.578-2.927l-4.62-1.061-.286.545-.004.009c-.453.865-.78 1.492-1.623 1.154a11.521 11.521 0 01-2.934-1.561l1.43-1.43c.447.304.918.574 1.412.799.65-1.241.654-1.245.796-1.382.243-.234.588-.326.916-.253l5.964 1.369a.995.995 0 01.72.647z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-pie-chart"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.821 14.057a.996.996 0 00-1.276.61A8.016 8.016 0 0112 20c-4.41 0-8-3.588-8-8a8.016 8.016 0 015.333-7.545.998.998 0 10-.666-1.885A10.015 10.015 0 002 12c0 5.514 4.486 10 10 10 4.231 0 8.02-2.678 9.43-6.668a.999.999 0 00-.609-1.275zM14 10V4.071A7.016 7.016 0 0119.929 10h-5.93zm-1-8a1 1 0 00-1 1v8a1 1 0 001 1h8a1 1 0 001-1c0-4.963-4.038-9-9-9z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 12 12",
    fill: "none",
    id: "sprite_svg__icon-light-platinum-zonajobs"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.438 12v-1.367l1.21-.235V2.234L.438 2V.625h5.414c.87 0 1.62.154 2.25.46.63.303 1.114.728 1.453 1.274.338.542.508 1.175.508 1.899s-.17 1.36-.508 1.906c-.339.542-.823.964-1.453 1.266-.63.297-1.38.445-2.25.445H3.93v2.523l1.218.235V12H.438zM3.93 6.117h1.922c.635 0 1.114-.172 1.437-.515.328-.35.492-.792.492-1.329 0-.546-.164-.997-.492-1.351-.323-.36-.802-.54-1.437-.54H3.93v3.735z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-play"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.25 11.278a.833.833 0 010 1.444l-12.5 7.217a.833.833 0 01-1.25-.722V4.783a.833.833 0 011.25-.722l12.5 7.217z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-play-circle"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 14.6V9.4l2.809 2.6-2.809 2.6zm.839-7.147a1.709 1.709 0 00-1.851-.307c-.61.266-.988.835-.988 1.484v6.74c0 .65.378 1.219.988 1.485.223.098.46.145.693.145.423 0 .838-.155 1.157-.451l3.642-3.37a1.61 1.61 0 00.52-1.18c0-.442-.189-.872-.52-1.177l-3.641-3.37zM12 20c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8zm0-18C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-play-simple"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.25 11.278a.833.833 0 010 1.444l-12.5 7.217a.833.833 0 01-1.25-.722V4.783a.833.833 0 011.25-.722l12.5 7.217z",
    fill: "#000018",
    fillOpacity: 0.84
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-power"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 12a1 1 0 11-2 0V2a1 1 0 112 0v10zm2.239-8.459a1 1 0 011.347-.43A9.973 9.973 0 0122 12.001c0 5.512-4.486 10-10 10S2 17.512 2 12a9.972 9.972 0 015.415-8.89 1 1 0 01.918 1.777A7.977 7.977 0 004 12c0 4.411 3.589 8 8 8s8-3.589 8-8a7.978 7.978 0 00-4.332-7.112.999.999 0 01-.429-1.347z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-pricetag"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.56 8.44a1.5 1.5 0 11-2.12 2.12 1.5 1.5 0 012.12-2.12zM5.834 12.89l6.032 6.033 7.058-7.058-6.032-6.033-7.785-.726.727 7.784zm6.032 8.107c-.465 0-.93-.177-1.284-.53L4.165 14.05a1 1 0 01-.29-.614l-.871-9.344a1.002 1.002 0 011.089-1.088l9.344.872a.995.995 0 01.614.288l6.417 6.418c.343.342.532.798.532 1.284s-.19.943-.532 1.286l-7.317 7.316a1.81 1.81 0 01-1.285.53z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-printer"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 16.333c0 .368-.285.667-.637.667H18.5v-2c0-1.103-.897-2-2-2h-9c-1.103 0-2 .897-2 2v2h-.863C4.285 17 4 16.701 4 16.333V9.667C4 9.299 4.285 9 4.637 9H19.363c.352 0 .637.299.637.667v6.666zM7.5 19v-4h9l.002 4H7.5zm.514-14H16v2H8.007l.007-2zm11.349 2H18V5c0-1.103-.822-2-1.833-2H7.833C6.822 3 6 3.897 6 5v2H4.637C3.183 7 2 8.196 2 9.667v6.666C2 17.804 3.183 19 4.637 19H5.5c0 1.103.897 2 2 2h9c1.103 0 2-.897 2-2h.863C20.817 19 22 17.804 22 16.333V9.667C22 8.196 20.817 7 19.363 7z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-publish"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 14c0 .551-.448 1-1 1H5c-.552 0-1-.449-1-1V6c0-.551.448-1 1-1h14c.552 0 1 .449 1 1v8zM19 3H5C3.346 3 2 4.346 2 6v8c0 1.654 1.346 3 3 3h6v2H7c-.55 0-1 .45-1 1s.45 1 1 1h10c.55 0 1-.45 1-1s-.45-1-1-1h-4v-2h6c1.654 0 3-1.346 3-3V6c0-1.654-1.346-3-3-3z",
    fill: "#000018"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.204 7.296l-3.258 3.727-1.407-1.565c-.292-.327-.835-.384-1.208-.128-.375.255-.441.727-.148 1.052l2.094 2.33a.914.914 0 00.678.288h.006c.266 0 .518-.11.679-.296l3.934-4.5c.288-.33.215-.8-.164-1.05-.38-.252-.919-.187-1.206.142z",
    fill: "#000018"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.11 7.214c.33-.38.94-.449 1.37-.165.436.29.53.846.188 1.237l-3.934 4.5a1.03 1.03 0 01-.773.339h-.006c-.297 0-.582-.118-.771-.329l-2.093-2.33c-.348-.385-.264-.944.17-1.24.422-.288 1.035-.227 1.372.149l1.311 1.46 3.166-3.621zm1.231.044c-.33-.22-.799-.16-1.043.12l-3.351 3.833-1.5-1.67c-.25-.277-.721-.33-1.046-.108-.316.215-.364.6-.125.866l2.093 2.33a.789.789 0 00.586.246h.006a.78.78 0 00.584-.252l3.935-4.501c.235-.27.181-.652-.139-.864z",
    fill: "#000018"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-qr"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8 17a.2.2 0 00.2-.2v-.6a.2.2 0 00-.2-.2h-2.6a.2.2 0 01-.2-.2v-2.6c0-.11.09-.2.2-.2h2.6c.11 0 .2.09.2.2v1.6c0 .11.09.2.2.2H18v1.8a.2.2 0 01-.2.2h-.6a.2.2 0 00-.2.2V19h-1.8a.2.2 0 00-.2.2v1.6a.2.2 0 01-.2.2h-1.6a.2.2 0 01-.2-.2v-2.6c0-.11.09-.2.2-.2h1.6a.2.2 0 00.2-.2v-.6c0-.11.09-.2.2-.2h.6zm5.2 3.8a.2.2 0 01-.2.2h-3.6a.2.2 0 01-.2-.2V19h1.8a.2.2 0 00.2-.2v-1.6c0-.11.09-.2.2-.2h1.6c.11 0 .2.09.2.2v3.6zM3 4a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1V4zm2 1v4h4V5H5zm8-1a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1h-6a1 1 0 01-1-1V4zm2 1v4h4V5h-4zM3 14a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zm2 1v4h4v-4H5zm13-1.8c0-.11.09-.2.2-.2h2.6c.11 0 .2.09.2.2v1.6a.2.2 0 01-.2.2H18v-1.8zM6 6h2v2H6V6zm0 10h2v2H6v-2zM16 6h2v2h-2V6z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-question-circle"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 9.5C8.5 7.57 10.07 6 12 6s3.5 1.57 3.5 3.5c0 1.58-1.06 2.903-2.5 3.337V14a1 1 0 11-2 0v-2a1 1 0 011-1c.827 0 1.5-.673 1.5-1.5S12.827 8 12 8s-1.5.673-1.5 1.5a1 1 0 11-2 0zM11 17a1 1 0 112 0 1 1 0 11-2 0zm1 3c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8zm0-18C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-question-mark"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4c2.757 0 5 2.243 5 5a5.007 5.007 0 01-4 4.898V15a1 1 0 11-2 0v-2a1 1 0 011-1c1.654 0 3-1.346 3-3s-1.346-3-3-3-3 1.346-3 3a1 1 0 11-2 0c0-2.757 2.243-5 5-5zm-1 15a1 1 0 112 0 1 1 0 11-2 0z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-radio"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.766 17.644c.355-.422.3-1.053-.122-1.41C4.938 14.8 4 12.941 4 11c0-1.94.938-3.8 2.644-5.234.422-.357.477-.988.122-1.41a1.002 1.002 0 00-1.41-.122C3.192 6.056 2 8.46 2 11c0 2.541 1.192 4.944 3.356 6.766a1 1 0 001.41-.122zm11.878.122C20.808 15.944 22 13.541 22 11c0-2.54-1.192-4.944-3.356-6.766a1.004 1.004 0 00-1.41.122c-.355.422-.3 1.053.122 1.41C19.062 7.2 20 9.06 20 11c0 1.941-.938 3.8-2.644 5.234a1.002 1.002 0 00-.122 1.41 1.002 1.002 0 001.41.122zM7.5 11c0-1.193.584-2.343 1.644-3.235a1 1 0 00-1.288-1.53C6.337 7.515 5.5 9.206 5.5 11c0 1.794.837 3.486 2.356 4.765a.999.999 0 101.288-1.53C8.084 13.343 7.5 12.193 7.5 11zm11 0c0 1.794-.837 3.486-2.356 4.765a.999.999 0 11-1.288-1.53c1.06-.892 1.644-2.042 1.644-3.235s-.584-2.343-1.644-3.235a1 1 0 011.288-1.53C17.663 7.515 18.5 9.206 18.5 11zM12 12a1 1 0 110-2 1 1 0 010 2zm0-4c-1.654 0-3 1.346-3 3 0 1.314.855 2.422 2.035 2.826-.011.059-.035.112-.035.174v6a1 1 0 102 0v-6c0-.062-.024-.115-.035-.174A2.993 2.993 0 0015 11c0-1.654-1.346-3-3-3z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-radio-button-off"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4c-4.411 0-8 3.589-8 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8zm0 18C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-radio-button-on"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 15c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zm0-8c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5zm0 13c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8zm0-18C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-refresh"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.303 13.426a1.001 1.001 0 00-1.256.65C18.11 17.022 15.352 19 12.184 19 8.222 19 5 15.86 5 12s3.222-7 7.184-7c1.728 0 3.358.602 4.645 1.67l-2.166-.357a.99.99 0 00-1.15.823.999.999 0 00.824 1.149l4.246.702a1.025 1.025 0 00.507-.048c.037-.014.067-.04.103-.06.066-.033.135-.063.192-.111.036-.03.06-.071.09-.105.047-.05.097-.096.132-.156.025-.043.035-.094.054-.142.024-.06.056-.114.068-.18l.754-4a1 1 0 10-1.966-.37l-.272 1.44A9.23 9.23 0 0012.185 3C7.12 3 3 7.037 3 12s4.12 9 9.184 9c4.042 0 7.566-2.54 8.77-6.318a1.001 1.001 0 00-.65-1.256z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-refresh-1"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.914 5H17.91c1.98 0 3.59 1.583 3.59 3.529V11a1 1 0 11-2 0V8.529C19.5 7.687 18.787 7 17.91 7H5.914l1.293 1.293a1 1 0 01-1.414 1.414l-3-3a.999.999 0 010-1.414l3-3a.999.999 0 111.414 1.414L5.914 5zm10.88 9.293a.999.999 0 011.413 0l3 3a.999.999 0 010 1.414l-3 3a.997.997 0 01-1.414 0 .999.999 0 010-1.414L18.086 19H6.09c-1.98 0-3.59-1.583-3.59-3.529V13a1 1 0 112 0v2.471c0 .843.713 1.529 1.59 1.529h11.996l-1.293-1.293a.999.999 0 010-1.414z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-rewind"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 15.986l-4.822-3.983L17.5 8.092v7.894zm-8 0l-4.822-3.983L9.5 8.092v7.894zM18.45 6.2a2.085 2.085 0 00-2.209.26L11.5 10.377v-2.59c0-.673-.402-1.28-1.05-1.586a2.085 2.085 0 00-2.209.26l-5.1 4.213A1.726 1.726 0 002.5 12c0 .506.234.99.642 1.325l5.099 4.215a2.05 2.05 0 001.303.46c.307 0 .617-.067.906-.203.648-.304 1.05-.912 1.05-1.584v-2.591l4.741 3.918a2.05 2.05 0 001.303.46c.307 0 .617-.067.906-.203.648-.304 1.05-.912 1.05-1.584V7.787c0-.673-.402-1.28-1.05-1.586z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-robot"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.586 12.386a2.636 2.636 0 00-.049-.543 2.194 2.194 0 00-.618-1.096 1.531 1.531 0 01-.155-.17c-.002 0-.002-.003-.002-.005-.002 0-.003-.002-.005-.004a.7.7 0 00-.408-.213.162.162 0 01-.044-.011h-.003l-.003-.002a2.377 2.377 0 00-.719-.187l-.12.004-.041.002c-.043-.002-.06-.046-.076-.082-.054-.125-.107-.25-.17-.37-.142-.27-.332-.512-.468-.786-.005-.003-.01-.011-.018-.025a6.277 6.277 0 00-1.15-1.565 8.353 8.353 0 00-2.162-1.561 10.541 10.541 0 00-1.957-.75 2.525 2.525 0 01-.29-.098.018.018 0 01-.01-.023.962.962 0 00-.051-.75.784.784 0 00-.16-.218.588.588 0 00-.238-.14 9.254 9.254 0 00-4.885-.106c-.243.06-.402.11-.476.152a.727.727 0 00-.333.408c-.071.2-.076.412-.015.64a.02.02 0 01-.012.023c-.104.046-.24.09-.406.131-.518.13-1.051.316-1.6.558a7.851 7.851 0 00-3.281 2.67 5.931 5.931 0 00-.27.415c-.257.433-.518.865-.737 1.319l-.027.058c-.015.03-.024.073-.055.091a.102.102 0 01-.053.012c-.072 0-.144-.007-.217-.002a2.525 2.525 0 00-.826.215 1.112 1.112 0 00-.24.134c-.078.061-.14.14-.214.206-.081.077-.143.144-.186.201-.273.36-.413.772-.42 1.237a90.248 90.248 0 00.005 2.87c.018.28.066.54.147.777a2.39 2.39 0 001.167 1.36c.459.226.957.27 1.495.13a.028.028 0 01.03.01c.197.294.423.57.661.831.227.247.462.483.729.688.26.2.539.374.821.54.128.074.256.148.384.22a8.077 8.077 0 001.438.647 12.822 12.822 0 001.672.444 16.63 16.63 0 002.461.29c.53.023 1.06.015 1.59-.023.225-.017.45-.036.676-.058a13.484 13.484 0 003.443-.798c.236-.088.444-.177.626-.266a8.967 8.967 0 001.722-1.117l.008-.006a6.298 6.298 0 001.241-1.406.024.024 0 01.026-.01c.56.154 1.085.1 1.572-.164.657-.356 1.069-1.02 1.216-1.742.03-.15.046-.36.047-.629 0-.786-.002-1.572-.007-2.357zm-3.3 4.668c-.083.12-.169.236-.256.351-.091.12-.184.232-.278.333a7.173 7.173 0 01-2.867 1.89c-.35.127-.63.22-.841.279a14.453 14.453 0 01-3.336.516 22.22 22.22 0 01-.68.015 14.4 14.4 0 01-3.707-.435 10.23 10.23 0 01-2.513-1 6.579 6.579 0 01-2.018-1.78c-.82-1.11-1.218-2.375-1.195-3.795a9.983 9.983 0 01.07-1.487c.115-.89.395-1.74.838-2.547a7.516 7.516 0 011.54-1.963 7.86 7.86 0 012.36-1.482 10.557 10.557 0 012.31-.634 15.302 15.302 0 011.517-.166 13.048 13.048 0 013.709.277c.819.181 1.61.472 2.374.872a7.37 7.37 0 013.928 5.539c.108.732.133 1.468.075 2.206a5.68 5.68 0 01-1.03 3.011zm2.805-2.03c-.029.618-.262 1.102-.698 1.455a1.608 1.608 0 01-.597.313 1.602 1.602 0 01-.768.013h-.003a.013.013 0 01-.006-.019c.273-.492.479-1.01.62-1.556.125-.56.19-1.128.193-1.7 0-.216-.003-.444-.011-.683a8.467 8.467 0 00-.345-2.127.03.03 0 01.032-.028c.283.014.54.08.769.197.207.105.38.25.515.434.2.27.3.587.298.951-.003.524 0 1.048.007 1.572.001.074 0 .17-.004.29a5.521 5.521 0 00-.003.29c.012.162.012.362.001.599z",
    fill: "#29293D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.022 21.384c-.205 0-.41-.004-.613-.013a17.125 17.125 0 01-2.52-.297 13.319 13.319 0 01-1.728-.459 8.448 8.448 0 01-1.506-.678c-.118-.066-.255-.144-.389-.223a8.492 8.492 0 01-.863-.567 6.16 6.16 0 01-.782-.737 7.845 7.845 0 01-.55-.667 2.442 2.442 0 01-1.515-.213 2.807 2.807 0 01-1.374-1.596 3.439 3.439 0 01-.167-.884 90.82 90.82 0 01-.005-2.902c.008-.553.177-1.05.502-1.48.057-.074.132-.156.23-.249l.01-.01c.019-.017.042-.04.066-.066.048-.048.1-.104.169-.157.112-.086.228-.143.327-.186l.072-.03a2.927 2.927 0 01.937-.22c.208-.42.446-.82.677-1.21l.04-.067a8.29 8.29 0 013.737-3.25 10.445 10.445 0 011.734-.598 1.41 1.41 0 01.08-.516c.098-.279.272-.49.517-.628.076-.042.21-.103.58-.193a9.696 9.696 0 015.095.11.993.993 0 01.402.234c.097.09.179.202.245.331.109.217.158.444.147.677.681.19 1.346.446 1.98.764.839.422 1.602.973 2.268 1.638a6.72 6.72 0 011.178 1.58l.012.006.055.111c.061.125.14.248.224.378.08.126.164.256.24.4.04.078.076.155.11.231.265.028.53.097.789.205a1.1 1.1 0 01.62.332l.056.057.009.023c.019.02.046.05.084.086.37.362.616.799.732 1.298.038.167.057.374.059.633.005.783.008 1.577.007 2.36 0 .302-.019.534-.055.711-.183.894-.701 1.63-1.423 2.021-.5.27-1.037.358-1.6.26a6.814 6.814 0 01-1.175 1.277l-.01.008h-.001a9.38 9.38 0 01-1.798 1.166 7.508 7.508 0 01-.662.281c-1.14.428-2.333.704-3.546.823-.228.022-.46.041-.687.058-.338.024-.68.037-1.023.037h.002zM12.12 5.53c-.287 0-.575.01-.863.029a15.18 15.18 0 00-1.48.162c-.773.122-1.52.327-2.222.61a7.493 7.493 0 00-2.24 1.405 7.135 7.135 0 00-1.456 1.857 6.78 6.78 0 00-.79 2.402 9.616 9.616 0 00-.066 1.425v.015c-.022 1.321.353 2.513 1.114 3.544a6.206 6.206 0 001.89 1.668c.73.413 1.543.736 2.415.96 1.131.29 2.343.432 3.603.422.235-.002.46-.007.668-.014 1.094-.04 2.185-.21 3.242-.503.2-.055.474-.146.812-.268a6.803 6.803 0 002.707-1.784c.084-.092.17-.194.252-.303.085-.111.168-.225.246-.337a5.3 5.3 0 00.956-2.798l.001-.011a9.424 9.424 0 00-.07-2.113 7.34 7.34 0 00-.511-1.815 7.003 7.003 0 00-3.203-3.42 9.17 9.17 0 00-2.274-.836 12.641 12.641 0 00-2.731-.297zm8.531 12.144l.003.001h-.003zM1.298 11.018a1.309 1.309 0 00-.138.148c-.22.291-.33.616-.336.994A90.959 90.959 0 00.828 15c.015.242.058.467.126.67.104.308.271.57.511.802.14.136.292.244.449.32.362.18.746.215 1.175.112-.618-1.041-.921-2.207-.901-3.476-.012-.56.013-1.079.073-1.54.058-.447.156-.886.292-1.316l-.026.001c-.042 0-.078 0-.11-.002-.033-.001-.065-.002-.086 0a2.115 2.115 0 00-.69.181.769.769 0 00-.156.084.974.974 0 00-.083.08c-.03.03-.064.066-.104.102zm20.727.204c.116.526.184 1.066.203 1.61.009.247.012.482.011.7a8.416 8.416 0 01-.203 1.788l-.003.012a6.997 6.997 0 01-.37 1.07 1.209 1.209 0 00.474-.244c.345-.278.524-.655.547-1.153.01-.22.01-.405 0-.548l-.001-.024c-.002-.101-.001-.206.003-.312.003-.114.005-.205.004-.27-.008-.518-.01-1.05-.007-1.58a1.128 1.128 0 00-.217-.704 1.044 1.044 0 00-.44-.345zm1.124-.776zm-2.102-1.74l.002.003-.002-.002zm-5.54-3.682v0zm-3.387-.315c.873 0 1.741.084 2.593.251a.428.428 0 01.017-.184.551.551 0 00-.027-.44.384.384 0 00-.074-.104.185.185 0 00-.074-.046 8.896 8.896 0 00-4.675-.1c-.292.07-.367.108-.374.112a.32.32 0 00-.147.186.655.655 0 00-.006.396l.002.007a.44.44 0 01.008.172l.287-.05A15.454 15.454 0 0111.2 4.74c.307-.02.613-.03.918-.03zm-3.335-.175h-.001z",
    fill: "#29293D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.091 15.025c-.029.617-.262 1.101-.698 1.454a1.607 1.607 0 01-.597.313 1.601 1.601 0 01-.768.013h-.003a.013.013 0 01-.006-.019 6.58 6.58 0 00.62-1.556c.125-.56.19-1.128.193-1.7 0-.216-.003-.444-.011-.683a8.464 8.464 0 00-.345-2.127.03.03 0 01.032-.028c.283.014.54.08.769.197.207.105.38.25.515.434.2.27.3.587.298.951-.003.524 0 1.048.007 1.572.001.074 0 .17-.004.29a5.519 5.519 0 00-.003.29c.012.162.012.362.001.599z",
    fill: "#29293D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.39 17.255c-.133 0-.268-.013-.404-.04h-.036l-.091-.034-.033-.018a.427.427 0 01-.167-.567l.004-.009c.253-.457.448-.946.579-1.453a7.6 7.6 0 00.182-1.606c.001-.207-.003-.43-.01-.667a8.086 8.086 0 00-.326-2.011.45.45 0 01-.02-.13l.002-.026a.441.441 0 01.455-.412h.003c.34.018.654.098.933.241.264.134.485.321.658.555.253.341.38.745.378 1.199-.002.524 0 1.05.008 1.563 0 .08 0 .18-.005.31a5.095 5.095 0 00-.003.258c.013.177.013.385.001.636-.035.737-.32 1.327-.85 1.755a2.018 2.018 0 01-.747.389 1.97 1.97 0 01-.511.067zm-.514-.07l.002.002-.002-.001zm1.15-5.963c.115.527.183 1.066.202 1.61.008.247.012.482.011.7a8.415 8.415 0 01-.203 1.788l-.003.012a7.024 7.024 0 01-.37 1.07 1.209 1.209 0 00.474-.244c.345-.278.524-.655.547-1.153.01-.22.01-.405 0-.548l-.002-.024a6.05 6.05 0 01.003-.312c.004-.114.006-.205.005-.27-.008-.517-.01-1.05-.008-1.58a1.127 1.127 0 00-.216-.704 1.043 1.043 0 00-.44-.345zM8.47 17.532c-.17 0-.351-.016-.54-.048a5.845 5.845 0 01-1.623-.532 3.787 3.787 0 01-.647-.408 4.19 4.19 0 01-.462-.418 2.881 2.881 0 01-.755-1.518 4.718 4.718 0 01-.05-1.012c.078-1.648.8-2.945 2.144-3.855a7.463 7.463 0 011.79-.882 9.394 9.394 0 011.33-.35 13.815 13.815 0 012.715-.21c.726.013 1.43.087 2.092.22.976.195 1.871.533 2.66 1.003.838.501 1.489 1.18 1.935 2.018.19.358.326.754.402 1.177.032.179.058.383.078.609.04.475.027.938-.043 1.376a2.25 2.25 0 01-.127.46c-.054.14-.125.28-.21.419-.305.489-.711.889-1.208 1.19-.58.353-1.213.591-1.88.71a3.31 3.31 0 01-1.041.011c-.428-.06-.72-.104-.87-.13a15.97 15.97 0 00-1.118-.156 9.903 9.903 0 00-2.316.031c-.369.049-.946.135-1.717.255-.17.027-.351.04-.54.04zm3.628-8.82c-.811 0-1.606.07-2.367.208a8.973 8.973 0 00-1.271.334 7.064 7.064 0 00-1.692.833c-.616.417-1.093.925-1.418 1.508-.325.585-.508 1.265-.545 2.022a4.27 4.27 0 00.046.92c.086.5.304.938.647 1.303.121.128.261.254.416.375.179.14.373.263.577.364.478.239.986.405 1.509.494a2.793 2.793 0 00.945.008c.774-.121 1.355-.207 1.727-.257.8-.105 1.611-.116 2.412-.032.382.04.768.093 1.147.16.142.025.438.07.856.128a2.9 2.9 0 00.911-.009 5.026 5.026 0 001.739-.655 3.205 3.205 0 001.07-1.055c.072-.116.131-.234.176-.35.051-.131.086-.257.104-.374.065-.404.078-.833.039-1.274a6.454 6.454 0 00-.073-.57 3.593 3.593 0 00-.36-1.056 4.732 4.732 0 00-1.78-1.856 7.953 7.953 0 00-2.53-.953 11.396 11.396 0 00-2.285-.215z",
    fill: "#29293D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.47 17.922h0a3.6 3.6 0 01-.604-.055l.605.055zm0 0c.208 0 .408-.015.598-.045a82.43 82.43 0 011.708-.253m-2.305.298l2.286-.447m-4.623-.174h0a4.194 4.194 0 01-.712-.45 4.56 4.56 0 01-.505-.457h0a3.264 3.264 0 01-.855-1.72L6.134 17.3zm0 0c.549.273 1.131.464 1.731.567l-1.73-.567zm.187-7.882h0a7.864 7.864 0 011.883-.928h0a9.726 9.726 0 011.385-.364 14.195 14.195 0 012.791-.217L6.321 9.419zm0 0c-1.45.98-2.23 2.384-2.316 4.159l2.316-4.16zm11-.23h0a5.524 5.524 0 012.08 2.168c.21.394.358.83.44 1.292 0 0 0 0 0 0l-.147.027-2.372-3.488zm0 0a8.757 8.757 0 00-2.78-1.051m2.78 1.05l-2.78-1.05m-.422 9.46a15.74 15.74 0 00-1.102-.153 9.67 9.67 0 00-2.26.03m3.362.124l-.026.147s0 0 0 0m.026-.147c.151.026.446.07.877.13l4.883-2.966s0 0 0 0a2.645 2.645 0 01-.15.54 2.894 2.894 0 01-.242.484h0a4.004 4.004 0 01-1.336 1.318 5.82 5.82 0 01-2.014.76c-.37.066-.76.07-1.162.013-.43-.06-.728-.104-.882-.132m.026-.147l-.026.147m0 0c-.362-.063-.73-.115-1.092-.152h0a9.517 9.517 0 00-2.225.03m0 0s0 0 0 0l-.02-.149m.02.149l-.02-.149M9.8 9.303h0c-.386.07-.795.177-1.217.32a6.662 6.662 0 00-1.598.787h0c-.568.384-1.003.847-1.296 1.375-.294.529-.463 1.15-.496 1.85h0c-.015.313 0 .594.04.837.073.423.257.793.547 1.1l4.02-6.27zm0 0a12.952 12.952 0 012.557-.199h0c.679.013 1.335.082 1.95.206l.03-.148-.03.148a7.568 7.568 0 012.406.906 4.347 4.347 0 011.638 1.705c.15.282.259.598.32.94h0c.028.154.05.334.068.536h0c.036.405.024.798-.033 1.167M9.8 9.303l9.089 4.081c.036.417.024.822-.035 1.203m0 0l-.148-.023m.148.023l-.148-.023m.148.023l-.002.013m-.146-.036h0m0 0h0m0 0l-.002.012.148.024m0 0l-.148-.023c-.014.086-.04.185-.083.294h0a1.69 1.69 0 01-.143.283m.374-.554a1.6 1.6 0 01-.091.325c-.04.102-.091.205-.156.309m0 0l-.127-.08m.127.08l-.127-.08s0 0 0 0m.127.08c-.25.4-.583.729-.992.977a4.79 4.79 0 01-1.656.625c-.261.046-.543.049-.838.007m3.36-1.689c-.238.38-.554.693-.943.929h0c-.495.3-1.035.504-1.606.605h0c-.243.043-.509.046-.79.007l-.02.148m0 0a33.039 33.039 0 01-.848-.126m.848.126l.02-.148-.868.022m0 0l.026-.148s0 0 0 0a16.952 16.952 0 00-1.174-.164m1.148.312l-7.609-.486m0 0h0c.445.221.916.376 1.402.459a2.424 2.424 0 00.82.006h0c.777-.12 1.36-.208 1.737-.257h0c.83-.11 1.671-.121 2.502-.034m-6.46-.174a3.017 3.017 0 01-.511-.323m.51.323l-.51-.323m6.971.497l-.015.15.015-.15s0 0 0 0zm1.416-8.267a12.161 12.161 0 00-2.16-.228l2.16.228zm-8.387 7.77a3.402 3.402 0 01-.373-.336l.373.337zm-2.148-2.33c-.019.395 0 .764.057 1.096l-.057-1.096z",
    fill: "#29293D",
    stroke: "#29293D",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.835 14.981c.462 0 .837-.84.837-1.879 0-1.038-.375-1.879-.837-1.879-.463 0-.837.841-.837 1.88 0 1.037.375 1.878.837 1.878z",
    fill: "#29293D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.835 11.343c.397 0 .719.787.719 1.76 0 .97-.322 1.759-.719 1.759-.397 0-.718-.788-.718-1.76s.321-1.76.718-1.76zm0-.24c-.398 0-.627.416-.728.664-.147.36-.228.835-.228 1.335s.081.975.228 1.335c.101.248.33.664.728.664.398 0 .627-.416.728-.664.148-.36.229-.834.229-1.335 0-.5-.082-.974-.229-1.335-.1-.248-.33-.664-.728-.664zM8.271 14.981c.463 0 .837-.84.837-1.879 0-1.038-.374-1.879-.837-1.879-.462 0-.837.841-.837 1.88 0 1.037.375 1.878.837 1.878z",
    fill: "#29293D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.27 11.343c.397 0 .719.787.719 1.76 0 .97-.322 1.759-.719 1.759-.397 0-.719-.788-.719-1.76s.322-1.76.719-1.76zm0-.24c-.398 0-.627.416-.728.664-.147.36-.228.835-.228 1.335s.08.975.228 1.335c.101.248.33.664.728.664.398 0 .627-.416.728-.664.148-.36.228-.834.228-1.335 0-.5-.08-.974-.228-1.335-.101-.248-.33-.664-.728-.664z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-rocket"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.788 15.968l.085-1.183 1.03-.588a12.944 12.944 0 002.703-2.087c2.935-2.936 3.83-6.387 2.751-7.467-1.08-1.078-4.531-.185-7.467 2.75a12.959 12.959 0 00-2.087 2.704l-.59 1.03-1.18.085c-.71.05-1.391.269-1.991.635-.311.19-.247.632.077.8a12.208 12.208 0 013.02 2.214c.9.9 1.643 1.92 2.214 3.02.168.324.61.389.8.077.366-.6.586-1.282.635-1.99zm-3.304 3.145c-.224.303-.47.59-.737.857-1.303 1.302-3.268 1.695-5.896 1.178-.515-2.627-.122-4.592 1.179-5.895.275-.273.562-.52.858-.737a9.973 9.973 0 00-2.311-.795c-.301-.064-.494-.371-.375-.655a6.64 6.64 0 011.435-2.135 6.643 6.643 0 014.235-1.935 15.157 15.157 0 012.446-3.174c3.69-3.69 8.44-4.92 10.611-2.75 2.17 2.17.938 6.92-2.75 10.61a15.155 15.155 0 01-3.174 2.445 6.643 6.643 0 01-1.935 4.235 6.62 6.62 0 01-2.136 1.436c-.284.119-.59-.073-.654-.374a9.974 9.974 0 00-.796-2.311zm-1.918-2.68a2.891 2.891 0 00-.6-.46c-.48.166-1.045.533-1.561 1.049-.244.244-.542 1.066-.545 2.117 1.051-.003 1.876-.304 2.117-.544.517-.518.884-1.082 1.05-1.562a2.888 2.888 0 00-.46-.6zm8.646-8.647a1.112 1.112 0 111.572-1.57 1.111 1.111 0 01-1.57 1.57h-.002z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-save"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 18c0 .551-.448 1-1 1h-2v-3a1 1 0 00-1-1H9a1 1 0 00-1 1v3H6c-.552 0-1-.449-1-1V6c0-.551.448-1 1-1h2v5a1 1 0 001 1h4a1 1 0 100-2h-3V5h3.172c.263 0 .52.107.707.293l4.828 4.828a.996.996 0 01.293.708V18zm-9 1h4v-2h-4v2zM20.121 8.707l-4.828-4.828A2.978 2.978 0 0013.172 3H6C4.346 3 3 4.346 3 6v12c0 1.654 1.346 3 3 3h12c1.654 0 3-1.346 3-3v-7.171c0-.802-.313-1.556-.879-2.122z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-scissors"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.707 18.293a.999.999 0 11-1.414 1.414l-5-5a.999.999 0 111.414-1.414l5 5zM7 19a1.001 1.001 0 010-2 1.001 1.001 0 010 2zM7 7a1.001 1.001 0 010-2 1.001 1.001 0 010 2zm13.708-1.294a.999.999 0 10-1.416-1.412l-6.28 6.303-3.305-3.304-.009-.006A2.96 2.96 0 0010 6c0-1.654-1.346-3-3-3S4 4.346 4 6s1.346 3 3 3a2.96 2.96 0 001.287-.302c.003.003.003.007.006.009l3.307 3.307-3.289 3.3A2.977 2.977 0 007 15c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3c0-.451-.107-.875-.286-1.26L20.708 5.706z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-screen"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 14c0 .551-.448 1-1 1H5c-.552 0-1-.449-1-1V6c0-.551.448-1 1-1h14c.552 0 1 .449 1 1v8zM19 3H5C3.346 3 2 4.346 2 6v8c0 1.654 1.346 3 3 3h6v2H7c-.55 0-1 .45-1 1s.45 1 1 1h10c.55 0 1-.45 1-1s-.45-1-1-1h-4v-2h6c1.654 0 3-1.346 3-3V6c0-1.654-1.346-3-3-3z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-search"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.326 14.899l5.38 5.38a1.009 1.009 0 01-1.427 1.426l-5.38-5.38a8 8 0 111.426-1.426zM10 15.999a6 6 0 100-12 6 6 0 000 12z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-search-ia"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.972 2.941a8.1 8.1 0 10.917 13.516l5.318 5.318a1.109 1.109 0 101.569-1.567l-5.318-5.318a8.094 8.094 0 001.145-2.096l-1.103-.555-1.381.695A5.896 5.896 0 0110 15.899a5.9 5.9 0 11.626-11.766c.199-.1.415-.167.639-.198l2.365-.33.342-.664z",
    fill: "#29293D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.559 12.03a.569.569 0 01-.255-.06L16.5 10.56l-2.804 1.41a.57.57 0 01-.579-.042.519.519 0 01-.218-.517l.534-2.978-2.266-2.109a.516.516 0 01-.14-.543.544.544 0 01.444-.36l3.135-.439 1.402-2.712c.185-.36.799-.36.985 0l1.4 2.712 3.136.438c.208.029.38.17.444.36a.516.516 0 01-.14.544l-2.266 2.109.534 2.978a.52.52 0 01-.218.517.56.56 0 01-.324.102z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-search-ia2"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.238 11.244a5.198 5.198 0 11-4.543-6.176c.711-.356 1.081-.545 1.404-.793.254-.196.485-.418.69-.664a7.136 7.136 0 00-9.785 6.4 7.137 7.137 0 0011.442 5.916l4.686 4.686a.978.978 0 001.382-1.38l-4.686-4.687a7.137 7.137 0 001.299-5.755c-.082.09-.16.182-.234.278-.26.338-.455.728-.845 1.508a1.266 1.266 0 01-.81.667z",
    fill: "#29293D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8 9l.523-1.046c.177-.354.265-.53.384-.684.105-.136.227-.258.363-.363.153-.119.33-.207.684-.384L17.8 6l-1.046-.523c-.354-.177-.53-.265-.684-.384a2.003 2.003 0 01-.363-.363c-.119-.153-.207-.33-.384-.684L14.8 3l-.523 1.046c-.177.354-.265.53-.384.684a2 2 0 01-.363.363c-.153.119-.33.207-.684.384L11.8 6l1.046.523c.354.177.531.265.684.384a2 2 0 01.363.363c.119.153.207.33.384.684L14.8 9z",
    fill: "#29293D",
    stroke: "#29293D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 9 13",
    fill: "none",
    id: "sprite_svg__icon-light-select-zonajobs"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.32 12.164a8.693 8.693 0 01-2.289-.281C1.344 11.695.667 11.37 0 10.906v-2.75h1.766l.242 1.617c.229.198.55.36.96.485.417.12.868.18 1.352.18.62 0 1.094-.126 1.422-.376.328-.255.492-.598.492-1.03 0-.407-.156-.748-.468-1.024-.308-.281-.85-.542-1.625-.781-1.35-.391-2.355-.855-3.016-1.391-.661-.537-.992-1.27-.992-2.203 0-.615.17-1.156.508-1.625.343-.474.817-.847 1.421-1.117C2.667.62 3.365.479 4.156.469c.875-.01 1.649.093 2.32.312.678.219 1.261.524 1.75.914v2.563h-1.71l-.297-1.563a3.052 3.052 0 00-.805-.328 4.22 4.22 0 00-1.14-.14c-.547 0-.995.122-1.344.367-.35.245-.524.588-.524 1.031 0 .38.162.698.485.953.328.25.93.516 1.804.797 1.256.349 2.206.81 2.852 1.383.65.573.976 1.325.976 2.258 0 .65-.174 1.21-.523 1.68-.349.468-.841.83-1.477 1.085-.63.255-1.364.383-2.203.383z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-selecta"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.727 11.155C15.524 11.682 17 12.89 17 14.986c0 2.613-2.178 4.012-5.594 4.012a13.04 13.04 0 01-4.566-.731.917.917 0 01-.587-1.02c.101-.627.77-.985 1.373-.79 1.163.375 2.386.564 3.62.556 2.255 0 3.471-.67 3.471-1.916 0-1.245-1.105-1.704-3.062-2.069l-1.83-.348C7.498 12.247 6 11.097 6 8.985c0-2.39 2.211-3.984 5.716-3.984 1.27-.013 2.534.156 3.75.499.445.126.71.57.641 1.028-.09.598-.704.963-1.29.815a12.333 12.333 0 00-2.958-.374c-2.283 0-3.543.729-3.543 1.958 0 1.23.967 1.584 2.946 1.932l1.465.296z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-settings"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.403 11.622c1.116.383 2.005 1.317 2.377 2.501l.04.12c.426 1.256.253 2.608-.461 3.622-.13.184-.101.404.036.508l2.072 1.574a.253.253 0 00.188.05.272.272 0 00.182-.119l.23-.328a3.796 3.796 0 012.972-1.614 3.78 3.78 0 013.234 1.639l.118.171a.272.272 0 00.182.12.231.231 0 00.188-.05l2.06-1.555c.145-.108.177-.339.07-.494l-.26-.375a3.968 3.968 0 01-.532-3.359 3.915 3.915 0 012.492-2.614l.2-.068c.162-.053.249-.253.192-.437l-.787-2.521a.317.317 0 00-.155-.193.235.235 0 00-.187-.015l-.34.113a3.743 3.743 0 01-3.431-.564l-.108-.081a3.79 3.79 0 01-1.49-3.035l.003-.28a.353.353 0 00-.101-.254.254.254 0 00-.183-.081L10.657 4c-.156 0-.283.149-.284.333l-.001.242A3.926 3.926 0 018.85 7.669l-.13.098a3.915 3.915 0 01-3.634.597.162.162 0 00-.133.009.238.238 0 00-.118.148l-.817 2.596a.357.357 0 00.22.449l.165.056zM8.613 22c-.485 0-.957-.158-1.355-.461l-2.072-1.573c-.99-.75-1.21-2.193-.49-3.216.375-.53.452-1.211.232-1.857l-.055-.168c-.183-.582-.601-1.034-1.118-1.211h-.001l-.163-.057a2.344 2.344 0 01-1.481-2.94l.816-2.595A2.23 2.23 0 014.05 6.588a2.157 2.157 0 011.683-.116 1.916 1.916 0 001.777-.297l.129-.098c.456-.348.73-.913.733-1.51v-.241C8.379 3.042 9.403 2 10.657 2h.004l2.547.003c.602.001 1.17.239 1.598.67.443.445.685 1.04.683 1.675l-.002.279a1.78 1.78 0 00.694 1.429l.107.081a1.74 1.74 0 001.594.264l.339-.113a2.226 2.226 0 011.732.132c.555.284.965.773 1.153 1.378l.787 2.521c.38 1.218-.278 2.532-1.465 2.929l-.201.067a1.918 1.918 0 00-1.21 1.286 1.949 1.949 0 00.259 1.652l.26.375c.714 1.032.486 2.48-.508 3.229l-2.061 1.556a2.23 2.23 0 01-1.711.428 2.262 2.262 0 01-1.51-.957l-.117-.172c-.35-.504-.91-.81-1.497-.777a1.773 1.773 0 00-1.428.767l-.231.328a2.268 2.268 0 01-1.858.97zM12 10.5c-.827 0-1.5.673-1.5 1.5s.673 1.5 1.5 1.5 1.5-.673 1.5-1.5-.673-1.5-1.5-1.5zm0 5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-settings-2"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.374 20h1.252v-.767c0-.935.575-1.775 1.463-2.142.92-.383 1.926-.195 2.588.471l.538.541.889-.888-.546-.544c-.663-.662-.85-1.666-.477-2.557l.002-.002.01-.028a2.324 2.324 0 012.14-1.459H20v-1.25h-.767c-.934 0-1.776-.575-2.142-1.464-.385-.92-.196-1.925.47-2.588l.541-.539-.887-.887-.544.545c-.662.662-1.665.849-2.556.477-.914-.377-1.49-1.217-1.49-2.152V4h-1.25v.767c0 .935-.575 1.775-1.464 2.142-.92.385-1.924.196-2.587-.471l-.54-.541-.887.888.545.544c.662.662.85 1.666.477 2.557-.376.913-1.217 1.489-2.152 1.489H4v1.25h.767c.935 0 1.776.575 2.142 1.464.385.92.196 1.925-.47 2.588l-.541.539.887.887.545-.545c.662-.662 1.665-.849 2.556-.477.913.377 1.489 1.217 1.489 2.152V20zm1.569 2H11.05a1.678 1.678 0 01-1.675-1.676v-1.091c0-.147-.117-.248-.227-.293-.144-.059-.298-.071-.404.032l-.77.771a1.683 1.683 0 01-2.377 0l-1.34-1.34a1.67 1.67 0 01-.492-1.19c0-.449.176-.871.495-1.189l.768-.765c.105-.105.094-.259.047-.37-.06-.147-.16-.264-.308-.264H3.683A1.684 1.684 0 012 12.943v-1.892c0-.925.752-1.676 1.677-1.676h1.09c.147 0 .248-.118.293-.228.06-.144.072-.299-.032-.403l-.771-.77a1.685 1.685 0 010-2.377l1.34-1.34a1.667 1.667 0 011.188-.492h.002c.449 0 .872.175 1.189.494l.765.769c.105.106.26.094.37.047.147-.061.264-.161.264-.308V3.683c0-.928.755-1.683 1.682-1.683h1.893c.924 0 1.676.752 1.676 1.676v1.091c0 .147.117.248.226.293.146.06.3.073.405-.032l.77-.771a1.683 1.683 0 012.377 0l1.34 1.341c.319.317.492.739.491 1.189 0 .448-.174.871-.494 1.188l-.768.766c-.105.105-.095.259-.047.37.06.147.16.264.308.264h1.083c.928 0 1.683.754 1.683 1.682v1.892c0 .925-.752 1.676-1.677 1.676h-1.09c-.146 0-.248.118-.293.228l-.014.033c-.045.111-.057.266.047.37l.77.77a1.685 1.685 0 010 2.377l-1.34 1.34a1.667 1.667 0 01-1.188.492h-.002c-.448 0-.872-.175-1.189-.494l-.765-.769c-.104-.105-.26-.093-.37-.047-.146.061-.263.161-.263.308v1.084c0 .928-.755 1.683-1.683 1.683zM12 10.5c-.827 0-1.5.673-1.5 1.5s.673 1.5 1.5 1.5 1.5-.673 1.5-1.5-.673-1.5-1.5-1.5zm0 5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-shake"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 7.142A3.978 3.978 0 0012 7c-.347 0-.679.06-1 .142V3a1 1 0 112 0v4.142zM5.5 18a.996.996 0 01-.644-.235C2.692 15.943 1.5 13.541 1.5 11c0-2.54 1.192-4.943 3.356-6.765a1 1 0 111.289 1.53C4.439 7.2 3.5 9.06 3.5 11c0 1.94.939 3.8 2.645 5.235A1.001 1.001 0 015.5 18zm6.5-6a1.001 1.001 0 010-2 1.001 1.001 0 010 2zm0 3c-.347 0-.679-.059-1-.142V20a1 1 0 102 0v-5.142A3.978 3.978 0 0112 15zm3.235.645a1.003 1.003 0 001.41.12C18.163 14.485 19 12.793 19 11c0-1.793-.837-3.485-2.355-4.765a1.002 1.002 0 00-1.41.12 1.002 1.002 0 00.12 1.41C16.416 8.657 17 9.807 17 11s-.584 2.343-1.645 3.235a1.002 1.002 0 00-.12 1.41zM8 16a.996.996 0 01-.644-.235C5.836 14.485 5 12.793 5 11c0-1.793.837-3.485 2.356-4.765a1.001 1.001 0 011.289 1.53C7.584 8.657 7 9.807 7 11s.584 2.343 1.645 3.235A1.001 1.001 0 018 16zm9.735 1.644a.999.999 0 001.41.121C21.308 15.943 22.5 13.541 22.5 11c0-2.54-1.192-4.943-3.355-6.765a1 1 0 00-1.29 1.53C19.561 7.2 20.5 9.06 20.5 11c0 1.94-.939 3.8-2.645 5.235a1.001 1.001 0 00-.12 1.41z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-share"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 19a1 1 0 110-2 1 1 0 010 2zM5 13a1 1 0 110-2 1 1 0 010 2zm13-8a1 1 0 110 2 1 1 0 010-2zm0 10c-.817 0-1.557.33-2.099.861l-7.935-3.526C7.979 12.224 8 12.114 8 12c0-.114-.021-.224-.034-.335l7.935-3.526A2.991 2.991 0 0018 9c1.654 0 3-1.346 3-3s-1.346-3-3-3-3 1.346-3 3c0 .114.021.224.034.335L7.099 9.861A2.991 2.991 0 005 9c-1.654 0-3 1.346-3 3s1.346 3 3 3c.817 0 1.557-.33 2.099-.861l7.935 3.526c-.013.111-.034.221-.034.335 0 1.654 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-shield"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4.146L5 8.084v.145a13.16 13.16 0 006.698 11.454l.302.17.302-.17A13.16 13.16 0 0019 8.23v-.145l-7-3.938zm0 17.704c-.339 0-.678-.084-.979-.254l-.303-.17A15.158 15.158 0 013 8.228v-.145c0-.719.39-1.387 1.018-1.742l7.002-3.938a2.009 2.009 0 011.959 0L19.98 6.34A2.006 2.006 0 0121 8.084v.145a15.158 15.158 0 01-7.718 13.196l-.302.17c-.302.17-.641.255-.98.255z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-shield-off"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.98 2.404l7 3.938A2.004 2.004 0 0121 8.085v.145c0 2.787-.774 5.466-2.162 7.78l-1.465-1.466A13.126 13.126 0 0019 8.23v-.145l-7-3.938-3.215 1.809-1.47-1.468 3.705-2.084a2.013 2.013 0 011.96 0zm-8.273.889a.999.999 0 10-1.414 1.414l16 16a.997.997 0 001.414 0 .999.999 0 000-1.414l-16-16zm7.595 16.39l-.302.17-.302-.17A13.161 13.161 0 015 8.23v-.145l.164-.092L3.732 6.56A1.992 1.992 0 003 8.085v.145a15.159 15.159 0 007.718 13.196l.303.17a2.005 2.005 0 001.96-.001l.3-.17a15.056 15.056 0 003.048-2.267l-1.414-1.414a13.093 13.093 0 01-2.613 1.94z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-shopping-bag"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 11a1 1 0 00-1 1c0 1.103-.897 2-2 2s-2-.897-2-2a1 1 0 10-2 0c0 2.206 1.794 4 4 4s4-1.794 4-4a1 1 0 00-1-1zm3 8H6c-.552 0-1-.449-1-1V9h14v9c0 .551-.448 1-1 1zM8.121 5.293A1.01 1.01 0 018.828 5h6.344c.263 0 .52.107.707.293L17.586 7H6.414l1.707-1.707zm12 1.414l-2.828-2.828A2.978 2.978 0 0015.172 3H8.828c-.801 0-1.555.312-2.121.879L3.879 6.707A2.978 2.978 0 003 8.829V18c0 1.654 1.346 3 3 3h12c1.654 0 3-1.346 3-3V8.829c0-.802-.312-1.556-.879-2.122z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-shopping-cart"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 19.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm-10 0a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm7.382-5.5H8.764L7.127 8h12.255l-3 6zm4.701-7.052A1.986 1.986 0 0019.382 6h-12.8l-.617-2.263A1 1 0 005 3H3a1 1 0 100 2h1.236l2.799 10.263A1 1 0 008 16h9c.379 0 .725-.214.895-.553l3.276-6.553a1.988 1.988 0 00-.088-1.946z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-shuffle"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 10.308a1 1 0 01-1-1l-.001-1.893L5.707 19.707a.997.997 0 01-1.414 0 .999.999 0 010-1.414l6.287-6.287-5.832-5.831a.999.999 0 111.414-1.414l5.832 5.831 4.582-4.583L14.687 6a1 1 0 01-.995-1.005c.003-.552.477-.985 1.005-.995l4.305.021a1 1 0 01.995 1L20 9.307c0 .552-.447 1-.999 1.001H19zm0 3.371h.005A1 1 0 0120 14.684l-.021 4.208a.98.98 0 01-.98 1.108.168.168 0 01-.044-.008.226.226 0 00-.035-.008l-4.227.003a1 1 0 01-.001-2l1.879-.001-2.778-2.779a.999.999 0 111.414-1.414l2.783 2.783.01-1.902a1 1 0 011-.995z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-shuffle-2"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.709 14.294a.998.998 0 00-1.414-.003.999.999 0 00-.004 1.414l.293.295H16c-2.206 0-4-1.795-4-4 0-2.206 1.794-4 4-4h1.588l-.293.291a.999.999 0 101.41 1.417l2-1.99a.997.997 0 00.004-1.415l-2-2.009a.998.998 0 00-1.414-.003.999.999 0 00-.004 1.414l.293.295H16a5.995 5.995 0 00-5 2.69A5.995 5.995 0 006 6H4a1 1 0 100 2h2c2.206 0 4 1.794 4 4 0 2.205-1.794 4-4 4H4a1 1 0 100 2h2a5.996 5.996 0 005-2.69A5.996 5.996 0 0016 18h1.588l-.293.291a.999.999 0 101.41 1.417l2-1.99a.997.997 0 00.004-1.415l-2-2.009z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-skip"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 15.908V8.014l4.822 3.984-4.822 3.91zM16 6a1 1 0 00-1 1v3.818c-.047-.049-.088-.1-.142-.144L9.759 6.46a2.088 2.088 0 00-2.209-.259c-.648.306-1.05.913-1.05 1.586v8.426c0 .673.402 1.28 1.05 1.586.289.135.599.202.906.202a2.04 2.04 0 001.303-.462l5.1-4.213c.053-.044.094-.096.141-.145v3.82a1 1 0 102 0V7a1 1 0 00-1-1z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-skip-to-start"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 15.986l-4.822-3.983L15.5 8.092v7.894zm.95-9.785a2.085 2.085 0 00-2.209.26l-5.1 4.213c-.053.043-.094.096-.141.145V7a1 1 0 10-2 0v10a1 1 0 002 0v-3.819c.047.05.088.102.142.146l5.099 4.214a2.05 2.05 0 001.303.46c.307 0 .617-.067.906-.203.648-.304 1.05-.912 1.05-1.584V7.787c0-.673-.402-1.28-1.05-1.586z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-slash"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 12c0-1.846.635-3.542 1.688-4.897l11.209 11.209A7.948 7.948 0 0112 20c-4.411 0-8-3.589-8-8zm16 0a7.954 7.954 0 01-1.688 4.897L7.103 5.688A7.948 7.948 0 0112 4c4.411 0 8 3.589 8 8zM12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-smartphone"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 6h5a1 1 0 110 2h-5a1 1 0 110-2zm1 10.5a1.5 1.5 0 113.001.001A1.5 1.5 0 0110.5 16.5zM18 19a1 1 0 01-1 1H7a1 1 0 01-1-1V5a1 1 0 011-1h10a1 1 0 011 1v14zM17 2H7C5.346 2 4 3.346 4 5v14c0 1.654 1.346 3 3 3h10c1.654 0 3-1.346 3-3V5c0-1.654-1.346-3-3-3z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-speaker"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 19a1 1 0 01-1 1H7a1 1 0 01-1-1V5a1 1 0 011-1h10a1 1 0 011 1v14zM17 2H7C5.346 2 4 3.346 4 5v14c0 1.654 1.346 3 3 3h10c1.654 0 3-1.346 3-3V5c0-1.654-1.346-3-3-3zm-5 15c-.827 0-1.5-.673-1.5-1.5S11.173 14 12 14s1.5.673 1.5 1.5S12.827 17 12 17zm0-5c-1.93 0-3.5 1.57-3.5 3.5S10.07 19 12 19s3.5-1.57 3.5-3.5S13.93 12 12 12zm0-5a1 1 0 110 2 1 1 0 010-2zm0 4c1.654 0 3-1.346 3-3s-1.346-3-3-3-3 1.346-3 3 1.346 3 3 3z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-square"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 5c-.551 0-1 .449-1 1v12c0 .551.449 1 1 1h12c.551 0 1-.449 1-1V6c0-.551-.449-1-1-1H6zm12 16H6c-1.654 0-3-1.346-3-3V6c0-1.654 1.346-3 3-3h12c1.654 0 3 1.346 3 3v12c0 1.654-1.346 3-3 3z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-square-minus"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 11H9c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1zm4 7c0 .551-.448 1-1 1H6c-.552 0-1-.449-1-1V6c0-.551.448-1 1-1h12c.552 0 1 .449 1 1v12zM18 3H6C4.346 3 3 4.346 3 6v12c0 1.654 1.346 3 3 3h12c1.654 0 3-1.346 3-3V6c0-1.654-1.346-3-3-3z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-square-plus"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 11h-2V9c0-.55-.45-1-1-1s-1 .45-1 1v2H9c-.55 0-1 .45-1 1s.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1v-2h2c.55 0 1-.45 1-1s-.45-1-1-1zm4 7c0 .551-.448 1-1 1H6c-.552 0-1-.449-1-1V6c0-.551.448-1 1-1h12c.552 0 1 .449 1 1v12zM18 3H6C4.346 3 3 4.346 3 6v12c0 1.654 1.346 3 3 3h12c1.654 0 3-1.346 3-3V6c0-1.654-1.346-3-3-3z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-star"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 16.05c.159 0 .318.038.463.113l3.769 1.97-.717-4.157a.999.999 0 01.29-.89l3.036-2.935-4.203-.612a.999.999 0 01-.752-.544L12 5.2l-1.886 3.794a.999.999 0 01-.752.544l-4.203.612 3.036 2.936a.999.999 0 01.29.889l-.717 4.157 3.769-1.97c.145-.075.304-.113.463-.113zm5.561 4.905a.996.996 0 01-.462-.113l-5.1-2.664-5.098 2.664a1 1 0 01-1.448-1.057l.972-5.628-4.12-3.985a.998.998 0 01.55-1.708l5.702-.828 2.546-5.126c.338-.68 1.454-.68 1.793 0l2.546 5.126 5.701.828a.998.998 0 01.551 1.708l-4.12 3.985.973 5.628a1 1 0 01-.986 1.17z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-stop"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 14,
    height: 14,
    rx: 2,
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-stop-circle"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 14h4v-4h-4v4zm4.75-6h-5.5C8.561 8 8 8.561 8 9.25v5.5c0 .689.561 1.25 1.25 1.25h5.5c.689 0 1.25-.561 1.25-1.25v-5.5C16 8.561 15.439 8 14.75 8zM12 20c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8zm0-18C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-stop-simple"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 14,
    height: 14,
    rx: 2,
    fill: "#000018",
    fillOpacity: 0.84
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-strikethrough"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 12.203h18v1.5h-4.366c.237.497.357 1.042.35 1.593a3.25 3.25 0 01-1.315 2.7A5.551 5.551 0 0112.203 19a6.443 6.443 0 01-2.624-.539 4.463 4.463 0 01-1.892-1.488 3.668 3.668 0 01-.67-2.156v-.113h.287v-.001h.341v.001H9.02v.113a2.183 2.183 0 00.854 1.831 3.69 3.69 0 002.329.68 3.388 3.388 0 002.076-.547 1.734 1.734 0 00.701-1.466 1.696 1.696 0 00-.646-1.435 3.007 3.007 0 00-.275-.177H3v-1.5zM16.345 7.06a4.181 4.181 0 00-1.721-1.514A5.627 5.627 0 0012.11 5a5.16 5.16 0 00-3.364 1.062A3.363 3.363 0 007.44 8.77a3.23 3.23 0 00.322 1.427h2.596c-.083-.053-.185-.105-.252-.16a1.607 1.607 0 01-.653-1.3 1.798 1.798 0 01.688-1.511 3.13 3.13 0 011.97-.553 3.048 3.048 0 012.106.669 2.35 2.35 0 01.736 1.832v.114h2.003v-.114a3.9 3.9 0 00-.611-2.113z",
    fill: "#000018"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-substract"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 13H5a1 1 0 110-2h14a1 1 0 110 2z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-substract-circle"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 11H9c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1zm-3 9c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8zm0-18C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-sun"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 12c0-1.103-.897-2-2-2s-2 .897-2 2 .897 2 2 2 2-.897 2-2zm2 0c0 2.206-1.794 4-4 4s-4-1.794-4-4 1.794-4 4-4 4 1.794 4 4zm-9.73 4.143l-1.439 1.389a1 1 0 001.39 1.44l1.439-1.39a1 1 0 00-1.39-1.44zm11.46 0a1 1 0 00-1.39 1.439l1.439 1.39a1 1 0 001.39-1.44l-1.439-1.39zM12 18a1 1 0 00-1 1v2a1 1 0 102 0v-2a1 1 0 00-1-1zm5.035-9.862c.25 0 .501-.093.695-.28l1.439-1.39a1 1 0 00-1.39-1.44l-1.439 1.39a1 1 0 00.695 1.72zM6.221 5.028a1.002 1.002 0 00-1.39 1.44l1.439 1.39a.996.996 0 001.414-.026 1 1 0 00-.024-1.414l-1.439-1.39zM6 12a1 1 0 00-1-1H3a1 1 0 100 2h2a1 1 0 001-1zm15-1h-2a1 1 0 100 2h2a1 1 0 100-2zM11 5V3a1 1 0 112 0v2a1 1 0 11-2 0z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-swap"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 8H4a1 1 0 110-2h13.082l-1.558-1.21a1 1 0 011.227-1.58l3.862 3A1 1 0 0120.6 7.8l-4 3a.998.998 0 01-1.4-.2 1 1 0 01.2-1.4L17 8zM7 15h13a1 1 0 110 2H6.918l1.558 1.21a1 1 0 01-1.227 1.58l-3.862-3A1 1 0 013.4 15.2l4-3a1 1 0 111.2 1.6L7 15z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-swap-1"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 17V4a1 1 0 112 0v13.082l1.21-1.558a1 1 0 011.58 1.227l-3 3.862a1 1 0 01-1.59-.013l-3-4a.998.998 0 01.2-1.4 1 1 0 011.4.2L16 17zM9 7v13a1 1 0 11-2 0V6.918L5.79 8.476a1 1 0 01-1.58-1.227l3-3.862A1 1 0 018.8 3.4l3 4a1 1 0 11-1.6 1.2L9 7z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-sync"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.683 10.326l-.021.048a.641.641 0 00-.018.052c-.009.028-.017.056-.032.081a.8.8 0 01-.107.132l-.033.035c-.013.013-.023.026-.034.04-.015.02-.03.038-.048.054a.944.944 0 01-.186.11l-.013.006a.368.368 0 00-.04.023c-.018.012-.037.024-.057.031a.982.982 0 01-.507.048l-4.25-.705a1 1 0 11.327-1.972l1.644.272C17.063 6.395 14.686 5 12.07 5 9.11 5 6.504 6.718 5.427 9.375a.998.998 0 01-1.302.552.999.999 0 01-.551-1.302C4.958 5.208 8.293 3 12.07 3c3.412 0 6.513 1.87 8.078 4.788l.369-1.973a1 1 0 011.966.37l-.75 4a.607.607 0 01-.05.141zm-3.11 4.3a1 1 0 111.854.75C19.043 18.791 15.707 21 11.93 21c-3.412 0-6.513-1.87-8.078-4.788l-.37 1.972a.998.998 0 01-1.167.798.999.999 0 01-.798-1.167l.749-4a.447.447 0 01.04-.109c.01-.02.02-.04.029-.062l.021-.061c.015-.045.03-.09.056-.128.014-.023.034-.04.053-.06a.525.525 0 00.062-.066.799.799 0 01.155-.152c.005-.004.012-.007.02-.01l.017-.007a.949.949 0 01.316-.137.078.078 0 01.021 0h.019c.11-.019.22-.03.338-.01l4.25.706a1 1 0 11-.327 1.972l-1.644-.272C6.938 17.605 9.315 19 11.93 19c2.959 0 5.566-1.718 6.643-4.375z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 16 16",
    fill: "none",
    id: "sprite_svg__icon-light-talent"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.376 3.85l-1.079 1.043a.75.75 0 11-1.041-1.079l1.078-1.042a.75.75 0 011.042 1.078zM4.763 4.874a.748.748 0 01-1.06.02L2.623 3.85a.75.75 0 011.043-1.08l1.079 1.042a.75.75 0 01.018 1.061zM3.5 8a.75.75 0 01-.75.75h-1.5a.75.75 0 110-1.5h1.5A.75.75 0 013.5 8zm12 0a.75.75 0 01-.75.75h-1.5a.75.75 0 110-1.5h1.5a.75.75 0 01.75.75zM7.25 2.75v-1.5a.75.75 0 111.5 0v1.5a.75.75 0 11-1.5 0zm1.876 7.195a.751.751 0 00-.376.65V14h-1.5v-3.405a.751.751 0 00-.376-.65A2.247 2.247 0 018 5.75a2.247 2.247 0 011.126 4.195zM8 4.25A3.754 3.754 0 004.25 8c0 1.184.565 2.296 1.5 2.997V14c0 .827.673 1.5 1.5 1.5h1.5c.827 0 1.5-.673 1.5-1.5v-3.003c.934-.7 1.5-1.813 1.5-2.997A3.754 3.754 0 008 4.25z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-target"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.923 4.603a.961.961 0 00-.887-.598h-1.04V2.964a.942.942 0 00-.598-.887.966.966 0 00-1.051.212l-2.41 2.41a.954.954 0 00-.28.684v1.61l-.057.058a8.289 8.289 0 00-5.205-1.841C5.77 5.21 2 8.978 2 13.605S5.769 22 10.395 22c4.627 0 8.395-3.768 8.395-8.395a8.41 8.41 0 00-1.821-5.214l.048-.049h1.62c.25 0 .5-.106.683-.28l2.41-2.409a.978.978 0 00.193-1.05zm-3.171 1.291l-.52.52h-.646V5.77l.52-.52c.087.308.337.549.646.645zm-8.357 10.583a2.88 2.88 0 01-2.872-2.872 2.88 2.88 0 012.872-2.872c.434 0 .848.096 1.234.28L9.71 12.92a.96.96 0 000 1.359c.357.366 1.002.366 1.368 0l1.909-1.909a2.873 2.873 0 01-2.593 4.106zm2.458-6.699a4.485 4.485 0 00-2.458-.742 4.578 4.578 0 00-4.568 4.569 4.578 4.578 0 004.568 4.569 4.578 4.578 0 004.569-4.569c0-.877-.25-1.716-.742-2.468L15.59 9.77a6.465 6.465 0 011.263 3.836 6.475 6.475 0 01-6.468 6.467c-3.566 0-6.457-2.9-6.457-6.467a6.475 6.475 0 016.467-6.468c1.379 0 2.728.444 3.836 1.263l-1.378 1.378z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 16 16",
    fill: "none",
    id: "sprite_svg__icon-light-team"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.433 9.667a3.72 3.72 0 00-.92-1.707A2 2 0 0012 4.667a1.96 1.96 0 00-1.433.613 2.667 2.667 0 00-5.12 0A1.96 1.96 0 004 4.667 2 2 0 002.487 7.96a3.78 3.78 0 00-.907 1.707 1.333 1.333 0 001.333 1.653h1.2c0 .153-.06.307-.086.447a1.333 1.333 0 001.306 1.566h5.334A1.333 1.333 0 0012 12a3.34 3.34 0 00-.08-.667h1.227a1.333 1.333 0 001.286-1.666zM12 6a.667.667 0 110 1.333A.667.667 0 0112 6zm-1.807 1.513c.068.135.148.262.24.38l-.2.194a3.955 3.955 0 00-.32-.234 2.7 2.7 0 00.28-.34zM8 4.667a1.333 1.333 0 110 2.666 1.333 1.333 0 010-2.666zM5.78 8.093a2.122 2.122 0 00-.2-.2 1.84 1.84 0 00.24-.38c.082.121.173.235.273.34a2.78 2.78 0 00-.313.24zM4 6a.667.667 0 110 1.334A.667.667 0 014 6zm-1.24 4c.127-.573.447-1.333 1.267-1.333a1.06 1.06 0 01.88.44A6.386 6.386 0 004.5 10H2.76zm2.573 2C5.86 9.067 6.973 8.667 8 8.667c1.013 0 2.127.413 2.667 3.333H5.333zm6.2-2a5.139 5.139 0 00-.433-.853 1.08 1.08 0 01.9-.48c.813 0 1.133.733 1.26 1.333h-1.727z",
    fill: "#24BB72"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 12 12",
    fill: "none",
    id: "sprite_svg__icon-light-tecnologia-zonajobs"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.055 12v-1.367l1.218-.235V2.383h-2.07l-.125 1.36H.352V.624H10.5v3.117H8.766l-.125-1.36H6.555v8.016l1.226.235V12H3.055z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-text"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 4H4a1 1 0 00-1 1v3a1 1 0 102 0V6h6v13H9a1 1 0 100 2h6a1 1 0 100-2h-2V6h6v2a1 1 0 102 0V5a1 1 0 00-1-1z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-thermometer"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4c-.552 0-1 .449-1 1v8.54a.998.998 0 01-.502.867A2.997 2.997 0 0012 20a2.997 2.997 0 001.502-5.593.998.998 0 01-.502-.867V5a.965.965 0 00-.287-.694A.976.976 0 0012 4zm0 18c-2.757 0-5-2.243-5-5a5.01 5.01 0 012-3.997V5c0-1.654 1.346-3 3-3 .812 0 1.566.317 2.127.892C14.684 3.434 15 4.189 15 5v8.003A5.01 5.01 0 0117 17c0 2.757-2.243 5-5 5z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-thermometer-minus"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 5c0-.551.448-1 1-1 .267 0 .514.102.713.306A.965.965 0 0115 5v8.54c0 .358.191.689.502.867A2.997 2.997 0 0114 20a2.997 2.997 0 01-1.502-5.593.998.998 0 00.502-.867V5zM9 17c0 2.757 2.243 5 5 5s5-2.243 5-5a5.01 5.01 0 00-2-3.997V5c0-.811-.316-1.566-.873-2.108A2.944 2.944 0 0014 2c-1.654 0-3 1.346-3 3v8.003A5.01 5.01 0 009 17zM3 7h4c.55 0 1-.45 1-1s-.45-1-1-1H3c-.55 0-1 .45-1 1s.45 1 1 1z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-thermometer-plus"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 4c-.552 0-1 .449-1 1v8.54a.998.998 0 01-.502.867A2.997 2.997 0 0014 20a2.997 2.997 0 001.502-5.593.998.998 0 01-.502-.867V5a.965.965 0 00-.287-.694A.976.976 0 0014 4zm0 18c-2.757 0-5-2.243-5-5a5.01 5.01 0 012-3.997V5c0-1.654 1.346-3 3-3 .812 0 1.566.317 2.127.892C16.684 3.434 17 4.189 17 5v8.003A5.01 5.01 0 0119 17c0 2.757-2.243 5-5 5zM4 7H3c-.55 0-1-.45-1-1s.45-1 1-1h1V4c0-.55.45-1 1-1s1 .45 1 1v1h1c.55 0 1 .45 1 1s-.45 1-1 1H6v1c0 .55-.45 1-1 1s-1-.45-1-1V7z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-thumb-down"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.675 20.843A1.968 1.968 0 0012.472 22H13.8a1.958 1.958 0 001.966-1.949v-2.765c0-.21-.034-.417-.1-.616l-.325-1.24a.2.2 0 01.193-.25h4.499c1.202 0 2.123-1.06 1.945-2.238l-1.18-7.795a1.961 1.961 0 00-1.945-1.66h-7.074l-4.16.458A1.97 1.97 0 005.933 3H3.967A1.958 1.958 0 002 4.949v7.795c0 1.076.88 1.948 1.967 1.948h2.98l2.077 2.469 1.651 3.682zm-5.242-8.1a.5.5 0 00.5-.5V5.45a.5.5 0 00-.5-.5h-.966a.5.5 0 00-.5.5v6.795a.5.5 0 00.5.5h.966zM7.9 6.772a1 1 0 01.89-.994l3.098-.341h6.535a.5.5 0 01.494.425l1.029 6.795a.5.5 0 01-.494.575h-4.97c-1.007 0-1.295 1.002-.977 1.949l.59 1.948v2.423a.5.5 0 01-.5.5h-.934a.5.5 0 01-.463-.31l-1.377-3.372a1.946 1.946 0 00-.287-.456l-2.27-2.7a1.308 1.308 0 00-.126-.13c-.135-.121-.238-.283-.238-.463V6.77z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-thumb-up"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.675 4.157A1.968 1.968 0 0112.472 3H13.8c1.086 0 1.966.872 1.966 1.949v2.765c0 .21-.034.417-.1.616l-.325 1.24a.2.2 0 00.193.25h4.499c1.202 0 2.123 1.06 1.945 2.238l-1.18 7.795a1.961 1.961 0 01-1.945 1.66h-7.074l-4.16-.458A1.97 1.97 0 015.933 22H3.967A1.958 1.958 0 012 20.051v-7.795c0-1.076.88-1.948 1.967-1.948h2.98l2.077-2.469 1.651-3.682zm-5.242 8.1a.5.5 0 01.5.5v6.794a.5.5 0 01-.5.5h-.966a.5.5 0 01-.5-.5v-6.795a.5.5 0 01.5-.5h.966zM7.9 18.228a1 1 0 00.89.994l3.098.341h6.535a.5.5 0 00.494-.425l1.029-6.795a.5.5 0 00-.494-.575h-4.97c-1.007 0-1.295-1.002-.977-1.948l.59-1.95V5.45a.5.5 0 00-.5-.5h-.934a.5.5 0 00-.463.31L10.82 8.632c-.074.164-.17.318-.287.456l-2.27 2.7c-.04.046-.081.09-.126.13-.135.121-.238.283-.238.463v5.85z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 18 17",
    fill: "none",
    id: "sprite_svg__icon-light-thumbs-down"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.896 15.37c.263.586.85.964 1.498.964H10.5c.905 0 1.64-.728 1.64-1.624v-2.305a1.61 1.61 0 00-.085-.513l-.26-.992a.2.2 0 01.194-.25h3.705c1.002 0 1.77-.883 1.621-1.865l-.983-6.496a1.634 1.634 0 00-1.62-1.383H8.815l-3.466.382A1.641 1.641 0 003.945.5h-1.64C1.402.5.668 1.227.668 2.124V8.62c0 .897.734 1.624 1.639 1.624H4.79L6.52 12.3l1.376 3.068zM3.445 8.62a.5.5 0 00.5-.5V2.624a.5.5 0 00-.5-.5h-.64a.5.5 0 00-.5.5V8.12a.5.5 0 00.5.5h.64zm2.139-4.828a1 1 0 01.89-.994l2.433-.268h5.374a.5.5 0 01.494.425l.832 5.496a.5.5 0 01-.494.575H11.07c-.84 0-1.08.835-.815 1.624l.492 1.624v1.936a.5.5 0 01-.5.5h-.64a.5.5 0 01-.462-.311L8.018 11.64a1.622 1.622 0 00-.239-.38l-1.892-2.25a1.094 1.094 0 00-.07-.075c-.129-.127-.233-.287-.233-.468V3.792z",
    fill: "#666674"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 18 17",
    fill: "none",
    id: "sprite_svg__icon-light-thumbs-up"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.896 1.464A1.64 1.64 0 019.394.5H10.5c.905 0 1.64.727 1.64 1.624v2.304c0 .175-.03.348-.085.514l-.26.991a.2.2 0 00.194.25h3.705c1.002 0 1.77.884 1.621 1.866l-.983 6.495a1.634 1.634 0 01-1.62 1.383H8.815l-3.466-.381a1.64 1.64 0 01-1.405.787h-1.64A1.631 1.631 0 01.668 14.71V8.214c0-.897.734-1.624 1.639-1.624H4.79l1.73-2.057 1.376-3.069zm-4.451 6.75a.5.5 0 01.5.5v5.495a.5.5 0 01-.5.5h-.64a.5.5 0 01-.5-.5V8.714a.5.5 0 01.5-.5h.64zm2.139 4.828a1 1 0 00.89.994l2.433.267h5.374a.5.5 0 00.494-.425l.832-5.495a.5.5 0 00-.494-.575H11.07c-.84 0-1.08-.836-.815-1.624l.492-1.624V2.624a.5.5 0 00-.5-.5h-.64a.5.5 0 00-.462.31L8.018 5.193a1.622 1.622 0 01-.239.38l-1.892 2.25a1.094 1.094 0 01-.07.075c-.129.127-.233.288-.233.469v4.676z",
    fill: "#666674"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-timer"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 12h-2v-2a1 1 0 10-2 0v3a1 1 0 001 1h3a1 1 0 100-2zm-3 7.75A6.758 6.758 0 015.25 13 6.758 6.758 0 0112 6.25 6.758 6.758 0 0118.75 13 6.758 6.758 0 0112 19.75zm.988-15.692C12.99 4.037 13 4.021 13 4V3h1a1 1 0 100-2h-4a1 1 0 100 2h1v1c0 .021.01.037.012.058C6.513 4.552 3 8.372 3 13c0 4.963 4.038 9 9 9s9-4.037 9-9c0-4.628-3.513-8.448-8.012-8.942z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-toggle-left"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 13a1 1 0 110-2 1 1 0 010 2zm0-4c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3zm6 8H9c-2.757 0-5-2.243-5-5s2.243-5 5-5h6c2.757 0 5 2.243 5 5s-2.243 5-5 5zm0-12H9c-3.859 0-7 3.141-7 7s3.141 7 7 7h6c3.859 0 7-3.141 7-7s-3.141-7-7-7z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-toggle-right"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 13a1 1 0 110-2 1 1 0 010 2zm0-4c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3zm0 8H9c-2.757 0-5-2.243-5-5s2.243-5 5-5h6c2.757 0 5 2.243 5 5s-2.243 5-5 5zm0-12H9c-3.859 0-7 3.141-7 7s3.141 7 7 7h6c3.859 0 7-3.141 7-7s-3.141-7-7-7z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-trash-1"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 19c0 .551-.448 1-1 1H7c-.552 0-1-.449-1-1V8h12v11zM10 4.328c0-.155.214-.328.5-.328h3c.286 0 .5.173.5.328V6h-4V4.328zM21 6h-5V4.328C16 3.044 14.879 2 13.5 2h-3C9.121 2 8 3.044 8 4.328V6H3c-.55 0-1 .45-1 1s.45 1 1 1h1v11c0 1.654 1.346 3 3 3h10c1.654 0 3-1.346 3-3V8h1c.55 0 1-.45 1-1s-.45-1-1-1z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-trash-2"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 16c0 .55-.45 1-1 1s-1-.45-1-1v-4c0-.55.45-1 1-1s1 .45 1 1v4zm6 0c0 .55-.45 1-1 1s-1-.45-1-1v-4c0-.55.45-1 1-1s1 .45 1 1v4zm2 3c0 .551-.448 1-1 1H7c-.552 0-1-.449-1-1V8h12v11zM10 4.328c0-.155.214-.328.5-.328h3c.286 0 .5.173.5.328V6h-4V4.328zM20 6h-4V4.328C16 3.044 14.879 2 13.5 2h-3C9.121 2 8 3.044 8 4.328V6H3c-.55 0-1 .45-1 1s.45 1 1 1h1v11c0 1.654 1.346 3 3 3h10c1.654 0 3-1.346 3-3V8h1c.55 0 1-.45 1-1s-.45-1-1-1h-1z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-trending-down"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 12a1 1 0 10-2 0v2.297l-4.241-4.948a.999.999 0 00-1.274-.206L9.22 11.702 4.769 6.36A1.002 1.002 0 003.23 7.64l5 6a1 1 0 001.284.217l4.275-2.565L17.826 16H15a1 1 0 100 2h5a.978.978 0 00.364-.074c.049-.019.087-.051.132-.076.052-.031.108-.05.154-.091.01-.008.014-.02.023-.029.055-.05.093-.111.135-.172.033-.048.072-.09.095-.142.025-.053.033-.112.047-.169.019-.07.04-.138.042-.21 0-.013.008-.024.008-.037v-5z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-trending-up"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.992 6.963c-.002-.072-.023-.14-.042-.209-.015-.058-.022-.117-.047-.17-.023-.052-.062-.094-.096-.142-.042-.061-.08-.122-.134-.172-.009-.009-.013-.021-.023-.029-.036-.031-.08-.042-.119-.067-.06-.039-.119-.079-.187-.105-.067-.024-.133-.03-.202-.04C20.094 6.022 20.052 6 20 6h-5a1 1 0 100 2h2.826l-4.036 4.708-4.276-2.565a.997.997 0 00-1.283.217l-5 6a1 1 0 001.537 1.28l4.452-5.342 4.265 2.56a1 1 0 001.274-.207L19 9.703V12a1 1 0 102 0V7c0-.013-.007-.024-.008-.037z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-truck"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 18a1 1 0 11-2 0 1 1 0 012 0zm-7-3H4l.016-10H15l-.016 10H12zm-5 3a1 1 0 11-2 0 1 1 0 012 0zm13-5.52V15h-3v-4.919l3 2.4zm1.625-1.261L17 7.519V5c0-1.103-.813-2-1.813-2H3.812C2.813 3 2 3.897 2 5v10c0 .873.513 1.609 1.221 1.882C3.081 17.228 3 17.604 3 18c0 1.654 1.346 3 3 3s3-1.346 3-3c0-.353-.072-.686-.185-1h6.37A2.938 2.938 0 0015 18c0 1.654 1.346 3 3 3s3-1.346 3-3c0-.353-.072-.686-.185-1H21a1 1 0 001-1v-4a1 1 0 00-.375-.781z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-tv"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 19a1 1 0 01-1 1H6a1 1 0 01-1-1V9a1 1 0 011-1h12a1 1 0 011 1v10zM18 6h-3.586l2.293-2.293a.999.999 0 10-1.414-1.414L12 5.586 8.707 2.293a.999.999 0 10-1.414 1.414L9.586 6H6C4.346 6 3 7.346 3 9v10c0 1.654 1.346 3 3 3h12c1.654 0 3-1.346 3-3V9c0-1.654-1.346-3-3-3z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-twitter"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.016 6.654v.002-.002zM8.513 17.997c.024 0 .05.001.074.003 5.695-.037 9.094-4.388 9.094-8.594 0-.382.196-.629.37-.848.158-.2.403-.508.62-.952-.792-.008-1.5-.36-1.912-.842a2.453 2.453 0 00-1.718-.763 2.483 2.483 0 00-1.79.685 2.568 2.568 0 00-.725 2.428l.26 1.14-1.165.081c-3.016.226-5.106-1.065-6.541-2.4.006 2.02.677 4.714 3.727 6.452l.958.546-.637.901c-.663.94-1.661 1.538-2.677 1.921a8.85 8.85 0 002.049.242h.012zm0 2.003a1.07 1.07 0 01-.08-.003 10.915 10.915 0 01-4.655-1.083 1.376 1.376 0 01-.763-1.442 1.394 1.394 0 011.158-1.18c1.045-.173 1.912-.479 2.54-.888-3.877-2.899-3.775-7.239-3.524-9.077.074-.538.457-.987.975-1.144.526-.16 1.07 0 1.43.41 1.537 1.74 3.072 2.615 4.872 2.748a4.57 4.57 0 011.409-3.106 4.46 4.46 0 013.228-1.233 4.459 4.459 0 013.147 1.43c.084.096.398.27.777.1a1.393 1.393 0 011.474.195c.41.341.586.878.458 1.401a6.667 6.667 0 01-1.283 2.6C19.508 14.833 15.36 20 8.513 20z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-type-minus"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 11H3.38a1 1 0 100 2H8.5a1 1 0 000-2zM20.92 17.39L16.43 6.61A1.001 1.001 0 0015.5 6a1 1 0 00-.92.61l-4.5 10.78a1 1 0 00.54 1.31 1 1 0 00.38.07 1 1 0 00.92-.61l1.25-3h4.66l1.25 3a1 1 0 00.92.61 1 1 0 00.38-.07 1.002 1.002 0 00.54-1.31zM14 13.19l1.5-3.6 1.5 3.6h-3z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-type-plus"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 11.58a1 1 0 00-1-1H6.94V9a1 1 0 10-2 0v1.56H3.38a1 1 0 000 2h1.56v1.56a1 1 0 102 0v-1.54H8.5a1 1 0 001-1zM20.931 17.712L16.285 6.525A.847.847 0 0015.498 6a.974.974 0 00-.787.525l-4.645 11.187a.846.846 0 00.457 1.109c.102.04.211.06.321.059a.846.846 0 00.779-.516l1.337-3.208h5.077l1.337 3.216a.846.846 0 00.779.516c.11.002.22-.019.321-.059a.846.846 0 00.457-1.117zm-7.269-4.231l1.836-4.418 1.837 4.4-3.673.018z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-umbrella"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.063 11c.493-3.94 3.865-7 7.936-7 4.074 0 7.446 3.06 7.938 7H4.063zm7.936-9C6.487 2 2 6.486 2 12a1 1 0 001.002 1h7.998v6c0 1.654 1.346 3 3.002 3 1.654 0 3-1.346 3-3a1 1 0 10-2 0 1.001 1.001 0 01-2 0v-6H21a1 1 0 001-1c0-5.514-4.486-10-10-10z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-underline"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 20v2H5v-2h14zm-3-6.785a4 4 0 01-5.74 3.4A3.75 3.75 0 018 13.085v-8.08H6v8.21a6 6 0 008 5.44 5.85 5.85 0 004-5.65v-8h-2v8.21zM16 5h2-2zM8 5H6h2z",
    fill: "#000018"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-undo"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.454 11.5c3.563 0 6.777 1.634 8.81 4.259-.935-3.87-4.53-6.76-8.81-6.76a1 1 0 01-1-1V6.078L4.63 10.25l4.824 4.212V12.5a1 1 0 011-1zm9.767 9.5a1 1 0 01-.972-.763c-.89-3.649-4.021-6.285-7.795-6.684v1.121c0 .706-.419 1.335-1.093 1.64a2.032 2.032 0 01-2.177-.304l-5.066-4.424A1.782 1.782 0 012.5 10.25c0-.505.225-.992.618-1.336L8.184 4.49a2.032 2.032 0 012.177-.304c.674.305 1.093.934 1.093 1.64v1.218C17.078 7.537 21.5 12.15 21.5 17.75c0 .81-.104 1.646-.308 2.486a.997.997 0 01-.971.764z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-unpublish"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.707 7.293a.999.999 0 00-1.414 0L12 8.586l-1.293-1.293a.999.999 0 10-1.414 1.414L10.586 10l-1.293 1.293a.999.999 0 101.414 1.414L12 11.414l1.293 1.293a.997.997 0 001.414 0 .999.999 0 000-1.414L13.414 10l1.293-1.293a.999.999 0 000-1.414z",
    fill: "#29293D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 14c0 .551-.448 1-1 1H5c-.552 0-1-.449-1-1V6c0-.551.448-1 1-1h14c.552 0 1 .449 1 1v8zM19 3H5C3.346 3 2 4.346 2 6v8c0 1.654 1.346 3 3 3h6v2H7c-.55 0-1 .45-1 1s.45 1 1 1h10c.55 0 1-.45 1-1s-.45-1-1-1h-4v-2h6c1.654 0 3-1.346 3-3V6c0-1.654-1.346-3-3-3z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-updated"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.535 4.27A10.12 10.12 0 0111.836 2c2.3-.02 4.537.741 6.34 2.158a9.99 9.99 0 013.574 5.628 9.933 9.933 0 01-.775 6.609 10.04 10.04 0 01-4.782 4.663 10.144 10.144 0 01-6.67.653 1 1 0 11.48-1.943 8.116 8.116 0 005.337-.522 8.032 8.032 0 003.825-3.73 7.946 7.946 0 00.62-5.287 7.992 7.992 0 00-2.859-4.503A8.098 8.098 0 0011.854 4a8.097 8.097 0 00-5.041 1.815 7.99 7.99 0 00-2.778 4.553 7.94 7.94 0 00-.076 2.848l.21-.577a1.01 1.01 0 011.288-.602c.524.186.796.76.608 1.279l-1.01 2.788a1.212 1.212 0 01-1.678.667l-2.82-1.399a.997.997 0 01-.45-1.342 1.01 1.01 0 011.351-.447l.57.283a9.926 9.926 0 01.035-3.906 9.988 9.988 0 013.472-5.69z",
    fill: "#29293D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.91 6.92c0-.553-.451-1-1.007-1-.557 0-1.008.447-1.008 1v5.097c0 .634.286 1.233.777 1.635l3.015 2.475a1.013 1.013 0 001.419-.133.995.995 0 00-.135-1.408l-3.015-2.475a.121.121 0 01-.046-.094V6.92z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-upload"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 4h14c.55 0 1 .45 1 1v2c0 .55-.45 1-1 1s-1-.45-1-1V6H6v1c0 .55-.45 1-1 1s-1-.45-1-1V5c0-.55.45-1 1-1zm3.001 10a1 1 0 01-.601-1.8l4-3a1 1 0 011.175-.018l4 2.814a1 1 0 11-1.15 1.636l-2.428-1.708c.002.025.003.05.003.076v8a1 1 0 11-2 0v-8l-2.4 1.8c-.18.135-.39.2-.599.2z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-upload-2"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 21h14c.55 0 1-.45 1-1v-2c0-.55-.45-1-1-1s-1 .45-1 1v1H6v-1c0-.55-.45-1-1-1s-1 .45-1 1v2c0 .55.45 1 1 1zM8.001 9A1 1 0 017.4 7.2l4-3a1 1 0 011.175-.018l4 2.814a1 1 0 11-1.15 1.636l-2.428-1.708C13 6.95 13 6.974 13 7v8a1 1 0 11-2 0V7L8.6 8.8c-.18.135-.39.2-.599.2z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 20 20",
    fill: "none",
    id: "sprite_svg__icon-light-user-circle"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 11.548a2.86 2.86 0 002.857-2.857A2.86 2.86 0 0010 5.833a2.86 2.86 0 00-2.857 2.858A2.86 2.86 0 0010 11.548z",
    fill: "#E90066"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 3.333A6.674 6.674 0 003.334 10 6.674 6.674 0 0010 16.666 6.674 6.674 0 0016.667 10 6.674 6.674 0 0010 3.333zm0 15c-4.595 0-8.333-3.738-8.333-8.333 0-4.595 3.738-8.333 8.333-8.333 4.595 0 8.334 3.738 8.334 8.333 0 4.595-3.739 8.333-8.334 8.333z",
    fill: "#E90066"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 17.857c.395 0 5-1.19 4.995-1.19 0-2.758-2.238-4.524-4.995-4.524-2.756 0-4.994 1.766-4.994 4.523-.006 0 5.016 1.19 5.411 1.19H10z",
    fill: "#E90066"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-verified"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.875 12.324a.506.506 0 000-.666l-2.042-2.33a.506.506 0 01-.124-.38l.285-3.079a.506.506 0 00-.393-.54l-3.018-.684a.507.507 0 01-.324-.236l-1.58-2.66a.508.508 0 00-.638-.208L12.2 2.76a.508.508 0 01-.4 0L8.957 1.54a.508.508 0 00-.637.207l-1.58 2.66a.508.508 0 01-.325.237L3.4 5.32a.507.507 0 00-.394.54l.284 3.088a.506.506 0 01-.123.38l-2.042 2.33a.506.506 0 000 .666l2.042 2.329a.506.506 0 01.123.38l-.284 3.089a.507.507 0 00.393.54l3.017.684c.137.03.254.116.325.236l1.58 2.669c.13.22.403.309.638.207l2.84-1.225a.508.508 0 01.402 0l2.84 1.217c.235.1.508.012.637-.207l1.58-2.661a.507.507 0 01.325-.236l3.018-.684a.506.506 0 00.393-.54l-.285-3.08a.505.505 0 01.123-.379l2.043-2.34zm-3.719 1.165l-.427.495a.506.506 0 00-.12.379l.06.646.142 1.532a.507.507 0 01-.393.54l-2.135.483a.508.508 0 00-.324.235l-.335.562-.778 1.317a.508.508 0 01-.639.207l-1.395-.602-.612-.26a.509.509 0 00-.4.001l-.602.259-1.397.603a.508.508 0 01-.638-.207l-.777-1.307-.335-.563a.508.508 0 00-.325-.235l-2.134-.482a.507.507 0 01-.394-.54l.142-1.543.061-.646a.506.506 0 00-.12-.378l-.428-.495-1.017-1.156a.506.506 0 010-.667l1.017-1.165.426-.493a.506.506 0 00.12-.383l-.069-.654L5.19 7.45a.507.507 0 01.393-.54l2.134-.483a.508.508 0 00.325-.235l.335-.562.777-1.317c.13-.22.404-.309.639-.207l1.396.602.612.26a.508.508 0 00.4-.001l.602-.259 1.395-.602a.508.508 0 01.64.207l.777 1.317.335.562c.071.12.188.205.324.235l2.134.482a.507.507 0 01.394.54l-.142 1.533-.061.647a.506.506 0 00.12.378l.428.495 1.018 1.157c.167.19.168.474.002.665l-1.01 1.165z",
    fill: "#29293D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.05 8.349l-4.268 5.033-1.841-2.113c-.384-.442-1.094-.519-1.584-.173-.49.344-.577.981-.193 1.42l2.742 3.148c.214.245.541.388.889.388h.008c.348-.001.677-.149.888-.4l5.153-6.077c.378-.445.282-1.08-.214-1.419-.497-.34-1.203-.252-1.58.193z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-video"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 14.6L17.191 12 20 9.4v5.2zM15 16a1 1 0 01-1 1H5a1 1 0 01-1-1V8c0-.551.448-1 1-1h9c.552 0 1 .449 1 1v8zm6.012-8.854a1.717 1.717 0 00-1.851.306l-2.161 2V8c0-1.654-1.346-3-3-3H5C3.346 5 2 6.346 2 8v8c0 1.654 1.346 3 3 3h9c1.654 0 3-1.346 3-3v-1.451l2.161 1.998c.32.297.735.453 1.158.453.234 0 .469-.047.693-.145.609-.267.988-.835.988-1.485V8.63c0-.65-.379-1.218-.988-1.484z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-video-off"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 9.4L17.191 12 20 14.6V9.4zm2-.77v6.74c0 .65-.379 1.219-.988 1.485a1.689 1.689 0 01-1.294.035L15 12.17v-4.17a1 1 0 00-1-1H9.828l-2-2H14c1.654 0 3 1.344 3 3v1.45l2.161-2a1.719 1.719 0 011.851-.306c.609.266.988.835.988 1.484zM14 17H5c-.552 0-1-.448-1-1V8c0-.32.161-.592.396-.776L2.974 5.802A2.985 2.985 0 002 8v8c0 1.653 1.346 3 3 3h9c.616 0 1.188-.189 1.665-.508l-1.522-1.522c-.049.008-.092.03-.143.03zm6.707 2.294a.999.999 0 11-1.414 1.413L16.386 17.8l-1.455-1.454L5.586 7l-1.76-1.76-.533-.533a.999.999 0 111.414-1.414L6.414 5l2 2L15 13.586l2 2 3.707 3.708z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-voice-message"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 14c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zM4 12c0-1.103.897-2 2-2s2 .897 2 2-.897 2-2 2-2-.897-2-2zm14-4c-2.206 0-4 1.794-4 4 0 .731.212 1.409.557 2H9.443A3.953 3.953 0 0010 12c0-2.206-1.794-4-4-4s-4 1.794-4 4 1.794 4 4 4h12c2.206 0 4-1.794 4-4s-1.794-4-4-4z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-volume"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 14.429h4.333c.202 0 .399.062.566.175L16 18.102V5.899l-5.101 3.498a1.011 1.011 0 01-.566.175H6v4.857zm11 6.57a.992.992 0 01-.565-.174l-6.412-4.396H5a1 1 0 01-1-1V8.572a1 1 0 011-1h5.023l6.412-4.397A.999.999 0 0118 4v16a1.001 1.001 0 01-1 1z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-volume-low"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 5.899L8.899 9.397a1.011 1.011 0 01-.566.175H4v4.857h4.333c.202 0 .399.062.566.175L14 18.102V5.899zM16 4v16a1 1 0 01-1.565.825l-6.412-4.397H3a1 1 0 01-1-1V8.572a1 1 0 011-1h5.023l6.412-4.397A1 1 0 0116 4zm3.779 11.627a.998.998 0 01-1.406.152 1 1 0 01-.152-1.406c1.035-1.287 1.035-3.46 0-4.746a1.002 1.002 0 01.152-1.407 1.002 1.002 0 011.406.153c1.637 2.034 1.637 5.219 0 7.254z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-volume-off"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 10.671V5.898L10.668 7.84 9.229 6.401l4.706-3.227A1 1 0 0115.5 4v8.671l-2-2zM4.707 3.293a.999.999 0 10-1.414 1.414l16 16a.997.997 0 001.414 0 .999.999 0 000-1.414l-16-16zm12.204 10.789l1.438 1.439c1.558-2.038 1.54-5.147-.07-7.148a1 1 0 00-1.559 1.254c.964 1.196 1.019 3.15.19 4.455zm2.311 2.312C20.37 15.12 21 13.599 21 12c0-1.964-.937-3.82-2.638-5.23a1 1 0 011.276-1.541C21.806 7.025 23 9.43 23 11.999c0 2.138-.837 4.156-2.363 5.81l-1.415-1.415zM13.5 18.102l-5.101-3.498a1.011 1.011 0 00-.566-.175H3.5V9.572h3.243l-2-2H2.5a1 1 0 00-1 1v6.857a1 1 0 001 1h5.023l6.412 4.397a.998.998 0 001.031.058A1 1 0 0015.5 20v-1.672l-2-2v1.774z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-volume-up"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 5.899L7.899 9.397a1.011 1.011 0 01-.566.175H3v4.857h4.333c.202 0 .399.062.566.175L13 18.102V5.899zM15 4v16a1 1 0 01-1.565.825l-6.412-4.397H2a1 1 0 01-1-1V8.572a1 1 0 011-1h5.023l6.412-4.397A1 1 0 0115 4zm4.138 1.229a1 1 0 10-1.276 1.54C19.563 8.18 20.5 10.038 20.5 12c0 1.964-.937 3.82-2.638 5.23a1 1 0 001.276 1.54c2.168-1.795 3.362-4.2 3.362-6.77 0-2.57-1.194-4.974-3.362-6.77zm-1.359 10.398a.998.998 0 01-1.406.152 1 1 0 01-.152-1.406c1.035-1.287 1.035-3.46 0-4.746a1.002 1.002 0 01.152-1.407 1.002 1.002 0 011.406.153c1.637 2.034 1.637 5.219 0 7.254z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-weight"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 19c0 .552-.449 1-1 1H6c-.551 0-1-.448-1-1V8c0-.552.449-1 1-1h1c0 2.757 2.243 5 5 5s5-2.243 5-5h1c.551 0 1 .448 1 1v11zM11 4.172V6a1 1 0 102 0V4.172a3 3 0 011.907 2.1c.063.22.093.46.093.728 0 1.654-1.346 3-3 3S9 8.654 9 7c0-.262.031-.495.091-.712l.007-.035.004-.015A2.975 2.975 0 0111 4.172zM18 5h-1.422A4.983 4.983 0 0012 2a4.984 4.984 0 00-4.58 3H6C4.346 5 3 6.346 3 8v11c0 1.654 1.346 3 3 3h12c1.654 0 3-1.346 3-3V8c0-1.654-1.346-3-3-3z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-whatsapp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.008 22l1.411-5.136a9.86 9.86 0 01-1.327-4.955C2.094 6.446 6.558 2 12.042 2a9.906 9.906 0 017.039 2.907 9.834 9.834 0 012.911 7.011c-.002 5.465-4.466 9.91-9.95 9.91a9.987 9.987 0 01-4.759-1.206L2.008 22zm5.52-3.172c1.402.829 2.74 1.325 4.51 1.326 4.559 0 8.272-3.695 8.274-8.237.002-4.552-3.694-8.242-8.267-8.244-4.561 0-8.272 3.695-8.273 8.237-.001 1.854.544 3.242 1.46 4.695l-.835 3.04 3.13-.817zm9.526-4.554c-.062-.103-.227-.165-.477-.289-.248-.124-1.47-.723-1.699-.806-.227-.082-.393-.124-.56.124-.165.248-.642.806-.787.971-.145.165-.29.186-.539.062-.248-.124-1.05-.385-2-1.23-.738-.656-1.237-1.467-1.382-1.715-.145-.248-.015-.382.109-.505.112-.111.248-.29.373-.434.126-.144.167-.247.25-.413.083-.165.042-.31-.02-.434-.063-.123-.56-1.343-.767-1.838-.202-.483-.407-.418-.56-.425l-.476-.009a.913.913 0 00-.663.31c-.227.249-.87.847-.87 2.066 0 1.22.891 2.397 1.015 2.562.125.165 1.753 2.666 4.247 3.739.593.255 1.056.407 1.417.522.596.188 1.138.161 1.566.098.478-.07 1.471-.6 1.679-1.177.207-.58.207-1.075.144-1.179z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-wifi-off"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.436 11.023L10.544 9.13 8.082 6.667l-1.55-1.55-1.825-1.824a1 1 0 10-1.415 1.414l1.376 1.376 1.461 1.46 2.234 2.234 1.546 1.546 2.74 2.74 2.792 2.792 3.851 3.852a1 1 0 001.415-1.413l-8.27-8.271zM12 18a1 1 0 100 2 1 1 0 000-2zm0-14a13.93 13.93 0 019.724 3.93 1 1 0 01-1.389 1.437A11.947 11.947 0 0012 6c-.963 0-1.908.127-2.823.347L7.56 4.732A14.018 14.018 0 0111.999 4zM3.823 6.653c-.539.39-1.062.807-1.549 1.276a1 1 0 001.39 1.439 12.075 12.075 0 011.591-1.284L3.824 6.653zm13.931 6.79a.998.998 0 01-.72-.305 6.999 6.999 0 00-2.849-1.78l-2.349-2.35c.025 0 .05-.002.075-.004.03-.002.059-.004.088-.004a9.047 9.047 0 016.474 2.748 1 1 0 01-.719 1.695zM7.432 10.26a8.913 8.913 0 00-1.906 1.488 1 1 0 001.439 1.39 6.99 6.99 0 011.94-1.404L7.433 10.26zm1.07 6.557a1 1 0 01.025-1.414 4.956 4.956 0 012.717-1.33l2.517 2.517c-1.142-.815-2.82-.738-3.845.251a.998.998 0 01-1.414-.024z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-wifi-on"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4a13.93 13.93 0 019.725 3.93 1 1 0 01-1.39 1.437A11.947 11.947 0 0012 6a11.947 11.947 0 00-8.336 3.367.998.998 0 11-1.388-1.438A13.93 13.93 0 0112 4zm0 5a9.047 9.047 0 00-6.475 2.748 1 1 0 001.44 1.39A7.03 7.03 0 0112 11a7.03 7.03 0 015.035 2.138.998.998 0 001.414.024 1 1 0 00.026-1.414A9.047 9.047 0 0012 9zm-3.473 6.403A4.978 4.978 0 0112 14c1.303 0 2.536.499 3.473 1.403a1 1 0 01-1.389 1.439c-1.125-1.086-3.043-1.086-4.168 0a1 1 0 11-1.389-1.439zM11 19a1 1 0 112 0 1 1 0 01-2 0z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-world"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2c-2.76 0-5.117.977-7.07 2.93C2.977 6.883 2 9.24 2 12c0 2.76.977 5.117 2.93 7.07C6.883 21.023 9.24 22 12 22c2.76 0 5.117-.977 7.07-2.93C21.023 17.117 22 14.76 22 12c0-2.76-.977-5.117-2.93-7.07C17.117 2.977 14.76 2 12 2zM6.258 14.93c.547 1.38.82 2.63.82 3.75-1.042-.73-1.868-1.686-2.48-2.871A8.18 8.18 0 013.68 12c0-2.682 1.054-4.844 3.164-6.484.468.364.898.84 1.289 1.425.39.586.573 1.14.547 1.66-.104.808-.638 1.602-1.602 2.383a3.97 3.97 0 00-.996 1.856c-.17.716-.11 1.413.176 2.09zM20.32 12c0 2.292-.814 4.251-2.441 5.879C16.25 19.506 14.292 20.32 12 20.32a8.024 8.024 0 01-3.242-.664c.13-1.692-.209-3.463-1.016-5.312-.286-.886-.117-1.589.508-2.11 1.302-1.302 1.992-2.46 2.07-3.476.157-1.406-.508-2.826-1.992-4.258 1.016-.547 2.24-.82 3.672-.82.677 0 1.315.078 1.914.234l-1.68 1.68a.829.829 0 000 1.172l1.6 1.599a1 1 0 00.568.283l5.528.774c.26.911.39 1.77.39 2.578zm-5.082-4.878a.966.966 0 01-.548-1.64l.982-.982c1.432.677 2.565 1.732 3.398 3.164l-3.832-.542zm-2.73 3.472l-.664.976c-.521.834-.586 1.667-.196 2.5l.307.682a1 1 0 01.067.206l.564 2.706c.078.599.55.9 1.094 1.172a.87.87 0 00.39.078c.39 0 .755-.143 1.094-.43l.858-.822a.64.64 0 00.175-.295c.37-1.365.788-2.3 1.251-2.805a1.04 1.04 0 01.13-.113c.646-.504.818-1.372.516-2.605-.183-.703-.664-1.211-1.446-1.524l-1.847-.76a.79.79 0 00-.301-.06c-.912 0-1.575.365-1.992 1.094zm.742 1.914l.664-1.016a.524.524 0 01.34-.292.563.563 0 01.328.036l1.52.53c.208.104.312.208.312.312.03.103.05.248.063.434.022.316-.142.609-.354.845-.55.613-1.059 1.662-1.524 3.147a.28.28 0 01-.544-.034l-.35-1.983a1 1 0 00-.09-.273l-.443-.886c-.156-.234-.13-.508.078-.82z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-zoom-in"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 10h-1V9c0-.55-.45-1-1-1s-1 .45-1 1v1H9c-.55 0-1 .45-1 1s.45 1 1 1h1v1c0 .55.45 1 1 1s1-.45 1-1v-1h1c.55 0 1-.45 1-1s-.45-1-1-1z",
    fill: "#29293D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.326 15.899l5.38 5.38a1.009 1.009 0 01-1.427 1.426l-5.38-5.38a8 8 0 111.426-1.426zM11 16.999a6 6 0 100-12 6 6 0 000 12z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sprite_svg__icon-light-zoom-out"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 10H9c-.55 0-1 .45-1 1s.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1z",
    fill: "#29293D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.326 15.899l5.38 5.38a1.009 1.009 0 01-1.427 1.426l-5.38-5.38a8 8 0 111.426-1.426zM11 16.999a6 6 0 100-12 6 6 0 000 12z",
    fill: "#29293D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "sprite_svg__icon-light-blog_clip0_2626_244281"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h80v62H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "sprite_svg__icon-light-briefcase-2_clip0_2636_244442"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h76.06v62H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "sprite_svg__icon-light-cvs_clip0_2637_244462"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h79.44v60.96H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "sprite_svg__icon-light-graph-up_clip0_2332_255103"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.736)",
    d: "M0 0h72.528v62H0z"
  })), /*#__PURE__*/React.createElement("style", null, ".sprite_svg__sprite-symbol-usage{display:none}.sprite_svg__sprite-symbol-usage:target{display:inline}"))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-add-circle-usage",
    xlinkHref: "#sprite_svg__icon-bold-add-circle",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-add-square-usage",
    xlinkHref: "#sprite_svg__icon-bold-add-square",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-alert-circle-usage",
    xlinkHref: "#sprite_svg__icon-bold-alert-circle",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-alert-triangle-usage",
    xlinkHref: "#sprite_svg__icon-bold-alert-triangle",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-archive-usage",
    xlinkHref: "#sprite_svg__icon-bold-archive",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-arrow-circle-down-usage",
    xlinkHref: "#sprite_svg__icon-bold-arrow-circle-down",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-arrow-circle-left-usage",
    xlinkHref: "#sprite_svg__icon-bold-arrow-circle-left",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-arrow-circle-right-usage",
    xlinkHref: "#sprite_svg__icon-bold-arrow-circle-right",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-arrow-circle-up-usage",
    xlinkHref: "#sprite_svg__icon-bold-arrow-circle-up",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-arrow-triangle-down-usage",
    xlinkHref: "#sprite_svg__icon-bold-arrow-triangle-down",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use11 || (_use11 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-arrow-triangle-left-usage",
    xlinkHref: "#sprite_svg__icon-bold-arrow-triangle-left",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use12 || (_use12 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-arrow-triangle-right-usage",
    xlinkHref: "#sprite_svg__icon-bold-arrow-triangle-right",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use13 || (_use13 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-arrow-triangle-up-usage",
    xlinkHref: "#sprite_svg__icon-bold-arrow-triangle-up",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use14 || (_use14 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-at-usage",
    xlinkHref: "#sprite_svg__icon-bold-at",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use15 || (_use15 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-award-usage",
    xlinkHref: "#sprite_svg__icon-bold-award",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use16 || (_use16 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-backspace-usage",
    xlinkHref: "#sprite_svg__icon-bold-backspace",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use17 || (_use17 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-battery-charging-usage",
    xlinkHref: "#sprite_svg__icon-bold-battery-charging",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use18 || (_use18 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-battery-full-usage",
    xlinkHref: "#sprite_svg__icon-bold-battery-full",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use19 || (_use19 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-behance-usage",
    xlinkHref: "#sprite_svg__icon-bold-behance",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use20 || (_use20 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-book-usage",
    xlinkHref: "#sprite_svg__icon-bold-book",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use21 || (_use21 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-book-open-usage",
    xlinkHref: "#sprite_svg__icon-bold-book-open",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use22 || (_use22 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-bookmark-usage",
    xlinkHref: "#sprite_svg__icon-bold-bookmark",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use23 || (_use23 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-briefcase-usage",
    xlinkHref: "#sprite_svg__icon-bold-briefcase",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use24 || (_use24 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-browser-usage",
    xlinkHref: "#sprite_svg__icon-bold-browser",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use25 || (_use25 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-brush-usage",
    xlinkHref: "#sprite_svg__icon-bold-brush",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use26 || (_use26 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-bulb-usage",
    xlinkHref: "#sprite_svg__icon-bold-bulb",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use27 || (_use27 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-calendar-usage",
    xlinkHref: "#sprite_svg__icon-bold-calendar",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use28 || (_use28 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-camera-usage",
    xlinkHref: "#sprite_svg__icon-bold-camera",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use29 || (_use29 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-car-usage",
    xlinkHref: "#sprite_svg__icon-bold-car",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use30 || (_use30 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-chat-bouble-circle-usage",
    xlinkHref: "#sprite_svg__icon-bold-chat-bouble-circle",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use31 || (_use31 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-chat-bouble-square-usage",
    xlinkHref: "#sprite_svg__icon-bold-chat-bouble-square",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use32 || (_use32 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-checkmark-active-usage",
    xlinkHref: "#sprite_svg__icon-bold-checkmark-active",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use33 || (_use33 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-checkmark-circle-usage",
    xlinkHref: "#sprite_svg__icon-bold-checkmark-circle",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use34 || (_use34 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-checkmark-circle-1-usage",
    xlinkHref: "#sprite_svg__icon-bold-checkmark-circle-1",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use35 || (_use35 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-clipboard-usage",
    xlinkHref: "#sprite_svg__icon-bold-clipboard",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use36 || (_use36 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-clock-usage",
    xlinkHref: "#sprite_svg__icon-bold-clock",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use37 || (_use37 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-close-circle-usage",
    xlinkHref: "#sprite_svg__icon-bold-close-circle",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use38 || (_use38 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-close-square-usage",
    xlinkHref: "#sprite_svg__icon-bold-close-square",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use39 || (_use39 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-color-palette-usage",
    xlinkHref: "#sprite_svg__icon-bold-color-palette",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use40 || (_use40 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-color-picker-usage",
    xlinkHref: "#sprite_svg__icon-bold-color-picker",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use41 || (_use41 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-compass-usage",
    xlinkHref: "#sprite_svg__icon-bold-compass",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use42 || (_use42 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-copy-usage",
    xlinkHref: "#sprite_svg__icon-bold-copy",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use43 || (_use43 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-credit-card-usage",
    xlinkHref: "#sprite_svg__icon-bold-credit-card",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use44 || (_use44 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-cube-usage",
    xlinkHref: "#sprite_svg__icon-bold-cube",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use45 || (_use45 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-download-usage",
    xlinkHref: "#sprite_svg__icon-bold-download",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use46 || (_use46 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-droplet-off-usage",
    xlinkHref: "#sprite_svg__icon-bold-droplet-off",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use47 || (_use47 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-droplet-on-usage",
    xlinkHref: "#sprite_svg__icon-bold-droplet-on",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use48 || (_use48 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-edit-usage",
    xlinkHref: "#sprite_svg__icon-bold-edit",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use49 || (_use49 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-edit-2-usage",
    xlinkHref: "#sprite_svg__icon-bold-edit-2",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use50 || (_use50 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-eye-usage",
    xlinkHref: "#sprite_svg__icon-bold-eye",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use51 || (_use51 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-eye-off-usage",
    xlinkHref: "#sprite_svg__icon-bold-eye-off",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use52 || (_use52 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-facebook-usage",
    xlinkHref: "#sprite_svg__icon-bold-facebook",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use53 || (_use53 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-fast-forward-usage",
    xlinkHref: "#sprite_svg__icon-bold-fast-forward",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use54 || (_use54 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-file-usage",
    xlinkHref: "#sprite_svg__icon-bold-file",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use55 || (_use55 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-file-2-usage",
    xlinkHref: "#sprite_svg__icon-bold-file-2",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use56 || (_use56 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-file-add-usage",
    xlinkHref: "#sprite_svg__icon-bold-file-add",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use57 || (_use57 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-file-remove-usage",
    xlinkHref: "#sprite_svg__icon-bold-file-remove",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use58 || (_use58 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-film-usage",
    xlinkHref: "#sprite_svg__icon-bold-film",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use59 || (_use59 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-fire-usage",
    xlinkHref: "#sprite_svg__icon-bold-fire",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use60 || (_use60 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-flag-usage",
    xlinkHref: "#sprite_svg__icon-bold-flag",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use61 || (_use61 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-flash-usage",
    xlinkHref: "#sprite_svg__icon-bold-flash",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use62 || (_use62 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-flash-off-usage",
    xlinkHref: "#sprite_svg__icon-bold-flash-off",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use63 || (_use63 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-folder-usage",
    xlinkHref: "#sprite_svg__icon-bold-folder",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use64 || (_use64 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-folder-add-usage",
    xlinkHref: "#sprite_svg__icon-bold-folder-add",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use65 || (_use65 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-folder-minus-usage",
    xlinkHref: "#sprite_svg__icon-bold-folder-minus",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use66 || (_use66 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-funnel-usage",
    xlinkHref: "#sprite_svg__icon-bold-funnel",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use67 || (_use67 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-gift-usage",
    xlinkHref: "#sprite_svg__icon-bold-gift",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use68 || (_use68 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-github-usage",
    xlinkHref: "#sprite_svg__icon-bold-github",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use69 || (_use69 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-globe-1-usage",
    xlinkHref: "#sprite_svg__icon-bold-globe-1",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use70 || (_use70 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-globe-2-usage",
    xlinkHref: "#sprite_svg__icon-bold-globe-2",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use71 || (_use71 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-google-usage",
    xlinkHref: "#sprite_svg__icon-bold-google",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use72 || (_use72 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-graph-usage",
    xlinkHref: "#sprite_svg__icon-bold-graph",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use73 || (_use73 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-grid-usage",
    xlinkHref: "#sprite_svg__icon-bold-grid",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use74 || (_use74 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-hard-drive-usage",
    xlinkHref: "#sprite_svg__icon-bold-hard-drive",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use75 || (_use75 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-headphones-usage",
    xlinkHref: "#sprite_svg__icon-bold-headphones",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use76 || (_use76 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-heart-usage",
    xlinkHref: "#sprite_svg__icon-bold-heart",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use77 || (_use77 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-home-usage",
    xlinkHref: "#sprite_svg__icon-bold-home",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use78 || (_use78 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-ia-stars-usage",
    xlinkHref: "#sprite_svg__icon-bold-ia-stars",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use79 || (_use79 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-image-usage",
    xlinkHref: "#sprite_svg__icon-bold-image",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use80 || (_use80 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-image-2-usage",
    xlinkHref: "#sprite_svg__icon-bold-image-2",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use81 || (_use81 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-inbox-usage",
    xlinkHref: "#sprite_svg__icon-bold-inbox",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use82 || (_use82 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-info-usage",
    xlinkHref: "#sprite_svg__icon-bold-info",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use83 || (_use83 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-keyboard-usage",
    xlinkHref: "#sprite_svg__icon-bold-keyboard",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use84 || (_use84 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-layers-usage",
    xlinkHref: "#sprite_svg__icon-bold-layers",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use85 || (_use85 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-layout-usage",
    xlinkHref: "#sprite_svg__icon-bold-layout",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use86 || (_use86 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-linkedin-usage",
    xlinkHref: "#sprite_svg__icon-bold-linkedin",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use87 || (_use87 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-location-pin-usage",
    xlinkHref: "#sprite_svg__icon-bold-location-pin",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use88 || (_use88 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-lock-usage",
    xlinkHref: "#sprite_svg__icon-bold-lock",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use89 || (_use89 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-lock-open-usage",
    xlinkHref: "#sprite_svg__icon-bold-lock-open",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use90 || (_use90 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-mail-usage",
    xlinkHref: "#sprite_svg__icon-bold-mail",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use91 || (_use91 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-map-usage",
    xlinkHref: "#sprite_svg__icon-bold-map",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use92 || (_use92 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-mark-blue-usage",
    xlinkHref: "#sprite_svg__icon-bold-mark-blue",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use93 || (_use93 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-mark-green-usage",
    xlinkHref: "#sprite_svg__icon-bold-mark-green",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use94 || (_use94 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-mark-red-usage",
    xlinkHref: "#sprite_svg__icon-bold-mark-red",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use95 || (_use95 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-mark-star-usage",
    xlinkHref: "#sprite_svg__icon-bold-mark-star",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use96 || (_use96 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-megaphone-usage",
    xlinkHref: "#sprite_svg__icon-bold-megaphone",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use97 || (_use97 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-message-square-usage",
    xlinkHref: "#sprite_svg__icon-bold-message-square",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use98 || (_use98 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-mic-usage",
    xlinkHref: "#sprite_svg__icon-bold-mic",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use99 || (_use99 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-mic-off-usage",
    xlinkHref: "#sprite_svg__icon-bold-mic-off",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use100 || (_use100 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-moon-usage",
    xlinkHref: "#sprite_svg__icon-bold-moon",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use101 || (_use101 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-music-usage",
    xlinkHref: "#sprite_svg__icon-bold-music",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use102 || (_use102 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-navigation-usage",
    xlinkHref: "#sprite_svg__icon-bold-navigation",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use103 || (_use103 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-navigation-up-usage",
    xlinkHref: "#sprite_svg__icon-bold-navigation-up",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use104 || (_use104 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-notification-usage",
    xlinkHref: "#sprite_svg__icon-bold-notification",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use105 || (_use105 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-notifiction-off-usage",
    xlinkHref: "#sprite_svg__icon-bold-notifiction-off",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use106 || (_use106 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-npm-usage",
    xlinkHref: "#sprite_svg__icon-bold-npm",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use107 || (_use107 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-office-usage",
    xlinkHref: "#sprite_svg__icon-bold-office",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use108 || (_use108 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-options-usage",
    xlinkHref: "#sprite_svg__icon-bold-options",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use109 || (_use109 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-options-2-usage",
    xlinkHref: "#sprite_svg__icon-bold-options-2",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use110 || (_use110 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-pantone-usage",
    xlinkHref: "#sprite_svg__icon-bold-pantone",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use111 || (_use111 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-paper-plane-usage",
    xlinkHref: "#sprite_svg__icon-bold-paper-plane",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use112 || (_use112 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-pause-usage",
    xlinkHref: "#sprite_svg__icon-bold-pause",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use113 || (_use113 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-pause-circle-usage",
    xlinkHref: "#sprite_svg__icon-bold-pause-circle",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use114 || (_use114 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-people-usage",
    xlinkHref: "#sprite_svg__icon-bold-people",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use115 || (_use115 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-phone-usage",
    xlinkHref: "#sprite_svg__icon-bold-phone",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use116 || (_use116 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-phone-call-usage",
    xlinkHref: "#sprite_svg__icon-bold-phone-call",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use117 || (_use117 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-phone-missed-usage",
    xlinkHref: "#sprite_svg__icon-bold-phone-missed",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use118 || (_use118 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-phone-off-usage",
    xlinkHref: "#sprite_svg__icon-bold-phone-off",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use119 || (_use119 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-pie-usage",
    xlinkHref: "#sprite_svg__icon-bold-pie",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use120 || (_use120 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-pie-2-usage",
    xlinkHref: "#sprite_svg__icon-bold-pie-2",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use121 || (_use121 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-play-usage",
    xlinkHref: "#sprite_svg__icon-bold-play",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use122 || (_use122 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-play-circle-usage",
    xlinkHref: "#sprite_svg__icon-bold-play-circle",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use123 || (_use123 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-price-tag-usage",
    xlinkHref: "#sprite_svg__icon-bold-price-tag",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use124 || (_use124 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-printer-usage",
    xlinkHref: "#sprite_svg__icon-bold-printer",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use125 || (_use125 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-question-mark-circle-usage",
    xlinkHref: "#sprite_svg__icon-bold-question-mark-circle",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use126 || (_use126 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-quotes-usage",
    xlinkHref: "#sprite_svg__icon-bold-quotes",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use127 || (_use127 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-radio-usage",
    xlinkHref: "#sprite_svg__icon-bold-radio",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use128 || (_use128 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-radio-button-usage",
    xlinkHref: "#sprite_svg__icon-bold-radio-button",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use129 || (_use129 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-rewind-usage",
    xlinkHref: "#sprite_svg__icon-bold-rewind",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use130 || (_use130 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-save-usage",
    xlinkHref: "#sprite_svg__icon-bold-save",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use131 || (_use131 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-screen-usage",
    xlinkHref: "#sprite_svg__icon-bold-screen",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use132 || (_use132 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-search-usage",
    xlinkHref: "#sprite_svg__icon-bold-search",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use133 || (_use133 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-settings-usage",
    xlinkHref: "#sprite_svg__icon-bold-settings",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use134 || (_use134 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-settings-1-usage",
    xlinkHref: "#sprite_svg__icon-bold-settings-1",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use135 || (_use135 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-share-usage",
    xlinkHref: "#sprite_svg__icon-bold-share",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use136 || (_use136 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-shield-usage",
    xlinkHref: "#sprite_svg__icon-bold-shield",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use137 || (_use137 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-shield-off-usage",
    xlinkHref: "#sprite_svg__icon-bold-shield-off",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use138 || (_use138 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-shopping-bag-usage",
    xlinkHref: "#sprite_svg__icon-bold-shopping-bag",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use139 || (_use139 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-shopping-cart-usage",
    xlinkHref: "#sprite_svg__icon-bold-shopping-cart",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use140 || (_use140 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-skip-forward-usage",
    xlinkHref: "#sprite_svg__icon-bold-skip-forward",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use141 || (_use141 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-skip-to-start-usage",
    xlinkHref: "#sprite_svg__icon-bold-skip-to-start",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use142 || (_use142 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-smartphone-usage",
    xlinkHref: "#sprite_svg__icon-bold-smartphone",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use143 || (_use143 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-speaker-usage",
    xlinkHref: "#sprite_svg__icon-bold-speaker",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use144 || (_use144 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-star-usage",
    xlinkHref: "#sprite_svg__icon-bold-star",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use145 || (_use145 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-stop-circle-usage",
    xlinkHref: "#sprite_svg__icon-bold-stop-circle",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use146 || (_use146 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-substract-circle-usage",
    xlinkHref: "#sprite_svg__icon-bold-substract-circle",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use147 || (_use147 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-substract-square-usage",
    xlinkHref: "#sprite_svg__icon-bold-substract-square",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use148 || (_use148 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-suitcase-usage",
    xlinkHref: "#sprite_svg__icon-bold-suitcase",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use149 || (_use149 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-sun-usage",
    xlinkHref: "#sprite_svg__icon-bold-sun",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use150 || (_use150 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-termometer-usage",
    xlinkHref: "#sprite_svg__icon-bold-termometer",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use151 || (_use151 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-termometer-menus-usage",
    xlinkHref: "#sprite_svg__icon-bold-termometer-menus",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use152 || (_use152 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-termometer-plus-usage",
    xlinkHref: "#sprite_svg__icon-bold-termometer-plus",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use153 || (_use153 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-thrash-usage",
    xlinkHref: "#sprite_svg__icon-bold-thrash",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use154 || (_use154 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-thrash-full-usage",
    xlinkHref: "#sprite_svg__icon-bold-thrash-full",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use155 || (_use155 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-timer-usage",
    xlinkHref: "#sprite_svg__icon-bold-timer",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use156 || (_use156 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-toggle-left-usage",
    xlinkHref: "#sprite_svg__icon-bold-toggle-left",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use157 || (_use157 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-toggle-right-usage",
    xlinkHref: "#sprite_svg__icon-bold-toggle-right",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use158 || (_use158 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-tv-usage",
    xlinkHref: "#sprite_svg__icon-bold-tv",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use159 || (_use159 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-twitter-usage",
    xlinkHref: "#sprite_svg__icon-bold-twitter",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use160 || (_use160 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-umbrella-usage",
    xlinkHref: "#sprite_svg__icon-bold-umbrella",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use161 || (_use161 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-undo-usage",
    xlinkHref: "#sprite_svg__icon-bold-undo",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use162 || (_use162 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-upload-usage",
    xlinkHref: "#sprite_svg__icon-bold-upload",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use163 || (_use163 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-user-usage",
    xlinkHref: "#sprite_svg__icon-bold-user",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use164 || (_use164 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-user-add-usage",
    xlinkHref: "#sprite_svg__icon-bold-user-add",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use165 || (_use165 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-user-ok-usage",
    xlinkHref: "#sprite_svg__icon-bold-user-ok",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use166 || (_use166 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-user-remove-usage",
    xlinkHref: "#sprite_svg__icon-bold-user-remove",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use167 || (_use167 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-user-remove-1-usage",
    xlinkHref: "#sprite_svg__icon-bold-user-remove-1",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use168 || (_use168 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-verified-usage",
    xlinkHref: "#sprite_svg__icon-bold-verified",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use169 || (_use169 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-video-usage",
    xlinkHref: "#sprite_svg__icon-bold-video",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use170 || (_use170 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-video-off-usage",
    xlinkHref: "#sprite_svg__icon-bold-video-off",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use171 || (_use171 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-voice-message-usage",
    xlinkHref: "#sprite_svg__icon-bold-voice-message",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use172 || (_use172 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-volume-usage",
    xlinkHref: "#sprite_svg__icon-bold-volume",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use173 || (_use173 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-volume-down-usage",
    xlinkHref: "#sprite_svg__icon-bold-volume-down",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use174 || (_use174 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-volume-off-usage",
    xlinkHref: "#sprite_svg__icon-bold-volume-off",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use175 || (_use175 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-volume-up-usage",
    xlinkHref: "#sprite_svg__icon-bold-volume-up",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use176 || (_use176 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-weight-usage",
    xlinkHref: "#sprite_svg__icon-bold-weight",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use177 || (_use177 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-whatsapp-usage",
    xlinkHref: "#sprite_svg__icon-bold-whatsapp",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use178 || (_use178 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-zoom-in-usage",
    xlinkHref: "#sprite_svg__icon-bold-zoom-in",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use179 || (_use179 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-bold-zoom-out-usage",
    xlinkHref: "#sprite_svg__icon-bold-zoom-out",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use180 || (_use180 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-activity-usage",
    xlinkHref: "#sprite_svg__icon-light-activity",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use181 || (_use181 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-add-usage",
    xlinkHref: "#sprite_svg__icon-light-add",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use182 || (_use182 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-add-circle-usage",
    xlinkHref: "#sprite_svg__icon-light-add-circle",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use183 || (_use183 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-add-comment-usage",
    xlinkHref: "#sprite_svg__icon-light-add-comment",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use184 || (_use184 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-alert-circle-usage",
    xlinkHref: "#sprite_svg__icon-light-alert-circle",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use185 || (_use185 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-alert-triangle-usage",
    xlinkHref: "#sprite_svg__icon-light-alert-triangle",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use186 || (_use186 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-antenna-usage",
    xlinkHref: "#sprite_svg__icon-light-antenna",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use187 || (_use187 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-archivar-usage",
    xlinkHref: "#sprite_svg__icon-light-archivar",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use188 || (_use188 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-archive-usage",
    xlinkHref: "#sprite_svg__icon-light-archive",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use189 || (_use189 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-arrow-circle-down-usage",
    xlinkHref: "#sprite_svg__icon-light-arrow-circle-down",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use190 || (_use190 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-arrow-circle-left-usage",
    xlinkHref: "#sprite_svg__icon-light-arrow-circle-left",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use191 || (_use191 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-arrow-circle-right-usage",
    xlinkHref: "#sprite_svg__icon-light-arrow-circle-right",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use192 || (_use192 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-arrow-circle-up-usage",
    xlinkHref: "#sprite_svg__icon-light-arrow-circle-up",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use193 || (_use193 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-arrow-corner-down-left-usage",
    xlinkHref: "#sprite_svg__icon-light-arrow-corner-down-left",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use194 || (_use194 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-arrow-corner-down-right-usage",
    xlinkHref: "#sprite_svg__icon-light-arrow-corner-down-right",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use195 || (_use195 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-arrow-corner-left-down-usage",
    xlinkHref: "#sprite_svg__icon-light-arrow-corner-left-down",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use196 || (_use196 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-arrow-corner-left-up-usage",
    xlinkHref: "#sprite_svg__icon-light-arrow-corner-left-up",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use197 || (_use197 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-arrow-corner-right-down-usage",
    xlinkHref: "#sprite_svg__icon-light-arrow-corner-right-down",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use198 || (_use198 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-arrow-corner-right-up-usage",
    xlinkHref: "#sprite_svg__icon-light-arrow-corner-right-up",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use199 || (_use199 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-arrow-corner-up-left-usage",
    xlinkHref: "#sprite_svg__icon-light-arrow-corner-up-left",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use200 || (_use200 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-arrow-corner-up-right-usage",
    xlinkHref: "#sprite_svg__icon-light-arrow-corner-up-right",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use201 || (_use201 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-arrow-down-usage",
    xlinkHref: "#sprite_svg__icon-light-arrow-down",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use202 || (_use202 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-arrow-ios-down-usage",
    xlinkHref: "#sprite_svg__icon-light-arrow-ios-down",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use203 || (_use203 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-arrow-ios-left-usage",
    xlinkHref: "#sprite_svg__icon-light-arrow-ios-left",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use204 || (_use204 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-arrow-ios-right-usage",
    xlinkHref: "#sprite_svg__icon-light-arrow-ios-right",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use205 || (_use205 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-arrow-ios-up-usage",
    xlinkHref: "#sprite_svg__icon-light-arrow-ios-up",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use206 || (_use206 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-arrow-left-usage",
    xlinkHref: "#sprite_svg__icon-light-arrow-left",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use207 || (_use207 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-arrow-left-down-usage",
    xlinkHref: "#sprite_svg__icon-light-arrow-left-down",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use208 || (_use208 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-arrow-left-up-usage",
    xlinkHref: "#sprite_svg__icon-light-arrow-left-up",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use209 || (_use209 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-arrow-right-usage",
    xlinkHref: "#sprite_svg__icon-light-arrow-right",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use210 || (_use210 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-arrow-right-down-usage",
    xlinkHref: "#sprite_svg__icon-light-arrow-right-down",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use211 || (_use211 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-arrow-right-up-usage",
    xlinkHref: "#sprite_svg__icon-light-arrow-right-up",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use212 || (_use212 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-arrow-triangle-down-usage",
    xlinkHref: "#sprite_svg__icon-light-arrow-triangle-down",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use213 || (_use213 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-arrow-triangle-left-usage",
    xlinkHref: "#sprite_svg__icon-light-arrow-triangle-left",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use214 || (_use214 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-arrow-triangle-right-usage",
    xlinkHref: "#sprite_svg__icon-light-arrow-triangle-right",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use215 || (_use215 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-arrow-triangle-up-usage",
    xlinkHref: "#sprite_svg__icon-light-arrow-triangle-up",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use216 || (_use216 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-arrow-up-usage",
    xlinkHref: "#sprite_svg__icon-light-arrow-up",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use217 || (_use217 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-arrowhead-down-usage",
    xlinkHref: "#sprite_svg__icon-light-arrowhead-down",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use218 || (_use218 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-arrowhead-left-usage",
    xlinkHref: "#sprite_svg__icon-light-arrowhead-left",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use219 || (_use219 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-arrowhead-right-usage",
    xlinkHref: "#sprite_svg__icon-light-arrowhead-right",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use220 || (_use220 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-arrowhead-up-usage",
    xlinkHref: "#sprite_svg__icon-light-arrowhead-up",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use221 || (_use221 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-at-usage",
    xlinkHref: "#sprite_svg__icon-light-at",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use222 || (_use222 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-attach-usage",
    xlinkHref: "#sprite_svg__icon-light-attach",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use223 || (_use223 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-attach-2-usage",
    xlinkHref: "#sprite_svg__icon-light-attach-2",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use224 || (_use224 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-award-usage",
    xlinkHref: "#sprite_svg__icon-light-award",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use225 || (_use225 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-back-to-search-result-2-usage",
    xlinkHref: "#sprite_svg__icon-light-back-to-search-result-2",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use226 || (_use226 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-background-usage",
    xlinkHref: "#sprite_svg__icon-light-background",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use227 || (_use227 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-backspace-usage",
    xlinkHref: "#sprite_svg__icon-light-backspace",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use228 || (_use228 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-bar-chart-1-usage",
    xlinkHref: "#sprite_svg__icon-light-bar-chart-1",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use229 || (_use229 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-bar-chart-2-usage",
    xlinkHref: "#sprite_svg__icon-light-bar-chart-2",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use230 || (_use230 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-battery-usage",
    xlinkHref: "#sprite_svg__icon-light-battery",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use231 || (_use231 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-battery-charging-usage",
    xlinkHref: "#sprite_svg__icon-light-battery-charging",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use232 || (_use232 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-behance-usage",
    xlinkHref: "#sprite_svg__icon-light-behance",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use233 || (_use233 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-blog-usage",
    xlinkHref: "#sprite_svg__icon-light-blog",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use234 || (_use234 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-bluetooth-usage",
    xlinkHref: "#sprite_svg__icon-light-bluetooth",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use235 || (_use235 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-bold-usage",
    xlinkHref: "#sprite_svg__icon-light-bold",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use236 || (_use236 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-book-usage",
    xlinkHref: "#sprite_svg__icon-light-book",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use237 || (_use237 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-book-open-usage",
    xlinkHref: "#sprite_svg__icon-light-book-open",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use238 || (_use238 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-bookmark-usage",
    xlinkHref: "#sprite_svg__icon-light-bookmark",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use239 || (_use239 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-briefcase-usage",
    xlinkHref: "#sprite_svg__icon-light-briefcase",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use240 || (_use240 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-briefcase-2-usage",
    xlinkHref: "#sprite_svg__icon-light-briefcase-2",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use241 || (_use241 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-browser-usage",
    xlinkHref: "#sprite_svg__icon-light-browser",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use242 || (_use242 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-brush-usage",
    xlinkHref: "#sprite_svg__icon-light-brush",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use243 || (_use243 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-bulb-usage",
    xlinkHref: "#sprite_svg__icon-light-bulb",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use244 || (_use244 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-bulleted-list-usage",
    xlinkHref: "#sprite_svg__icon-light-bulleted-list",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use245 || (_use245 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-bumi-usage",
    xlinkHref: "#sprite_svg__icon-light-bumi",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use246 || (_use246 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-calendar-usage",
    xlinkHref: "#sprite_svg__icon-light-calendar",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use247 || (_use247 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-camera-usage",
    xlinkHref: "#sprite_svg__icon-light-camera",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use248 || (_use248 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-car-usage",
    xlinkHref: "#sprite_svg__icon-light-car",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use249 || (_use249 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-caret-down-usage",
    xlinkHref: "#sprite_svg__icon-light-caret-down",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use250 || (_use250 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-caret-left-usage",
    xlinkHref: "#sprite_svg__icon-light-caret-left",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use251 || (_use251 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-caret-right-usage",
    xlinkHref: "#sprite_svg__icon-light-caret-right",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use252 || (_use252 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-caret-up-usage",
    xlinkHref: "#sprite_svg__icon-light-caret-up",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use253 || (_use253 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-cast-usage",
    xlinkHref: "#sprite_svg__icon-light-cast",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use254 || (_use254 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-chair-usage",
    xlinkHref: "#sprite_svg__icon-light-chair",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use255 || (_use255 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-checkbox-checked-usage",
    xlinkHref: "#sprite_svg__icon-light-checkbox-checked",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use256 || (_use256 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-checkmark-usage",
    xlinkHref: "#sprite_svg__icon-light-checkmark",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use257 || (_use257 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-checkmark-circle-usage",
    xlinkHref: "#sprite_svg__icon-light-checkmark-circle",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use258 || (_use258 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-checkmark-circle-1-usage",
    xlinkHref: "#sprite_svg__icon-light-checkmark-circle-1",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use259 || (_use259 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-checkmark-double-usage",
    xlinkHref: "#sprite_svg__icon-light-checkmark-double",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use260 || (_use260 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-checkmark-square-usage",
    xlinkHref: "#sprite_svg__icon-light-checkmark-square",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use261 || (_use261 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-classic-zonajobs-usage",
    xlinkHref: "#sprite_svg__icon-light-classic-zonajobs",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use262 || (_use262 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-clipboard-usage",
    xlinkHref: "#sprite_svg__icon-light-clipboard",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use263 || (_use263 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-clock-usage",
    xlinkHref: "#sprite_svg__icon-light-clock",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use264 || (_use264 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-close-usage",
    xlinkHref: "#sprite_svg__icon-light-close",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use265 || (_use265 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-close-circle-usage",
    xlinkHref: "#sprite_svg__icon-light-close-circle",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use266 || (_use266 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-close-square-usage",
    xlinkHref: "#sprite_svg__icon-light-close-square",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use267 || (_use267 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-cloud-download-usage",
    xlinkHref: "#sprite_svg__icon-light-cloud-download",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use268 || (_use268 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-cloud-upload-usage",
    xlinkHref: "#sprite_svg__icon-light-cloud-upload",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use269 || (_use269 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-code-usage",
    xlinkHref: "#sprite_svg__icon-light-code",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use270 || (_use270 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-code-download-usage",
    xlinkHref: "#sprite_svg__icon-light-code-download",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use271 || (_use271 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-collapse-usage",
    xlinkHref: "#sprite_svg__icon-light-collapse",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use272 || (_use272 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-collapse---horizontal-usage",
    xlinkHref: "#sprite_svg__icon-light-collapse---horizontal",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use273 || (_use273 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-color-palette-usage",
    xlinkHref: "#sprite_svg__icon-light-color-palette",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use274 || (_use274 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-color-picker-usage",
    xlinkHref: "#sprite_svg__icon-light-color-picker",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use275 || (_use275 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-compass-usage",
    xlinkHref: "#sprite_svg__icon-light-compass",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use276 || (_use276 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-conecta-usage",
    xlinkHref: "#sprite_svg__icon-light-conecta",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use277 || (_use277 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-copy-usage",
    xlinkHref: "#sprite_svg__icon-light-copy",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use278 || (_use278 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-credit-card-usage",
    xlinkHref: "#sprite_svg__icon-light-credit-card",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use279 || (_use279 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-crop-usage",
    xlinkHref: "#sprite_svg__icon-light-crop",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use280 || (_use280 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-crown-usage",
    xlinkHref: "#sprite_svg__icon-light-crown",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use281 || (_use281 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-cube-usage",
    xlinkHref: "#sprite_svg__icon-light-cube",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use282 || (_use282 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-cvs-usage",
    xlinkHref: "#sprite_svg__icon-light-cvs",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use283 || (_use283 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-desarchivar-usage",
    xlinkHref: "#sprite_svg__icon-light-desarchivar",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use284 || (_use284 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-discapacity-usage",
    xlinkHref: "#sprite_svg__icon-light-discapacity",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use285 || (_use285 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-download-usage",
    xlinkHref: "#sprite_svg__icon-light-download",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use286 || (_use286 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-drag-usage",
    xlinkHref: "#sprite_svg__icon-light-drag",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use287 || (_use287 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-drop-usage",
    xlinkHref: "#sprite_svg__icon-light-drop",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use288 || (_use288 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-drop-off-usage",
    xlinkHref: "#sprite_svg__icon-light-drop-off",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use289 || (_use289 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-edit-1-usage",
    xlinkHref: "#sprite_svg__icon-light-edit-1",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use290 || (_use290 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-edit-2-usage",
    xlinkHref: "#sprite_svg__icon-light-edit-2",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use291 || (_use291 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-email-usage",
    xlinkHref: "#sprite_svg__icon-light-email",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use292 || (_use292 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-emoji-usage",
    xlinkHref: "#sprite_svg__icon-light-emoji",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use293 || (_use293 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-envelope-calado-usage",
    xlinkHref: "#sprite_svg__icon-light-envelope-calado",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use294 || (_use294 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-exit-usage",
    xlinkHref: "#sprite_svg__icon-light-exit",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use295 || (_use295 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-expand-usage",
    xlinkHref: "#sprite_svg__icon-light-expand",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use296 || (_use296 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-expand---horizontal-usage",
    xlinkHref: "#sprite_svg__icon-light-expand---horizontal",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use297 || (_use297 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-export-usage",
    xlinkHref: "#sprite_svg__icon-light-export",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use298 || (_use298 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-external-link-usage",
    xlinkHref: "#sprite_svg__icon-light-external-link",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use299 || (_use299 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-eye-closed-usage",
    xlinkHref: "#sprite_svg__icon-light-eye-closed",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use300 || (_use300 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-eye-off-usage",
    xlinkHref: "#sprite_svg__icon-light-eye-off",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use301 || (_use301 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-eye-open-usage",
    xlinkHref: "#sprite_svg__icon-light-eye-open",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use302 || (_use302 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-facebook-usage",
    xlinkHref: "#sprite_svg__icon-light-facebook",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use303 || (_use303 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-file-usage",
    xlinkHref: "#sprite_svg__icon-light-file",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use304 || (_use304 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-file-add-usage",
    xlinkHref: "#sprite_svg__icon-light-file-add",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use305 || (_use305 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-file-remove-usage",
    xlinkHref: "#sprite_svg__icon-light-file-remove",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use306 || (_use306 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-file-text-usage",
    xlinkHref: "#sprite_svg__icon-light-file-text",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use307 || (_use307 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-film-usage",
    xlinkHref: "#sprite_svg__icon-light-film",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use308 || (_use308 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-fire-usage",
    xlinkHref: "#sprite_svg__icon-light-fire",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use309 || (_use309 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-flag-usage",
    xlinkHref: "#sprite_svg__icon-light-flag",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use310 || (_use310 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-flash-off-usage",
    xlinkHref: "#sprite_svg__icon-light-flash-off",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use311 || (_use311 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-flash-on-usage",
    xlinkHref: "#sprite_svg__icon-light-flash-on",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use312 || (_use312 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-flip-usage",
    xlinkHref: "#sprite_svg__icon-light-flip",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use313 || (_use313 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-flip-1-usage",
    xlinkHref: "#sprite_svg__icon-light-flip-1",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use314 || (_use314 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-folder-usage",
    xlinkHref: "#sprite_svg__icon-light-folder",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use315 || (_use315 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-folder-add-usage",
    xlinkHref: "#sprite_svg__icon-light-folder-add",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use316 || (_use316 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-folder-remove-usage",
    xlinkHref: "#sprite_svg__icon-light-folder-remove",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use317 || (_use317 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-food-usage",
    xlinkHref: "#sprite_svg__icon-light-food",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use318 || (_use318 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-foward-usage",
    xlinkHref: "#sprite_svg__icon-light-foward",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use319 || (_use319 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-funnel-usage",
    xlinkHref: "#sprite_svg__icon-light-funnel",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use320 || (_use320 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-gift-usage",
    xlinkHref: "#sprite_svg__icon-light-gift",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use321 || (_use321 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-github-usage",
    xlinkHref: "#sprite_svg__icon-light-github",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use322 || (_use322 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-globe-usage",
    xlinkHref: "#sprite_svg__icon-light-globe",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use323 || (_use323 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-gold-zonajobs-usage",
    xlinkHref: "#sprite_svg__icon-light-gold-zonajobs",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use324 || (_use324 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-google-usage",
    xlinkHref: "#sprite_svg__icon-light-google",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use325 || (_use325 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-graduation-cap-usage",
    xlinkHref: "#sprite_svg__icon-light-graduation-cap",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use326 || (_use326 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-graph-usage",
    xlinkHref: "#sprite_svg__icon-light-graph",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use327 || (_use327 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-graph-up-usage",
    xlinkHref: "#sprite_svg__icon-light-graph-up",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use328 || (_use328 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-gratis-zonajobs-usage",
    xlinkHref: "#sprite_svg__icon-light-gratis-zonajobs",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use329 || (_use329 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-grid-usage",
    xlinkHref: "#sprite_svg__icon-light-grid",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use330 || (_use330 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-gym-usage",
    xlinkHref: "#sprite_svg__icon-light-gym",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use331 || (_use331 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-hard-drive-usage",
    xlinkHref: "#sprite_svg__icon-light-hard-drive",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use332 || (_use332 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-hashtag-usage",
    xlinkHref: "#sprite_svg__icon-light-hashtag",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use333 || (_use333 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-headphones-usage",
    xlinkHref: "#sprite_svg__icon-light-headphones",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use334 || (_use334 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-health-usage",
    xlinkHref: "#sprite_svg__icon-light-health",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use335 || (_use335 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-heart-usage",
    xlinkHref: "#sprite_svg__icon-light-heart",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use336 || (_use336 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-height-usage",
    xlinkHref: "#sprite_svg__icon-light-height",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use337 || (_use337 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-hiring-room-usage",
    xlinkHref: "#sprite_svg__icon-light-hiring-room",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use338 || (_use338 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-home-usage",
    xlinkHref: "#sprite_svg__icon-light-home",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use339 || (_use339 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-hr-usage",
    xlinkHref: "#sprite_svg__icon-light-hr",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use340 || (_use340 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-ia-stars-usage",
    xlinkHref: "#sprite_svg__icon-light-ia-stars",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use341 || (_use341 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-image-usage",
    xlinkHref: "#sprite_svg__icon-light-image",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use342 || (_use342 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-inbox-usage",
    xlinkHref: "#sprite_svg__icon-light-inbox",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use343 || (_use343 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-info-usage",
    xlinkHref: "#sprite_svg__icon-light-info",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use344 || (_use344 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-instagram-usage",
    xlinkHref: "#sprite_svg__icon-light-instagram",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use345 || (_use345 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-italic-usage",
    xlinkHref: "#sprite_svg__icon-light-italic",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use346 || (_use346 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-key-usage",
    xlinkHref: "#sprite_svg__icon-light-key",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use347 || (_use347 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-keypad-usage",
    xlinkHref: "#sprite_svg__icon-light-keypad",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use348 || (_use348 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-lamp-usage",
    xlinkHref: "#sprite_svg__icon-light-lamp",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use349 || (_use349 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-layers-usage",
    xlinkHref: "#sprite_svg__icon-light-layers",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use350 || (_use350 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-layout-usage",
    xlinkHref: "#sprite_svg__icon-light-layout",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use351 || (_use351 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-lifeguard-usage",
    xlinkHref: "#sprite_svg__icon-light-lifeguard",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use352 || (_use352 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-link-1-usage",
    xlinkHref: "#sprite_svg__icon-light-link-1",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use353 || (_use353 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-link-2-usage",
    xlinkHref: "#sprite_svg__icon-light-link-2",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use354 || (_use354 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-linkedin-usage",
    xlinkHref: "#sprite_svg__icon-light-linkedin",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use355 || (_use355 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-list-usage",
    xlinkHref: "#sprite_svg__icon-light-list",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use356 || (_use356 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-list-cards-usage",
    xlinkHref: "#sprite_svg__icon-light-list-cards",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use357 || (_use357 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-loader-usage",
    xlinkHref: "#sprite_svg__icon-light-loader",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use358 || (_use358 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-location-pin-usage",
    xlinkHref: "#sprite_svg__icon-light-location-pin",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use359 || (_use359 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-lock-usage",
    xlinkHref: "#sprite_svg__icon-light-lock",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use360 || (_use360 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-lock-open-usage",
    xlinkHref: "#sprite_svg__icon-light-lock-open",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use361 || (_use361 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-log-in-usage",
    xlinkHref: "#sprite_svg__icon-light-log-in",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use362 || (_use362 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-log-out-usage",
    xlinkHref: "#sprite_svg__icon-light-log-out",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use363 || (_use363 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-map-usage",
    xlinkHref: "#sprite_svg__icon-light-map",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use364 || (_use364 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-mapa-del-empleo-usage",
    xlinkHref: "#sprite_svg__icon-light-mapa-del-empleo",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use365 || (_use365 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-megaphone-usage",
    xlinkHref: "#sprite_svg__icon-light-megaphone",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use366 || (_use366 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-menu-usage",
    xlinkHref: "#sprite_svg__icon-light-menu",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use367 || (_use367 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-menu-2-usage",
    xlinkHref: "#sprite_svg__icon-light-menu-2",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use368 || (_use368 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-menu-back-usage",
    xlinkHref: "#sprite_svg__icon-light-menu-back",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use369 || (_use369 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-message-circle-usage",
    xlinkHref: "#sprite_svg__icon-light-message-circle",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use370 || (_use370 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-message-square-usage",
    xlinkHref: "#sprite_svg__icon-light-message-square",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use371 || (_use371 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-mic-off-usage",
    xlinkHref: "#sprite_svg__icon-light-mic-off",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use372 || (_use372 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-mic-on-usage",
    xlinkHref: "#sprite_svg__icon-light-mic-on",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use373 || (_use373 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-money-usage",
    xlinkHref: "#sprite_svg__icon-light-money",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use374 || (_use374 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-money-1-usage",
    xlinkHref: "#sprite_svg__icon-light-money-1",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use375 || (_use375 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-money-panama-usage",
    xlinkHref: "#sprite_svg__icon-light-money-panama",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use376 || (_use376 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-money-peru-usage",
    xlinkHref: "#sprite_svg__icon-light-money-peru",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use377 || (_use377 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-money-venezuela-usage",
    xlinkHref: "#sprite_svg__icon-light-money-venezuela",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use378 || (_use378 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-moon-usage",
    xlinkHref: "#sprite_svg__icon-light-moon",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use379 || (_use379 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-more-horizontal-usage",
    xlinkHref: "#sprite_svg__icon-light-more-horizontal",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use380 || (_use380 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-more-vertical-usage",
    xlinkHref: "#sprite_svg__icon-light-more-vertical",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use381 || (_use381 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-move-usage",
    xlinkHref: "#sprite_svg__icon-light-move",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use382 || (_use382 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-music-usage",
    xlinkHref: "#sprite_svg__icon-light-music",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use383 || (_use383 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-navigation-usage",
    xlinkHref: "#sprite_svg__icon-light-navigation",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use384 || (_use384 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-navigation-up-usage",
    xlinkHref: "#sprite_svg__icon-light-navigation-up",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use385 || (_use385 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-new-notifications-bell-usage",
    xlinkHref: "#sprite_svg__icon-light-new-notifications-bell",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use386 || (_use386 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-new-notifications-ellipse-usage",
    xlinkHref: "#sprite_svg__icon-light-new-notifications-ellipse",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use387 || (_use387 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-notes-usage",
    xlinkHref: "#sprite_svg__icon-light-notes",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use388 || (_use388 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-notification-off-usage",
    xlinkHref: "#sprite_svg__icon-light-notification-off",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use389 || (_use389 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-notification-on-usage",
    xlinkHref: "#sprite_svg__icon-light-notification-on",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use390 || (_use390 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-npm-usage",
    xlinkHref: "#sprite_svg__icon-light-npm",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use391 || (_use391 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-numbered-list-usage",
    xlinkHref: "#sprite_svg__icon-light-numbered-list",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use392 || (_use392 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-office-usage",
    xlinkHref: "#sprite_svg__icon-light-office",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use393 || (_use393 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-options-usage",
    xlinkHref: "#sprite_svg__icon-light-options",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use394 || (_use394 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-options-2-usage",
    xlinkHref: "#sprite_svg__icon-light-options-2",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use395 || (_use395 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-order-usage",
    xlinkHref: "#sprite_svg__icon-light-order",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use396 || (_use396 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-order-1-usage",
    xlinkHref: "#sprite_svg__icon-light-order-1",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use397 || (_use397 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-pantone-usage",
    xlinkHref: "#sprite_svg__icon-light-pantone",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use398 || (_use398 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-paper-plane-usage",
    xlinkHref: "#sprite_svg__icon-light-paper-plane",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use399 || (_use399 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-pause-usage",
    xlinkHref: "#sprite_svg__icon-light-pause",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use400 || (_use400 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-pause-circle-usage",
    xlinkHref: "#sprite_svg__icon-light-pause-circle",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use401 || (_use401 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-pause-simple-usage",
    xlinkHref: "#sprite_svg__icon-light-pause-simple",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use402 || (_use402 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-people-usage",
    xlinkHref: "#sprite_svg__icon-light-people",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use403 || (_use403 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-percent-usage",
    xlinkHref: "#sprite_svg__icon-light-percent",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use404 || (_use404 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-person-usage",
    xlinkHref: "#sprite_svg__icon-light-person",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use405 || (_use405 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-person-add-usage",
    xlinkHref: "#sprite_svg__icon-light-person-add",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use406 || (_use406 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-person-checked-usage",
    xlinkHref: "#sprite_svg__icon-light-person-checked",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use407 || (_use407 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-person-delete-usage",
    xlinkHref: "#sprite_svg__icon-light-person-delete",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use408 || (_use408 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-person-remove-usage",
    xlinkHref: "#sprite_svg__icon-light-person-remove",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use409 || (_use409 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-phone-usage",
    xlinkHref: "#sprite_svg__icon-light-phone",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use410 || (_use410 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-phone-call-usage",
    xlinkHref: "#sprite_svg__icon-light-phone-call",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use411 || (_use411 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-phone-missed-usage",
    xlinkHref: "#sprite_svg__icon-light-phone-missed",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use412 || (_use412 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-phone-off-usage",
    xlinkHref: "#sprite_svg__icon-light-phone-off",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use413 || (_use413 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-pie-chart-usage",
    xlinkHref: "#sprite_svg__icon-light-pie-chart",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use414 || (_use414 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-platinum-zonajobs-usage",
    xlinkHref: "#sprite_svg__icon-light-platinum-zonajobs",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use415 || (_use415 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-play-usage",
    xlinkHref: "#sprite_svg__icon-light-play",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use416 || (_use416 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-play-circle-usage",
    xlinkHref: "#sprite_svg__icon-light-play-circle",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use417 || (_use417 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-play-simple-usage",
    xlinkHref: "#sprite_svg__icon-light-play-simple",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use418 || (_use418 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-power-usage",
    xlinkHref: "#sprite_svg__icon-light-power",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use419 || (_use419 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-pricetag-usage",
    xlinkHref: "#sprite_svg__icon-light-pricetag",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use420 || (_use420 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-printer-usage",
    xlinkHref: "#sprite_svg__icon-light-printer",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use421 || (_use421 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-publish-usage",
    xlinkHref: "#sprite_svg__icon-light-publish",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use422 || (_use422 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-qr-usage",
    xlinkHref: "#sprite_svg__icon-light-qr",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use423 || (_use423 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-question-circle-usage",
    xlinkHref: "#sprite_svg__icon-light-question-circle",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use424 || (_use424 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-question-mark-usage",
    xlinkHref: "#sprite_svg__icon-light-question-mark",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use425 || (_use425 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-radio-usage",
    xlinkHref: "#sprite_svg__icon-light-radio",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use426 || (_use426 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-radio-button-off-usage",
    xlinkHref: "#sprite_svg__icon-light-radio-button-off",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use427 || (_use427 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-radio-button-on-usage",
    xlinkHref: "#sprite_svg__icon-light-radio-button-on",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use428 || (_use428 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-refresh-usage",
    xlinkHref: "#sprite_svg__icon-light-refresh",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use429 || (_use429 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-refresh-1-usage",
    xlinkHref: "#sprite_svg__icon-light-refresh-1",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use430 || (_use430 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-rewind-usage",
    xlinkHref: "#sprite_svg__icon-light-rewind",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use431 || (_use431 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-robot-usage",
    xlinkHref: "#sprite_svg__icon-light-robot",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use432 || (_use432 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-rocket-usage",
    xlinkHref: "#sprite_svg__icon-light-rocket",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use433 || (_use433 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-save-usage",
    xlinkHref: "#sprite_svg__icon-light-save",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use434 || (_use434 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-scissors-usage",
    xlinkHref: "#sprite_svg__icon-light-scissors",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use435 || (_use435 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-screen-usage",
    xlinkHref: "#sprite_svg__icon-light-screen",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use436 || (_use436 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-search-usage",
    xlinkHref: "#sprite_svg__icon-light-search",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use437 || (_use437 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-search-ia-usage",
    xlinkHref: "#sprite_svg__icon-light-search-ia",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use438 || (_use438 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-search-ia2-usage",
    xlinkHref: "#sprite_svg__icon-light-search-ia2",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use439 || (_use439 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-select-zonajobs-usage",
    xlinkHref: "#sprite_svg__icon-light-select-zonajobs",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use440 || (_use440 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-selecta-usage",
    xlinkHref: "#sprite_svg__icon-light-selecta",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use441 || (_use441 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-settings-usage",
    xlinkHref: "#sprite_svg__icon-light-settings",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use442 || (_use442 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-settings-2-usage",
    xlinkHref: "#sprite_svg__icon-light-settings-2",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use443 || (_use443 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-shake-usage",
    xlinkHref: "#sprite_svg__icon-light-shake",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use444 || (_use444 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-share-usage",
    xlinkHref: "#sprite_svg__icon-light-share",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use445 || (_use445 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-shield-usage",
    xlinkHref: "#sprite_svg__icon-light-shield",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use446 || (_use446 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-shield-off-usage",
    xlinkHref: "#sprite_svg__icon-light-shield-off",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use447 || (_use447 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-shopping-bag-usage",
    xlinkHref: "#sprite_svg__icon-light-shopping-bag",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use448 || (_use448 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-shopping-cart-usage",
    xlinkHref: "#sprite_svg__icon-light-shopping-cart",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use449 || (_use449 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-shuffle-usage",
    xlinkHref: "#sprite_svg__icon-light-shuffle",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use450 || (_use450 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-shuffle-2-usage",
    xlinkHref: "#sprite_svg__icon-light-shuffle-2",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use451 || (_use451 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-skip-usage",
    xlinkHref: "#sprite_svg__icon-light-skip",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use452 || (_use452 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-skip-to-start-usage",
    xlinkHref: "#sprite_svg__icon-light-skip-to-start",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use453 || (_use453 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-slash-usage",
    xlinkHref: "#sprite_svg__icon-light-slash",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use454 || (_use454 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-smartphone-usage",
    xlinkHref: "#sprite_svg__icon-light-smartphone",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use455 || (_use455 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-speaker-usage",
    xlinkHref: "#sprite_svg__icon-light-speaker",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use456 || (_use456 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-square-usage",
    xlinkHref: "#sprite_svg__icon-light-square",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use457 || (_use457 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-square-minus-usage",
    xlinkHref: "#sprite_svg__icon-light-square-minus",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use458 || (_use458 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-square-plus-usage",
    xlinkHref: "#sprite_svg__icon-light-square-plus",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use459 || (_use459 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-star-usage",
    xlinkHref: "#sprite_svg__icon-light-star",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use460 || (_use460 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-stop-usage",
    xlinkHref: "#sprite_svg__icon-light-stop",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use461 || (_use461 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-stop-circle-usage",
    xlinkHref: "#sprite_svg__icon-light-stop-circle",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use462 || (_use462 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-stop-simple-usage",
    xlinkHref: "#sprite_svg__icon-light-stop-simple",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use463 || (_use463 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-strikethrough-usage",
    xlinkHref: "#sprite_svg__icon-light-strikethrough",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use464 || (_use464 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-substract-usage",
    xlinkHref: "#sprite_svg__icon-light-substract",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use465 || (_use465 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-substract-circle-usage",
    xlinkHref: "#sprite_svg__icon-light-substract-circle",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use466 || (_use466 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-sun-usage",
    xlinkHref: "#sprite_svg__icon-light-sun",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use467 || (_use467 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-swap-usage",
    xlinkHref: "#sprite_svg__icon-light-swap",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use468 || (_use468 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-swap-1-usage",
    xlinkHref: "#sprite_svg__icon-light-swap-1",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use469 || (_use469 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-sync-usage",
    xlinkHref: "#sprite_svg__icon-light-sync",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use470 || (_use470 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-talent-usage",
    xlinkHref: "#sprite_svg__icon-light-talent",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use471 || (_use471 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-target-usage",
    xlinkHref: "#sprite_svg__icon-light-target",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use472 || (_use472 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-team-usage",
    xlinkHref: "#sprite_svg__icon-light-team",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use473 || (_use473 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-tecnologia-zonajobs-usage",
    xlinkHref: "#sprite_svg__icon-light-tecnologia-zonajobs",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use474 || (_use474 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-text-usage",
    xlinkHref: "#sprite_svg__icon-light-text",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use475 || (_use475 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-thermometer-usage",
    xlinkHref: "#sprite_svg__icon-light-thermometer",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use476 || (_use476 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-thermometer-minus-usage",
    xlinkHref: "#sprite_svg__icon-light-thermometer-minus",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use477 || (_use477 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-thermometer-plus-usage",
    xlinkHref: "#sprite_svg__icon-light-thermometer-plus",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use478 || (_use478 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-thumb-down-usage",
    xlinkHref: "#sprite_svg__icon-light-thumb-down",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use479 || (_use479 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-thumb-up-usage",
    xlinkHref: "#sprite_svg__icon-light-thumb-up",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use480 || (_use480 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-thumbs-down-usage",
    xlinkHref: "#sprite_svg__icon-light-thumbs-down",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use481 || (_use481 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-thumbs-up-usage",
    xlinkHref: "#sprite_svg__icon-light-thumbs-up",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use482 || (_use482 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-timer-usage",
    xlinkHref: "#sprite_svg__icon-light-timer",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use483 || (_use483 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-toggle-left-usage",
    xlinkHref: "#sprite_svg__icon-light-toggle-left",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use484 || (_use484 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-toggle-right-usage",
    xlinkHref: "#sprite_svg__icon-light-toggle-right",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use485 || (_use485 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-trash-1-usage",
    xlinkHref: "#sprite_svg__icon-light-trash-1",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use486 || (_use486 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-trash-2-usage",
    xlinkHref: "#sprite_svg__icon-light-trash-2",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use487 || (_use487 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-trending-down-usage",
    xlinkHref: "#sprite_svg__icon-light-trending-down",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use488 || (_use488 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-trending-up-usage",
    xlinkHref: "#sprite_svg__icon-light-trending-up",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use489 || (_use489 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-truck-usage",
    xlinkHref: "#sprite_svg__icon-light-truck",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use490 || (_use490 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-tv-usage",
    xlinkHref: "#sprite_svg__icon-light-tv",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use491 || (_use491 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-twitter-usage",
    xlinkHref: "#sprite_svg__icon-light-twitter",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use492 || (_use492 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-type-minus-usage",
    xlinkHref: "#sprite_svg__icon-light-type-minus",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use493 || (_use493 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-type-plus-usage",
    xlinkHref: "#sprite_svg__icon-light-type-plus",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use494 || (_use494 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-umbrella-usage",
    xlinkHref: "#sprite_svg__icon-light-umbrella",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use495 || (_use495 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-underline-usage",
    xlinkHref: "#sprite_svg__icon-light-underline",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use496 || (_use496 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-undo-usage",
    xlinkHref: "#sprite_svg__icon-light-undo",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use497 || (_use497 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-unpublish-usage",
    xlinkHref: "#sprite_svg__icon-light-unpublish",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use498 || (_use498 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-updated-usage",
    xlinkHref: "#sprite_svg__icon-light-updated",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use499 || (_use499 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-upload-usage",
    xlinkHref: "#sprite_svg__icon-light-upload",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use500 || (_use500 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-upload-2-usage",
    xlinkHref: "#sprite_svg__icon-light-upload-2",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use501 || (_use501 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-user-circle-usage",
    xlinkHref: "#sprite_svg__icon-light-user-circle",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use502 || (_use502 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-verified-usage",
    xlinkHref: "#sprite_svg__icon-light-verified",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use503 || (_use503 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-video-usage",
    xlinkHref: "#sprite_svg__icon-light-video",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use504 || (_use504 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-video-off-usage",
    xlinkHref: "#sprite_svg__icon-light-video-off",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use505 || (_use505 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-voice-message-usage",
    xlinkHref: "#sprite_svg__icon-light-voice-message",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use506 || (_use506 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-volume-usage",
    xlinkHref: "#sprite_svg__icon-light-volume",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use507 || (_use507 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-volume-low-usage",
    xlinkHref: "#sprite_svg__icon-light-volume-low",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use508 || (_use508 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-volume-off-usage",
    xlinkHref: "#sprite_svg__icon-light-volume-off",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use509 || (_use509 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-volume-up-usage",
    xlinkHref: "#sprite_svg__icon-light-volume-up",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use510 || (_use510 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-weight-usage",
    xlinkHref: "#sprite_svg__icon-light-weight",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use511 || (_use511 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-whatsapp-usage",
    xlinkHref: "#sprite_svg__icon-light-whatsapp",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use512 || (_use512 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-wifi-off-usage",
    xlinkHref: "#sprite_svg__icon-light-wifi-off",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use513 || (_use513 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-wifi-on-usage",
    xlinkHref: "#sprite_svg__icon-light-wifi-on",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use514 || (_use514 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-world-usage",
    xlinkHref: "#sprite_svg__icon-light-world",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use515 || (_use515 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-zoom-in-usage",
    xlinkHref: "#sprite_svg__icon-light-zoom-in",
    className: "sprite_svg__sprite-symbol-usage"
  })), _use516 || (_use516 = /*#__PURE__*/React.createElement("use", {
    id: "sprite_svg__icon-light-zoom-out-usage",
    xlinkHref: "#sprite_svg__icon-light-zoom-out",
    className: "sprite_svg__sprite-symbol-usage"
  })));
}
export default __webpack_public_path__ + "static/media/sprite.46c2bbb2.svg";
export { SvgSprite as ReactComponent };